import React, { useEffect, useState } from 'react'
import { HeaderMenu } from '../../component/HeaderMenu'
import { Drawer, FormControl, InputLabel, MenuItem, Pagination, Select, Stack, TextField, ToggleButton, ToggleButtonGroup } from '@mui/material'
import { AddLog } from '../../api/crudSolicitud/AddLog.api';


export const Pruebas = () => {

  // prueba de busqueda
  const [search, setSearch] = useState("");

  const data = [
    {"descripcion":"{ AGA-0001 } ARICA"},
{"descripcion":"{ AGP-0001 } PAICO"},
{"descripcion":"{ IOC-0001 } OCHAGAVIA"},
{"descripcion":"{ AGA-0002 } PLANTA DE POLLO"},
{"descripcion":"{ AGA-0003 } SALA PORTERIA"},
{"descripcion":"{ AGA-0004 } BAÑO PORTERIA"},
{"descripcion":"{ AGA-0005 } OFICINA RRHH"},
{"descripcion":"{ AGA-0006 } BAÑO RRHH"},
{"descripcion":"{ AGA-0007 } INGRESO CAMIONES"},
{"descripcion":"{ AGA-0008 } PATIO CAMIONES"},
{"descripcion":"{ AGA-0009 } SALA VISCERADO Y PLUMAS"},
{"descripcion":"{ AGA-0010 } SALA CALDERA"},
{"descripcion":"{ AGA-0011 } BAÑO EX RENDERING"},
{"descripcion":"{ AGA-0012 } PLANTA TRATAMIENTO DE RILES"},
{"descripcion":"{ AGA-0013 } GALPON MANTENIMIENTO (TALLER)"},
{"descripcion":"{ AGA-0014 } BAÑO MANTENIMIENTO"},
{"descripcion":"{ AGA-0015 } OFICINA MANTENIMIENTO"},
{"descripcion":"{ AGA-0016 } VESTIDORES DE MANTENIMIENTO"},
{"descripcion":"{ AGA-0017 } BODEGA DETERGENTE"},
{"descripcion":"{ AGA-0018 } BODEGA PINTURA"},
{"descripcion":"{ AGA-0019 } BODEGA PAÑOL"},
{"descripcion":"{ AGA-0020 } BODEGA REPUESTOS"},
{"descripcion":"{ AGA-0021 } SALA ARMADO CAJA"},
{"descripcion":"{ AGA-0022 } PATIO"},
{"descripcion":"{ AGA-0023 } SALA DE MAQUINAS"},
{"descripcion":"{ AGA-0024 } GALPON POLLO"},
{"descripcion":"{ AGA-0025 } SALA RECEPCION DE JABAS"},
{"descripcion":"{ AGA-0026 } SALA INSENSIBILIZADO"},
{"descripcion":"{ AGA-0027 } SALA DESPLUMADO Y ESCALDADO"},
{"descripcion":"{ AGA-0028 } SALA DE GARRAS Y PATAS"},
{"descripcion":"{ AGA-0029 } SALA DE EVISCERADO AUTOMATICO"},
{"descripcion":"{ AGA-0030 } SALA DE EVISCERADO MANUAL"},
{"descripcion":"{ AGA-0031 } SALA DE CHILLER DE AGUA"},
{"descripcion":"{ AGA-0032 } SALA DE CHILLER DE AIRE"},
{"descripcion":"{ AGA-0033 } SALA DE EMPAQUE"},
{"descripcion":"{ AGA-0034 } SALA DE TROZADO AUTOMATICO"},
{"descripcion":"{ AGA-0035 } SALA DESHUESADO PECHUGA"},
{"descripcion":"{ AGA-0036 } SALA IQF 2DO NIVEL"},
{"descripcion":"{ AGA-0037 } SALA IQF 1ER NIVEL"},
{"descripcion":"{ AGA-0038 } SALA DE PULPA"},
{"descripcion":"{ AGA-0039 } SALA DE TERMOENCAJADO"},
{"descripcion":"{ AGA-0040 } PASILLO CAMARA 21"},
{"descripcion":"{ AGA-0041 } CAMARA 21"},
{"descripcion":"{ AGA-0042 } SALA DE DESPACHO"},
{"descripcion":"{ AGA-0043 } DESPACHO 1"},
{"descripcion":"{ AGA-0044 } DESPACHO 2"},
{"descripcion":"{ AGA-0045 } SALA DE HIELO"},
{"descripcion":"{ AGA-0046 } SALA DE TRANSPORTE DE HIELO"},
{"descripcion":"{ AGA-0047 } BAÑO SADEMA"},
{"descripcion":"{ AGA-0048 } SALA HALL PRINCIPAL"},
{"descripcion":"{ AGA-0049 } PASILLO PRINCIPAL ACCESO PLANTA"},
{"descripcion":"{ AGA-0050 } SALA FILTRO INTERMEDIO"},
{"descripcion":"{ AGA-0051 } SALA FILTRO SALA LIMPIA"},
{"descripcion":"{ AGA-0052 } SALA FILTRO SALA SUCIA"},
{"descripcion":"{ AGA-0053 } COMEDOR 1"},
{"descripcion":"{ AGA-0054 } COMEDOR 2"},
{"descripcion":"{ AGA-0055 } CASINO"},
{"descripcion":"{ AGA-0056 } CAMARIN HOMBRES"},
{"descripcion":"{ AGA-0057 } CAMARIN MUJERES"},
{"descripcion":"{ AGA-0058 } BAÑO DE HOMBRES"},
{"descripcion":"{ AGA-0059 } BAÑO DE MUJERES"},
{"descripcion":"{ AGA-0062 } SALA OFICINA SAG"},
{"descripcion":"{ AGA-0063 } BAÑO SAG"},
{"descripcion":"{ AGA-0064 } SALA DE PRODUCCION PLANIFICACION"},
{"descripcion":"{ AGA-0065 } BAÑO PRODUCCION PLANIFICACION"},
{"descripcion":"{ AGA-0066 } SALA OFICINA DE GESTION"},
{"descripcion":"{ AGA-0067 } SALA DE BALANZAS"},
{"descripcion":"{ AGA-0068 } SALA SUBGERENTE PLANTA"},
{"descripcion":"{ AGA-0069 } BAÑO SUBGERENTE PLANTA"},
{"descripcion":"{ AGA-0070 } CAMARIN SUPERVISORES"},
{"descripcion":"{ AGA-0071 } BAÑO SUPERVISORES"},
{"descripcion":"{ AGA-0072 } PASILLO ADMINISTRACION 2DO PISO"},
{"descripcion":"{ AGA-0073 } BAÑO ADMINISTRATIVOS 2 PISO MUJERES"},
{"descripcion":"{ AGA-0074 } SALA OFICINA GESTION PERSONAL"},
{"descripcion":"{ AGA-0075 } SALA OFICINA PREVENCION DE RIESGO"},
{"descripcion":"{ AGA-0076 } SALA DE SERVIDORES"},
{"descripcion":"{ AGA-0077 } SALA DE LABORATORIO"},
{"descripcion":"{ AGA-0078 } SALA DE ASEGURAMIENTO DE CALIDAD"},
{"descripcion":"{ AGA-0079 } BAÑO DE ASEGURAMIENTO DE CALIDAD"},
{"descripcion":"{ AGA-0080 } BODEGA DE ASEGURAMIENTO DE CALIDAD"},
{"descripcion":"{ AGA-0081 } SALA DE REUNIONES PLANTA"},
{"descripcion":"{ AGA-0082 } SALA ELECTRICA N 1"},
{"descripcion":"{ AGA-0083 } SALA ELECTRICA N 2"},
{"descripcion":"{ AGA-0084 } SALA GENERACION PLANTA"},
{"descripcion":"{ AGA-0085 } SALA GENERACION SADEMA"},
{"descripcion":"{ AGA-0086 } SALA SUBESTACION N 3 (400 KVA)"},
{"descripcion":"{ AGA-0087 } SALA SUBESTACION N 1 (1500 KVA)"},
{"descripcion":"{ AGA-0088 } SALA SUBESTACION N 2 (2000 KVA)"},
{"descripcion":"{ AGA-0089 } BODEGA CASINO"},
{"descripcion":"{ AGA-0090 } BAÑO CASINO"},
{"descripcion":"{ AGA-0091 } CAMARIN CASINO"},
{"descripcion":"{ AGA-0092 } OFICINA CASINO"},
{"descripcion":"{ AGA-0093 } RED DE INCENDIO"},
{"descripcion":"{ AGA-0094 } SALA DE COMPRESORES DE AIRE"},
{"descripcion":"{ AGA-0095 } ESTANQUE ACUMULACION DE AIRE"},
{"descripcion":"{ AGA-0096 } ESTANQUE ACUMULACION DE AGUA"},
{"descripcion":"{ AGA-0097 } ESTANQUE ALMACENAMIENTO AGUA (LECHERO)"},
{"descripcion":"{ AGA-0098 } COMEDOR RECEPCION DE POLLO"},
{"descripcion":"{ AGA-0099 } CAMARINES RECEPCION DE POLLO"},
{"descripcion":"{ AGA-0100 } BAÑO RECEPCION POLLO"},
{"descripcion":"{ AGA-0101 } SALA DE PREPARACION SALMUERA"},
{"descripcion":"{ AGA-0102 } SALA PALETIZADO"},
{"descripcion":"{ AGA-0103 } BODEGA DE HUEVO"},
{"descripcion":"{ AGA-0104 } VESTIDOR DE HUEVO"},
{"descripcion":"{ AGA-0105 } BAÑO DE HUEVO"},
{"descripcion":"{ AGA-0106 } COMEDOR DE HUEVO"},
{"descripcion":"{ AGA-0107 } CAFETERIA RRHH"},
{"descripcion":"{ AGA-0108 } BAÑO RRHH"},
{"descripcion":"{ AGA-0109 } SALA PRIMERO AUXILIOS"},
{"descripcion":"{ AGA-0110 } BODEGA ASEO"},
{"descripcion":"{ AGA-0111 } SALA DE JUEGOS"},
{"descripcion":"{ AGA-0112 } BAÑO SAG MUJERES"},
{"descripcion":"{ AGA-0113 } SALA DE ROTULADO Y SALA DE CONTROL"},
{"descripcion":"{ AGA-0114 } SADEMA 2DO PISO"},
{"descripcion":"{ AGA-0115 } SADEMA 1ER PISO"},
{"descripcion":"{ AGA-0119 } SALA ESTERILIZACION CUCHILLOS TROZADO"},
{"descripcion":"{ AGA-0121 } SALA DE LAVADO DE BINS"},
{"descripcion":"{ AGA-0122 } SALA DE LAVADO DE BANDEJAS"},
{"descripcion":"{ AGA-0123 } SALA TENDERIZADO"},
{"descripcion":"{ AGA-0124 } SALA DE BOMBAS"},
{"descripcion":"{ AGA-0125 } CONTAINER"},
{"descripcion":"{ AGA-0126 } SALA DE EMPAQUE CONGELADO"},
{"descripcion":"{ AGA-0127 } SALA DE CAJAS, 3ER PISO (TECHO TROZADO)"},
{"descripcion":"{ AGA-0200 } Oficina de Servicios Generales"},
{"descripcion":"{ AGA-0201 } Oficina de Infraestructura"},
{"descripcion":"{ AGA-0202 } Taller al lado de Oficina de Infraestructura (2ndo piso)"},
{"descripcion":"{ AGA-0223 } SECTOR RECEPCION POLLO VIVO"},
{"descripcion":"{ AGA-0224 } CONTENEDOR DE BOMBAS DE MEZCLA DE AGUA"},
{"descripcion":"{ AGA-0225 } EX SALA DE CAPACITACIONES"},
{"descripcion":"{ AGA-P-DP-001 } Oficina Jefe de Despacho (Contenedor al lado de Oficina de HH)"},
{"descripcion":"{ AGA-0060 } DUCHA DE HOMBRES"},
{"descripcion":"{ AGA-0061 } DUCHAS DE MUJERES"},
{"descripcion":"{ AGA-0116 } ANDEN 1"},
{"descripcion":"{ AGA-0117 } ANDEN 2"},
{"descripcion":"{ AGA-0118 } ANDEN 3"},
{"descripcion":"{ AGA-0120 } SALA ESTERILIZACION CUCHILLOS MATANZA POLLO"},
{"descripcion":"{ IOCU-00138 } PLANTA POLLO"},
{"descripcion":"{ IOCU-00003 } TALLER DE MANTENIMIENTO"},
{"descripcion":"{ IOCU-00006 } SALA LAVADO BANDEJAS"},
{"descripcion":"{ IOCU-00011 } PLANTA TRATAMIENTO DE RILES"},
{"descripcion":"{ IOCU-00015 } PASILLO ACCESO A PLANTA"},
{"descripcion":"{ IOCU-00020 } SALA TABLERO EX SILO HIELO"},
{"descripcion":"{ IOCU-00021 } SALA TABLERO SOBRE CALDERA"},
{"descripcion":"{ IOCU-00022 } SALA TABLERO EMPAQUE Y TROZADO"},
{"descripcion":"{ IOCU-00023 } GALPON DE ESPERA"},
{"descripcion":"{ IOCU-00024 } SALA RECEPCION POLLO VIVO"},
{"descripcion":"{ IOCU-00025 } SALA COLGADO DE POLLO"},
{"descripcion":"{ IOCU-00026 } SALA MATANZA DE POLLOS"},
{"descripcion":"{ IOCU-00027 } SALA DESPLUMADO"},
{"descripcion":"{ IOCU-00028 } SALA EVISCERADO"},
{"descripcion":"{ IOCU-00029 } SALA DE ENFRIAMIENTO POR AGUA"},
{"descripcion":"{ IOCU-00030 } SALA MARINADO POLLO ENTERO"},
{"descripcion":"{ IOCU-00031 } SALA CHILLER AIRE POLLO ENTERO"},
{"descripcion":"{ IOCU-00032 } SALA CALIBRADO POLLO ENTERO"},
{"descripcion":"{ IOCU-00033 } SALA EMPAQUE POLLO ENTERO"},
{"descripcion":"{ IOCU-00034 } SALA EMPAQUE GARRAS"},
{"descripcion":"{ IOCU-00035 } FOSO GUANO ALTERNATIVO"},
{"descripcion":"{ IOCU-00036 } SALA CAJAS"},
{"descripcion":"{ IOCU-00037 } TUNEL DE CAJAS"},
{"descripcion":"{ IOCU-00038 } BODEGA REPUESTOS"},
{"descripcion":"{ IOCU-00039 } BODEGA INSUMOS"},
{"descripcion":"{ IOCU-00040 } PATIO 1"},
{"descripcion":"{ IOCU-00041 } PATIO 2"},
{"descripcion":"{ IOCU-00042 } PATIO 3"},
{"descripcion":"{ IOCU-00043 } PATIO 4"},
{"descripcion":"{ IOCU-00044 } SALA TROZADO MECANICO"},
{"descripcion":"{ IOCU-00045 } SALA EMPAQUE TROZADO POLLO"},
{"descripcion":"{ IOCU-00046 } SALA TROZADO PRESITAS"},
{"descripcion":"{ IOCU-00047 } SALA SABORIZADO"},
{"descripcion":"{ IOCU-00048 } SALA ESTERILIZADO"},
{"descripcion":"{ IOCU-00049 } SALA IQF"},
{"descripcion":"{ IOCU-00050 } SALA BANDEJITAS"},
{"descripcion":"{ IOCU-00051 } SALA DESHUESE PECHUGA"},
{"descripcion":"{ IOCU-00052 } TUNEL CONGELADO"},
{"descripcion":"{ IOCU-00053 } ESTACIONAMIENTO PONIENTE PLANTA"},
{"descripcion":"{ IOCU-00054 } PASILLO CALDERA"},
{"descripcion":"{ IOCU-00055 } SALA CALDERA"},
{"descripcion":"{ IOCU-00056 } SALA SEPARADORES SOLIDOS"},
{"descripcion":"{ IOCU-00057 } SALA SALMUERA"},
{"descripcion":"{ IOCU-00058 } SALA GARRAS"},
{"descripcion":"{ IOCU-00059 } CAMARA 1"},
{"descripcion":"{ IOCU-00060 } CAMARA 2"},
{"descripcion":"{ IOCU-00061 } CAMARA 3"},
{"descripcion":"{ IOCU-00062 } CAMARA 4"},
{"descripcion":"{ IOCU-00063 } CAMARA 5"},
{"descripcion":"{ IOCU-00064 } CAMARA 5A"},
{"descripcion":"{ IOCU-00065 } CAMARA 5B"},
{"descripcion":"{ IOCU-00066 } CAMARA 7"},
{"descripcion":"{ IOCU-00067 } CAMARA 9"},
{"descripcion":"{ IOCU-00068 } CAMARA 34"},
{"descripcion":"{ IOCU-00069 } CAMARA 36"},
{"descripcion":"{ IOCU-00070 } TUNEL 31"},
{"descripcion":"{ IOCU-00071 } TUNEL 32"},
{"descripcion":"{ IOCU-00072 } TUNEL 33"},
{"descripcion":"{ IOCU-00073 } SALA DE MAQUINAS"},
{"descripcion":"{ IOCU-00074 } OFICINA SUPERVISORES TROZADO/EMPAQUE"},
{"descripcion":"{ IOCU-00075 } OFICINA JEFES AREA TROZADO/FAENA"},
{"descripcion":"{ IOCU-00076 } OFICINA CASETA ROMANA TROZADO"},
{"descripcion":"{ IOCU-00077 } PASILLO ROMANA TROZADO"},
{"descripcion":"{ IOCU-00078 } PASILLO TROZADO"},
{"descripcion":"{ IOCU-00079 } PASILLO TUNELES"},
{"descripcion":"{ IOCU-00080 } OFICINA SUPERVISORES FAENA"},
{"descripcion":"{ IOCU-00081 } SALA DESPACHO"},
{"descripcion":"{ IOCU-00082 } OFICINAS DESPACHO"},
{"descripcion":"{ IOCU-00083 } OFICINA CASETA ROMANA DESPACHO"},
{"descripcion":"{ IOCU-00084 } PASILLO ANTECAMARA DESPACHO"},
{"descripcion":"{ IOCU-00085 } PASILLO CAMARA PONIENTE"},
{"descripcion":"{ IOCU-00086 } PASILLO MATADERO"},
{"descripcion":"{ IOCU-00087 } OFICINAS DE MANTENIMIENTO"},
{"descripcion":"{ IOCU-00088 } OFICINA OPERADORES SALA MAQUINAS"},
{"descripcion":"{ IOCU-00089 } SALA COMEDORES PRINCIPAL"},
{"descripcion":"{ IOCU-00090 } SALA CASINO PRINCIPAL"},
{"descripcion":"{ IOCU-00091 } SALA COMEDOR RECEPCION"},
{"descripcion":"{ IOCU-00092 } ESTACIONAMIENTO MANTENIMIENTO"},
{"descripcion":"{ IOCU-00094 } OFICINA CONTROL PLANTA RILES"},
{"descripcion":"{ IOCU-00095 } SALA DE RECICLAJE"},
{"descripcion":"{ IOCU-00096 } PORTERIA 1 NORTE"},
{"descripcion":"{ IOCU-00097 } PORTERIA 1 SUR"},
{"descripcion":"{ IOCU-00098 } PORTERIA 2"},
{"descripcion":"{ IOCU-00099 } PORTERIA 2B"},
{"descripcion":"{ IOCU-00100 } PORTERIA 3"},
{"descripcion":"{ IOCU-00101 } PORTERIA 4"},
{"descripcion":"{ IOCU-00102 } BODEGA MANTENIMIENTO PATIO 3"},
{"descripcion":"{ IOCU-00103 } BODEGA INFRAESTRUCTURA PATIO3"},
{"descripcion":"{ IOCU-00104 } OFICINAS PATIO 3"},
{"descripcion":"{ IOCU-00105 } ESTACIONAMIENTO PATIO 3"},
{"descripcion":"{ IOCU-00106 } SALA CONTENEDORES PLUMAS VISCERAS"},
{"descripcion":"{ IOCU-00107 } FILTRO SANITARIO TROZADO"},
{"descripcion":"{ IOCU-00108 } FILTRO SANITARIO 2 PISO"},
{"descripcion":"{ IOCU-00109 } FILTRO SANITARIO FAENA"},
{"descripcion":"{ IOCU-00110 } BAÑO HOMBRES 1 PISO"},
{"descripcion":"{ IOCU-00111 } BAÑO MUJERES 1 PISO"},
{"descripcion":"{ IOCU-00112 } OFICINA PRIMEROS AUXILIOS"},
{"descripcion":"{ IOCU-00113 } VESTIDORES DAMAS"},
{"descripcion":"{ IOCU-00114 } VESTIDORES VARONES"},
{"descripcion":"{ IOCU-00115 } VESTIDORES SUPERVISORES"},
{"descripcion":"{ IOCU-00116 } SALA GUARDA ROPA"},
{"descripcion":"{ IOCU-00117 } VESTIDORES RECEPCION"},
{"descripcion":"{ IOCU-00118 } VESTIDORES MANTENIMIENTO"},
{"descripcion":"{ IOCU-00119 } BAÑO MUJERES 2 PISO"},
{"descripcion":"{ IOCU-00120 } BAÑO HOMBRES 2 PISO"},
{"descripcion":"{ IOCU-00121 } BAÑO MANTENIMIENTO"},
{"descripcion":"{ IOCU-00122 } BAÑO RECEPCION"},
{"descripcion":"{ IOCU-00123 } BAÑO PATIO 4"},
{"descripcion":"{ IOCU-00124 } BODEGA DE RESIDUOS PELIGROSOS"},
{"descripcion":"{ IOCU-00125 } OFICINA ADMINISTRACION"},
{"descripcion":"{ IOCU-00126 } OFICINA SERVICIOS GENERALES"},
{"descripcion":"{ IOCU-00127 } OFICINA CALIDAD"},
{"descripcion":"{ IOCU-00128 } OFICINA PREVENCION DE RIESGOS"},
{"descripcion":"{ IOCU-00129 } OFICINA CONTROL DE GESTION"},
{"descripcion":"{ IOCU-00130 } SALA DE REUNIONES A"},
{"descripcion":"{ IOCU-00131 } SALA DE REUNIONES B"},
{"descripcion":"{ IOCU-00132 } SALA DE REUNIONES C"},
{"descripcion":"{ IOCU-00133 } SALA DE CAPACITACION"},
{"descripcion":"{ IOCU-00135 } OFICINAS ALTILLO"},
{"descripcion":"{ IOCU-00136 } OFICINA ASISTENTE SOCIAL"},
{"descripcion":"{ IOCU-00137 } SALA DE JUEGOS"},
{"descripcion":"{ IOCU-00139 } SALA DE BOMBAS ALTA PRESION SOBRE CALDERA"},
{"descripcion":"{ IOCU-00140 } SALA BANDEJITAS SEGUNDO PISO"},
{"descripcion":"{ IOCU-00142 } CAMARA 38"},
{"descripcion":"{ IOCU-00141 } SALA DE DILUCION"},
{"descripcion":"{ PAH-0001 } PLANTA AHUMADO"},
{"descripcion":"{ PPA-0001 } PLANTA PAVOS"},
{"descripcion":"{ PPO-0001 } PLANTA POLLO"},
{"descripcion":"{ AGPU-0004 } ANTE TUNEL AHUMADO"},
{"descripcion":"{ AGPU-0040 } COMEDOR AHUMADO"},
{"descripcion":"{ AGPU-0061 } OFICINA AHUMADO"},
{"descripcion":"{ AGPU-0200 } PATIO PLANTA"},
{"descripcion":"{ AGPU-0201 } TECHUMBRE PLANTA"},
{"descripcion":"{ AGPU-0202 } TERRAZA SALA DE MAQUINAS"},
{"descripcion":"{ AGPU-0226 } SECTOR MAQUINAS EQUIPOS DADOS DE BAJA"},
{"descripcion":"{ AGPU-0227 } SALA MAQUINAS NUEVA"},
{"descripcion":"{ AGPU-0236 } BAÑOS PLANTA"},
{"descripcion":"{ AGPU-0237 } BODEGAS PLANTA"},
{"descripcion":"{ AGPU-0238 } CAMARAS PLANTA"},
{"descripcion":"{ AGPU-0239 } OFICINAS PLANTA"},
{"descripcion":"{ AGPU-0240 } ENTRETECHOS PLANTA"},
{"descripcion":"{ AGPU-0241 } ESTACIONAMIENTOS PLANTA"},
{"descripcion":"{ AGPU-0242 } FILTROS SANITARIOS PLANTA"},
{"descripcion":"{ AGPU-0243 } GALPONES PLANTA"},
{"descripcion":"{ AGPU-0244 } PASILLOS PLANTA"},
{"descripcion":"{ AGPU-0245 } SALAS PLANTA"},
{"descripcion":"{ AGPU-0247 } TUNELES PLANTA"},
{"descripcion":"{ AGPU-0248 } CASINO PLANTA"},
{"descripcion":"{ AGPU-0249 } ANDENES FRIGORIFICO"},
{"descripcion":"{ AGPU-0002 } ANDEN DESPACHO CONGELADO"},
{"descripcion":"{ AGPU-0003 } ANDEN DESPACHO FRESCO"},
{"descripcion":"{ AGPU-0218 } ANDEN DECOMISO"},
{"descripcion":"{ AGPU-0005 } BAÑO GERENCIA"},
{"descripcion":"{ AGPU-0006 } BAÑO MATADERO"},
{"descripcion":"{ AGPU-0007 } BAÑO MATADERO SAG"},
{"descripcion":"{ AGPU-0008 } BAÑO RECEPCION"},
{"descripcion":"{ AGPU-0009 } BAÑO SUPERVISORAS"},
{"descripcion":"{ AGPU-0010 } BAÑO SUPERVISORES"},
{"descripcion":"{ AGPU-0011 } BAÑOS HOMBRES PRINCIPAL"},
{"descripcion":"{ AGPU-0012 } BAÑOS MUJERES PRINCIPAL"},
{"descripcion":"{ AGPU-0013 } BAÑOS DE AHUMADO"},
{"descripcion":"{ AGPU-0014 } BAÑOS DE CAMIONEROS"},
{"descripcion":"{ AGPU-0015 } BAÑOS DE MANTENIMIENTO Y MONTAJE"},
{"descripcion":"{ AGPU-0016 } BODEGA BAJO ESCALA HALL PRINCIPAL"},
{"descripcion":"{ AGPU-0017 } BODEGA CASINO"},
{"descripcion":"{ AGPU-0018 } BODEGA DE DETERGENTES"},
{"descripcion":"{ AGPU-0019 } BODEGA DE INSUMOS"},
{"descripcion":"{ AGPU-0020 } BODEGA DE SSGG TERCER PISO"},
{"descripcion":"{ AGPU-0021 } BODEGA PALLET"},
{"descripcion":"{ AGPU-0022 } BODEGA PATIO 14"},
{"descripcion":"{ AGPU-0023 } BODEGA REPUESTOS"},
{"descripcion":"{ AGPU-0024 } BODEGA RESIDUOS PELIGROSOS"},
{"descripcion":"{ AGPU-0025 } BODEGA SALA DE MAQUINAS"},
{"descripcion":"{ AGPU-0026 } BODEGA SSGG NIVEL 1 ZONA SUCIA"},
{"descripcion":"{ AGPU-0027 } BODEGA SSGG NIVEL 3 ZONA LIMPIA"},
{"descripcion":"{ AGPU-0028 } BODEGAS ANTE SUB ESTACION 5"},
{"descripcion":"{ AGPU-0029 } BODEGAS COSTADO CANCHA FUTBOL"},
{"descripcion":"{ AGPU-0096 } PAÑOL DE MATADERO"},
{"descripcion":"{ AGPU-0097 } PAÑOL SS.GG"},
{"descripcion":"{ AGPU-0220 } SALA DE DILUCION DE QUIMICOS"},
{"descripcion":"{ AGPU-0221 } SALA DE HIPOCLORITO"},
{"descripcion":"{ AGPU-0030 } CAMARA 201 ORIENTE (FRESCO)"},
{"descripcion":"{ AGPU-0032 } CAMARA 202 (FRESCO)"},
{"descripcion":"{ AGPU-0033 } CAMARA 203"},
{"descripcion":"{ AGPU-0034 } CAMARA 207"},
{"descripcion":"{ AGPU-0035 } CAMARA 208"},
{"descripcion":"{ AGPU-0036 } CAMARA 290"},
{"descripcion":"{ AGPU-0037 } CAMARA 304"},
{"descripcion":"{ AGPU-0214 } CAMARA 201 PONIENTE (FRESCO)"},
{"descripcion":"{ AGPU-0039 } COCINA PLANTA"},
{"descripcion":"{ AGPU-0041 } COMEDOR FAENACION"},
{"descripcion":"{ AGPU-0042 } COMEDOR PRINCIPAL"},
{"descripcion":"{ AGPU-0043 } ENTRETECHO FAENA DE PAVOS"},
{"descripcion":"{ AGPU-0044 } ENTRETECHO ORIENTE SOBRE TROZADO PAVOS"},
{"descripcion":"{ AGPU-0045 } ENTRETECHO PONIENTE SOBRE CALIBRADO"},
{"descripcion":"{ AGPU-0046 } ENTRETECHO PONIENTE SOBRE ENCAJADO FRESCO"},
{"descripcion":"{ AGPU-0047 } ESTACIONAMIENTO ENTRADA"},
{"descripcion":"{ AGPU-0048 } ESTACIONAMIENTO ORIENTE"},
{"descripcion":"{ AGPU-0049 } ESTACIONAMIENTO PRINCIPAL"},
{"descripcion":"{ AGPU-0050 } FILTRO SANITARIO ENFRIAMIENTO DE AGUA"},
{"descripcion":"{ AGPU-0051 } FILTRO SANITARIO ENFRIAMIENTO DE AIRE"},
{"descripcion":"{ AGPU-0052 } FILTRO SANITARIO ESCALDADO Y DESPLUMADOS DE PAVOS"},
{"descripcion":"{ AGPU-0053 } FILTRO SANITARIO ESCALDADO Y DESPLUMADOS DE POLLOS"},
{"descripcion":"{ AGPU-0054 } FILTRO SANITARIO EVISCERADO DE PAVOS"},
{"descripcion":"{ AGPU-0055 } FILTRO SANITARIO EVISCERADO DE POLLOS"},
{"descripcion":"{ AGPU-0056 } FILTRO SANITARIO PRINCIPAL"},
{"descripcion":"{ AGPU-0057 } FILTRO SANITARIO RECEPCION DE PAVOS"},
{"descripcion":"{ AGPU-0217 } FILTRO SANITARIO DESPACHO FRESCO"},
{"descripcion":"{ AGPU-0058 } GALPON ESPERA AVES"},
{"descripcion":"{ AGPU-0059 } GALPON DE MANTENIMIENTO Y MONTAJES"},
{"descripcion":"{ AGPU-0060 } GALPON RECEPCION AVES"},
{"descripcion":"{ AGPU-0213 } GALPON SOLDADURA Y GASFITERIA"},
{"descripcion":"{ AGPU-0038 } OFICINA CASETA CONTROL RECEPCION FAENA"},
{"descripcion":"{ AGPU-0062 } OFICINA ASEGURAMIENTO CALIDAD"},
{"descripcion":"{ AGPU-0063 } OFICINA ASISTENTE SOCIAL"},
{"descripcion":"{ AGPU-0064 } OFICINA CAPACITACION"},
{"descripcion":"{ AGPU-0065 } OFICINA CASETA CAMARA 208"},
{"descripcion":"{ AGPU-0066 } OFICINA CASETA IQF"},
{"descripcion":"{ AGPU-0067 } OFICINA CASETA PULPA"},
{"descripcion":"{ AGPU-0068 } OFICINA CASETA TROZADOS"},
{"descripcion":"{ AGPU-0069 } OFICINA CONTENEDOR PERSONAL"},
{"descripcion":"{ AGPU-0070 } OFICINA CONTENEDOR PERSONAL CAPACITACION"},
{"descripcion":"{ AGPU-0071 } OFICINA CONTROL OPERACIONES"},
{"descripcion":"{ AGPU-0072 } OFICINA DE INFRAESTRUCTURA"},
{"descripcion":"{ AGPU-0073 } OFICINA DE MANTENIMIENTO"},
{"descripcion":"{ AGPU-0074 } OFICINA DESARROLLO"},
{"descripcion":"{ AGPU-0075 } OFICINA FRIGORIFICO"},
{"descripcion":"{ AGPU-0076 } OFICINA GERENTE OPERACIONES"},
{"descripcion":"{ AGPU-0078 } OFICINA GESTION GASTOS"},
{"descripcion":"{ AGPU-0079 } OFICINA MATADERO"},
{"descripcion":"{ AGPU-0080 } OFICINA MONTAJE"},
{"descripcion":"{ AGPU-0081 } OFICINA PERSONAL"},
{"descripcion":"{ AGPU-0082 } OFICINA PLANIFICACION"},
{"descripcion":"{ AGPU-0083 } OFICINA PREVENCION"},
{"descripcion":"{ AGPU-0084 } OFICINA PROCESOS POSTERIORES"},
{"descripcion":"{ AGPU-0085 } OFICINA PROYECTOS"},
{"descripcion":"{ AGPU-0086 } OFICINA REUNIONES"},
{"descripcion":"{ AGPU-0087 } OFICINA REUNIONES GESTION GASTOS"},
{"descripcion":"{ AGPU-0088 } OFICINA SAG"},
{"descripcion":"{ AGPU-0089 } OFICINA SALA DE MAQUINAS"},
{"descripcion":"{ AGPU-0090 } OFICINA SINDICATO"},
{"descripcion":"{ AGPU-0091 } OFICINA SERVICIOS GENERALES"},
{"descripcion":"{ AGPU-0092 } OFICINA SUBGERENTE"},
{"descripcion":"{ AGPU-0093 } OFICINA TRAZABILIDAD"},
{"descripcion":"{ AGPU-0094 } OFICINA TROZADOS"},
{"descripcion":"{ AGPU-0215 } OFICINA GESTION DE PERSONAS"},
{"descripcion":"{ AGPU-0001 } ACCESO TERCER NIVEL"},
{"descripcion":"{ AGPU-0095 } ORATORIO"},
{"descripcion":"{ AGPU-0098 } PASILLO TUNEL DESPLUMADO - EVISCERADO PAVO"},
{"descripcion":"{ AGPU-0099 } PASILLO 1 NIVEL 3"},
{"descripcion":"{ AGPU-0100 } PASILLO 2 NIVEL 3"},
{"descripcion":"{ AGPU-0101 } PASILLO A"},
{"descripcion":"{ AGPU-0102 } PASILLO ANTE SUB ESTACION 5"},
{"descripcion":"{ AGPU-0103 } PASILLO B"},
{"descripcion":"{ AGPU-0104 } PASILLO BAÑOS PRINCIPALES"},
{"descripcion":"{ AGPU-0105 } PASILLO C"},
{"descripcion":"{ AGPU-0106 } PASILLO CALIDAD"},
{"descripcion":"{ AGPU-0107 } PASILLO CASINO"},
{"descripcion":"{ AGPU-0108 } PASILLO CHILLER DE AIRE"},
{"descripcion":"{ AGPU-0109 } PASILLO D"},
{"descripcion":"{ AGPU-0110 } PASILLO EVISCERADO PAVO"},
{"descripcion":"{ AGPU-0111 } PASILLO FRENTE BODEGA INSUMOS"},
{"descripcion":"{ AGPU-0112 } PASILLO GERENCIA"},
{"descripcion":"{ AGPU-0113 } PASILLO HACIA CMR"},
{"descripcion":"{ AGPU-0114 } PASILLO HALL CENTRAL EDIFICIO"},
{"descripcion":"{ AGPU-0115 } PASILLO MATADERO"},
{"descripcion":"{ AGPU-0116 } PASILLO OFICINA SERVICIOS GENERALES"},
{"descripcion":"{ AGPU-0117 } PASILLO SALIDA EMERGENCIA"},
{"descripcion":"{ AGPU-0118 } PASILLO TUNELES N 1-2-3-4"},
{"descripcion":"{ AGPU-0119 } PASILLO TUNELES N 5-6-7-8"},
{"descripcion":"{ AGPU-0199 } PATIO CIP"},
{"descripcion":"{ AGPU-0212 } PATIO ESTANQUES GAS NATURAL"},
{"descripcion":"{ AGPU-0224 } POZO CAMARA 208"},
{"descripcion":"{ AGPU-0225 } SALA PALETIZADO CALIBRADO"},
{"descripcion":"{ AGPU-0228 } SALA ACTIVOS DESHABILITADOS"},
{"descripcion":"{ AGPU-0229 } CONTENEDOR BAÑOS CONTRATISTAS"},
{"descripcion":"{ AGPU-0233 } CONTENEDOR CHOFERES FRIGORIFICO"},
{"descripcion":"{ AGPU-0234 } PATIO CAMIONES LABBE FRIGORIFICO"},
{"descripcion":"{ AGPU-0235 } PATIO REFFER PONIENTE FRIGORIFICO"},
{"descripcion":"{ AGPU-0120 } SALA ACOPIO DE BINS LIMPIOS"},
{"descripcion":"{ AGPU-0121 } SALA DE ARMADO CAJAS MANUAL"},
{"descripcion":"{ AGPU-0122 } SALA DE CENTRAL MONTACARGAS"},
{"descripcion":"{ AGPU-0123 } SALA DE ALMACENAMIENTO DE SANGRE"},
{"descripcion":"{ AGPU-0124 } SALA DE ANEXO AHUMADO"},
{"descripcion":"{ AGPU-0125 } SALA ARMADO DE CAJAS MANUAL"},
{"descripcion":"{ AGPU-0126 } SALA DE BALANZAS"},
{"descripcion":"{ AGPU-0127 } SALA DE BANDEJAS LIMPIAS"},
{"descripcion":"{ AGPU-0128 } SALA DE BANDEJAS SUCIAS"},
{"descripcion":"{ AGPU-0129 } SALA DE BATERIAS"},
{"descripcion":"{ AGPU-0130 } SALA DE BOMBAS"},
{"descripcion":"{ AGPU-0131 } SALA DE BOMBAS GLICOL"},
{"descripcion":"{ AGPU-0132 } SALA DE CALDERA Y COGENERACION"},
{"descripcion":"{ AGPU-0133 } SALA DE CALIBRADO PECHUGA"},
{"descripcion":"{ AGPU-0134 } SALA DE CARNE MECANICAMENTE RECUPERADA (PULPA)"},
{"descripcion":"{ AGPU-0135 } SALA DE COLGADO DE PAVOS"},
{"descripcion":"{ AGPU-0136 } SALA DE COLGADO DE POLLOS"},
{"descripcion":"{ AGPU-0137 } SALA DE COMPRESORES NIVEL 2"},
{"descripcion":"{ AGPU-0138 } SALA DE CONTENEDORES PLUMAS"},
{"descripcion":"{ AGPU-0139 } SALA DE CONTENEDORES VISCERAS"},
{"descripcion":"{ AGPU-0140 } SALA DE DESHUESADO PECHUGA"},
{"descripcion":"{ AGPU-0141 } SALA DE DRIP"},
{"descripcion":"{ AGPU-0142 } SALA DE EMBALAJE Y ETIQUETADO"},
{"descripcion":"{ AGPU-0143 } SALA DE EMPAQUE AHUMADO"},
{"descripcion":"{ AGPU-0144 } SALA DE EMPAQUE DE PAVOS"},
{"descripcion":"{ AGPU-0145 } SALA DE EMPAQUE PRODUCTOS CONGELADOS"},
{"descripcion":"{ AGPU-0146 } SALA DE EMPAQUE TRUTRO"},
{"descripcion":"{ AGPU-0147 } SALA DE ENFRIADO POR AGUA"},
{"descripcion":"{ AGPU-0148 } SALA DE ENFRIADO POR AIRE"},
{"descripcion":"{ AGPU-0149 } SALA DE ENVASES AREA LIMPIA"},
{"descripcion":"{ AGPU-0150 } SALA DE ENVASES AREA SUCIA"},
{"descripcion":"{ AGPU-0151 } SALA DE EQUIPOS ARMADO DE CAJAS"},
{"descripcion":"{ AGPU-0152 } SALA DE ESCALDADO GARRAS Y PATAS"},
{"descripcion":"{ AGPU-0153 } SALA DE EVISCERADO DE PAVOS"},
{"descripcion":"{ AGPU-0154 } SALA DE EX CHULETAS"},
{"descripcion":"{ AGPU-0155 } SALA DE EX LTS"},
{"descripcion":"{ AGPU-0156 } SALA DE GENERACION ELECTRICA"},
{"descripcion":"{ AGPU-0157 } SALA DE HERRAMIENTAS"},
{"descripcion":"{ AGPU-0158 } SALA DE HIELO"},
{"descripcion":"{ AGPU-0159 } SALA DE HORNOS AHUMADO"},
{"descripcion":"{ AGPU-0160 } SALA DE INSENSIBILIZADO DE PAVOS"},
{"descripcion":"{ AGPU-0161 } SALA DE INSENSIBILIZADO DE POLLOS"},
{"descripcion":"{ AGPU-0162 } SALA DE INYECTADO AHUMADO"},
{"descripcion":"{ AGPU-0163 } SALA DE INYECTADO DE PAVOS"},
{"descripcion":"{ AGPU-0164 } SALA DE IQF"},
{"descripcion":"{ AGPU-0165 } SALA DE JUEGOS"},
{"descripcion":"{ AGPU-0166 } SALA DE LAVADO DE CARROS AHUMADO"},
{"descripcion":"{ AGPU-0167 } SALA DE LAVANDERIA"},
{"descripcion":"{ AGPU-0168 } SALA DE OSMOSIS INVERSA"},
{"descripcion":"{ AGPU-0169 } SALA DE PORTERIA"},
{"descripcion":"{ AGPU-0170 } SALA DE PREPARACION SALMUERA"},
{"descripcion":"{ AGPU-0171 } SALA DE PRIMEROS AUXILIOS"},
{"descripcion":"{ AGPU-0172 } SALA DE PROCESOS CARNICOS ( EX JAPON)"},
{"descripcion":"{ AGPU-0173 } SALA DE RECEPCION JABAS POLLO"},
{"descripcion":"{ AGPU-0174 } SALA DE RECEPCION PAVO"},
{"descripcion":"{ AGPU-0175 } SALA DE RED CONTRA INCENDIO"},
{"descripcion":"{ AGPU-0176 } SALA DE SANGRADO DE PAVOS"},
{"descripcion":"{ AGPU-0177 } SALA DE SANGRADO DE POLLOS"},
{"descripcion":"{ AGPU-0178 } SALA DE SECTOR DE DECOMISO"},
{"descripcion":"{ AGPU-0179 } SALA DE SEPARACION DE SOLIDOS"},
{"descripcion":"{ AGPU-0180 } SALA DE SERVIDORES"},
{"descripcion":"{ AGPU-0181 } SALA DE TRANSFORMADOR N 5"},
{"descripcion":"{ AGPU-0182 } SALA DE TRANSFORMADORES 1-4"},
{"descripcion":"{ AGPU-0183 } SALA DE TRATAMIENTOS DE AGUA"},
{"descripcion":"{ AGPU-0184 } SALA DE TROZADO AUTOMATICO"},
{"descripcion":"{ AGPU-0185 } SALA DE TROZADO DE PAVOS"},
{"descripcion":"{ AGPU-0186 } SALA DE TROZADOS CONOS"},
{"descripcion":"{ AGPU-0187 } SALA DE TRUTROS"},
{"descripcion":"{ AGPU-0188 } SALA DE TUMBLER"},
{"descripcion":"{ AGPU-0189 } SALA DE VACIO Y SEPARADOR DE PLUMAS"},
{"descripcion":"{ AGPU-0190 } SALA DE VALVULAS TUNELES N 1-4"},
{"descripcion":"{ AGPU-0191 } SALA DESPLUMADO Y ESCALDADO DE PAVOS"},
{"descripcion":"{ AGPU-0192 } SALA DESPLUMADO Y ESCALDADO DE POLLOS"},
{"descripcion":"{ AGPU-0193 } SALA DOSIFICADORA PERACETICO"},
{"descripcion":"{ AGPU-0194 } SALA EVISCERADO DE POLLOS"},
{"descripcion":"{ AGPU-0195 } SALA ESTANQUE BAJA 3 SECTOR AHUMADO"},
{"descripcion":"{ AGPU-0196 } SALA TABLEROS FAENA DE PAVOS"},
{"descripcion":"{ AGPU-0197 } SALA DE COMPRESORES NIVEL 1 NORTE"},
{"descripcion":"{ AGPU-0198 } SALA DE COMPRESORES NIVEL 1 SUR"},
{"descripcion":"{ AGPU-0216 } SALA DE RESIDUOS"},
{"descripcion":"{ AGPU-0219 } SALA TABLEROS CONTROL RAPID HQ"},
{"descripcion":"{ AGPU-0222 } SALA RECEPCION DE PLUMAS"},
{"descripcion":"{ AGPU-0223 } SALA DE BOMBAS SIN CLORO HACIA CALDERA"},
{"descripcion":"{ AGPU-0250 } ALTILLO HACIA CALIBRADO PECHUGAS"},
{"descripcion":"{ AGPU-0230 } SALA NECROPSIA RECEPCION DE PAVOS"},
{"descripcion":"{ AGPU-0231 } SALA NECROPSIA RECEPCION DE POLLOS"},
{"descripcion":"{ AGPU-0203 } TUNEL N 1(MENUDENCIA)"},
{"descripcion":"{ AGPU-0204 } TUNEL N 2-3"},
{"descripcion":"{ AGPU-0205 } TUNEL N 4 (PROCESOS)"},
{"descripcion":"{ AGPU-0206 } TUNEL N 5"},
{"descripcion":"{ AGPU-0207 } TUNEL N 6"},
{"descripcion":"{ AGPU-0208 } TUNEL N 9"},
{"descripcion":"{ AGPU-0209 } TUNEL N 10"},
{"descripcion":"{ AGPU-0210 } TUNEL N 11"},
{"descripcion":"{ AGPU-0211 } TUNEL N 12"},
{"descripcion":"{ } Balanza Mettler Toledo IND236 (N 111, Grupo B N 4)"},
{"descripcion":"{ } Balanza Triunfo XKSS-WP (N 115, Grupo B N 4)"},
{"descripcion":"{ AGA-11-0151 } Balanza Triunfo XKSS-WP (N 118, Grupo B N 5)"},
{"descripcion":"{ AGA-11-0152 } Balanza Triunfo XKSS-WP (N 119, Grupo B N 5)"},
{"descripcion":"{ AGA-11-0153 } Balanza Weighting Indicator XK3119WP (N 124, Grupo B N 5)"},
{"descripcion":"{ AGA-11-0154 } Balanza Weighting Indicator XK3119WP (N 123, Grupo B N 5)"},
{"descripcion":"{ AGA-11-0156 } Balanza Weighting Indicator XK3119WP (N 133, Grupo B N 5)"},
{"descripcion":"{ AGA-1271 } TRAMPA MAQUINA DE HIELO N 1 Y N 3"},
{"descripcion":"{ AGA-1272 } TRAMPA MAQUINA DE HIELO N 2 Y N 4"},
{"descripcion":"{ AGA-BB-0004 } Bomba de VacÃ­o N 2 (Lado Pared de Eviscerado)"},
{"descripcion":"{ AGA-DE-0010 } Contador de Pollos"},
{"descripcion":"{ AGA-TR-9000 } Transpaleta 1122CT001"},
{"descripcion":"{ AGA-0050 } OFICINA DE PRODUCCION"},
{"descripcion":"{ AGA-04-0151 } Balanza Pesamatic AGUA-SS de 6Kg (N 117, Grupo B N 5)"},
{"descripcion":"{ AGA-1264 } ESTANQUE DE AGUA DE PROCESOS"},
{"descripcion":"{ AGA-300 } LÃNEAS AEREAS GENERALES"},
{"descripcion":"{ AGA-OX-0000 } Planta (Control de Oxido)"},
{"descripcion":"{ AGA-PE-PA-TS02-12 } Tablero de Telemetria de Bomba de Pozo N 1 (Costado de sala de Juegos)"},
{"descripcion":"{ AGA-P-RE-0007 } Cinta Elevadora de Plumas"},
{"descripcion":"{ AGA-S-DE-C002 } CAmara 21 B"},
{"descripcion":"{ AGA-SU-00200 } Red de Paracetico"},
{"descripcion":"{ AGA-SU-0030 } Estanque de petroleo"},
{"descripcion":"{ AGA-SU-9003 } Transpaleta 1122QU001"},
{"descripcion":"{ AGA-SU-9004 } Transpaleta 1122QU002"},
{"descripcion":"{ AGA-SU-9006 } Transpaleta 1122AS001"},
{"descripcion":"{ Prueba-001 } Tablero de prueba de plan, ignorar correos"},
{"descripcion":"{ AGA-PE-OF-TS02-02 } TDF y A - Pañol de ropa-1-1-D011"},
{"descripcion":"{ AGA-SU-9000 } Transpaleta 1122PÑ001"},
{"descripcion":"{ AGA-PP-CS-TS02-13 } Tablero de Alubrado-Bodega-Cocina-Lavado (Bodega Casino)"},
{"descripcion":"{ AGA-0249 } BOMBA MEZCLA AGUA POZO"},
{"descripcion":"{ AGA-1250 } BOMBA MEZCLA AGUA BLANDA"},
{"descripcion":"{ AGA-1251 } BOMBA MEZCLA AGUA POTABLE"},
{"descripcion":"{ AGA-1252 } SISTEMA RED HUMEDA CONTRA INCEDIO"},
{"descripcion":"{ AGA-PE-PA-TS06-00 } Tablero de Fuerza de Mezcla (Conteneder de Bombas de Mezcla)"},
{"descripcion":"{ AGA-PE-PA-TS06-01 } Tablero de Control de Mezcla (Conteneder de Bombas de Mezcla)"},
{"descripcion":"{ AGA-PE-PA-TS06-02 } Tablero de Fuerza y control de Bomba (Conteneder de Bombas de Mezcla)"},
{"descripcion":"{ AGA-PE-PA-TS06-03 } Tablero de Fuerza y control de Bomba de Casino (Conteneder de Bombas de Mezcla)"},
{"descripcion":"{ AGA-PE-PA-TS06-04 } Tablero de Fuerza y control de ventilacion de Pollo Vivo (Conteneder de Bombas de Mezcla)"},
{"descripcion":"{ AGA-PP-DP-TS05-00 } Tablero de Cortina de despacho (Sala de Despacho)"},
{"descripcion":"{ AGA-PP-DP-TS05-01 } Tablero de Visualizadores de temperatura (Sala de Despacho)"},
{"descripcion":"{ AGA-PP-DP-TS05-02 } Tablero de Visualizadores de CAmara N 9A (Sala de Despacho)"},
{"descripcion":"{ AGA-PP-DP-TS05-03 } Tablero de Resistencia de camara N 9 (Sala de Despacho)"},
{"descripcion":"{ AGA-PP-DP-TS05-04 } Tablero de Caseta de despacho (Sala de Despacho)"},
{"descripcion":"{ AGA-PP-DP-TS05-08 } Tablero de General de cortina despacho y otros (Sala de Despacho)"},
{"descripcion":"{ AGA-PP-DP-TS05-09 } Tablero de Luminaria de exterior despacho y otros (Sala de Despacho)"},
{"descripcion":"{ AGA-PP-DP-TS05-10 } Tablero de Cargador de Transpaletas (Sala de Despacho)"},
{"descripcion":"{ AGA-PP-DP-TS05-11 } Tablero de Controlador de Temperatura Analogico de camara 9-C (Sala de Despacho)"},
{"descripcion":"{ AGA-PP-DP-TS05-12 } Tablero de Enchufe Trifasico a la entrada de Camara 21-C (Sala de Despacho)"},
{"descripcion":"{ AGA-PP-DP-TS05-13 } Tablero de Controlador de Temperatura analogico de Tunel N 4 (Sala de Despacho)"},
{"descripcion":"{ AGA-PP-DP-TS05-14 } Tablero de Interruptores de luminarias de Despacho (Sala de Despacho)"},
{"descripcion":"{ AGA-PP-DP-TS05-15 } Tablero de Frente a puerta de Camara 21A (Pasillo Despacho)"},
{"descripcion":"{ AGA-PP-DP-TS05-16 } Tablero de Visualizador de Temperatura Tunel N 4 (Pasillo Despacho)"},
{"descripcion":"{ AGA-PP-DP-TS05-17 } Tablero de Visualizador de Temperatura Tunel N 3 (Pasillo Despacho)"},
{"descripcion":"{ AGA-PP-DP-TS05-18 } Tablero de Visualizador de Temperatura Tunel N 1 (Pasillo Despacho)"},
{"descripcion":"{ AGA-PP-DP-TS05-19 } Tablero de Termoestato Tunel N 1 (Pasillo Despacho)"},
{"descripcion":"{ AGA-PP-DP-TS05-20 } Tablero de Resistencia de Tunel N 1 (Pasillo Despacho)"},
{"descripcion":"{ AGA-PP-DP-TS05-21 } Tablero de Visualizador de Temperatura Tunel N 2 (Pasillo Despacho)"},
{"descripcion":"{ AGA-PP-DP-TS05-22 } Tablero de Termoestato Tunel N 2 (Pasillo Despacho)"},
{"descripcion":"{ AGA-PP-DP-TS05-23 } Tablero de Resistencia de Tunel N 2 (Pasillo Despacho)"},
{"descripcion":"{ AGA-PE-OF-TS11-05 } Tablero de Fuerza de oficinas ex sala de capacitaciones (Ex sala de capacitaciones)"},
{"descripcion":"{ AGA-PE-OF-TS10-01 } Tablero de Fuerza y luminarias de Enchufes N 1 Taller (Tornillo perforador) (Taller de Mantencion)"},
{"descripcion":"{ AGA-PE-OF-TS10-02 } Tablero de Fuerza y luminarias de Enchufes N 2 Taller (Mezon ElÃ©ctrico) (Taller de Mantencion)"},
{"descripcion":"{ AGA-PE-OF-TS10-03 } Tablero de Fuerza y luminarias de Pruebas en taller (Taller de Mantencion)"},
{"descripcion":"{ AGA-PE-OF-TS10-04 } Tablero de Fuerza y luminaria general del Taller (Sobre oficinas) (Taller de Mantencion)"},
{"descripcion":"{ AGA-PE-OF-TS10-07 } Tablero de Oficina de Jefe de Mantencion (Taller de Mantencion)"},
{"descripcion":"{ AGA-PE-OF-TS10-09 } Tablero de Camarines Taller de Mantencion (Taller de Mantencion)"},
{"descripcion":"{ AGA-PE-PO-TS10-05 } Tablero de Fuerza y luminaria de caseta de guardia (Interior) (Caseta Guardia Victor Ocho)"},
{"descripcion":"{ AGA-PE-PO-TS10-06 } Tablero de Fuerza y luminaria de caseta de guardia (Exterior) (Caseta Guardia Victor Ocho)"},
{"descripcion":"{ AGA-PE-PO-TS10-08 } Tablero de Bomba de agua de Baños Mantencion (Bajo Caseta Guardia Victor Ocho)"},
{"descripcion":"{ AGA-PE-PA-TS09-13 } Tablero de Enchufes detrAs de oficina de SSGG (Oficina SSGG e Infraestructura)"},
{"descripcion":"{ AGA-PE-OF-TS02-16 } TDF - Empaque menudencias-1-1-D022"},
{"descripcion":"{ AGA-0246 } BOMBA TRANSVASIJE DE POZO"},
{"descripcion":"{ AGA-0247 } BOMBA TRASVASIJE ESTANQUE N 1 BLANDA - LECHEROS"},
{"descripcion":"{ AGA-0248 } BOMBA ESTANQUE AGUA POZO"},
{"descripcion":"{ AGA-PE-PA-TS01-00 } TDA y F - Recursos humanos-1-1-D001"},
{"descripcion":"{ AGA-PE-PA-TS01-01 } TDF - Carga de transpaletas-1-1-D001-S001"},
{"descripcion":"{ AGA-PE-PA-TS01-02 } TDF - N 1 Contenedor-1-1-D001-S002"},
{"descripcion":"{ AGA-PE-PA-TS01-03 } TDF - N 2 Contenedor-1-1-D001-S003"},
{"descripcion":"{ AGA-PE-PA-TS01-04 } TDF - N 3 Contenedor-1-1-D001-S004"},
{"descripcion":"{ AGA-PE-PA-TS01-05 } TDF - N 4 Contenedor-1-1-D001-S005"},
{"descripcion":"{ AGA-PE-PA-TS01-06 } TDF - N 5 Contenedor-1-1-D001-S006"},
{"descripcion":"{ AGA-PE-PA-TS01-10 } TDF - Enchufes reefer-1-1-D001-S010"},
{"descripcion":"{ AGA-PE-PA-TS01-11 } TDF - Enchufes reefer-1-1-D001-S011"},
{"descripcion":"{ AGA-PE-PA-TS01-12 } TDF - Alimentacion santa maria-3-D002"},
{"descripcion":"{ AGA-PE-PA-TS01-13 } TDF - Medidor santa maria-3-D002-S001"},
{"descripcion":"{ AGA-PE-PA-TS01-33 } TDF - Cargador de transpaletas-1-1-D001-S012"},
{"descripcion":"{ AGA-PE-PA-TS01-34 } Tablero de Andenes de Despacho (Patio Santa MarÃ­a)"},
{"descripcion":"{ AGA-PE-PA-TS01-35 } TDF y C - Reefer cAmara 21 -2-3-D009"},
{"descripcion":"{ AGA-PE-PA-TS06-05 } Tablero de Fuerza y control de bomba USA (Sector Lecheros)"},
{"descripcion":"{ AGA-PE-PA-TS06-06 } Tablero de Fuerza y control de Peracetico (Sala de Peracetico)"},
{"descripcion":"{ AGA-PE-PA-TS06-07 } Tablero de Fuerza y control inoperativo en sector de Peracetico (Sala de Peracetico)"},
{"descripcion":"{ AGA-PE-PA-TS06-08 } Tablero de Fuerza y control de viejo sistema de peracetico y luminarias (Sala de Peracetico)"},
{"descripcion":"{ AGA-PE-PA-TS06-09 } Tablero de Fuerza y control de zona estanque peracetico y higienizadores (Sala de Peracetico)"},
{"descripcion":"{ AGA-PE-PA-TS06-10 } Tablero de Fuerza y control de Gas (Sala de Peracetico)"},
{"descripcion":"{ AGA-PE-PA-TS07-01 } Tablero de Control Camara 21 C o 9 C (Costado Contenedor)"},
{"descripcion":"{ AGA-PE-PA-TS09-14 } Tablero de Luminaria y fuerza de bomba petroleo (Bodega de bines detrAs de planta de riles)"},
{"descripcion":"{ AGA-1260 } PLANTA DE TRATAMIENTO"},
{"descripcion":"{ AGA-SU-PT-TS08-01 } Tablero de General de Osmoflow (Planta de Riles)"},
{"descripcion":"{ AGA-SU-PT-TS08-02 } Tablero de Decanter (Planta de Riles)"},
{"descripcion":"{ AGA-SU-PT-TS08-03 } Tablero de Dosificador de polimeros (Planta de Riles)"},
{"descripcion":"{ AGA-SU-PT-TS08-04 } Tablero de Control PH de tratamiento (Planta de Riles)"},
{"descripcion":"{ AGA-SU-PT-TS08-16 } Tablero de Bombas SPL4 de Planta de Tratamiento (Planta de Riles)"},
{"descripcion":"{ AGA-SU-0021 } Decanter"},
{"descripcion":"{ AGA-SU-BB-TS01-29 } Tablero de General red de Incendio (Pozo de Red contra Incendios)"},
{"descripcion":"{ AGA-SU-BB-TS01-30 } Tablero de Control Red incendio (Pozo de Red contra Incendios)"},
{"descripcion":"{ AGA-0207 } COMPRESOR MYCOM 160"},
{"descripcion":"{ AGA-0208 } COMPRESOR MYCOM 200"},
{"descripcion":"{ AGA-0209 } COMPRESOR FRICK 222"},
{"descripcion":"{ AGA-0210 } COMPRESOR GRAM GSV 111"},
{"descripcion":"{ AGA-0211 } COMPRESOR FRICK VIPER 399"},
{"descripcion":"{ AGA-0212 } COMPRESOR ALTERNATIVO 6 B"},
{"descripcion":"{ AGA-0214 } UNIDAD CONDENSADORA CAMARA N 21 A"},
{"descripcion":"{ AGA-0216 } UNIDAD CONDENSADORA CAMARA N 21 C o 9C"},
{"descripcion":"{ AGA-0222 } COMPRESOR ALTERNATIVO 6 BM"},
{"descripcion":"{ AGA-0234 } TUNEL N 4"},
{"descripcion":"{ AGA-0236 } ENFRIADOR DE AGUA PLACA BUCO"},
{"descripcion":"{ AGA-0237 } SISTEMA ABLANDADORES AGUA SADEMA"},
{"descripcion":"{ AGA-1228 } RECIRCULADOR NH3 1 (1000 LTS)"},
{"descripcion":"{ AGA-1229 } RECIRCULADOR NH3 2 (2000 LTS)"},
{"descripcion":"{ AGA-1230 } RECIRCULADOR NH3 3 (5200 LTS)"},
{"descripcion":"{ AGA-1231 } RECIRCULADOR NH3 4 (6200 LTS)"},
{"descripcion":"{ AGA-1232 } TORRE DE ENFRIAMIENTO VIPER"},
{"descripcion":"{ AGA-1233 } TUNEL N 3"},
{"descripcion":"{ AGA-1234 } RECIBIDOR DE LIQUIDO 5.000Kg"},
{"descripcion":"{ AGA-1257 } RED DE GLICOL"},
{"descripcion":"{ AGA-1258 } RED DE NH3 (AMONIACO)"},
{"descripcion":"{ AGA-1270 } PURGADOR ELECTRONICO"},
{"descripcion":"{ AGA-SU-SA-TS07-02 } Tablero de Bomba Santa MarÃ­a (1 Piso Sadema, Costado Santa MarÃ­a)"},
{"descripcion":"{ AGA-SU-SA-TS07-03 } Tablero de General Camara N 9 y Otros (Frente a Oficinas)"},
{"descripcion":"{ AGA-SU-SA-TS07-04 } Tablero de CamarA 9A (Frente a Oficinas)"},
{"descripcion":"{ AGA-SU-SA-TS07-05 } Tablero de Tablero de Pruebas de Taller Suministros (Taller Suministros)"},
{"descripcion":"{ AGA-SU-SA-TS07-06 } Tablero de Fuerza Camara 21 A (Costado Colo-Colo)"},
{"descripcion":"{ AGA-SU-SA-TS07-07 } Tablero de Fuerza Alumbrado SADEMA (Costado Colo-Colo)"},
{"descripcion":"{ AGA-SU-SA-TS07-08 } Tablero de Adicional de 399 (1 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-09 } Tablero de Frick 399 (1 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-10 } Tablero de Fuerza de camaras alumbrado (1 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-11 } Tablero de Iluminacion y Camara (1 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-12 } Tablero de Fuerza de tuneles y Compresor (1 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-13 } Tablero de Fuerza de Compresor Frick 2 399 (1 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-14 } Tablero de General de Fuerza de Subestacion 2000 KVA (1 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-15 } Tablero de Fuerza de emergerncia de Refeer (1 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-16 } Tablero de Fuerza de compresor 220 KW (1 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-17 } Tablero de Fuerza de Chiller de Aire (1 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-18 } Tablero de Fuerza de Tuneles (1 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-19 } Tablero de Fuerza de IQF (1 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-20 } Tablero de Partidor suave Mycom 160 (1 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-21 } Tablero de Fuerza de Ventiladores Frick 2 (1 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-22 } Tablero de General de fuerza de Compresores (1 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-23 } Tablero de Fuerza de Bomba de Glicol (1 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-24 } Tablero de Fuerza de Bombas de Agua FrÃ­a (1 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-25 } Tablero de Fuerza alimentancion SADEMA (1 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-26 } Tablero de Fuerza MADEF y Torre Viper (1 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-27 } Tablero de Fuerza Bomba de Agua Blanda (1 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-28 } Tablero de Chiller de Agua (1 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-29 } Tablero de Amoniaco (1 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-46 } Tablero de Fotocelda costado santa marÃ­a (1 Piso Sadema, Costado Santa MarÃ­a)"},
{"descripcion":"{ AGA-SU-SA-TS07-49 } Tablero de Apoyo Fuerza MADEF y Torre Viper (1 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-50 } Tablero de Presencia de tension en Ablandadores (1 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-51 } Tablero de Fuerza Panico (Taller Suministros)"},
{"descripcion":"{ AGA-SU-SA-TS07-52 } Tablero de Dosificador de Productor QuÃ­micos de Condensador (1 Piso Sadema)"},
{"descripcion":"{ AGA-PP-DP-TS05-24 } Resistencia de Turnel N 3"},
{"descripcion":"{ AGA-0213 } UNIDAD CONDENSADORA CAMARA N 21"},
{"descripcion":"{ AGA-0215 } UNIDAD CONDENSADORA CAMARA N 21 B o 9B"},
{"descripcion":"{ AGA-0217 } CAMARA N 9"},
{"descripcion":"{ AGA-0218 } CAMARA N 9 A"},
{"descripcion":"{ AGA-0219 } UNIDAD CONDENSADORA DESPACHO"},
{"descripcion":"{ AGA-0220 } UNIDAD CONDENSADORA EMPAQUE"},
{"descripcion":"{ AGA-0221 } UNIDAD CONDENSADORA PASILLO CONGELADO"},
{"descripcion":"{ AGA-1223 } CONDENSADOR FRICK"},
{"descripcion":"{ AGA-1224 } CONDENSADOR EVAPORATIVO GUNTNER 1"},
{"descripcion":"{ AGA-1261 } SISTEMA DETENCION DE INCENDIO"},
{"descripcion":"{ AGA-1269 } CONDENSADOR EVAPORATIVO GUNTNER 2"},
{"descripcion":"{ AGA-SU-SA-TS07-30 } Tablero de Fuerza Transferencia (2 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-31 } Tablero de General control de MAquinas de hielo PLC frÃ­o Sadema (2 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-32 } Tablero de General Furza y Control de MAquinas de Hielo N 1, 2, 3 y 4 (2 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-33 } Tablero de General Fuerza y control compresor FRICK 222 200 KW (2 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-34 } Tablero de General Fuerza y Control Compresor GRAM 111 200 KW (2 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-35 } Tablero de Tablero condensador SE-3 (2 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-36 } Tablero de Fuerza y Control Tuneles Frio 1-2 (2 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-37 } Tablero de Fuerza y Control compresor 6B y 6BM (2 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-38 } Tablero de Fuerza Calefactores Tuneles y camara (2 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-39 } Tablero de Fuerza Pasillo Congelado Precamara (2 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-40 } Tablero de Fuerza Alumbrado Camaras (2 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-41 } Tablero de Fuerza Despacho Evaporador (2 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-42 } Tablero de Fuerza Camara 21 (2 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-43 } Tablero de Control Camara 21 Adicionales (2 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-44 } Tablero de Fuerza y Control Empaque Fresco Ventiladores (2 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-45 } Tablero de Fuerza Ventiladores Sector Empaque (2 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-47 } Tablero de Camara 9 Direccion Santa MarÃ­a (2 Piso Sadema, Costado Santa MarÃ­a)"},
{"descripcion":"{ AGA-SU-SA-TS07-48 } Tablero de Camara 9 Direccion Taller SADEMA (2 Piso Sadema, Costado Santa MarÃ­a)"},
{"descripcion":"{ AGA-SU-SA-TS07-53 } Tablero de Apoyo a 21C (2 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-54 } Tablero de Interruptores de Swicth de Internet (2 Piso Sadema)"},
{"descripcion":"{ AGA-SU-SA-TS07-55 } Tablero de Tablero de cAmaras de Vigilacia (2 Piso Sadema)"},
{"descripcion":"{ AGA-1100 } LÃNEA TRANSPORTE AEREA CAJAS"},
{"descripcion":"{ AGA-1101 } ARMADORA CAJA PRIMER PISO"},
{"descripcion":"{ AGA-518 } SELLADORA DE PIE N 1-2-3 EMPAQUE"},
{"descripcion":"{ AGA-SU-9001 } Transpaleta 1122CA001"},
{"descripcion":"{ AGA-SU-9002 } Transpaleta 1122CA002"},
{"descripcion":"{ AGA-SU-AC-TS02-15 } TDF y A - Oficina calidad-1-1-D021"},
{"descripcion":"{ AGA-SU-AC-TS11-01 } Tablero de Enchufes de bodega de cajas (Bodega de cajas primer piso)"},
{"descripcion":"{ AGA-SU-AC-TS11-02 } Tablero de General de distribucion de fuerza y luminarias (Bodega de cajas primer piso)"},
{"descripcion":"{ AGA-SU-AC-TS11-03 } Tablero de Conexion de armadora de cajas primer piso (Bodega de cajas primer piso)"},
{"descripcion":"{ AGA-SU-AC-TS11-04 } Tablero de Iluminacion y enchufes de pañol (Bodega de cajas primer piso)"},
{"descripcion":"{ AGA-0238 } CALDERA ESCOCESA"},
{"descripcion":"{ AGA-0239 } CALDERA FIMACO"},
{"descripcion":"{ AGA-0240 } RED DE VAPOR"},
{"descripcion":"{ AGA-SU-CA-TS09-10 } Tablero de Fuerza general de Calderas (Sala de Calderas)"},
{"descripcion":"{ AGA-SU-CA-TS09-11 } Tablero de Fuerza de caldera Escocesa (Sala de Calderas)"},
{"descripcion":"{ AGA-SU-CA-TS09-12 } Tablero de Fuerza de caldera Fimaco (Sala de Calderas)"},
{"descripcion":"{ AGA-PE-OF-TS02-14 } Tablero de General de Fuerza y Auxiliar armado de cajas (Oficina Jefe Calidad)"},
{"descripcion":"{ AGA-0235 } BOMBA AGUA BLANDA N 1"},
{"descripcion":"{ AGA-1253 } RED DE AGUA BLANDA"},
{"descripcion":"{ AGA-1254 } RED DE PERACETICO"},
{"descripcion":"{ AGA-1255 } RED DE AGUA POZO"},
{"descripcion":"{ AGA-1256 } RED DE AGUA POTABLE"},
{"descripcion":"{ AGA-1259 } SISTEMA DETENCION DE AMONIACO"},
{"descripcion":"{ AGA-319 } BOMBA BY-PASS PLUMAS/TRIPAS (TRIPAS VIEJA)"},
{"descripcion":"{ AGA-BB-0002 } Bomba de Alta Presion (By-pass)"},
{"descripcion":"{ AGA-BB-0005 } Bomba de VacÃ­o N 1 (Lado Camiones de Agua)"},
{"descripcion":"{ AGA-SU-0010 } Bomba de Alta N 1"},
{"descripcion":"{ AGA-SU-0011 } Bomba de Alta N 2"},
{"descripcion":"{ AGA-SU-0012 } Sensor de cloro de red de proceso"},
{"descripcion":"{ AGA-SU-BB-TS01-19 } Tablero de General de Bombas (Sala de Bombas)"},
{"descripcion":"{ AGA-SU-BB-TS01-20 } Tablero de Fuerza de Bombas (Sala de Bombas)"},
{"descripcion":"{ AGA-SU-BB-TS01-21 } Tablero de Control en sala de Bombas (Sala de Bombas)"},
{"descripcion":"{ AGA-SU-BB-TS01-22 } Tablero de Fuerza y control de sala de Bombas (Sala de Bombas)"},
{"descripcion":"{ AGA-SU-BB-TS01-23 } Tablero de Control y visualizacion (Sala de Bombas)"},
{"descripcion":"{ AGA-SU-BB-TS01-24 } TDF - Area bombas-1-1-D003-S005"},
{"descripcion":"{ AGA-SU-BB-TS01-25 } Tablero de Fuerza compresores (Sala de Bombas)"},
{"descripcion":"{ AGA-SU-BB-TS01-26 } Tablero de Control Bombas de cloro (Sala de Bombas)"},
{"descripcion":"{ AGA-SU-BB-TS01-27 } Tablero de Control Analizador de cloro (Sala de Bombas)"},
{"descripcion":"{ AGA-SU-BB-TS01-28 } Tablero de Control conductividad cloruros (Sala de Bombas)"},
{"descripcion":"{ AGA-SU-BB-TS01-31 } Tablero de Fuerza Bomba de Pozo N 1 (Sala de Bombas (DetrAs de Casino))"},
{"descripcion":"{ AGA-SU-BB-TS01-32 } Tablero de Fuerza Bomba de Pozo N 2 (Sala de Bombas (DetrAs de Casino))"},
{"descripcion":"{ AGA-3001 } Descolgador de Pollos de Eviscerado AutomAtico"},
{"descripcion":"{ AGA-3002 } Descolgador de Pollos de Eviscerado Manual"},
{"descripcion":"{ AGA-328 } CHILLER MENUDENCIA N 1 (COGOTES)"},
{"descripcion":"{ AGA-329 } CHILLER MENUDENCIA N 2 (CONTRE)"},
{"descripcion":"{ AGA-330 } CHILLER MENUDENCIA N 3 (PANAS)"},
{"descripcion":"{ AGA-400 } Cinta cope (Grupo N 5)"},
{"descripcion":"{ AGA-401 } CHILLER AGUA POLLO N 1"},
{"descripcion":"{ AGA-402 } Cinta de traspaso del 1 al 2 (Grupo N 4)"},
{"descripcion":"{ AGA-403 } CHILLER AGUA POLLO N 2"},
{"descripcion":"{ AGA-404 } Cinta de traspaso del 2 al 3 (Grupo N 4)"},
{"descripcion":"{ AGA-405 } CHILLER AGUA POLLO N 3 MEYN"},
{"descripcion":"{ AGA-406 } Cinta de traspaso del 3 al 4 (Grupo N 4)"},
{"descripcion":"{ AGA-407 } CHILLER AGUA POLLO N 4 (LINCO)"},
{"descripcion":"{ AGA-408 } Cinta de traspaso del 4 al 5 (Grupo N 4)"},
{"descripcion":"{ AGA-409 } CHILLER AGUA POLLO N 5 (LINCO)"},
{"descripcion":"{ AGA-410 } SECADOR SALIDA CHILLER N 5"},
{"descripcion":"{ AGA-411 } Cinta de salida de secador chiller 5 (Grupo N 4)"},
{"descripcion":"{ AGA-412 } Cinta de colgado Chiller de aire (Grupo N 4)"},
{"descripcion":"{ AGA-413 } LÃNEA CHILLER AIRE"},
{"descripcion":"{ AGA-414 } BOMBA 1 RETORNO AGUA CHILLER 1-2"},
{"descripcion":"{ AGA-415 } BOMBA 2 RETORNO AGUA CHILLER 2-3"},
{"descripcion":"{ AGA-416 } BOMBA 3 RETORNO AGUA CHILLER 3-4"},
{"descripcion":"{ AGA-AP-CH-0020 } Mesa de Repaso de Necropsia para Garras"},
{"descripcion":"{ AGA-CH-0010 } Cinta de descolgado desde Eviscerado (Grupo N 5)"},
{"descripcion":"{ AGA-CH-0021 } Cinta bypass Cope (Grupo N 5)"},
{"descripcion":"{ AGA-CH-9001 } Transpaleta 1122CH001"},
{"descripcion":"{ AGA-CH-E001 } Extractor de aire de Sala de Chiller de Agua N 1 (Segun orden de proximidad a la entrada a la sala)"},
{"descripcion":"{ AGA-CH-E002 } Extractor de Aire de Sala de Chiller de Agua N 2 (Segun orden de proximidad a la entrada a la sala)"},
{"descripcion":"{ AGA-CH-I001 } Inyector de Aire de Sala de Chiller de Agua N 1 (Segun orden de proximidad a la entrada a la sala)"},
{"descripcion":"{ AGA-CH-I002 } Inyector de Aire de Sala de Chiller de Agua N 2 (Segun orden de proximidad a la entrada a la sala)"},
{"descripcion":"{ AGA-GP-0035 } Chiller de Muñones"},
{"descripcion":"{ AGA-M-CH-M001 } Mezclador de Vapor N 1 de Chiller de agua (Lado Descolgador de Pollo)"},
{"descripcion":"{ AGA-M-CH-M002 } Mezclador de Vapor N 2 de Chiller de agua (Lado Entrada de sala desde Empaque)"},
{"descripcion":"{ AGA-PP-CH-TS04-13 } Tablero de Pantalla de Control chiller de agua (Sala de Chiller de agua)"},
{"descripcion":"{ AGA-PP-CH-TS04-14 } Tablero de Botoneras de cintas de chiller de agua (Sala de Chiller de agua)"},
{"descripcion":"{ AGA-PP-CH-TS04-15 } Tablero de Dosificador de cloro (Sala de Chiller de agua)"},
{"descripcion":"{ AGA-PP-CH-TS04-16 } Tablero de Control peracetico (Sala de Chiller de agua)"},
{"descripcion":"{ AGA-PP-CH-TS04-17 } Tablero de Enchufes de Sala de Chillers (Sala de Chiller de agua)"},
{"descripcion":"{ AGA-PP-CH-TS04-18 } Tablero de Control de hielo (Sala de Chiller de agua)"},
{"descripcion":"{ AGA-M-CH-M003 } Mezclador de Vapor de Chiller de Aire"},
{"descripcion":"{ AGA-0202 } COMPRESOR DE AIRE L45"},
{"descripcion":"{ AGA-0203 } COMPRESOR AIRE ATLAS COPCO"},
{"descripcion":"{ AGA-DP-9001 } Transpaleta 1122DP001"},
{"descripcion":"{ AGA-DP-9002 } Transpaleta 1122DP002"},
{"descripcion":"{ AGA-DP-9003 } Transpaleta 1122DP003"},
{"descripcion":"{ AGA-DP-9004 } Transpaleta 1024DP001"},
{"descripcion":"{ AGA-920 } ENZUNCHADORA N 1 CONGELADO"},
{"descripcion":"{ AGA-9203 } ENZUNCHADORA N 2 CONGELADO"},
{"descripcion":"{ AGA-921 } DETECTOR DE METALES CONGELADO 1"},
{"descripcion":"{ AGA-EC-9001 } Transpaleta 0823EC001"},
{"descripcion":"{ AGA-PP-EC-TS05-05 } Tablero de Enchufes de empaque congelado (Sala de Empaque Congelado)"},
{"descripcion":"{ AGA-PP-EC-TS05-06 } Tablero de Enchufes de enzunchadora de empaque congelado (Sala de Empaque Congelado)"},
{"descripcion":"{ AGA-503 } LÃNEA EMPAQUE N 1"},
{"descripcion":"{ AGA-5031 } LÃNEA EMPAQUE N 2"},
{"descripcion":"{ AGA-504 } Cinta de descarga chiller de aire (Grupo N 4)"},
{"descripcion":"{ AGA-505 } Cinta de colgado N 1 de Pollo Entero (Grupo N 4)"},
{"descripcion":"{ AGA-506 } CALIBRADORA N 1"},
{"descripcion":"{ AGA-507 } Cinta de Entrada a Inyectora de Pollo Entero (Grupo N 4)"},
{"descripcion":"{ AGA-508 } INYECTORA FOMACO POLLO ENTERO (Grupo N 4)"},
{"descripcion":"{ AGA-509 } Superchill Pollo Entero"},
{"descripcion":"{ AGA-510 } Cinta Ascendente Salida de Fomaco Pollo Entero (Entrada Secador Fomaco) (Grupo N 4)"},
{"descripcion":"{ AGA-511 } SECADOR FOMACO EMPAQUE"},
{"descripcion":"{ AGA-512 } DETECTOR METAL EMPAQUE POLLO ENTERO"},
{"descripcion":"{ AGA-513 } Cinta de colgado N 2 de Pollo Entero (Grupo N 4)"},
{"descripcion":"{ AGA-514 } CALIBRADORA N 2"},
{"descripcion":"{ AGA-515 } CALIBRADORA PESAJE M3000"},
{"descripcion":"{ AGA-516 } CLIPEADORAS"},
{"descripcion":"{ AGA-517 } Cinta de Empaque de Pollo Entero (Producto Clipeado) (Grupo N 3)"},
{"descripcion":"{ AGA-519 } Cinta de Cajas VacÃ­as desde Techo (Grupo N 3)"},
{"descripcion":"{ AGA-520 } Cinta Curva de Armado de Cajas (Grupo N 3)"},
{"descripcion":"{ AGA-521 } Cinta de cajas vacÃ­as Pollo Entero (Grupo N 3)"},
{"descripcion":"{ AGA-523 } Cinta de cajas llenas desde Pollo Entero (Grupo N 3)"},
{"descripcion":"{ AGA-524 } CINTA CAJAS PRODUCTO TERMINADO (AZUL CURVA)"},
{"descripcion":"{ AGA-525 } Cinta de Pesaje Polypack Lado Pared (Grupo N 1)"},
{"descripcion":"{ AGA-530 } EMBOLSADORA MENUDENCIAS"},
{"descripcion":"{ AGA-536 } BALANZA PESAMATIC ACS-3S/NEWSU-15 (N 74, Grupo B N 2)"},
{"descripcion":"{ AGA-EM-0070 } Cinta detector de Metales de Pollo Entero (Grupo N 4)"},
{"descripcion":"{ AGA-EM-9001 } Transpaleta 1122EM001"},
{"descripcion":"{ AGA-EM-9002 } Transpaleta 1122EM002"},
{"descripcion":"{ AGA-EM-9003 } Transpaleta 1122EM003"},
{"descripcion":"{ AGA-EM-9004 } Transpaleta 1122EM004"},
{"descripcion":"{ AGA-EM-9005 } Transpaleta 1024EM001"},
{"descripcion":"{ AGA-M-EM-M001 } Mezclador de Vapor de Empaque Pollo Entero"},
{"descripcion":"{ AGA-PP-EM-TS04-08 } Tablero de Enchufes de Emapque (Sala de Empaque (Pollo Entero))"},
{"descripcion":"{ AGA-PP-EM-TS04-09 } Tablero de Control botoneras de empaque (Sala de Empaque (Pollo Entero))"},
{"descripcion":"{ AGA-PP-EM-TS04-10 } Tablero de Secador de pollos (Sala de Empaque (Pollo Entero))"},
{"descripcion":"{ AGA-PP-EM-TS04-11 } Tablero de Fuerza detector de metales de empaque (Sala de Empaque (Pollo Entero))"},
{"descripcion":"{ AGA-PP-EM-TS04-12 } Tablero de Control detector de metales empaque (Sala de Empaque (Pollo Entero))"},
{"descripcion":"{ AGA-301 } LÃNEA DE EVISCERADO AUTOMATICO"},
{"descripcion":"{ AGA-302 } Cinta de descarga de cortador de patas prime (Grupo N 5)"},
{"descripcion":"{ AGA-303 } Cinta de colgado Eviscerado AutomAtico (Grupo N 5)"},
{"descripcion":"{ AGA-304 } Cinta de colgado eviscerado manual (Grupo N 5)"},
{"descripcion":"{ AGA-305 } CORTADOR DE GLANDULA"},
{"descripcion":"{ AGA-306 } ANERA"},
{"descripcion":"{ AGA-307 } ABRIDORA DE ABDOMEN"},
{"descripcion":"{ AGA-308 } EVISCERADOR MAESTRO"},
{"descripcion":"{ AGA-309 } LÃNEA DE EXPURGO N1"},
{"descripcion":"{ AGA-310 } BUCHERA"},
{"descripcion":"{ AGA-311 } QUEBRANTADORA COGOTES"},
{"descripcion":"{ AGA-312 } CORTADOR DE PIEL"},
{"descripcion":"{ AGA-313 } INSPECTOR FINAL (PULMONERA)"},
{"descripcion":"{ AGA-314 } PISTOLA PULMONERA N 1-2-3"},
{"descripcion":"{ AGA-315 } DUCHA DE POLLOS (DUCHA FINAL)"},
{"descripcion":"{ AGA-316 } BOMBA RETORNO DUCHA"},
{"descripcion":"{ AGA-317 } TIJERA COGOTE N 1-2"},
{"descripcion":"{ AGA-320 } BOMBA DE TRIPAS"},
{"descripcion":"{ AGA-321 } BOMBA MENUDO N 1 (COGOTES)"},
{"descripcion":"{ AGA-322 } BOMBA MENUDO N 2 (CORAZONES)"},
{"descripcion":"{ AGA-323 } BOMBA MENUDO N 3 (PANAS)"},
{"descripcion":"{ AGA-324 } BOMBA MENUDO N 4 (CONTRES)"},
{"descripcion":"{ AGA-325 } PELADOR CORAZONES"},
{"descripcion":"{ AGA-326 } PELADOR COGOTES"},
{"descripcion":"{ AGA-327 } PELADOR CONTRES"},
{"descripcion":"{ AGA-331 } PROCESADORA DE CONTRES"},
{"descripcion":"{ AGA-332 } LÃNEA DE EXPURGO N2"},
{"descripcion":"{ AGA-4121 } BALANZA PESAMATIC SERIE SS0621037 (N 108, Grupo B N 3)"},
{"descripcion":"{ AGA-EV-0001 } Triturador de Pollos (Moledor de Pollos)"},
{"descripcion":"{ AGA-EV-0054 } Tornillo Sinfin elevador de contres (Antes de mesa de repaso)"},
{"descripcion":"{ AGA-EV-0055 } Mesa de Repaso de Contres"},
{"descripcion":"{ AGA-EV-0056 } Cinta de seleccion de Contres (Grupo N 5)"},
{"descripcion":"{ AGA-EV-0080 } Ducha Tunel (Intermedia, antes de la Ducha Final)"},
{"descripcion":"{ AGA-EV-0081 } Filtro rotatrio de Ducha Tunel"},
{"descripcion":"{ AGA-EV-9001 } Transpaleta 1122EV001"},
{"descripcion":"{ AGA-EV-E001 } Extractor de aire sala Eviscerado N 1 (Segun orden de proximidad a la entrada a la sala)"},
{"descripcion":"{ AGA-EV-E002 } Extractor de Aire Sala Eviscerado N 2 (Segun orden de proximidad a la entrada a la sala)"},
{"descripcion":"{ AGA-EV-I001 } Inyector de Aire Sala Eviscerado N 1 (Segun orden de proximidad a la entrada a la sala)"},
{"descripcion":"{ AGA-EV-I002 } Inyector de Aire Sala Eviscerado N 2 (Segun orden de proximidad a la entrada a la sala)"},
{"descripcion":"{ AGA-FA-EV-TS04-19 } Tablero de Pantalla de control de Eviscerado AutomAtico (Sala de Eviscerado AutomAtico)"},
{"descripcion":"{ AGA-FA-EV-TS04-20 } Tablero de Control de botoneras de Eviscerado AutomAtico (Sala de Eviscerado AutomAtico)"},
{"descripcion":"{ AGA-FA-EV-TS04-21 } Tablero de Enchufes N 1 de Eviscerado AutomAtico (Sala de Eviscerado AutomAtico)"},
{"descripcion":"{ AGA-FA-EV-TS04-22 } Tablero de Enchufes N 2 de Eviscerado AutomAtico (Sala de Eviscerado AutomAtico)"},
{"descripcion":"{ AGA-FA-EV-TS04-23 } Tablero de Fuerza y control de procesadora de contres (Sala de Eviscerado AutomAtico)"},
{"descripcion":"{ AGA-M-DE-E001 } Extractor de Aire Sala Desplumado N 1 (Segun orden de proximidad a la entrada del pasillo del techo)"},
{"descripcion":"{ AGA-M-DE-E002 } Extractor de Aire Sala Desplumado N 2 (Segun orden de proximidad a la entrada del pasillo del techo)"},
{"descripcion":"{ AGA-M-DE-I001 } Inyector de Aire Sala Desplumado N 1 (Segun orden de proximidad a la entrada del pasillo del techo)"},
{"descripcion":"{ AGA-M-DE-I002 } Inyector de Aire Sala Desplumado N 2 (Segun orden de proximidad a la entrada del pasillo del techo)"},
{"descripcion":"{ AGA-M-EV-M001 } Mezclador de Vapor de Eviscerado"},
{"descripcion":"{ AGA-BB-0001 } Bomba de Alta Presion (Anera)"},
{"descripcion":"{ AGA-BB-0003 } Bomba de Alta Presion (Maestro)"},
{"descripcion":"{ AGA-333 } LÃNEA DE EVISCERADO MANUAL"},
{"descripcion":"{ AGA-EV-G010 } Cinta Elevadora de Eviscerdo Manual (Grupo N 5)"},
{"descripcion":"{ AGA-FA-EG-TS04-01 } Tablero de Control cintas (Botoneras) Sala de gallina (Sala de Eviscerado Manual)"},
{"descripcion":"{ } Cinta de Salida de Escaldadora de Garras, entrada Pelador de Garras (Grupo N 5)"},
{"descripcion":"{ AGA-210 } CORTADOR DE GARRA (MUÑON)"},
{"descripcion":"{ AGA-211 } BOTADOR DE GARRA"},
{"descripcion":"{ AGA-212 } ESCALDADORA GARRAS"},
{"descripcion":"{ AGA-213 } Cinta de Salida de Escaldadora de Muñones (Grupo N 5)"},
{"descripcion":"{ AGA-214 } PELADOR GARRAS"},
{"descripcion":"{ AGA-215 } Cinta de salida de escaldadora de Garras (Grupo N 5)"},
{"descripcion":"{ AGA-216 } Cinta de Salida de Peladora de Garras (Grupo N 5)"},
{"descripcion":"{ AGA-217 } CHILLER GARRAS"},
{"descripcion":"{ AGA-218 } Cinta seleccion de garras (Grupo N 5)"},
{"descripcion":"{ AGA-219 } EXTRACTOR AIRE GARRAS Y PATAS"},
{"descripcion":"{ AGA-220 } EXTRACTOR AIRE GARRAS Y PATAS"},
{"descripcion":"{ AGA-221 } ESCALDADORA DE MUÑONES"},
{"descripcion":"{ AGA-Fa-GP-TS04-06 } Tablero de Control cintas sala de Garras (Sala de Garras y Patas)"},
{"descripcion":"{ AGA-Fa-GP-TS04-07 } Tablero de Peladora de Garras (Sala de Garras y Patas)"},
{"descripcion":"{ AGA-GP-0010 } Limpiador de Necropsia"},
{"descripcion":"{ AGA-GP-0033 } Pelador de Muñones"},
{"descripcion":"{ AGA-GP-0034 } Cinta de Salida de Peladora de Muñones (Grupo N 5)"},
{"descripcion":"{ AGA-1227 } MAQUINA DE HIELO MADEF N 4"},
{"descripcion":"{ AGA-1265 } BALANZA METTLER TOLEDO IND236 100KG EMP. CONG. (N 79, Grupo B N 2)"},
{"descripcion":"{ AGA-1266 } MAQUINA DE HIELO GUNTNER 1"},
{"descripcion":"{ AGA-1267 } MAQUINA DE HIELO GUNTNER 2"},
{"descripcion":"{ AGA-1268 } MAQUINA DE HIELO COOLING FREEZING N 3"},
{"descripcion":"{ } BALANZA METTLER TOLEDO SW6KG LABORATORIO CALIDAD (N 12, Grupo B N 2)"},
{"descripcion":"{ AGA-BA-0000 } LÃ­nea de Transporte de Bandejas"},
{"descripcion":"{ AGA-BA-0010 } Lavadora de Bandejas"},
{"descripcion":"{ AGA-SU-9009 } Transpaleta 1122BA003"},
{"descripcion":"{ AGA-SU-BA-TS02-01 } Tablero de Control de Sala de Badenjas (Sala de Lavadora de Bandejas)"},
{"descripcion":"{ AGA-SU-9005 } Transpaleta 1122BN001"},
{"descripcion":"{ AGA-SU-9007 } Transpaleta 1122BA001"},
{"descripcion":"{ AGA-SU-9008 } Transpaleta 1122BA002"},
{"descripcion":"{ AGA-00-0001 } BOMBA GP-52 N 01"},
{"descripcion":"{ AGA-00-0002 } BOMBA GP-52 N 02"},
{"descripcion":"{ AGA-00-0003 } BOMBA GP-52 N 03"},
{"descripcion":"{ AGA-00-0004 } BOMBA GP-52 N 04"},
{"descripcion":"{ AGA-00-0005 } BOMBA GP-52 N 05"},
{"descripcion":"{ AGA-00-0006 } BOMBA GP-52 N 06"},
{"descripcion":"{ AGA-4565 } TUNEL N 1"},
{"descripcion":"{ AGA-4566 } TUNEL N 2"},
{"descripcion":"{ AGA-TU-9001 } Transpaleta 1122TU001"},
{"descripcion":"{ AGA-TU-9002 } Transpaleta 1122TU002"},
{"descripcion":"{ AGA-TU-9003 } Transpaleta 1122TU003"},
{"descripcion":"{ AGA-TU-9004 } Transpaleta 1122TU004"},
{"descripcion":"{ } Balanza (Sector Trabajo: Porcionado) (Rango Operativo = 3.0 - 60.0 Kg) (N 144, Grupo B N 3)"},
{"descripcion":"{ AGA-500 } SISTEMA PREPARACION SALMUERA"},
{"descripcion":"{ AGA-501 } RED DE SALMUERA EMPAQUE"},
{"descripcion":"{ AGA-502 } ESTANQUE ACUMULADOR N 1-2"},
{"descripcion":"{ AGA-638 } RED DE SALMUERA TROZADO"},
{"descripcion":"{ AGA-1000 } VOLTEADOR DE BINS PULPA"},
{"descripcion":"{ AGA-1001 } SINFÃN ELEVADOR PRODUCTO HACIA PULPERA"},
{"descripcion":"{ AGA-1002 } DETECTOR METAL PULPA"},
{"descripcion":"{ AGA-1003 } PULPERA"},
{"descripcion":"{ AGA-1004 } SINFÃN SALIDA PULPERA"},
{"descripcion":"{ AGA-1005 } CONGELADOR PLACAS N 1"},
{"descripcion":"{ AGA-1006 } CONGELADOR PLACAS N 2"},
{"descripcion":"{ AGA-1007 } CONGELADOR PLACAS N 3"},
{"descripcion":"{ AGA-PP-PU-TS03-24 } Tablero de Fuerza ventiladores y sinfÃ­n (Sala de Pulpa)"},
{"descripcion":"{ AGA-PP-PU-TS03-25 } Tablero de Fuerza bomba Pulpa (Sala de Pulpa)"},
{"descripcion":"{ AGA-PP-PU-TS03-26 } Tablero de PLC Congeladora de Placas (Sala de Pulpa)"},
{"descripcion":"{ AGA-PP-PU-TS03-27 } TDF - Cortina pulpa-1-1-D050"},
{"descripcion":"{ AGA-PP-PU-TS03-28 } Tablero de Fuerza cinta de detector de metales (Sala de Pulpa)"},
{"descripcion":"{ AGA-PP-PU-TS03-29 } Tablero de Detector de metales (Sala de Pulpa)"},
{"descripcion":"{ AGA-PP-PU-TS03-30 } Tablero de Control bomba pulpa (Sala de Pulpa)"},
{"descripcion":"{ AGA-PU-0001 } Cortina enrollable AutomAtica de Sala de Pulpa"},
{"descripcion":"{ AGA-PU-0030 } Cinta de detector de Metales de Pulpa (Grupo N 1)"},
{"descripcion":"{ AGA-PU-0041 } Tornillo de Pulpina"},
{"descripcion":"{ AGA-PU-0050 } Bomba Pulpera"},
{"descripcion":"{ AGA-PU-9001 } Transpaleta 1122PU001"},
{"descripcion":"{ AGA-PU-9002 } Transpaleta 1122PU002"},
{"descripcion":"{ AGA-PU-9003 } Transpaleta 1122PU003"},
{"descripcion":"{ AGA-PE-OF-TS02-03 } Tablero de General Santa MarÃ­a (Sala de Etiquetado)"},
{"descripcion":"{ AGA-PE-OF-TS02-04 } TDA - Sala etiquetado-1-1-D012-S001"},
{"descripcion":"{ AGA-PE-OF-TS02-05 } Tablero de Control de LÃ­nea de Chiller de Aire (Sala de Etiquetado)"},
{"descripcion":"{ AGA-PE-OF-TS02-06 } Tablero de Control de Cotadores (Sala de Etiquetado)"},
{"descripcion":"{ AGA-PE-OF-TS02-07 } Tablero de Control de Atontador Principal (Sala de Etiquetado)"},
{"descripcion":"{ AGA-PE-OF-TS02-08 } Tablero de Control Escaldadora de Garras (Sala de Etiquetado)"},
{"descripcion":"{ AGA-PE-OF-TS02-09 } Tablero de Control Atontador secuandario (Sala de Etiquetado)"},
{"descripcion":"{ AGA-PE-OF-TS02-10 } Tablero de Control Servidores (Sala de Etiquetado)"},
{"descripcion":"{ AGA-522 } Cinta de bajada desde sala IQF segundo piso (Grupo N 2)"},
{"descripcion":"{ AGA-526 } Cinta de Pesaje Polypack Pasillo (Grupo N 1)"},
{"descripcion":"{ AGA-527 } EMBOLSADORA POLYPACK N 1 (PARED, EMPAQUE)"},
{"descripcion":"{ AGA-528 } Cinta Paletizado Polypack Lado Pared (Grupo N 1)"},
{"descripcion":"{ AGA-529 } Cinta Paletizado Polypack Lado Pasillo (Grupo N 1)"},
{"descripcion":"{ AGA-531 } BALANZA METTLER TOLEDO IND236 ESTACION 1 (N 77, Grupo B N 1)"},
{"descripcion":"{ AGA-532 } BALANZA METTLER TOLEDO PHANTER ESTACION 2 (N 8, Grupo B N 1)"},
{"descripcion":"{ AGA-533 } BALANZA METTLER TOLEDO WILDCAT ESTACION 3 (N 54, Grupo B N 1)"},
{"descripcion":"{ AGA-534 } BALANZA METTLER TOLEDO WILDCAT ESTACION 4 (N 53, Grupo B N 1)"},
{"descripcion":"{ AGA-535 } BALANZA METTLER TOLEDO INGRESO DESPACHO (2000KG) (N 7, Grupo B N 1)"},
{"descripcion":"{ AGA-633 } SELLADORA DE BANDEJAS N 1-2-3-4 POLYPACK"},
{"descripcion":"{ AGA-634 } Cinta Puente (Grupo N 2)"},
{"descripcion":"{ AGA-635 } Cinta de Cajas llenas desde amado de Cajas (Grupo N 2)"},
{"descripcion":"{ AGA-636 } EMBOLSADORA POLYPACK N 2 (PASILLO, TROZADO)"},
{"descripcion":"{ AGA-PP-TE-TS03-21 } Tablero de Polypack N 1 (Sala de Termoencajado)"},
{"descripcion":"{ AGA-PP-TE-TS03-22 } Tablero de Polypack N 2 (Sala de Termoencajado)"},
{"descripcion":"{ AGA-TE-9001 } Transpaleta 1122PO001"},
{"descripcion":"{ AGA-TE-9002 } Transpaleta 1122PO002"},
{"descripcion":"{ AGA-TE-9003 } Transpaleta 1122PO003"},
{"descripcion":"{ AGA-TE-9004 } Transpaleta 1122PO004"},
{"descripcion":"{ AGA-TE-9005 } Transpaleta 1122PO005"},
{"descripcion":"{ AGA-1263 } SISTEMA TRANSPORTE DE HIELO"},
{"descripcion":"{ AGA-334 } BALANZA EXCEL QW SERIE A21303219 (N 109, Grupo B N 3)"},
{"descripcion":"{ AGA-600 } LÃNEA TROZADO AUTOMATICO"},
{"descripcion":"{ AGA-601 } Cinta de Colgado de Trozado (Grupo N 3)"},
{"descripcion":"{ AGA-602 } ESTIRADOR ALAS"},
{"descripcion":"{ AGA-603 } CORTADOR PUNTILLAS"},
{"descripcion":"{ AGA-604 } CORTADOR ALA MEDIA"},
{"descripcion":"{ AGA-605 } Cinta de Seleccion de Alas (Grupo N 3)"},
{"descripcion":"{ AGA-606 } CORTADOR ALA TRUTO"},
{"descripcion":"{ AGA-607 } Cinta de CaÃ­da de Alas (Grupo N 3)"},
{"descripcion":"{ AGA-609 } CORTADOR PECHUGA"},
{"descripcion":"{ AGA-610 } CORTADOR PUNTA LAPIZ"},
{"descripcion":"{ AGA-611 } CORTADOR COLA"},
{"descripcion":"{ AGA-612 } CORTADOR TRUTRO CUARTO"},
{"descripcion":"{ AGA-613 } PROCESADOR TRUTRO"},
{"descripcion":"{ AGA-614 } Cinta de Hueso (Cazuela) (Grupo N 3)"},
{"descripcion":"{ AGA-615 } CORTADOR TRUTRO CORTO O TRUTRO LARGO"},
{"descripcion":"{ AGA-616 } Cinta de CaÃ­da de Trutro (Grupo N 3)"},
{"descripcion":"{ AGA-617 } BOMBA DESAGUE TROZADO N 2 (LADO PAÑOL DE ROPA)"},
{"descripcion":"{ AGA-618 } BOMBA DESAGUE TROZADO N 1 (LADO PORTERIA)"},
{"descripcion":"{ AGA-619 } TROZADORA N 1-2-3"},
{"descripcion":"{ AGA-620 } Cinta Buffer de Inyectoras (Grupo N 3)"},
{"descripcion":"{ AGA-621 } Cinta puente de Inyectoras (By-Pass Inyectora Sur) (Grupo N 2)"},
{"descripcion":"{ AGA-622 } INYECTORA TROZADO SUR (N 2/698) (Grupo N 2)"},
{"descripcion":"{ AGA-623 } Superchill Inyectora Trozado (Inyectora 698, N 2, Sur)"},
{"descripcion":"{ AGA-624 } ZARANDA ENTRADA INYECTORA TROZADO SUR"},
{"descripcion":"{ AGA-625 } Cinta de Salida Inyectora Fomaco Sur (Grupo N 2)"},
{"descripcion":"{ AGA-626 } ZARANDA SALIDA INYECTORA TROZADO SUR"},
{"descripcion":"{ AGA-627 } INYECTORA TROZADO NORTE (N 1/421) (Grupo N 2)"},
{"descripcion":"{ AGA-628 } Superchill Inyectora Trozado (Inyectora 421, N 1, Norte)"},
{"descripcion":"{ AGA-629 } ZARANDA SALIDA INYECTORA TROZADO NORTE"},
{"descripcion":"{ AGA-630 } Cinta de llenado de Cajas Inyectora Norte (Grupo N 2)"},
{"descripcion":"{ AGA-631 } Cinta de Llenado de Cajas Inyectora Sur (Grupo N 2)"},
{"descripcion":"{ AGA-632 } DETECTOR METAL TROZADO"},
{"descripcion":"{ AGA-637 } Trozadora Manual (Lado Cortadoras de Alas)"},
{"descripcion":"{ AGA-639 } VOLTEADOR DE BINS TENDERIZADO"},
{"descripcion":"{ AGA-640 } VOLTEADOR DE BINS COLGADO TROZADO"},
{"descripcion":"{ AGA-641 } BALANZA METTLER TOLEDO BBA236-4B150 (N 96, Grupo B N 2)"},
{"descripcion":"{ AGA-642 } BALANZA WT-SS-30KG SERIE 1905061 G2295 (N 99, Grupo B N 3)"},
{"descripcion":"{ AGA-643 } BALANZA WT-SS-30KG SERIE 1905062 G2291 (N 100, Grupo B N 3)"},
{"descripcion":"{ AGA-644 } Balanza de 30 Kg (Sector Trabajo: Porcionado) (Rango Operativo = 0.1 - 0.6 Kg) (N 102, Grupo B N 3)"},
{"descripcion":"{ AGA-645 } Balanza de 60Kg (Sector Trabajo: Porcionado) (Rango Operativo = 12 - 31 Kg) (N 103, Grupo B N 3)"},
{"descripcion":"{ AGA-646 } BALANZA TRIUNFO BSS-3040 SERIE WXK21090558 (N 104, Grupo B N 3)"},
{"descripcion":"{ AGA-647 } BALANZA TRIUNFO BSS-3040 SERIE 19041302 (N 105, Grupo B N 3)"},
{"descripcion":"{ AGA-648 } BALANZA TRIUNFO BSS-3040 SERIE 19041308 (N 106, Grupo B N 3)"},
{"descripcion":"{ AGA-649 } BALANZA TRIUNFO BSS-3040 SERIE 19041301 (N 107, Grupo B N 3)"},
{"descripcion":"{ AGA-650 } BALANZA WT-SS-30KG SERIE 1905067 G2297 (N 101, Grupo B N 3)"},
{"descripcion":"{ AGA-CH-9009 } Transpaleta 1122GA001"},
{"descripcion":"{ AGA-DH-0011 } Trozadora Manual (Deshuesado)"},
{"descripcion":"{ AGA-IQ-9001 } Transpaleta 1122IQ001"},
{"descripcion":"{ AGA-M-TR-M001 } Mezclador de Vapor de Trozado AutomAtico"},
{"descripcion":"{ AGA-PE-TC-TS03-48 } TDF - Ventiladores bins-1-1-D065-S002"},
{"descripcion":"{ AGA-PE-TC-TS03-49 } Tablero de MAquinas IQF (Techo de Trozado)"},
{"descripcion":"{ AGA-PE-TC-TS03-50 } Tablero de Fuerza placas de Pulpa (Techo de Trozado)"},
{"descripcion":"{ AGA-PE-TC-TS03-51 } TDC - Congeladora de placas-1-1-D065-S005"},
{"descripcion":"{ AGA-PE-TC-TS03-52 } Tablero de Fuerza cintas de trozado (Techo de Trozado)"},
{"descripcion":"{ AGA-PE-TC-TS03-53 } Tablero de General IQF (Techo de Trozado)"},
{"descripcion":"{ AGA-PP-TE-TS03-03 } Tablero de Alimentancion de Estaciones Polypack (Sala de Trozado)"},
{"descripcion":"{ AGA-PP-TN-TS03-04 } Tablero de Fuerza tenderizado (Sala de Trozado)"},
{"descripcion":"{ AGA-PP-TN-TS03-05 } Tablero de Fuerza Zaranda Entrada Inyectora 1 (Sala de Trozado)"},
{"descripcion":"{ AGA-PP-TN-TS03-06 } Tablero de Fuerza zaranda y cintas tenderizado (Sala de Trozado)"},
{"descripcion":"{ AGA-PP-TR-TS03-01 } Tablero de PLC de cintas (Sala de Trozado)"},
{"descripcion":"{ AGA-PP-TR-TS03-02 } Tablero de Partida de LÃ­nea de Trozado automAtico (Sala de Trozado)"},
{"descripcion":"{ AGA-PP-TR-TS03-07 } Tablero de Volteador de Bins Colgado (Sala de Trozado)"},
{"descripcion":"{ AGA-PP-TR-TS03-08 } TDF - Sierras circulares-1-1-D031"},
{"descripcion":"{ AGA-S-AI-0030 } Secador de Aire de red de Trozado AutomAtico"},
{"descripcion":"{ AGA-TN-0030 } ZARANDA ENTRADA INYECTORA TROZADO NORTE"},
{"descripcion":"{ AGA-TR-0020 } Cinta de descarga de Levantador de Bins de Trozado (Grupo N 3)"},
{"descripcion":"{ AGA-TR-0081 } Cinta de Pechugas (Grupo N 3)"},
{"descripcion":"{ AGA-TR-0091 } Trozadora Manual (Lado Cortador Trutro Corto o Trutro Largo)"},
{"descripcion":"{ AGA-TR-0142 } Cinta de salida de Trutro (Llenado de Bins) (Grupo N 3)"},
{"descripcion":"{ AGA-TR-0150 } Botador de Trutros"},
{"descripcion":"{ AGA-TR-0152 } Trozadora Manual (Lado Botador de Trutros)"},
{"descripcion":"{ AGA-TR-9001 } Transpaleta 1122TR001"},
{"descripcion":"{ AGA-TR-9002 } Transpaleta 1122TR002"},
{"descripcion":"{ AGA-TR-9003 } Transpaleta 1122TR003"},
{"descripcion":"{ AGA-TR-9004 } Transpaleta 1122TR004"},
{"descripcion":"{ AGA-TR-9005 } Transpaleta 1122TR005"},
{"descripcion":"{ AGA-TR-9006 } Transpaleta 1122TR006"},
{"descripcion":"{ AGA-TR-9007 } Transpaleta 1122TE001"},
{"descripcion":"{ AGA-TR-9008 } Transpaleta 1122PE001"},
{"descripcion":"{ AGA-TR-9009 } Transpaleta 1122BI001"},
{"descripcion":"{ AGA-TR-9010 } Transpaleta 1122GA002"},
{"descripcion":"{ AGA-TR-9011 } Transpaleta 0823TR007"},
{"descripcion":"{ AGA-TR-9012 } Transpaleta 0823CA003"},
{"descripcion":"{ AGA-TR-9013 } Transpaleta 1122TR008"},
{"descripcion":"{ AGA-TR-9014 } Transpaleta 1122TR009"},
{"descripcion":"{ AGA-TR-9015 } Transpaleta con Balanza de Trozado N 1"},
{"descripcion":"{ AGA-TR-9016 } Transpaleta 1024TR001"},
{"descripcion":"{ AGA-TR-9017 } Transpaleta 1024TR002"},
{"descripcion":"{ AGA-TR-B008 } Balanza Pesamatic modelo AQUA-SS de 6 KG (N 122, Grupo B N 5)"},
{"descripcion":"{ AGA-TR-B009 } Balanza Pesamatic modelo AQUA-SS de 6 KG (N 121, Grupo B N 5)"},
{"descripcion":"{ AGA-TR-B010 } Balanza Pesamatic modelo AQUA-SS de 6 KG (N 120, Grupo B N 5)"},
{"descripcion":"{ } Deshuesadora BC40 (Mini HQ)"},
{"descripcion":"{ AGA-700 } Volteador de Bins de Dehuesado (HQ)"},
{"descripcion":"{ AGA-701 } Cinta Elevadora de BC40 (Grupo N 1)"},
{"descripcion":"{ AGA-702 } Cinta de BC40 (Colgado de Pechuga) (Grupo N 1)"},
{"descripcion":"{ AGA-703 } DESHUESADOR PECHUGAS HQ"},
{"descripcion":"{ AGA-704 } CORTADOR DE FILETE"},
{"descripcion":"{ AGA-705 } CINTA FILETE"},
{"descripcion":"{ AGA-706 } CINTA SELECCION FILETILLOS"},
{"descripcion":"{ AGA-707 } CORTADOR DE FILETILLO"},
{"descripcion":"{ AGA-708 } CINTA FILETILLOS"},
{"descripcion":"{ AGA-709 } Cinta Doble de BC40 (Grupo N 1)"},
{"descripcion":"{ AGA-710 } CINTA CARCAZA"},
{"descripcion":"{ AGA-DH-0000 } Rapid M4.1 (HQ)"},
{"descripcion":"{ AGA-DH-9001 } Transpaleta 1122FI001"},
{"descripcion":"{ AGA-DH-9002 } Transpaleta 0823HQ001"},
{"descripcion":"{ AGA-M-DH-0020 } Cinta de descarga de volteador de bins de deshuesado (HQ)"},
{"descripcion":"{ AGA-M-DH-0030 } Cinta de alimentacion de cinta de colgado de HQ (DespuÃ©s de cinta elevadora de volteador)"},
{"descripcion":"{ AGA-M-DH-0050 } Cinta de descarga de piel de HQ"},
{"descripcion":"{ AGA-M-DH-0060 } Cinta de descarga de filetes (Debajo de HQ)"},
{"descripcion":"{ AGA-M-DH-0061 } Cinta de alimentacion de cinta doble de filete (HQ)"},
{"descripcion":"{ AGA-M-DH-0062 } Cinta doble de filetes (HQ)"},
{"descripcion":"{ AGA-M-DH-0063 } Cinta de filetes seleccionados (Elevadora debajo de cinta doble de HQ)"},
{"descripcion":"{ AGA-M-DH-0070 } Cinta de descarga de filetitos de HQ"},
{"descripcion":"{ AGA-M-DH-0071 } Cinta de seleccion de filetitos de HQ"},
{"descripcion":"{ AGA-M-DH-0080 } Cinta del hueso del deseo (Espoleta) de HQ"},
{"descripcion":"{ AGA-M-DH-0090 } Cinta de carcasas de HQ"},
{"descripcion":"{ AGA-PP-DH-TS03-09 } Tablero de Volteador de Bins de HQ (Sala de Deshuesado)"},
{"descripcion":"{ AGA-PP-DH-TS03-10 } TDF - Esterilizador Area limpia-1-1-D033"},
{"descripcion":"{ AGA-PP-DH-TS03-11 } Tablero de General de Rapid 2 (Sala de Deshuesado)"},
{"descripcion":"{ AGA-PP-DH-TS03-12 } Tablero de PLC de cintas HQ (Sala de Deshuesado)"},
{"descripcion":"{ AGA-PP-DH-TS03-13 } TDF - Enchufes sala hq-1-1-D036"},
{"descripcion":"{ AGA-M-DH-0040 } Cinta de colgado de pechugas (HQ)"},
{"descripcion":"{ AGA-200 } ESCALDADORA LINCO"},
{"descripcion":"{ AGA-201 } ESCALDADORA MEYN"},
{"descripcion":"{ AGA-202 } ESCALDADORA ALAS"},
{"descripcion":"{ AGA-203 } DESPLUMADORA IMPIANTI"},
{"descripcion":"{ AGA-204 } DESPLUMADORA MEYN N 1"},
{"descripcion":"{ AGA-205 } DESPLUMADORA MEYN N 2"},
{"descripcion":"{ AGA-206 } BOMBA DE ACIDO CITRICO"},
{"descripcion":"{ AGA-207 } BOMBA PLUMAS"},
{"descripcion":"{ AGA-208 } CORTADOR DE PATAS PRIME"},
{"descripcion":"{ AGA-209 } CINTA DE COLGADO ANTES DE CORTADOR DE PATAS PRIME"},
{"descripcion":"{ AGA-DE-0030 } Limpiador de Pechuga"},
{"descripcion":"{ AGA-DE-0031 } Dosifiador de Cloro Prominent, de rodillos limpiadores (Desplumado)"},
{"descripcion":"{ AGA-DE-0100 } Extractor de Cabeza"},
{"descripcion":"{ AGA-FA-DE-TS04-03 } Tablero de Botoneras de Desplumado (Sala de Desplumado)"},
{"descripcion":"{ AGA-FA-DE-TS04-04 } Tablero de Control rodillos de limpiador de necropsia (Sala de Desplumado)"},
{"descripcion":"{ AGA-FA-DE-TS04-05 } Tablero de Control de LÃ­nea de Faena (Botonera) (Sala de Desplumado)"},
{"descripcion":"{ AGA-M-DE-M001 } Mezclador de Vapor de Desplumado"},
{"descripcion":"{ AGA-PE-TC-TS04-24 } Tablero de Control cintas de recepcion de Pollo Vivo (Techo sobre Desplumado)"},
{"descripcion":"{ AGA-SU-SE-TS04-25 } Tablero de Alumbrado N 1 Empaque, desplumado, pollo vivo, Chiller Agua (Sala ElÃ©ctrica N 1 (Nueva))"},
{"descripcion":"{ AGA-SU-SE-TS04-26 } Tablero de Alumbrado N 2 Empaque, desplumado, pollo vivo, Chiller Agua (Sala ElÃ©ctrica N 1 (Nueva))"},
{"descripcion":"{ AGA-SU-SE-TS04-27 } Tablero de Fuerza y control de chiller de agua N 1 (General) (Sala ElÃ©ctrica N 1 (Nueva))"},
{"descripcion":"{ AGA-SU-SE-TS04-28 } Tablero de Fuerza y control de chiller de agua N 2 (Sala ElÃ©ctrica N 1 (Nueva))"},
{"descripcion":"{ AGA-SU-SE-TS04-29 } Tablero de Fuerza de Chiller, menzal, empaque y Pollo vivo (Sala ElÃ©ctrica N 1 (Nueva))"},
{"descripcion":"{ AGA-SU-SE-TS04-30 } Tablero de General de recepcion de Pollo Vivo y Desplumado (Sala ElÃ©ctrica N 1 (Nueva))"},
{"descripcion":"{ AGA-SU-SE-TS04-31 } Tablero de Fuerza y control de peladoras de Pollo (Sala ElÃ©ctrica N 1 (Nueva))"},
{"descripcion":"{ AGA-SU-SE-TS04-32 } Tablero de Inyectores y extractores de Chiller de Agua y Atontador (Sala ElÃ©ctrica N 1 (Nueva))"},
{"descripcion":"{ AGA-SU-SE-TS04-33 } Tablero de Fuerza y control de cintas de Empaque (Sala ElÃ©ctrica N 1 (Nueva))"},
{"descripcion":"{ AGA-SU-SE-TS04-34 } Tablero de Fuerza de Empaque y Chiller de Agua (Sala ElÃ©ctrica N 1 )"},
{"descripcion":"{ AGA-SU-SE-TS04-35 } Tablero de Fuerza y control empaque y sala de gallina (Sala ElÃ©ctrica N 1 )"},
{"descripcion":"{ AGA-SU-SE-TS04-36 } Tablero de Fuerza de desplumado (Peladoras) (Sala ElÃ©ctrica N 1 )"},
{"descripcion":"{ AGA-SU-SE-TS04-37 } Tablero de Fuerza y control de ventiladores, extractor de garra y desplumado (Sala ElÃ©ctrica N 1 )"},
{"descripcion":"{ AGA-SU-SE-TS04-38 } Tablero de Fuerza de Pollo Vivo (Sala ElÃ©ctrica N 1 )"},
{"descripcion":"{ AGA-SU-SE-TS04-39 } Tablero de Fuerza y control mensal y peladora de muñones (Sala ElÃ©ctrica N 1 )"},
{"descripcion":"{ AGA-SU-SE-TS02-17 } Tablero de General de fuerza de sala elÃ©ctrica N 2 (Sala ElÃ©ctrica N 2)"},
{"descripcion":"{ AGA-SU-SE-TS02-18 } Tablero de General de fuerza y PLC de Fancoil IQF (Sala ElÃ©ctrica N 2)"},
{"descripcion":"{ AGA-SU-SE-TS02-19 } Tablero de Fuerza de fancoil de Empaque (Sala ElÃ©ctrica N 2)"},
{"descripcion":"{ AGA-SU-SE-TS02-20 } Tablero de Fuerza de fancoil trozado y cintas (Sala ElÃ©ctrica N 2)"},
{"descripcion":"{ AGA-SU-SE-TS02-21 } Tablero de Fuerza Evaporadores de Chiller de Aire (Sala ElÃ©ctrica N 2)"},
{"descripcion":"{ AGA-SU-SE-TS02-22 } Tablero de Fuerza y control tableros adicionales de Trozado (Sala ElÃ©ctrica N 2)"},
{"descripcion":"{ AGA-SU-SE-TS02-23 } Tablero de Fuerza de cintas trozado y HQ (Sala ElÃ©ctrica N 2)"},
{"descripcion":"{ AGA-SU-SE-TS02-24 } Tablero de Fuerza y control de Chiller de Aire (Sala ElÃ©ctrica N 2)"},
{"descripcion":"{ AGA-SU-SE-TS02-25 } Tablero de Fuerza y control adicional de IQF (Sala ElÃ©ctrica N 2)"},
{"descripcion":"{ AGA-SU-SE-TS02-26 } Tablero de Fuerza de cintas trozado y Polypacks (Sala ElÃ©ctrica N 2)"},
{"descripcion":"{ AGA-SU-SE-TS02-27 } Tablero de Fuerza de Deshues de pechugas HQ (Sala ElÃ©ctrica N 2)"},
{"descripcion":"{ AGA-SU-SE-TS02-28 } Tablero de Control de Deshuese de Pechuga HQ (Sala ElÃ©ctrica N 2)"},
{"descripcion":"{ AGA-SU-SE-TS02-29 } Tablero de Fuerza trozado automAtico (Sala ElÃ©ctrica N 2)"},
{"descripcion":"{ AGA-SU-SE-TS02-30 } Tablero de Control y PLC trozado automAtico (Sala ElÃ©ctrica N 2)"},
{"descripcion":"{ AGA-SU-SE-TS02-31 } Tablero de Control y PLC de Chiller de aire (Sala ElÃ©ctrica N 2)"},
{"descripcion":"{ AGA-SU-SE-TS02-32 } Tablero de General de Fuerza de Chiller de Aire (Sala ElÃ©ctrica N 2)"},
{"descripcion":"{ AGA-SU-SE-TS02-33 } Tablero de Fuerza y control de red estabilizadora (Sala ElÃ©ctrica N 2)"},
{"descripcion":"{ AGA-SU-SE-TS02-34 } Tablero de Fuerza y control tablero adicionales eviscerado (Sala ElÃ©ctrica N 2)"},
{"descripcion":"{ AGA-SU-SE-TS02-35 } Tablero de Fuerza Eviscerado automAtico (Sala ElÃ©ctrica N 2)"},
{"descripcion":"{ AGA-SU-SE-TS02-36 } Tablero de Fuerza y control Eviscerado automAtico (Sala ElÃ©ctrica N 2)"},
{"descripcion":"{ AGA-SU-SE-TS02-37 } Tablero de Control y PLC de bypass Eviscerado automAtico (Sala ElÃ©ctrica N 2)"},
{"descripcion":"{ AGA-0200 } GENERADOR ELÃ‰CTRICO N 1 PLANTA"},
{"descripcion":"{ AGA-0201 } GENERADOR ELÃ‰CTRICO N 2 REFRIGERACION"},
{"descripcion":"{ AGA-SU-0020 } COMPRESOR N220"},
{"descripcion":"{ AGA-FA-IN-TS06-20 } Tablero de Botoneras de Killer (Sala del Killer)"},
{"descripcion":"{ } Tambler"},
{"descripcion":"{ AGA-1262 } BIOTUNEL"},
{"descripcion":"{ AGA-900 } VOLTEADOR DE BINS IQF"},
{"descripcion":"{ AGA-901 } Cinta Buffer IQF (Grupo N 1)"},
{"descripcion":"{ AGA-902 } Cinta de Entrada Biofreezer (Cinta de Salida Fomaco IQF) (Grupo N 1)"},
{"descripcion":"{ AGA-903 } TUMBLER (MASAJEADOR DORIT 1400)"},
{"descripcion":"{ AGA-904 } ZARANDA N 1 (ENTRADA FOMACO IQF)"},
{"descripcion":"{ AGA-905 } Inyectora Fomaco IQF (Grupo N 1)"},
{"descripcion":"{ AGA-906 } ZARANDA N 2 (SALIDA FOMACO IQF)"},
{"descripcion":"{ AGA-907 } Superchill IQF"},
{"descripcion":"{ AGA-908 } CINTA DE VOLTEO FOMACO"},
{"descripcion":"{ AGA-909 } GLACIADOR STARFROST (SALIDA PRODUCTO IQF)"},
{"descripcion":"{ AGA-910 } CONGELADOR ESPIRAL IQF (STARFROST)"},
{"descripcion":"{ AGA-911 } CINTA DE SALIDA GLACIADOR (IQF)"},
{"descripcion":"{ AGA-912 } CINTA DE REENTRADA A IQF"},
{"descripcion":"{ AGA-PP-IQ-TS03-31 } Tablero de Volteador de Bins IQF (IQF 1er Piso)"},
{"descripcion":"{ AGA-PP-IQ-TS03-32 } Tablero de Tumbler (IQF 1er Piso)"},
{"descripcion":"{ AGA-PP-IQ-TS03-33 } Tablero de Alumbrado de sala IQF (IQF 1er Piso)"},
{"descripcion":"{ AGA-PP-IQ-TS03-34 } Tablero de Buffer de IQF (IQF 1er Piso)"},
{"descripcion":"{ AGA-PP-IQ-TS03-35 } TDF y C - Zaranda entrada inyectora iqf-1-1-D056"},
{"descripcion":"{ AGA-PP-IQ-TS03-36 } TDF y C - Zaranda salida inyectora iqf-1-1-D057"},
{"descripcion":"{ AGA-PP-IQ-TS03-37 } TDF y C - Biotunel-1-1-D058"},
{"descripcion":"{ AGA-PP-IQ-TS03-38 } TDF y C - Starfrost-1-1-D059"},
{"descripcion":"{ AGA-PP-IQ-TS03-39 } Tablero de PLC de Starfrost (IQF 1er Piso)"},
{"descripcion":"{ } Balanza Mettler Toledo IND236 (N 110, Grupo B N 4)"},
{"descripcion":"{ } Balanza Triunfo XKSS-WP (N 112, Grupo B N 4)"},
{"descripcion":"{ } Balanza Triunfo XKSS-WP (N 113, Grupo B N 4)"},
{"descripcion":"{ } Balanza Triunfo XKSS-WP (N 114, Grupo B N 4)"},
{"descripcion":"{ } Cinta de salida de Biofreezer (Bypass IQF) (Grupo N 1)"},
{"descripcion":"{ } Impresora Linx 8920"},
{"descripcion":"{ } Selladora Tecmaes Smart Sealer 620 NR (N 1)"},
{"descripcion":"{ } Selladora Tecmaes Smart Sealer 620 NR (N 2)"},
{"descripcion":"{ AGA-913 } CINTA N 3 (SEGUNDO PISO)"},
{"descripcion":"{ AGA-914 } CINTA N 4 (SEGUNDO PISO)"},
{"descripcion":"{ AGA-915 } CINTA N 5 (SEGUNDO PISO)"},
{"descripcion":"{ AGA-916 } CINTA N 6 (SEGUNDO PISO)"},
{"descripcion":"{ AGA-917 } CINTA N 7 (DOBLE - SEGUNDO PISO)"},
{"descripcion":"{ AGA-918 } DETECTOR METAL IQF"},
{"descripcion":"{ AGA-919 } CINTA N 10 (BAJADA)"},
{"descripcion":"{ AGA-9201 } ENZUNCHADORA N 4 IQF"},
{"descripcion":"{ AGA-9202 } ENZUNCHADORA N 3 IQF"},
{"descripcion":"{ AGA-922 } DETECTOR DE METALES CONGELADO 3 (IQF)"},
{"descripcion":"{ AGA-PP-IQ-TS03-40 } TDF - Selladora tecmaes-1-1-D060"},
{"descripcion":"{ AGA-PP-IQ-TS03-41 } TDF - Selladora tecmaes-1-1-D061"},
{"descripcion":"{ AGA-PP-IQ-TS03-42 } Tablero de Comunicacion de Balanzas (IQF 2do Piso)"},
{"descripcion":"{ AGA-PP-IQ-TS03-43 } TDF y C - Ventiladores iqf 2do piso-1-1-D062"},
{"descripcion":"{ AGA-PP-IQ-TS03-44 } TDF - Detector de metales iqf-1-1-D064-S001"},
{"descripcion":"{ AGA-PP-IQ-TS03-45 } TDF - Enzunchadoras iqf-1-1-D063"},
{"descripcion":"{ AGA-PP-IQ-TS03-46 } Tablero de Fuerza cinta detector de metales (IQF 2do Piso)"},
{"descripcion":"{ AGA-PP-IQ-TS03-47 } Tablero de Control cintas (IQF 2do Piso)"},
{"descripcion":"{ AGA-PE-OF-TS02-11 } TDF y A - Sag-1-1-D012-S002"},
{"descripcion":"{ AGA-1102 } ARMADORA CAJAS SEGUNDO PISO"},
{"descripcion":"{ AGA-PP-TE-TS03-19 } TDF - Enchufes paletizado-1-1-D042"},
{"descripcion":"{ AGA-PP-TE-TS03-20 } TDF - Enchufes paletizado-1-1-D043"},
{"descripcion":"{ AGA-PP-TE-TS03-54 } TDF - Cargador de transpaletas-1-1-D066"},
{"descripcion":"{ AGA-PP-TE-TS05-07 } Tablero de Caseta de ingreso a despacho (Romana) (Sala de Paletizado)"},
{"descripcion":"{ AGA-PE-PO-TS01-14 } TDC - Medidor santa marÃ­a-3-D002-S002"},
{"descripcion":"{ AGA-PE-PO-TS01-15 } TDF y C - PorterÃ­a-1-1-D001-S012"},
{"descripcion":"{ AGA-PE-PO-TS01-16 } TDF y C - PorterÃ­a-1-1-D001-S013"},
{"descripcion":"{ AGA-PE-PO-TS01-17 } TDF y C - PorterÃ­a-1-1-D001-S014"},
{"descripcion":"{ AGA-PE-PO-TS01-18 } TDA - EnfermerÃ­a-1-1-D001-S015"},
{"descripcion":"{ AGA-100 } VENTILADORES GALPON DE AVES VIVAS"},
{"descripcion":"{ AGA-102 } VENTILACION COLGADO DE POLLO VIVO"},
{"descripcion":"{ AGA-103 } SISTEMA DE TRANSPORTE ENTRADA PALLETS LLENOS"},
{"descripcion":"{ AGA-104 } ROMANA PALLETS LLENO"},
{"descripcion":"{ AGA-105 } LAVADORA DE PALLETS"},
{"descripcion":"{ AGA-106 } CINTA ENTRADA DE JABAS LLENAS (ANTES DE COLGADO)"},
{"descripcion":"{ AGA-107 } CINTA COLGADO DE POLLO VIVO (POLLO DESDE LAS JABAS A LINEA AEREA)"},
{"descripcion":"{ AGA-108 } LÃNEA DE MATANZA"},
{"descripcion":"{ AGA-109 } ATONTADOR ELÃ‰CTRICO"},
{"descripcion":"{ AGA-110 } MATADOR"},
{"descripcion":"{ AGA-111 } LAVADORA DE JABAS N 1"},
{"descripcion":"{ AGA-112 } LAVADORA DE JABAS N 2 VAPORERA"},
{"descripcion":"{ AGA-113 } ROMANA PALLETS VACÃO"},
{"descripcion":"{ AGA-114 } CINTA SALIDA PALLET - JABAS LIMPIAS"},
{"descripcion":"{ AGA-115 } BOMBA LAVADO CAMIONES"},
{"descripcion":"{ AGA-116 } BOMBA DE GUANO N 1 (LADO PARED)"},
{"descripcion":"{ AGA-117 } BOMBA DE GUANO N 2 (LADO PASILLO)"},
{"descripcion":"{ AGA-118 } TROMEL GUANO"},
{"descripcion":"{ AGA-119 } BALANZA METLER TOLERO PALLET LLENO (N 2, Grupo B N 1)"},
{"descripcion":"{ AGA-120 } BALANZA METLER TOLEDO PALLET VACÃO (N 3, Grupo B N 1)"},
{"descripcion":"{ AGA-EV-B008 } Balanza Veit Electronics BAT1 2201761 (N 116, Grupo B N 4)"},
{"descripcion":"{ AGA-FA-PV-TS06-16 } Tablero de Control de romanas de Pallets (Caseta de Pollo Vivo)"},
{"descripcion":"{ AGA-FA-PV-TS06-17 } Tablero de Enchufes y otros, caseta pollo vivo (Caseta de Pollo Vivo)"},
{"descripcion":"{ AGA-FA-PV-TS06-18 } Tablero de Enchufes colgado pollo vivo (Caseta de Pollo Vivo)"},
{"descripcion":"{ AGA-M-PV-E002 } Extractor de Polvo de Recepcion de Pollo Vivo"},
{"descripcion":"{ AGA-PV-E001 } Extractor de aire de Coglado de Pollo Vivo"},
{"descripcion":"{ AGA-PV-I001 } Inyector de Aire de Pollo Vivo"},
{"descripcion":"{ AGA-0205 } SUBESTACION ELÃ‰CTRICA 3 (2000 KVA)"},
{"descripcion":"{ AGA-SU-SE-TS08-05 } Tablero de Control red de incendio, arranque remoto (Sub estacion de 1500 KVA)"},
{"descripcion":"{ AGA-SU-SE-TS08-06 } Tablero de Interruptor general trafo 1500 KVA control (Sub estacion de 1500 KVA)"},
{"descripcion":"{ AGA-SU-SE-TS08-07 } Tablero de Tranformador 1500 KVA (Sub estacion de 1500 KVA)"},
{"descripcion":"{ AGA-SU-SE-TS08-08 } Tablero de Transferiancia 1500 KVA (Sub estacion de 1500 KVA)"},
{"descripcion":"{ AGA-SU-SE-TS08-09 } Tablero de Fuerza de Lavado de Badenjas (Sub estacion de 1500 KVA)"},
{"descripcion":"{ AGA-SU-SE-TS08-10 } Tablero de Fuerza de equipos varios N 1 (Sub estacion de 1500 KVA)"},
{"descripcion":"{ AGA-SU-SE-TS08-11 } Tablero de Banco de condensadores (Sub estacion de 1500 KVA)"},
{"descripcion":"{ AGA-SU-SE-TS08-12 } Tablero de Banco de condensadores (Sub estacion de 1500 KVA)"},
{"descripcion":"{ AGA-SU-SE-TS08-13 } Tablero de General de Faena (Sub estacion de 1500 KVA)"},
{"descripcion":"{ AGA-SU-SE-TS08-14 } Tablero de Fuerza de equipos varios N 2 (Sub estacion de 1500 KVA)"},
{"descripcion":"{ AGA-SU-SE-TS08-15 } Tablero de Fuerza de equipos varios N 3 (Sub estacion de 1500 KVA)"},
{"descripcion":"{ AGA-0206 } SUBESTACION ELÃ‰CTRICA 2 (400 KVA)"},
{"descripcion":"{ AGA-0204 } SUBESTACION ELÃ‰CTRICA 1 (1500 KVA)"},
{"descripcion":"{ AGA-SU-SE-TS10-00 } Tablero de Fuerza y luminaria SE-2 de transformador de 400 KVA (Sub estacion de 400 KVA)"},
{"descripcion":"{ AGA-PP-TN-TS03-14 } Tablero de Zaranda de Entrada de Inyectora N 2 (Sala de Tenderizado)"},
{"descripcion":"{ AGA-PP-TN-TS03-15 } Tablero de Volteador de Bins Tenderizado (Sala de Tenderizado)"},
{"descripcion":"{ AGA-PP-TN-TS03-16 } Tablero de Buffer de Tenderizado (Sala de Tenderizado)"},
{"descripcion":"{ AGA-PP-TN-TS03-17 } Tablero de Zaranda de Salida de Inyectora N 2 (Sala de Tenderizado)"},
{"descripcion":"{ AGA-PP-TN-TS03-18 } TDF - Enchufes pulpa-1-1-D041"},
{"descripcion":"{ AGA-PP-TN-TS03-23 } Tablero de Detector de metales (Sala de Tenderizado)"},
{"descripcion":"{ AGA-TN-0060 } Cinta de Salida Inyectora Fomaco Norte (Grupo N 2)"},
{"descripcion":"{ AGA-TN-0071 } Cinta de Cajas Vacias de Inyectora 421 (N 1, Norte)(Grupo N 2)"},
{"descripcion":"{ AGA-TN-0072 } Cinta de Cajas Vacias de Inyectora 698 (N 2, Sur)(Grupo N 2)"},
{"descripcion":"{ AGA-TN-0080 } Cinta antes de detector de metales de Tenderizado (Grupo N 2)"},
{"descripcion":"{ AGA-TN-0090 } Cinta de detector de Metales de Tenderizado (Grupo N 2)"},
{"descripcion":"{ AGA-TN-9001 } Transpaleta 1122IN001"},
{"descripcion":"{ AGA-M-RE-0010 } Filtro Parabolico de Plumas"},
{"descripcion":"{ AGA-M-RE-0011 } Tornillo Elevador de Plumas"},
{"descripcion":"{ AGA-M-RE-0012 } Tolva de Plumas"},
{"descripcion":"{ AGA-M-RE-0020 } Filtro rotatorio de Viceras (Tromel de Viceras)"},
{"descripcion":"{ AGA-M-RE-0021 } Tolva N 2 de Visceras (Lado tolva de Pulmas)"},
{"descripcion":"{ AGA-M-RE-0022 } Tolva N 1 de Visceras (Lado entrada de sala)"},
{"descripcion":"{ AGA-M-RE-0023 } Tornillo de Viceras"},
{"descripcion":"{ AGA-SU-RE-TS09-01 } Tablero de Luminarias de contratistas de Infraestructura (DetrAs de taller de contratistas)"},
{"descripcion":"{ AGA-SU-RE-TS09-02 } Tablero de Enchufes entrada trasera a reendering (Reendering)"},
{"descripcion":"{ AGA-SU-RE-TS09-03 } Tablero de Banco de condensadores, entrada a sector de Reendering (Reendering)"},
{"descripcion":"{ AGA-SU-RE-TS09-04 } Tablero de Fuerza de Reendering N 1 (Reendering)"},
{"descripcion":"{ AGA-SU-RE-TS09-05 } Tablero de Fuerza de Reendering N 2 (Reendering)"},
{"descripcion":"{ AGA-SU-RE-TS09-06 } Tablero de Fuerza de Reendering N 3 (Reendering)"},
{"descripcion":"{ AGA-SU-RE-TS09-07 } Tablero de Fuerza de Reendering N 4 (Reendering)"},
{"descripcion":"{ AGA-SU-RE-TS09-08 } Tablero de Fuerza de Reendering N 5 (Reendering)"},
{"descripcion":"{ AGA-SU-RE-TS09-09 } Tablero de Fuerza y control de cinta de plumas (Reendering)"},
{"descripcion":"{ AGA-FA-PV-TS06-14 } Tablero de Control de bombas de guano (Fosa de Bombas de Guano)"},
{"descripcion":"{ AGA-FA-PV-TS06-15 } Tablero de Control de Cintas y bombas de pollo vivo (Recepcion de Pollo Vivo)"},
{"descripcion":"{ AGA-FA-PV-TS06-19 } Tablero de Ventiladores de piso en Patio de Pollo Vivo (Recepcion de Pollo Vivo)"},
{"descripcion":"{ AGA-FA-PV-TS06-21 } Tablero de Control de conexiones de sensores de transporte de pallets (Recepcion Pollo Vivo)"},
{"descripcion":"{ AGA-PV-0043 } Parabolica separadora de solidos para recuperacion de agua de pollo vivo"},
{"descripcion":"{ AGA-FA-PV-TS06-11 } Tablero de Fuerza y control de ventiladores de Andenes de Pollo Vivo N 1 (Anden N 2 de Pollo Vivo)"},
{"descripcion":"{ AGA-FA-PV-TS06-12 } Tablero de Fuerza y control de ventiladores de Andenes de Pollo Vivo N 2 (Anden N 2 de Pollo Vivo)"},
{"descripcion":"{ AGA-FA-PV-TS06-13 } Tablero de Fuerza y control de ventiladores de Andenes de Pollo Vivo N 3 (Anden N 2 de Pollo Vivo)"},
{"descripcion":"{ AGA-FA-EG-TS04-02 } Tablero de Control y fuerza de moledor de pollos (Sala de Esterilizado de Cuchillos de Eviscerado)"},
{"descripcion":"{ IOCA-01448 } COMPRESOR DE AIRE 5"},
{"descripcion":"{ IOCE-00500 } TABLEROS RECEPCION"},
{"descripcion":"{ IOCE-00501 } TABLEROS PATIO NORTE"},
{"descripcion":"{ IOCE-00502 } TABLEROS SEPARADOR DE SOLIDOS"},
{"descripcion":"{ IOCE-00503 } TABLEROS SOBRE CALDERA"},
{"descripcion":"{ IOCE-00504 } TABLEROS BANDEJITAS"},
{"descripcion":"{ IOCE-00505 } TABLEROS EX SILO HIELO"},
{"descripcion":"{ IOCE-00506 } TABLEROS PROCESOS POSTERIORES"},
{"descripcion":"{ IOCE-00507 } TABLEROS CAMARAS"},
{"descripcion":"{ IOCE-00508 } TABLEROS SALMUERA"},
{"descripcion":"{ IOCE-00509 } TABLEROS SADEMA"},
{"descripcion":"{ IOCE-00510 } TABLEROS EMPAQUE Y TROZADO 2 PISO"},
{"descripcion":"{ IOCE-00511 } TABLEROS CASINO"},
{"descripcion":"{ IOCE-00512 } TABLEROS PORTERIA 1"},
{"descripcion":"{ IOCE-00513 } TABLEROS TALLER"},
{"descripcion":"{ IOCE-00514 } TABLEROS ECORILES"},
{"descripcion":"{ IOCE-00515 } TABLEROS PATIO SUR"},
{"descripcion":"{ IOCE-00516 } TABLEROS CALDERA"},
{"descripcion":"{ IOCE-00517 } TABLEROS PATIO 3"},
{"descripcion":"{ IOCE-00518 } TABLEROS SALA BANDEJAS"},
{"descripcion":"{ IOCE-01500 } BALANZAS"},
{"descripcion":"{ IOCA-00609 } CAMARA N 37 (PROCESOS CONGELADOS)"},
{"descripcion":"{ IOCA-00600 } CAMARA NÂº 1"},
{"descripcion":"{ IOCE-00410 } CINTA BARRAS N 2 CURV"},
{"descripcion":"{ IOCE-00420 } CINTA BARRAS N 12 (CA"},
{"descripcion":"{ IOCE-00422 } CINTA MENUDENCIAS (CAMARA 1)"},
{"descripcion":"{ IOCE-00600 } CAMARA N 1"},
{"descripcion":"{ IOCE-03840 } ENZUNCHADORA GAMPACK"},
{"descripcion":"{ IOCE-05010 } CINTA CAJAS N 6"},
{"descripcion":"{ IOCA-00603 } CAMARA NÂº 2"},
{"descripcion":"{ IOCA-00606 } CAMARA NÂº 3"},
{"descripcion":"{ IOCA-00601 } CAMARA NÂº 36"},
{"descripcion":"{ IOCA-00604 } CAMARA NÂº 4"},
{"descripcion":"{ IOCE-00490 } CAMARA DE DESCONGELACION"},
{"descripcion":"{ IOCE-00491 } CALDERIN DE CAMARA DESCONGELACION"},
{"descripcion":"{ IOCE-00492 } TAMBLER"},
{"descripcion":"{ IOCE-00493 } CALDERIN DE TAMBLER"},
{"descripcion":"{ IOCE-00605 } CAMARA NÂº 5"},
{"descripcion":"{ IOCE-03800 } CINTA ELEVADORA SEPAMATIC"},
{"descripcion":"{ IOCE-03801 } DETECTOR DE METALES SEPAMATIC"},
{"descripcion":"{ IOCE-03802 } CINTA ALIMENTACION SEPAMATIC"},
{"descripcion":"{ IOCE-03803 } SEPARADORA DE CARNE MODERNPACK SEPAMATIC"},
{"descripcion":"{ IOCE-03804 } REVOLVEDOR DE CARNE SEPAMATIC"},
{"descripcion":"{ IOCA-00608 } CAMARA NÂº 7"},
{"descripcion":"{ IOCA-00607 } CAMARA NÂº 9"},
{"descripcion":"{ IOCA-01447 } TRANSFORMADOR ELECTRICO NÂº 4 (BOMBA POZO)"},
{"descripcion":"{ IOCE-00167 } BOMBA ALTERNATIVA GUAN"},
{"descripcion":"{ IOCE-01049 } BOMBA ETIQUETA"},
{"descripcion":"{ IOCE-01049.1 } UNIDAD ROTATORIA BOMBA ETIQUETA"},
{"descripcion":"{ IOCE-00250 } BOMBA VOGEL 1"},
{"descripcion":"{ IOCE-00365 } BOMBA VOGEL 2"},
{"descripcion":"{ IOCE-00366 } BOMBA VOGEL 3"},
{"descripcion":"{ IOCE-03831 } ENVOLVEDORA DE PALLET PASILLO ANTECAMARA"},
{"descripcion":"{ IOCA-00610 } CAMARA NÂª38"},
{"descripcion":"{ IOCA-06033 } TECLE ELÃ‰CTRICO SALA MAQUINA NORTE"},
{"descripcion":"{ IOCA-06035 } TECLE ELÃ‰CTRICO SALA MAQUINA SUR"},
{"descripcion":"{ IOCE-00162 } ROMANA CAMIONES POLLOS VIVOS"},
{"descripcion":"{ IOCA-06034 } TECLE ELÃ‰CTRICO STAHL ST-20 CASINO Y GUARDARROPÃA"},
{"descripcion":"{ IOCE-00169 } BOMBA ALIMENTACION AGUA A ASPERSORES SANGRADO Y PERCOLADORES"},
{"descripcion":"{ IOCE-01055 } SEPARADOR DE ETIQUETA"},
{"descripcion":"{ IOCA-01430 } GENERADOR HONDA (PATIO 3)"},
{"descripcion":"{ IOCE-00132 } UNIDAD VENTILACION P.4"},
{"descripcion":"{ IOCA-01320 } RECONECTADOR"},
{"descripcion":"{ IOCE-00990 } MOLEDORA CARNE VEMAG LINEA GT2"},
{"descripcion":"{ IOCE-00991 } PORCIONADORA BANDEJAS VEMAG LINEA GT2"},
{"descripcion":"{ IOCE-00994 } CINTA S LINEA GT2"},
{"descripcion":"{ IOCE-02112 } DETECTOR DE METALES LINEA ROLLSTOCK"},
{"descripcion":"{ IOCE-02200 } CINTA ARMADO BANDEJITAS LINEA GT2"},
{"descripcion":"{ IOCE-02201 } CINTA CURVA ALIMENTACION GT2"},
{"descripcion":"{ IOCE-02202 } ENVASADORA DE BANDEJAS DE ATMOSFERA MODIFICADA PROSEAL GT2"},
{"descripcion":"{ IOCE-02203 } DETECTOR METALES LINEA GT2"},
{"descripcion":"{ IOCE-02204 } CINTA ETIQUETADO Y FECHAJE LINEA GT2"},
{"descripcion":"{ IOCE-02205 } ETIQUETADOR STIPACK T190 WR LINEA GT2"},
{"descripcion":"{ IOCE-02206 } FECHADORA LINX 8910 LINEA GT2"},
{"descripcion":"{ IOCE-02207 } TORNAMESA LINEA GT2"},
{"descripcion":"{ IOCE-02208 } CINTA ENTRADA HORNO SMIPACK LINEA GT2"},
{"descripcion":"{ IOCE-02209 } HORNO SMIPACK LINEA GT2"},
{"descripcion":"{ IOCE-02210 } TERMOFORMADORA ROLLSTOCK RI-200"},
{"descripcion":"{ IOCE-02211 } CINTA ELEVADORA SALIDA TERMOFORMADORA"},
{"descripcion":"{ IOCE-02212 } TORNAMESA TERMOFORMADORA"},
{"descripcion":"{ IOCE-02216 } FECHADORA KGK GT2 (3)"},
{"descripcion":"{ IOCE-02220 } CINTA ELEVADORA LINEA GT2"},
{"descripcion":"{ IOCE-02221 } CINTA MONTAJE MENUDENCIAS LINEA GT2"},
{"descripcion":"{ IOCE-02222 } CINTA CON RUEDAS LINEA GT2"},
{"descripcion":"{ IOCE-02249 } CINTA ALIMENTACION DESHUESADORA"},
{"descripcion":"{ IOCE-02250 } DESHUESADORA TRUTRO"},
{"descripcion":"{ IOCE-02251 } CINTA SALIDA DESHUESADORA"},
{"descripcion":"{ IOCA-01911 } EQUIPO AIRE ACONDICIONADO N 7"},
{"descripcion":"{ IOCA-01912 } EQUIPO AIRE ACONDICIONADO N 8"},
{"descripcion":"{ IOCE-00957 } ENVOLVEDORA DE CAJAS"},
{"descripcion":"{ IOCE-00958 } TERMORRETRACTIL"},
{"descripcion":"{ IOCE-00960 } CINTA CURVA LINEA PROSEAL"},
{"descripcion":"{ IOCE-00979 } CINTA DESHUESADO TRUTRO (CORTA)"},
{"descripcion":"{ IOCE-00980 } ENVASADORA DE BANDEJAS DE ATMOSFERA MODIFICADA PROSEAL GT1"},
{"descripcion":"{ IOCE-00981 } DETECTOR DE METALES LINEA GT1"},
{"descripcion":"{ IOCE-00982 } ETIQUETADOR STIPACK T190 WR LINEA GT1"},
{"descripcion":"{ IOCE-00983 } CINTA ALIMENTACION HORNO SMIPACK LINEA GT1"},
{"descripcion":"{ IOCE-00984 } CINTA SALIDA TORNAMESA LINEA GT1"},
{"descripcion":"{ IOCE-00985 } HORNO SMIPACK LINEA GT1"},
{"descripcion":"{ IOCE-00986 } CINTA POLIN SALIDA HORNO SMIPACK"},
{"descripcion":"{ IOCE-00987 } CALIBRADORA LINEA GT1"},
{"descripcion":"{ IOCE-00988 } FECHADORA KGK GT1 (4)"},
{"descripcion":"{ IOCE-00992 } CINTA ELEVADORA LINEA GT1"},
{"descripcion":"{ IOCE-00993 } CINTA S LINEA GT1"},
{"descripcion":"{ IOCE-00995 } CINTA SUPERIOR ENTRADA PROSEAL GT1"},
{"descripcion":"{ IOCE-00996 } CINTA INFERIOR ENTRADA PROSEAL GT1"},
{"descripcion":"{ IOCE-01900 } LINEA ALIMENTACION DE CAJAS"},
{"descripcion":"{ IOCE-01901 } DETECTOR METALES LINEA BANDEJITAS / CEIA"},
{"descripcion":"{ IOCE-01902 } TORNAMESA LINEA BANDEJITAS"},
{"descripcion":"{ IOCE-01905 } TORNAMESA LINEA GT1"},
{"descripcion":"{ IOCE-01906 } CINTA CURVA SALIDA TORNAMESA"},
{"descripcion":"{ IOCE-01907 } CINTA RECEPCION CINTA CURVA SALIDA TORNAMESA"},
{"descripcion":"{ IOCE-01908 } CINTA ALIMENTACION TERMOSELLADORA MONTESA"},
{"descripcion":"{ IOCE-01917 } FECHADORA LINX 7300 NÂº1"},
{"descripcion":"{ IOCE-01918 } FECHADORA LINX 7300 N 2"},
{"descripcion":"{ IOCE-01920 } ENVASADORA BANDEJAS 4"},
{"descripcion":"{ IOCE-01921 } ENVASADORA DE BANDEJAS PIU 55 (ORIENTE)"},
{"descripcion":"{ IOCE-01924 } CINTA ELEVADORA PRODU"},
{"descripcion":"{ IOCE-01925 } CINTA CUADRUPLE"},
{"descripcion":"{ IOCE-01926 } CINTA INTRALOX TRASPASO BANDEJITAS"},
{"descripcion":"{ IOCE-01927 } CINTA LINEA PRO SEAL"},
{"descripcion":"{ IOCE-01931 } ENVASADORA DE BANDEJAS PIU 55 (PONIENTE)"},
{"descripcion":"{ IOCE-01932 } CALIBRADORA SALIDA ULMA ORIENTE"},
{"descripcion":"{ IOCE-01933 } CINTA ALIMENTACION DETECTOR METALES BANDEJITAS"},
{"descripcion":"{ IOCE-01934 } FECHADORA KGK ULMA PONIENTE (2)"},
{"descripcion":"{ IOCE-01936 } CINTA ETIQUETADORA STIPACK T190 WR LINEA GT1"},
{"descripcion":"{ IOCE-01938 } CINTA ALIMENTACION PIU 1921"},
{"descripcion":"{ IOCE-01939 } CINTA SALIDA ULMA 1920"},
{"descripcion":"{ IOCE-01940 } CALIBRADORA SALIDA ULMA PONIENTE"},
{"descripcion":"{ IOCE-01941 } CINTA POLINES SALIDA 1940"},
{"descripcion":"{ IOCE-01942 } CINTA POLINES SALIDA 1950"},
{"descripcion":"{ IOCE-01943 } ETIQUETADOR STIPACK T190 WR (LINEA PIU)"},
{"descripcion":"{ IOCE-01944 } CINTA ALIMENTACION PIU 1931"},
{"descripcion":"{ IOCE-01945 } CINTA POLINES SALIDA 1939"},
{"descripcion":"{ IOCE-01946 } CAMA RUEDAS RECEPCION CINTA 1907"},
{"descripcion":"{ IOCE-01950 } CALIBRADORA SALIDA TERMOFORMADORA"},
{"descripcion":"{ IOCE-01951 } FECHADORA KGK ULMA ORIENTE (1)"},
{"descripcion":"{ IOCE-02601 } CINTA ELEVADORA ULMA PONIENTE"},
{"descripcion":"{ IOCE-02602 } CINTA DOBLE ULMA PONIENTE"},
{"descripcion":"{ IOCE-02603 } SELLADORA BANDEJAS ULMA PONIENTE"},
{"descripcion":"{ IOCE-02604 } ETIQUETADOR STIPACK ULMA PONIENTE"},
{"descripcion":"{ IOCE-02701 } CINTA ELEVADORA ULMA ORIENTE"},
{"descripcion":"{ IOCE-02702 } CINTA DOBLE ULMA ORIENTE"},
{"descripcion":"{ IOCE-02703 } SELLADORA BANDEJAS ULMA ORIENTE"},
{"descripcion":"{ IOCE-02704 } ETIQUETADOR STIPACK ULMA ORIENTE"},
{"descripcion":"{ IOCE-00476 } ARMADORA DE CAJAS N 3 (TERCERA DE ORIENTE A PONIENTE)"},
{"descripcion":"{ IOCE-00477 } ARMADORA DE CAJAS N 2 (SEGUNDA DE ORIENTE A PONIENTE)"},
{"descripcion":"{ IOCE-00478 } ARMADORA DE CAJAS N 1 (PRIMERA DE ORIENTE A PONIENTE)"},
{"descripcion":"{ IOCE-00479 } CINTA SALIDA ARMADO CAJAS"},
{"descripcion":"{ IOCE-00480 } CINTA ALIMENTACION LINEA DE CAJAS"},
{"descripcion":"{ IOCA-01467 } ABLANDADOR AGUA NÂº 3"},
{"descripcion":"{ IOCA-01468 } ABLANDADOR AGUA NÂº 4"},
{"descripcion":"{ IOCE-00260 } BOMBA DE SANGRE VOGT"},
{"descripcion":"{ IOCE-00261 } BOMBA DE SANGRE 2 GRESCO"},
{"descripcion":"{ IOCE-00271 } BOMBA SANGRE KSB"},
{"descripcion":"{ IOCE-05000 } LINEA CALIBRADO"},
{"descripcion":"{ IOCE-05001 } TRANSFERIDOR CALIBRAD"},
{"descripcion":"{ IOCE-05002 } UNIDAD BOTADORES CALI"},
{"descripcion":"{ IOCE-05012 } LINEA CALIBRADO POLLO"},
{"descripcion":"{ IOCE-05013 } CALIBRADORA DE POLLO SEGUNDA"},
{"descripcion":"{ IOCE-05014 } CINTA POLLOS SEGUNDA"},
{"descripcion":"{ IOCA-01615 } EXTRACTOR CAMPANA LINEA CASINO"},
{"descripcion":"{ IOCA-01618 } EXTRACTOR SOBRE DESCONCHE CASINO"},
{"descripcion":"{ IOCA-01619 } EXTRACTOR SOBRE COCINA N 1"},
{"descripcion":"{ IOCA-01620 } EXTRACTOR SOBRE COCINA N 2"},
{"descripcion":"{ IOCA-01621 } EXTRACTOR SOBRE COCINA N 3"},
{"descripcion":"{ IOCA-00473 } SALA DE SECADO (AMONIACO)"},
{"descripcion":"{ IOCA-00475 } SALA DE SECADO (GLICOL)"},
{"descripcion":"{ IOCE-00426 } LINEA SECADO POR AIRE"},
{"descripcion":"{ IOCE-00474 } DESINFECTADOR GANCHOS"},
{"descripcion":"{ IOCE-00110 } CINTA N 5 COLGADO"},
{"descripcion":"{ IOCE-00111 } CINTA N 6 CURVA"},
{"descripcion":"{ IOCE-00112 } LAVADORA DE JABAS N 1"},
{"descripcion":"{ IOCE-00113 } LAVADORA DE JABAS N 2"},
{"descripcion":"{ IOCE-00116 } LINEA MATANZA"},
{"descripcion":"{ IOCE-00123 } CINTA N 3 SUBIDA JABAS"},
{"descripcion":"{ IOCE-00130 } CINTA BY PASS"},
{"descripcion":"{ IOCE-00152 } LAVADOR DE GANCHOS"},
{"descripcion":"{ IOCA-00346 } BOMBA AGUA BLANDA 2"},
{"descripcion":"{ IOCA-00351 } BOMBA AGUA BLANDA 1"},
{"descripcion":"{ IOCA-00352 } BOMBA AGUA DURA SUR"},
{"descripcion":"{ IOCA-00353 } BOMBA AGUA DURA NORTE"},
{"descripcion":"{ IOCA-00354 } BOMBA ANERA 1"},
{"descripcion":"{ IOCA-00359 } BOMBA ANERA 2"},
{"descripcion":"{ IOCE-00312 } DESCOLGADOR DE POLLOS"},
{"descripcion":"{ IOCE-00314 } CHILLER AGUA N 2 MEYN"},
{"descripcion":"{ IOCE-00322 } CHILLER AGUA N 3 SEMIL"},
{"descripcion":"{ IOCE-00323 } CINTA ELEVADORA CHILLER AGUA N 1"},
{"descripcion":"{ IOCE-00324 } CINTA TRASPASO CHILLER N 2 A N 3"},
{"descripcion":"{ IOCE-00328 } BOMBA RECUPERACION AGUA PARA TRITURADOR Y CANALETA EXPURGO"},
{"descripcion":"{ IOCE-00329 } BOMBA RECUPERACION AGUA DE CHILLER A PRECHILLER SEMIL"},
{"descripcion":"{ IOCE-00330 } BOMBA RECUPERACION AGUA DE CINTA SALIDA A PRECHILLER SEMIL"},
{"descripcion":"{ IOCE-00331 } BOMBA RECUPERACION AGUA PARA PRECHILLER MEYN"},
{"descripcion":"{ IOCE-00332 } BOMBA RECIRCULACION CHILLER"},
{"descripcion":"{ IOCE-00347 } CINTA ALIMENTACION POLLO EXPURGO/COPE"},
{"descripcion":"{ IOCE-00348 } CINTA ALIMENTACION POLLO/COPE"},
{"descripcion":"{ IOCE-00349 } COPE CHILLER MORRIS"},
{"descripcion":"{ IOCE-00350 } CHILLER AGUA N 1 MORRIS"},
{"descripcion":"{ IOCE-00392 } CINTA TRASPASO CHILLER N 1 A N 2"},
{"descripcion":"{ IOCE-00465 } ROSCA HIELO CHILLER POLLOS"},
{"descripcion":"{ IOCE-00467 } ROSCA HIELO GARRAS"},
{"descripcion":"{ IOCE-01007 } CHILLER DE CORAZONES"},
{"descripcion":"{ IOCE-01008 } EMBOLS.MENUD.MONTAL 1"},
{"descripcion":"{ IOCE-01040 } CHILLER MENUDOS NÂº1 CONTRE"},
{"descripcion":"{ IOCE-01041 } CHILLER MENUDOS NÂº2 PANAS"},
{"descripcion":"{ IOCE-01042 } CHILLER MENUDOS NÂº3 COGOTE CON PIEL"},
{"descripcion":"{ IOCE-01050 } ROSCA DE HIELO SALA MAQUINAS N 1 (PRINCIPAL)"},
{"descripcion":"{ IOCE-01051 } ROSCA DE HIELO N 2 DESCARGA A CHILLER DE MENUDENCIAS"},
{"descripcion":"{ IOCE-01052 } ROSCA DE HIELO INCLINADA N 3"},
{"descripcion":"{ IOCE-01053 } ROSCA DE HIELO PRECHILLER N 4 (DESCARGA A ROSCA 1056)"},
{"descripcion":"{ IOCE-01056 } ROSCA DE HIELO N 6 DESCARGA A PRECHILLER SEMIL"},
{"descripcion":"{ IOCA-00070 } SISTEMA DETECCION DE AMONIACO"},
{"descripcion":"{ IOCA-00071 } DETECTOR DE AMONIACO"},
{"descripcion":"{ IOCA-00072 } DETECTOR DE AMONIACO"},
{"descripcion":"{ IOCA-00073 } EQUIPO DE RESPIRACION AUTONOMO"},
{"descripcion":"{ IOCA-00074 } EQUIPO DE RESPIRACION AUTONOMO"},
{"descripcion":"{ IOCA-00356 } BOMBA EVISCERADO N 1"},
{"descripcion":"{ IOCA-00357 } BOMBA EVISCERADO N 2"},
{"descripcion":"{ IOCA-00358 } BOMBA EVISCERADO N 3"},
{"descripcion":"{ IOCA-00360 } BOMBA ASEO 1"},
{"descripcion":"{ IOCA-00361 } BOMBA ASEO 2"},
{"descripcion":"{ IOCA-00370 } BOMBA AMONIACO WITT GP-51"},
{"descripcion":"{ IOCA-00371 } BOMBA AMONIACO WITT GP-51"},
{"descripcion":"{ IOCA-00372 } BOMBA AMONIACO WITT GP-51"},
{"descripcion":"{ IOCA-00373 } BOMBA AMONIACO WITT GP-52"},
{"descripcion":"{ IOCA-00374 } BOMBA AMONIACO WITT GP-52"},
{"descripcion":"{ IOCA-00375 } BOMBA AMONIACO WITT GP-52"},
{"descripcion":"{ IOCA-00376 } BOMBA AMONIACO WITT GP-51"},
{"descripcion":"{ IOCA-00377 } BOMBA AMONIACO WITT GP-51"},
{"descripcion":"{ IOCA-00378 } BOMBA AMONIACO WITT GP-52"},
{"descripcion":"{ IOCA-00379 } BOMBA AMONIACO WITT GP-52"},
{"descripcion":"{ IOCA-01310 } CELDA DE CARGA DE TRANSFORMADOR N 1"},
{"descripcion":"{ IOCA-01311 } CELDA DE CARGA DE TRANSFORMADOR N 2"},
{"descripcion":"{ IOCA-01312 } CELDA DE CARGA DE TRANSFORMADOR N 3"},
{"descripcion":"{ IOCA-01400 } COMPRESOR AMONIACO NÂº 1 (ALTA)"},
{"descripcion":"{ IOCA-01401 } COMPRESOR AMONIACO NÂº 2 (ALTA)"},
{"descripcion":"{ IOCA-01402 } COMPRESOR AMONIACO NÂº 3 (ALTA)"},
{"descripcion":"{ IOCA-01405 } COMPRESOR AMONIACO NÂº 9 (TORNILLO)"},
{"descripcion":"{ IOCA-01406 } COMPRESOR AMONIACO NÂº10 (TORNILLO)"},
{"descripcion":"{ IOCA-01407 } COMPRESOR FREON NÂº 1"},
{"descripcion":"{ IOCA-01408 } COMPRESOR FREON NÂº 2"},
{"descripcion":"{ IOCA-01409 } COMPRESOR FREON NÂº 3"},
{"descripcion":"{ IOCA-01411 } COMPRESOR FREON NÂº 5"},
{"descripcion":"{ IOCA-01412 } COMPRESOR FREON NÂº 6"},
{"descripcion":"{ IOCA-01413 } COMPRESOR FREON NÂº 7"},
{"descripcion":"{ IOCA-01414 } BOMBA AGUA NÂº 1 COMPRESORES FREON"},
{"descripcion":"{ IOCA-01415 } BOMBA AGUA NÂº 2 COMPRESORES FREON"},
{"descripcion":"{ IOCA-01416 } CONDENSADOR EVAPORATIVO NÂº 1"},
{"descripcion":"{ IOCA-01417 } CONDENSADOR EVAPORATIVO NÂº 2"},
{"descripcion":"{ IOCA-01418 } CONDENSADOR EVAPORATIVO NÂº 3"},
{"descripcion":"{ IOCA-01419 } CONDENSADOR EVAPORATIVO NÂº 4"},
{"descripcion":"{ IOCA-01420 } CONDENSADOR EVAPORATIVO NÂº 5"},
{"descripcion":"{ IOCA-01422 } CHILLER MORRIS"},
{"descripcion":"{ IOCA-01423 } RECIRCULADOR LIQUIDO BAJA NÂº 5"},
{"descripcion":"{ IOCA-01424 } RECIRCULADOR LIQUIDO ALTA NÂº 1"},
{"descripcion":"{ IOCA-01425 } RECIRCULADOR LIQUIDO ALTA NÂº 2"},
{"descripcion":"{ IOCA-01426 } DESHIDRATADOR"},
{"descripcion":"{ IOCA-01431 } GENERADOR NÂº 3 VOLVO"},
{"descripcion":"{ IOCA-01432 } BOMBA POZO NÂº 1 NORTE"},
{"descripcion":"{ IOCA-01433 } BOMBA POZO NÂº 2 SUR"},
{"descripcion":"{ IOCA-01434 } BOMBA POZO NÂº 3"},
{"descripcion":"{ IOCA-01435 } BOMBA HIDROPAC NÂº 1 20 HP"},
{"descripcion":"{ IOCA-01436 } BOMBA HIDROPAC NÂº 2 20 HP"},
{"descripcion":"{ IOCA-01437 } BOMBA HIDROPAC NÂº 3 20 HP"},
{"descripcion":"{ IOCA-01438 } BOMBA HIDROPAC NÂº 4 10 HP"},
{"descripcion":"{ IOCA-01440 } SECADOR DE AIRE"},
{"descripcion":"{ IOCA-01442 } TRANSFORMADOR ELECTRICO NÂº 1 (PRODUCCION)"},
{"descripcion":"{ IOCA-01443 } TRANSFORMADOR ELECTRICO NÂº 2 (SADEMA)"},
{"descripcion":"{ IOCA-01444 } COMPRESOR AIRE NÂº 1"},
{"descripcion":"{ IOCA-01445 } COMPRESOR AIRE NÂº 2"},
{"descripcion":"{ IOCA-01446 } COMPRESOR AIRE NÂº 3"},
{"descripcion":"{ IOCA-01463 } PLATE CHILLER NÂº 2"},
{"descripcion":"{ IOCA-01469 } ABLANDADOR AGUA NÂº 5"},
{"descripcion":"{ IOCA-01470 } ABLANDADOR AGUA NÂº 6"},
{"descripcion":"{ IOCA-01471 } GRUPO GENERADOR CUMMINS STAMFORD LEEGA 200CS"},
{"descripcion":"{ IOCA-01476 } GRUPO GENERADOR WILSON/PERKINS.(1.650 KV"},
{"descripcion":"{ IOCA-01477 } COMPRESOR AIRE NÂº 4 (COMP AIR)"},
{"descripcion":"{ IOCA-01478 } SECADOR AIRE (DEMAG)"},
{"descripcion":"{ IOCA-01479 } COMPRESOR AMONIACO NÂº 11 (TORNILLO)"},
{"descripcion":"{ IOCA-01481 } RECIRCULADOR DE LIQUIDO BAJA NÂº 6"},
{"descripcion":"{ IOCA-01482 } CONDENSADOR DE PLACA NÂº 6"},
{"descripcion":"{ IOCA-01483 } TRANSFORMADOR ELECTRICO NÂº 3 (PRODUCCION)"},
{"descripcion":"{ IOCA-01484 } CALDERA (GENERADOR VAPOR)"},
{"descripcion":"{ IOCA-01485 } ABLANDADOR AGUA NÂº 7"},
{"descripcion":"{ IOCA-01486 } ABLANDADOR AGUA NÂº 8"},
{"descripcion":"{ IOCA-01489 } COMPRESOR AMONIACO NÂº 12 (TORNILLO)"},
{"descripcion":"{ IOCA-01493 } UNIDAD MANEJADORA AIRE CASINO"},
{"descripcion":"{ IOCA-01494 } BOMBA DE VACIO SALA DE MAQUINAS"},
{"descripcion":"{ IOCA-01495 } SISTEMA GLICOL SALA MAQUINAS"},
{"descripcion":"{ IOCA-01496 } SISTEMA DE CLORACION SALA DE MAQUINAS"},
{"descripcion":"{ IOCA-01497 } CALENTADOR DE AGUA DUCHAS"},
{"descripcion":"{ IOCA-01498 } COPA DE AGUA"},
{"descripcion":"{ IOCA-01499 } SISTEMA DE SANITIZACION SALA DE MAQUINAS"},
{"descripcion":"{ IOCA-01500 } MAQUINA HIELO MADEF N 1"},
{"descripcion":"{ IOCA-01501 } COMPRESOR MADEF"},
{"descripcion":"{ IOCA-01502 } TRAMPA DE HIELO MADEF N 1"},
{"descripcion":"{ IOCA-01503 } PURGADOR DE GASES NO CONDENSABLES"},
{"descripcion":"{ IOCA-01504 } CONDENSADOR EVAPORATIVO N 7"},
{"descripcion":"{ IOCA-01506 } ACUMULADOR DE AMONIACO LIQUIDO"},
{"descripcion":"{ IOCA-01507 } MAQUINA DE HIELO MADEF N 2"},
{"descripcion":"{ IOCA-01508 } MAQUINA DE HIELO MADEF N 3"},
{"descripcion":"{ IOCA-01509 } MAQUINA DE HIELO MADEF N 4"},
{"descripcion":"{ IOCA-01510 } TRAMPA DE HIELO MADEF N 3-4"},
{"descripcion":"{ IOCA-01522 } PLATE CHILLER NÂº 3"},
{"descripcion":"{ IOCA-01600 } EXTRACTOR POLVO RECEPCION"},
{"descripcion":"{ IOCA-01601 } EXTRACTOR TUNEL SANGRADO"},
{"descripcion":"{ IOCA-01602 } EXTRACTOR AIRE DESPLUMADO"},
{"descripcion":"{ IOCA-01603 } EXTRACTOR AIRE SALA EVISCERADO"},
{"descripcion":"{ IOCA-01604 } EXTRACTOR DE AIRE COPE"},
{"descripcion":"{ IOCA-01605 } EXTRACTOR AIRE SALA ENFRIADO"},
{"descripcion":"{ IOCA-01606 } EXTRACTOR DE AIRE EMPAQUE"},
{"descripcion":"{ IOCA-01607 } EXTRACTOR EMBOLSADORAS SALA EMPAQUE"},
{"descripcion":"{ IOCA-01608 } EXTRACTOR VAPOR SALA PATAS"},
{"descripcion":"{ IOCA-01609 } EXTRACTOR DE AIRE TROZADO 1 Y 2 PISO"},
{"descripcion":"{ IOCA-01610 } EXTRACTOR MADEF 4"},
{"descripcion":"{ IOCA-01611 } EXTRACTOR MADEF 1"},
{"descripcion":"{ IOCA-01612 } EXTRACTOR LAVADORABANDEJAS N 1"},
{"descripcion":"{ IOCA-01613 } EXTRACTOR LAVADORABANDEJAS N 2"},
{"descripcion":"{ IOCA-01614 } EXTRACTOR LAVADORABANDEJAS N 3"},
{"descripcion":"{ IOCA-01616 } EXTRACTOR BAÑO"},
{"descripcion":"{ IOCA-01617 } EXTRACTOR DE AIRE PASILLO MATADERO"},
{"descripcion":"{ IOCA-01700 } INYECTOR AIRE SALA EMPAQUE"},
{"descripcion":"{ IOCA-01701 } INYECTOR DE AIRE RECEPCION/SANGRADO"},
{"descripcion":"{ IOCA-01702 } INYECTOR AIRE TUNEL SANGRADO"},
{"descripcion":"{ IOCA-01703 } INYECTOR DE AIRE SALA DESPLUMADO"},
{"descripcion":"{ IOCA-01704 } INYECTOR SALA EVISCERADO"},
{"descripcion":"{ IOCA-01705 } INYECTOR DE AIRE SALA ENFRIADO"},
{"descripcion":"{ IOCA-01706 } INYECTOR BAÑO NUEVO"},
{"descripcion":"{ IOCA-01707 } INYECTOR DE AIRE TROZADO 2 PISO"},
{"descripcion":"{ IOCE-03400 } LAVADORA DE PLASTICO"},
{"descripcion":"{ IOCE-03500 } ENFARDADORA"},
{"descripcion":"{ IOCE-00978 } CINTA DESHUESADO TRUTRO (LARGA)"},
{"descripcion":"{ IOCA-00624 } RAMPA DE CARGA NÂº 2 (ORIENTE)."},
{"descripcion":"{ IOCA-00625 } RAMPA DE CARGA NÂº 1 (PONIENTE)"},
{"descripcion":"{ IOCA-00650 } RAMPA CARGA NÂº 3"},
{"descripcion":"{ IOCA-00651 } RAMPA CARGA NÂº 4"},
{"descripcion":"{ IOCA-00652 } RAMPA CARGA NÂº 5"},
{"descripcion":"{ IOCA-00656 } CAMARA DESPACHO"},
{"descripcion":"{ IOCE-00624 } ANDEN N 1"},
{"descripcion":"{ IOCE-00625 } ANDEN N 2"},
{"descripcion":"{ IOCE-00650 } ANDEN N 3"},
{"descripcion":"{ IOCE-00651 } ANDEN N 4"},
{"descripcion":"{ IOCE-00652 } ANDEN N 5"},
{"descripcion":"{ IOCE-00653 } ANDEN N 6"},
{"descripcion":"{ IOCE-00657 } CORTINA DE AIRE ANDEN N 1"},
{"descripcion":"{ IOCE-00658 } CORTINA DE AIRE ANDEN N 2"},
{"descripcion":"{ IOCE-00659 } CORTINA DE AIRE ANDEN N 3"},
{"descripcion":"{ IOCE-00660 } CORTINA DE AIRE ANDEN N 4"},
{"descripcion":"{ IOCE-00661 } CORTINA DE AIRE ANDEN N 5"},
{"descripcion":"{ IOCE-00662 } CORTINA DE AIRE ANDEN N 6"},
{"descripcion":"{ IOCE-03830 } ENVOLVEDORA DE PALLET DESPACHO"},
{"descripcion":"{ IOCA-654 } CAMARA FRESCO NÂº 38"},
{"descripcion":"{ IOCE-00200 } ESCALDADORA N 1"},
{"descripcion":"{ IOCE-00201 } ESCALDADORA N 2"},
{"descripcion":"{ IOCE-00210 } CORTADOR DE CABEZAS"},
{"descripcion":"{ IOCE-00211 } PELADOR DE COLA"},
{"descripcion":"{ IOCE-00222 } PELADORA IMPIANTI SCP3-350 CONTRAROTANTE"},
{"descripcion":"{ IOCE-00223 } PELADORA IMPIANTI B5-D22 REPASADORA"},
{"descripcion":"{ IOCE-00224 } PELADORA MEYN N 1"},
{"descripcion":"{ IOCE-00225 } PELADORA MEYN N 2"},
{"descripcion":"{ IOCE-00226 } ESCALDADORA DE ALA IMPIANTI"},
{"descripcion":"{ IOCE-00254 } VENTILADOR SALA PELADO"},
{"descripcion":"{ IOCE-00258 } EXTRACTOR AIRE NÂº 3 PUERTA PELADO SUPERIOR LADO SUR"},
{"descripcion":"{ IOCE-00259 } EXTRACTOR AIRE N 4 PUERTA SUPERIOR PELADO LADO NORTE"},
{"descripcion":"{ IOCE-00262 } EXTRACTOR AIRE NÂº 5 PUERTA PELADO INFERIOR LADO SUR"},
{"descripcion":"{ IOCE-00263 } EXTRACTOR AIRE NÂº 6 PUERTA PELADO INFERIOR LADO NORTE"},
{"descripcion":"{ IOCE-00381 } PISTOLA ANERA NÂº1"},
{"descripcion":"{ IOCE-00382 } PISTOLA ANERA NÂº 2"},
{"descripcion":"{ IOCE-00383 } PISTOLA ANERA NÂº3"},
{"descripcion":"{ IOCE-04006 } CINTA INTRALOX ELEVADORA NÂº 1 ( Enfriado)"},
{"descripcion":"{ IOCE-04007 } CINTA EMPAQUE GARRAS N 2 ( Enfriado)"},
{"descripcion":"{ IOCE-04009 } CHILLER DE GARRAS"},
{"descripcion":"{ IOCE-04010 } SECADOR DE PATAS"},
{"descripcion":"{ IOCE-04011 } CINTA ELEVADORA SELECCION GARRAS"},
{"descripcion":"{ IOCE-04012 } CINTA EMPAQUE CAJAS GARRAS"},
{"descripcion":"{ IOCA-05017 } EVAPORADOR DE GLICOL N 1 EMPAQUE SELECCION"},
{"descripcion":"{ IOCA-05018 } EVAPORADOR DE GLICOL N 2 EMPAQUE SELECCION"},
{"descripcion":"{ IOCA-05019 } EVAPORADOR DE GLICOL N 3 EMPAQUE CALIBRADO"},
{"descripcion":"{ IOCA-05020 } EVAPORADOR DE GLICOL N 4 EMPAQUE CALIBRADO"},
{"descripcion":"{ IOCA-05021 } EVAPORADOR DE GLICOL N 5 EMPAQUE"},
{"descripcion":"{ IOCA-05022 } EVAPORADOR DE GLICOL N 6 EMPAQUE"},
{"descripcion":"{ IOCA-05023 } EVAPORADOR DE GLICOL N 7 EMPAQUE SABORIZADO"},
{"descripcion":"{ IOCE-00423 } SIST. EMBOLSADO STAR F"},
{"descripcion":"{ IOCE-00433 } CINTA ENTRADA MAQ.5015"},
{"descripcion":"{ IOCE-00471 } FECHADORA LINX 7300 N 3"},
{"descripcion":"{ IOCE-00472 } FECHADORA VIDEOJET 1510"},
{"descripcion":"{ IOCE-00484 } CLIPEADORAS"},
{"descripcion":"{ IOCE-00487 } SELLADO POLLO AL VACIO"},
{"descripcion":"{ IOCE-00700 } CLIPEADORA EZ4525 8419 (2)"},
{"descripcion":"{ IOCE-00701 } CLIPEADORA EZ4524 6088 (3)"},
{"descripcion":"{ IOCE-00702 } CLIPEADORA EZ4525 350/14 (4)"},
{"descripcion":"{ IOCE-00703 } CLIPEADORA EZ4524 5923 (5)"},
{"descripcion":"{ IOCE-00704 } CLIPEADORA EZ4525 348/14 (6)"},
{"descripcion":"{ IOCE-00705 } CLIPEADORA EZ90 5931 (7)"},
{"descripcion":"{ IOCE-00706 } CLIPEADORA EZ4500 429/15 (8)"},
{"descripcion":"{ IOCE-00707 } CLIPEADORA EZ635 10368 (10)"},
{"descripcion":"{ IOCE-00708 } CLIPEADORA EZ4500 1160/20 (11)"},
{"descripcion":"{ IOCE-00709 } CLIPEADORA EZ4500 1211/20 (12)"},
{"descripcion":"{ IOCE-00710 } CLIPEADORA EZ4500 1280/21 (13)"},
{"descripcion":"{ IOCE-01937 } FECHADORA LINX 7900"},
{"descripcion":"{ IOCE-01947 } FECHADORA LINX 8910"},
{"descripcion":"{ IOCE-05003 } CINTA TRANSP.POLLOS 1"},
{"descripcion":"{ IOCE-05004 } CINTA TRANSPORTADORA POLLOS N 2"},
{"descripcion":"{ IOCE-05005 } CINTA CAJAS N 1"},
{"descripcion":"{ IOCE-05006 } CINTA CAJAS N 2"},
{"descripcion":"{ IOCE-05007 } CINTA CAJAS N 3"},
{"descripcion":"{ IOCE-05008 } CINTA CAJAS N 4"},
{"descripcion":"{ IOCE-05009 } CINTA CAJAS N 5"},
{"descripcion":"{ IOCE-05011 } CINTA TRANSPORTE Y POLINES"},
{"descripcion":"{ IOCE-05015 } ENVOLVEDORA CAJAS POL"},
{"descripcion":"{ IOCE-05016 } CINTA POLLOS 3"},
{"descripcion":"{ IOCE-05017 } CINTA POLLOS 4"},
{"descripcion":"{ IOCE-05100 } EMBOLSADORA DE POLLO ENTERO"},
{"descripcion":"{ IOCE-05102 } EMBOLSADORA DE POLLO ENTERO"},
{"descripcion":"{ IOCE-05103 } EMBOLSADORA DE POLLO ENTERO"},
{"descripcion":"{ IOCE-05104 } EMBOLSADORA DE POLLO ENTERO"},
{"descripcion":"{ IOCA-00605 } CAMARA NÂº 5"},
{"descripcion":"{ IOCE-00955 } CINTA SALIDA IQF N 1"},
{"descripcion":"{ IOCE-00961 } DETECTOR DE METALES IQF"},
{"descripcion":"{ IOCE-00963 } CINTA DOBLE ARMADO CAJ"},
{"descripcion":"{ IOCE-00965 } ENVOLVEDORA CAJAS POLY"},
{"descripcion":"{ IOCE-00971 } MONTACARGA 1 A 2 PIS"},
{"descripcion":"{ IOCE-00972 } CINTA CURVA ENTRADA PO"},
{"descripcion":"{ IOCE-06026 } CINTA BAJADA (TRUTROS"},
{"descripcion":"{ IOCE-00150 } CONTROLAD LINEAS MATANZAS"},
{"descripcion":"{ IOCE-00300 } LINEA EVISCERADO AUTOM"},
{"descripcion":"{ IOCE-00301 } LINEA EVISCERADO MANUA"},
{"descripcion":"{ IOCE-00302 } TRANSFERIDOR AUTOMATIC"},
{"descripcion":"{ IOCE-00303 } CINTA COLGADO EVISCERADO 1"},
{"descripcion":"{ IOCE-00304 } CINTA COLGADO EVISCERADO 2"},
{"descripcion":"{ IOCE-00309 } BOMBA RECUPERACION AGUA DE DUCHA EMERGENCIA"},
{"descripcion":"{ IOCE-00310 } EXTRACTOR DE PULMONES"},
{"descripcion":"{ IOCE-00311 } DUCHA PARA POLLOS"},
{"descripcion":"{ IOCE-00316 } ANERA MODELO 595"},
{"descripcion":"{ IOCE-00317 } BUCHERA"},
{"descripcion":"{ IOCE-00318 } PELADORA DE CONTRES SM900"},
{"descripcion":"{ IOCE-00319 } EVISCERADOR MAESTRO NU"},
{"descripcion":"{ IOCE-00320 } ABRIDOR DE ABDOMEN TIJ"},
{"descripcion":"{ IOCE-00321 } QUEBRANTADOR COGOTES N"},
{"descripcion":"{ IOCE-00325 } ESTERILIZADOR"},
{"descripcion":"{ IOCE-00326 } BBA. TRANSPORTADORA HIGADO (WILDEN)"},
{"descripcion":"{ IOCE-00327 } BBA. TRANSPORTADORA COGOTES S/PIEL (WILDEN)"},
{"descripcion":"{ IOCE-00351 } PROCESADOR DE CONTRES MMD005"},
{"descripcion":"{ IOCE-00352 } TORNILLO ELEVADOR DE CONTRES"},
{"descripcion":"{ IOCE-00353 } MESA REPASO CONTRES"},
{"descripcion":"{ IOCE-00354 } CINTA ELEVADORA CONTRES"},
{"descripcion":"{ IOCE-00355 } LAVADOR DE CONTRES"},
{"descripcion":"{ IOCE-00360 } PROCESADORA DE CONTRES FRINOX PONIENTE"},
{"descripcion":"{ IOCE-00361 } PROCESADORA DE CONTRES FRINOX ORIENTE"},
{"descripcion":"{ IOCE-00362 } BOMBA TRANSPORTADORA COGOTE CON PIEL"},
{"descripcion":"{ IOCE-00363 } BBA. TRANSPOT. CORAZON"},
{"descripcion":"{ IOCE-00380 } PELADOR/SEPARADOR CORA"},
{"descripcion":"{ IOCE-00384 } PISTOLA ANERA NÂº4"},
{"descripcion":"{ IOCE-00386 } PROCESADORA CONTRES"},
{"descripcion":"{ IOCE-00388 } PELADOR DE COGOTES"},
{"descripcion":"{ IOCE-00390 } BBA. TRANSPORT. CONTRE"},
{"descripcion":"{ IOCE-00394 } TRITURADORA POLLOS"},
{"descripcion":"{ IOCE-00395 } CINTA TRITURADOR DE POLLOS"},
{"descripcion":"{ IOCE-00398 } BOMBA DE VACIO SERIE D-23-340321-01"},
{"descripcion":"{ IOCE-00399 } TRITURADOR DE POLLOS"},
{"descripcion":"{ IOCE-00400 } BOMBA DE VACIO SERIE D-21-330588-01"},
{"descripcion":"{ IOCE-04001 } DESCOLGADOR DE PATAS"},
{"descripcion":"{ IOCE-04002 } CINTA PATAS N 1"},
{"descripcion":"{ IOCE-04003 } ESCALDADORA DE PATAS"},
{"descripcion":"{ IOCE-04005 } PELADORA DE GARRAS"},
{"descripcion":"{ IOCE-04013 } CINTA PATAS N 2"},
{"descripcion":"{ IOCE-04014 } BOMBA MURZAN"},
{"descripcion":"{ IOCE-04015 } CORTADORA TENDONES DE GARRAS"},
{"descripcion":"{ IOCA-00954 } IQF"},
{"descripcion":"{ IOCE-00482 } INYECTORA METALQUIMIA"},
{"descripcion":"{ IOCE-00941 } ZARANDA ALIMENTACION IQF"},
{"descripcion":"{ IOCE-00942 } VOLTEADOR DE BINS"},
{"descripcion":"{ IOCE-00943 } CINTA ELEVACION DE PRODUCTO A GUNTHER"},
{"descripcion":"{ IOCE-00944 } CINTA ALIMENTACION GUNTHER"},
{"descripcion":"{ IOCE-00945 } COPE IQF"},
{"descripcion":"{ IOCE-00946 } CINTA ELEVADORA SALIDA GUNTHER"},
{"descripcion":"{ IOCE-00947 } INYECTORA GUNTHER"},
{"descripcion":"{ IOCE-00948 } SUPER CHILLER NOWIKI"},
{"descripcion":"{ IOCE-00951 } CINTA ALIMENTACION CHILLER IQF"},
{"descripcion":"{ IOCE-00953 } CINTA SALIDA IQF"},
{"descripcion":"{ IOCE-00954 } IQF"},
{"descripcion":"{ IOCE-00977 } CINTA ALIMENTACION IQF"},
{"descripcion":"{ IOCE-00450 } LINEA BANDEJAS LIMPIAS"},
{"descripcion":"{ IOCE-01000 } LINEA BANDEJAS SUCIAS"},
{"descripcion":"{ IOCE-01001 } LAVADORA BANDEJAS 1"},
{"descripcion":"{ IOCE-01002 } LAVADORA BANDEJAS 2"},
{"descripcion":"{ IOCE-00340 } SECADOR DE POLLOS KUCMAQ"},
{"descripcion":"{ IOCE-00401 } SECADOR DE POLLOS"},
{"descripcion":"{ IOCE-00428 } CINTA SALIDA SECADOR DE POLLOS"},
{"descripcion":"{ IOCE-00430 } CINTA CURVA ALIMENTACION 440"},
{"descripcion":"{ IOCE-00440 } CINTA ALIMENTACION INYECTORA"},
{"descripcion":"{ IOCE-00441 } DETECTOR METALES MARINADO"},
{"descripcion":"{ IOCE-00443 } CINTA COLGADO"},
{"descripcion":"{ IOCE-00444 } CINTA SALIDA INYECTORA"},
{"descripcion":"{ IOCE-00445 } CINTA ACELERACION POLLO"},
{"descripcion":"{ IOCE-00446 } SISTEMA RECHAZO PRODUCTO"},
{"descripcion":"{ IOCE-00447 } INYECTORA POLLOS FM10631"},
{"descripcion":"{ IOCE-00483 } INYECTORA POLLOS FM11747"},
{"descripcion":"{ IOCE-00950 } INYECTORA POLLOS FM8484"},
{"descripcion":"{ IOCE-00117 } INSENSIBILIZADOR"},
{"descripcion":"{ IOCE-00118 } MATADOR"},
{"descripcion":"{ IOCE-00131 } LAVADOR DE POLLOS"},
{"descripcion":"{ IOCE-00136 } ESTERILIZADOR DE HERRAMIENTAS SANGRADO"},
{"descripcion":"{ IOCE-00155 } CONTADOR POLLOS RECEPC"},
{"descripcion":"{ IOCE-00100 } UNIDAD DE VENTILACION"},
{"descripcion":"{ IOCE-00109 } CINTA N 9 INTRALOX"},
{"descripcion":"{ IOCE-00114 } CINTA N 7 CURVA POLIN"},
{"descripcion":"{ IOCE-00115 } CINTA N 8 SALIDA BAJADA"},
{"descripcion":"{ IOCE-00119 } CINTA RECEPCION PALET"},
{"descripcion":"{ IOCE-00120 } CINTA N 1 TRASP JABA"},
{"descripcion":"{ IOCE-00121 } CINTA CURVA N 2 JABAS"},
{"descripcion":"{ IOCE-00122 } DESAPILADOR JABAS"},
{"descripcion":"{ IOCE-00124 } SISTEMA DE LAVADO JABAS ALTA PRESION"},
{"descripcion":"{ IOCE-00125 } APILADOR JABAS"},
{"descripcion":"{ IOCE-00127 } CINTA CURVA N 11"},
{"descripcion":"{ IOCE-00128 } CINTA N 12 TRANSPORTADORA"},
{"descripcion":"{ IOCE-00129 } LAVADOR DE PALLET"},
{"descripcion":"{ IOCE-00134 } DESINFECTADOR DE JABAS"},
{"descripcion":"{ IOCE-00165 } BOMBA GUANO N 1"},
{"descripcion":"{ IOCE-00165.1 } UNIDAD ROTATORIA BOMBA GUANO N 1"},
{"descripcion":"{ IOCE-00932 } VOLTEADOR DE TAMBLER"},
{"descripcion":"{ IOCE-00966 } TAMBLER"},
{"descripcion":"{ IOCE-01928 } FECHADORA LINX 4900"},
{"descripcion":"{ IOCE-00466 } SIST. ALIMENT. SALMUER"},
{"descripcion":"{ IOCE-00160 } SEPARADOR SOLIDOS PLUMAS"},
{"descripcion":"{ IOCE-00161 } SIST HIDRAULICO REPECION"},
{"descripcion":"{ IOCE-00166 } SECADOR DE GUANO"},
{"descripcion":"{ IOCE-00168 } CENTRAL HIDRAUL.CILIN."},
{"descripcion":"{ IOCE-00389 } BBA. VACIO 2 ETAPAS 20"},
{"descripcion":"{ IOCE-00391 } SECADOR TRIPAS NAHUELC"},
{"descripcion":"{ IOCE-00393 } BBA. VACIO 2 ETAPAS SI"},
{"descripcion":"{ IOCE-00396 } BOMBA DE VACIO SERIE D-19-302922-01"},
{"descripcion":"{ IOCE-00397 } BOMBA DE VACIO SERIE D-20-312011-01"},
{"descripcion":"{ IOCA-00663 } CAMARA TROZADO FRESCO SEGUNDO PISO (5 B)"},
{"descripcion":"{ IOCA-00814 } EQUIPO AIRE ACONDICIONADO N 1"},
{"descripcion":"{ IOCA-00815 } EQUIPO AIRE ACONDICIONADO N 2"},
{"descripcion":"{ IOCA-00816 } EQUIPO AIRE ACONDICIONADO N 3"},
{"descripcion":"{ IOCA-00817 } EQUIPO AIRE ACONDICIONADO N 4"},
{"descripcion":"{ IOCA-00818 } EQUIPO AIRE ACONDICIONADO N 5"},
{"descripcion":"{ IOCA-00819 } EQUIPO AIRE ACONDICIONADO N 6"},
{"descripcion":"{ IOCA-06027 } EVAPORADOR DE GLICOL N 1 TROZADO"},
{"descripcion":"{ IOCA-06028 } EVAPORADOR DE GLICOL N 2 TROZADO"},
{"descripcion":"{ IOCA-06029 } EVAPORADOR DE GLICOL N 3 TROZADO"},
{"descripcion":"{ IOCA-06030 } EVAPORADOR DE GLICOL N 4 TROZADO"},
{"descripcion":"{ IOCA-06031 } EVAPORADOR DE GLICOL N 5 TROZADO"},
{"descripcion":"{ IOCA-06032 } EVAPORADOR DE GLICOL N 6 TROZADO"},
{"descripcion":"{ IOCE-00974 } ESTERILIZADOR"},
{"descripcion":"{ IOCE-06000 } LINEA TROZADO AUTOMAT"},
{"descripcion":"{ IOCE-06001 } CINTA COLGADO POLLOS"},
{"descripcion":"{ IOCE-06002 } ABRIDOR DE ALAS"},
{"descripcion":"{ IOCE-06003 } CORTADOR PUNTA ALAS"},
{"descripcion":"{ IOCE-06004 } CORTADOR ALA MEDIA"},
{"descripcion":"{ IOCE-06005 } CORTADOR ALA TRUTRO"},
{"descripcion":"{ IOCE-06006 } PRE CORTE PECHUGA"},
{"descripcion":"{ IOCE-06007 } CORTADOR PECHUGAS"},
{"descripcion":"{ IOCE-06008 } ARRANCADOR PUNTA LAPI"},
{"descripcion":"{ IOCE-06009 } CORTADOR DE COLA"},
{"descripcion":"{ IOCE-06010 } CORTADOR TRUTRO CUARTO"},
{"descripcion":"{ IOCE-06011 } PROCESADOR TRUTROS"},
{"descripcion":"{ IOCE-06012 } CORTADOR TRUTRO CORTO"},
{"descripcion":"{ IOCE-06013 } DESCOLGADOR TRUTROS"},
{"descripcion":"{ IOCE-06014 } LAVADOR DE GANCHOS"},
{"descripcion":"{ IOCE-06015 } CINTA ELEV.PUNTA LAPI"},
{"descripcion":"{ IOCE-06017 } CINTA ALA MEDIA"},
{"descripcion":"{ IOCE-06018 } CINTA ALA MEDIA Y ALA TRUTRO"},
{"descripcion":"{ IOCE-06019 } CINTA ELEV. ALA MEDIA"},
{"descripcion":"{ IOCE-06020 } CINTA SALIDA ALA MEDIA Y ALA TRUTRO"},
{"descripcion":"{ IOCE-06021 } CINTA PECHUGAS"},
{"descripcion":"{ IOCE-06022 } CINTA TRUTRO ENTERO"},
{"descripcion":"{ IOCE-06023 } CINTA TRUTRO CORTO"},
{"descripcion":"{ IOCE-06024 } CINTA SALIDA TRUTRO CORTO Y PECHUGA"},
{"descripcion":"{ IOCE-06025 } CINTA SALIDA TRUTRO LARGO"},
{"descripcion":"{ IOCE-06030 } ZARANDA SALIDA PRODUCTO TROZADO"},
{"descripcion":"{ IOCE-06040 } ABRIDOR DE ALAS ESTATICO"},
{"descripcion":"{ IOCE-02100 } LINEA TROZADO PRESITA"},
{"descripcion":"{ IOCE-02101 } SIERRA TROZADORA NÂº 1"},
{"descripcion":"{ IOCE-02102 } SIERRA TROZADORA NÂº 2"},
{"descripcion":"{ IOCE-02104 } SIERRA TROZADORA NÂº 4"},
{"descripcion":"{ IOCE-02105 } SIERRA TROZADORA NÂº 5"},
{"descripcion":"{ IOCE-02106 } SIERRA TROZADORA NÂº 6"},
{"descripcion":"{ IOCE-02107 } SIERRA TROZADORA NÂº 7"},
{"descripcion":"{ IOCE-02108 } CINTA N 9 PRESITAS"},
{"descripcion":"{ IOCE-02109 } SIERRA TROZADORA N 8"},
{"descripcion":"{ IOCE-02111 } SIERRA TROZADORA N 9"},
{"descripcion":"{ IOCE-00075 } MULTIMETRO DIGITAL"},
{"descripcion":"{ IOCE-00076 } CLAMP METER"},
{"descripcion":"{ IOCE-03000 } ALZA HOMBRE"},
{"descripcion":"{ IOCA-00602 } CAMARA NÂº 34"},
{"descripcion":"{ IOCA-02000 } CAMARA NÂº 31 TUNEL CONGELADO NÂº 1"},
{"descripcion":"{ IOCA-02001 } CAMARA NÂº 32 TUNEL CONGELADO NÂº 2"},
{"descripcion":"{ IOCA-02002 } CAMARA NÂº 33 TUNEL CONGELADO NÂº 3"},
{"descripcion":"{ IOCE-02006 } SELLADORA CONTINUA DE BOLSAS 1"},
{"descripcion":"{ IOCE-02007 } SELLADORA CONTINUA DE BOLSAS 2"},
{"descripcion":"{ IOCE-02008 } DETECTOR METALES CONGELADO"},
{"descripcion":"{ IOCE-02010 } SELLADORA DE BOLSA CONTINUA"},
{"descripcion":"{ IOCE-03841 } ENZUNCHADORA MARIENBERG"},
{"descripcion":"{ IOCE-00481 } LINEA TRANSPORTE CAJAS"},
{"descripcion":"{ AGP-10203.1 } MOTORREDUCTOR CINTA LARGA HACIA CALIBRADO 1"},
{"descripcion":"{ AGP-10204.1 } MOTORREDUCTOR CINTA LARGA HACIA CALIBRADO 2"},
{"descripcion":"{ AGP-10210 } ELEVADOR DE CAJAS EXTERIOR (REPETIDO 10317)"},
{"descripcion":"{ AGP-10519 } TUNEL SANITIZADO DE AVES DESPLUMADO"},
{"descripcion":"{ AGP-10638 } IMPULSOR PONIENTE VESTIDORES [N 77]"},
{"descripcion":"{ AGP-10639 } IMPULSOR ORIENTE VESTIDORES [N 78]"},
{"descripcion":"{ AGP-10646 } TABLEROS ELECTRICOS SUB ESTACION N 1-2-3-4"},
{"descripcion":"{ AGP-10647 } TABLERO ELECTRCO SUB ESTACION N 6"},
{"descripcion":"{ AGP-10664 } SECADOR KAESER DC 50 E CALIBRADO"},
{"descripcion":"{ AGP-10665 } SEPARADOR AGUA ACEITE AQUAMAT CF 75"},
{"descripcion":"{ AGP-10666 } FILTRO LINEA F 250 KE"},
{"descripcion":"{ AGP-09489 } UNIDAD EVAPORADORA ANTECAMARA AHUMADO"},
{"descripcion":"{ AGP-09489.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA ANTECAMARA AHUMADO"},
{"descripcion":"{ AGP-09489.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA ANTECAMARA AHUMADO"},
{"descripcion":"{ AGP-09489.3 } MOTOR VENTILADOR N 3 UNIDAD EVAPORADORA ANTECAMARA AHUMADO"},
{"descripcion":"{ AGP-09374 } AIRE AC CASINO AHUMADO"},
{"descripcion":"{ AGP-09373 } AIRE AC OFICINA SUPERVISORES AHUMADO"},
{"descripcion":"{ AGP-09133 } LÃNEA DE AGUA BLANDA"},
{"descripcion":"{ AGP-09134 } LÃNEA AGUA FRÃA"},
{"descripcion":"{ AGP-09135 } LÃNEA AGUA NATURAL (POZO)"},
{"descripcion":"{ AGP-09160 } SISTEMA DE DETECCION DE INCENDIOS"},
{"descripcion":"{ AGP-09166 } SISTEMA DE DETECCION DE AMONIACO"},
{"descripcion":"{ AGP-10214 } LINEA DE AIRE COMPRIMIDO"},
{"descripcion":"{ AGP-10656 } ESTANQUE DE GAS LICUADO ALIMENTACION CASINO LAVANDERIA Y CALEFONT"},
{"descripcion":"{ AGP-10673 } LINEA AEREA MEDIA TENSION"},
{"descripcion":"{ AGP-01001 } RAMPAS ANDEN CONGELADOS"},
{"descripcion":"{ AGP-10249 } REFEERS 237"},
{"descripcion":"{ AGP-10250 } REFEERS 238"},
{"descripcion":"{ AGP-10251 } REFEERS 256"},
{"descripcion":"{ AGP-10252 } REFEERS 258"},
{"descripcion":"{ AGP-10253 } REFEERS 257"},
{"descripcion":"{ AGP-10256 } REFEERS 259"},
{"descripcion":"{ AGP-10603 } RAMPA N 4 ANDEN CONGELADO"},
{"descripcion":"{ AGP-10604 } ANDEN N 5 ANDEN CONGELADO"},
{"descripcion":"{ AGP-10641 } TUNEL DE CONGELADO REFEERS"},
{"descripcion":"{ AGP-01000 } RAMPAS ANDEN FRESCOS"},
{"descripcion":"{ AGP-10601 } RAMPA N 2 ANDEN FRESCO"},
{"descripcion":"{ AGP-10602 } RAMPA N 3 ANDEN FRESCO"},
{"descripcion":"{ AGP-10600 } RAMPA N 1 ANDEN FRESCO"},
{"descripcion":"{ AGP-10555 } CALEFONT N 15 BAÑO SUPERVISORAS"},
{"descripcion":"{ AGP-10556 } CALEFONT N 16 BAÑO SUPERVISORAS"},
{"descripcion":"{ AGP-10552 } CALEFONT N 12 BAÑO SUPERVISORES"},
{"descripcion":"{ AGP-10553 } CALEFONT N 13 BAÑO SUPERVISORES"},
{"descripcion":"{ AGP-10554 } CALEFONT N 14 BAÑO SUPERVISORES"},
{"descripcion":"{ AGP-10541 } CALEFONT N 1 BAÑO MANTENIMIENTO"},
{"descripcion":"{ AGP-10542 } CALEFONT N 2 BAÑO MANTENIMIENTO"},
{"descripcion":"{ AGP-10543 } CALEFONT N 3 BAÑO MANTENIMIENTO"},
{"descripcion":"{ AGP-10544 } CALEFONT N 4 BAÑO MONTAJE"},
{"descripcion":"{ AGP-10545 } CALEFONT N 5 BAÑO MONTAJE"},
{"descripcion":"{ AGP-10548 } CALEFONT N 8 BAÑO HOMBRES"},
{"descripcion":"{ AGP-10549 } CALEFONT N 9 BAÑO HOMBRES"},
{"descripcion":"{ AGP-10550 } CALEFONT N 10 BAÑO HOMBRES"},
{"descripcion":"{ AGP-10551 } CALEFONT N 11 BAÑO HOMBRES"},
{"descripcion":"{ AGP-10546 } CALEFONT N 6 BAÑO DAMAS"},
{"descripcion":"{ AGP-10547 } CALEFONT N 7 BAÑO DAMAS"},
{"descripcion":"{ AGP-03039 } TECLE BODEGA PARA AHUMADO"},
{"descripcion":"{ AGP-03041 } TECLE BODEGA INSUMOS"},
{"descripcion":"{ AGP-08172 } CINTA RECEPTORA CAJAS VACIAS (BAJO ARMADORAS DE CAJAS)"},
{"descripcion":"{ AGP-09174 } ARMADORA DE CAJAS BOIX"},
{"descripcion":"{ AGP-09346 } AIRE AC OFICINA JEFE BODEGA ENVASES"},
{"descripcion":"{ AGP-09347 } AIRE AC OFICINA SUPERVISORES BODEGA ENVASES"},
{"descripcion":"{ AGP-10057 } IMPULSOR BODEGA INSUMOS [N 55]"},
{"descripcion":"{ AGP-10091 } BALANZAS BODEGA ENVASES"},
{"descripcion":"{ AGP-10207 } TRASPALETAS BODEGA DE INSUMOS"},
{"descripcion":"{ AGP-10211 } ARMADORA DE CAJAS PONIENTE"},
{"descripcion":"{ AGP-10211.1 } MOTORREDUCTOR DE FORMADOR DE ARMADORA DE CAJAS PONIENTE"},
{"descripcion":"{ AGP-10211.2 } MOTORREDUCTOR ARRASTRE DE CADENA DE ARMADORA DE CAJAS PONIENTE"},
{"descripcion":"{ AGP-10212 } ARMADORA DE CAJAS ORIENTE"},
{"descripcion":"{ AGP-10212.1 } MOTORREDUCTOR DE FORMADOR DE ARMADORA DE CAJAS ORIENTE"},
{"descripcion":"{ AGP-10212.2 } MOTORREDUCTOR ARRASTRE DE CADENA DE ARMADORA DE CAJAS ORIENTE"},
{"descripcion":"{ AGP-10317 } MONTACARGAS EXTERIOR BODEGA INSUMOS"},
{"descripcion":"{ AGP-10365 } SELLADORA DE BOLSA BODEGA INSUMOS"},
{"descripcion":"{ AGP-10584 } CINTA ELEVADORA CAJAS VACIAS (TUNEL DESDE BODEGA A SALA)"},
{"descripcion":"{ AGP-10584.1 } MOTORREDUCTOR CINTA ELEVADORA CAJAS VACIAS (TUNEL DESDE BODEGA A SALA)"},
{"descripcion":"{ AGP-08172.1 } MOTORREDUCTOR CINTA RECEPTORA CAJAS VACIAS (BAJO ARMADORAS DE CAJAS)"},
{"descripcion":"{ AGP-08172.S1 } SENSOR PRESENCIA DE BAJADA DE CAJAS"},
{"descripcion":"{ AGP-08172.S2 } SENSOR SALIDA DE CAJAS DESCARGADAS LADO ORIENTE"},
{"descripcion":"{ AGP-08172.S3 } SENSOR CAJAS VACIAS"},
{"descripcion":"{ AGP-08172.S4 } SENSOR SALIDA DE CAJAS DESCARGADAS LADO PONIENTE"},
{"descripcion":"{ AGP-10057.1 } MOTOR IMPULSOR BODEGA INSUMOS"},
{"descripcion":"{ AGP-03010 } HIDROLAVADORAS SSGG"},
{"descripcion":"{ AGP-09359 } AIRE AC OFICINA BODEGA REPUESTOS"},
{"descripcion":"{ AGP-10058 } RADIOS BODEGA REPUESTOS"},
{"descripcion":"{ AGP-10242 } MOTOR BOMBA DOSIFICACION DE QUIMICOS"},
{"descripcion":"{ AGP-10243 } MOTOR BOMBA DOSIFICACION DE CLORO"},
{"descripcion":"{ AGP-10642 } BOMBA HIPOCLORITO ORIENTE"},
{"descripcion":"{ AGP-10643 } BOMBA HIPOCLORITO PONIENTE"},
{"descripcion":"{ AGP-09507 } UNIDAD EVAPORADORA DOBLE CAMARA 201 ORIENTE"},
{"descripcion":"{ AGP-10303 } IMPRESORA REPORTE FRESCO"},
{"descripcion":"{ AGP-09507.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA DOBLE CAMARA 201 ORIENTE"},
{"descripcion":"{ AGP-09507.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA DOBLE CAMARA 201 ORIENTE"},
{"descripcion":"{ AGP-09507.3 } MOTOR VENTILADOR N 3 UNIDAD EVAPORADORA DOBLE CAMARA 201 ORIENTE"},
{"descripcion":"{ AGP-09507.4 } MOTOR VENTILADOR N 4 UNIDAD EVAPORADORA DOBLE CAMARA 201 ORIENTE"},
{"descripcion":"{ AGP-09507.5 } LINEA DE SUCCION CAMARA 201 ORIENTE"},
{"descripcion":"{ AGP-09507.6 } LINEA DE GAS CALIENTE CAMARA 201 ORIENTE"},
{"descripcion":"{ AGP-09507.7 } LINEA DE LIQUIDO DE CAMARA 201 ORIENTE"},
{"descripcion":"{ AGP-09500 } UNIDAD EVAPORADORA DOBLE CAMARA 201 PONIENTE"},
{"descripcion":"{ AGP-09500.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA DOBLE CAMARA 201 PONIENTE"},
{"descripcion":"{ AGP-09500.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA DOBLE CAMARA 201 PONIENTE"},
{"descripcion":"{ AGP-09500.3 } MOTOR VENTILADOR N 3 UNIDAD EVAPORADORA DOBLE CAMARA 201 PONIENTE"},
{"descripcion":"{ AGP-09500.4 } MOTOR VENTILADOR N 4 UNIDAD EVAPORADORA DOBLE CAMARA 201 PONIENTE"},
{"descripcion":"{ AGP-09500.5 } LINEA DE SUCCION CAMARA 201 PONIENTE"},
{"descripcion":"{ AGP-09500.6 } LINEA DE LIQUIDO DE CAMRA 201 PONIENTE"},
{"descripcion":"{ AGP-09500.7 } LINEA DE GAS CALIENTE DE CAMARA 201 PONIENTE"},
{"descripcion":"{ AGP-09505 } UNIDAD EVAPORADORA DOBLE CAMARA 202"},
{"descripcion":"{ AGP-09505.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA DOBLE CAMARA 202"},
{"descripcion":"{ AGP-09505.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA DOBLE CAMARA 202"},
{"descripcion":"{ AGP-09505.3 } MOTOR VENTILADOR N 3 UNIDAD EVAPORADORA DOBLE CAMARA 202"},
{"descripcion":"{ AGP-09505.4 } MOTOR VENTILADOR N 4 UNIDAD EVAPORADORA DOBLE CAMARA 202"},
{"descripcion":"{ AGP-09505.5 } LINEA DE GAS CALIENTE DE CAMARA 202"},
{"descripcion":"{ AGP-09505.6 } LINEA DE SUCCION DE CAMARA 202"},
{"descripcion":"{ AGP-09505.7 } LINEA DE LIQUIDO DE CAMARA 202"},
{"descripcion":"{ AGP-0034.1 } UNIDAD EVAPORADORA CAMARA 207 SECTOR A"},
{"descripcion":"{ AGP-0034.2 } UNIDAD EVAPORADORA CAMARA 207 SECTOR C"},
{"descripcion":"{ AGP-0034.1.1 } LINEA DE LIQUIDO CAMARA 207 LADO A"},
{"descripcion":"{ AGP-0034.1.2 } LINEA DE SUCCION CAMARA 207 LADO A"},
{"descripcion":"{ AGP-0034.1.3 } LINEA DE GAS CALIENTE CAMARA 207 LADO A"},
{"descripcion":"{ AGP-0034.1.1.1 } VALVULA SERVO ACCIONADA DE SUCCION"},
{"descripcion":"{ AGP-0034.2.1 } LINEA DE LIQUIDO CAMARA 207 LADO C"},
{"descripcion":"{ AGP-0034.2.2 } LINEA DE SUCCION CAMARA 207 LADO C"},
{"descripcion":"{ AGP-0034.2.3 } LINEA DE GAS CALIENTE CAMARA 207 LADO C"},
{"descripcion":"{ AGP-09482 } UNIDAD EVAPORADORA DOBLE CAMARA 208 (SECTOR A)"},
{"descripcion":"{ AGP-09483 } UNIDAD EVAPORADORA TRIPLE CAMARA 208 (SECTOR B)"},
{"descripcion":"{ AGP-09484 } UNIDAD EVAPORADORA DOBLE CAMARA 208 (SECTOR C)"},
{"descripcion":"{ AGP-09485 } UNIDAD EVAPORADORA TRIPLE CAMARA 208 (SECTOR D)"},
{"descripcion":"{ AGP-10189 } BASCULA DE PISO CAMARA 208"},
{"descripcion":"{ AGP-10206 } TRASPALETAS CAMARA 208"},
{"descripcion":"{ AGP-09482.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA DOBLE CAMARA 208 NORTE ORIENTE"},
{"descripcion":"{ AGP-09482.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA DOBLE CAMARA 208 NORTE ORIENTE"},
{"descripcion":"{ AGP-09482.3 } MOTOR VENTILADOR N 3 UNIDAD EVAPORADORA DOBLE CAMARA 208 NORTE ORIENTE"},
{"descripcion":"{ AGP-09482.4 } MOTOR VENTILADOR N 4 UNIDAD EVAPORADORA DOBLE CAMARA 208 NORTE ORIENTE"},
{"descripcion":"{ AGP-09482.5 } LINEA DE GAS CALIENTE CAMARA 208 SECTOR A"},
{"descripcion":"{ AGP-09482.6 } LINEA DE SUCCION DE CAMARA 208 SECTOR A"},
{"descripcion":"{ AGP-09482.7 } LINEA DE LIQUIDO CAMARA 208 SECTOR A"},
{"descripcion":"{ AGP-09484.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA DOBLE CAMARA 208 NORTE PONIENTE"},
{"descripcion":"{ AGP-09484.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA DOBLE CAMARA 208 NORTE PONIENTE"},
{"descripcion":"{ AGP-09484.3 } MOTOR VENTILADOR N 3 UNIDAD EVAPORADORA DOBLE CAMARA 208 NORTE PONIENTE"},
{"descripcion":"{ AGP-09484.4 } MOTOR VENTILADOR N 4 UNIDAD EVAPORADORA DOBLE CAMARA 208 NORTE PONIENTE"},
{"descripcion":"{ AGP-09484.5 } LINEA DE SUCCION DE CAMARA 208 SECTOR C"},
{"descripcion":"{ AGP-09484.6 } LINEA DE LIQUIDO CAMARA 208 SECTOR C"},
{"descripcion":"{ AGP-09484.7 } LINEA DE GAS CALIENTE CAMARA 208 LADO C"},
{"descripcion":"{ AGP-09483.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA TRIPLE CAMARA 208 SUR ORIENTE"},
{"descripcion":"{ AGP-09483.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA TRIPLE CAMARA 208 SUR ORIENTE"},
{"descripcion":"{ AGP-09483.3 } MOTOR VENTILADOR N 3 UNIDAD EVAPORADORA TRIPLE CAMARA 208 SUR ORIENTE"},
{"descripcion":"{ AGP-09483.4 } MOTOR VENTILADOR N 4 UNIDAD EVAPORADORA TRIPLE CAMARA 208 SUR ORIENTE"},
{"descripcion":"{ AGP-09483.5 } MOTOR VENTILADOR N 5 UNIDAD EVAPORADORA TRIPLE CAMARA 208 SUR ORIENTE"},
{"descripcion":"{ AGP-09483.6 } MOTOR VENTILADOR N 6 UNIDAD EVAPORADORA TRIPLE CAMARA 208 SUR ORIENTE"},
{"descripcion":"{ AGP-09483.7 } LINEA DE LIQUIDO CAMARA 208 SECTOR B"},
{"descripcion":"{ AGP-09483.8 } LINEA DE SUCCION CAMARA 208 SECTOR B"},
{"descripcion":"{ AGP-09483.9 } LINEA DE GAS CALIENTE CAMARA 208 SECTOR B"},
{"descripcion":"{ AGP-09485.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA TRIPLE CAMARA 208 SUR PONIENTE"},
{"descripcion":"{ AGP-09485.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA TRIPLE CAMARA 208 SUR PONIENTE"},
{"descripcion":"{ AGP-09485.3 } MOTOR VENTILADOR N 3 UNIDAD EVAPORADORA TRIPLE CAMARA 208 SUR PONIENTE"},
{"descripcion":"{ AGP-09485.4 } MOTOR VENTILADOR N 4 UNIDAD EVAPORADORA TRIPLE CAMARA 208 SUR PONIENTE"},
{"descripcion":"{ AGP-09485.5 } MOTOR VENTILADOR N 5 UNIDAD EVAPORADORA TRIPLE CAMARA 208 SUR PONIENTE"},
{"descripcion":"{ AGP-09485.6 } MOTOR VENTILADOR N 6 UNIDAD EVAPORADORA TRIPLE CAMARA 208 SUR ORIENTE"},
{"descripcion":"{ AGP-09028 } UNIDAD EVAPORADORA CAMARA 304 5A"},
{"descripcion":"{ AGP-09385 } UNIDAD EVAPORADORA CAMARA 304 7A"},
{"descripcion":"{ AGP-09386 } UNIDAD EVAPORADORA DOBLE CAMARA 304 6B"},
{"descripcion":"{ AGP-09387 } UNIDAD EVAPORADORA CAMARA 304 7B"},
{"descripcion":"{ AGP-09388 } UNIDAD EVAPORADORA DOBLE CAMARA 304 5B"},
{"descripcion":"{ AGP-09389 } UNIDAD EVAPORADORA CAMARA 304 N 6A"},
{"descripcion":"{ AGP-09028.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA CAMARA 304 5A"},
{"descripcion":"{ AGP-09028.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA CAMARA 304 5A"},
{"descripcion":"{ AGP-09028.3 } LINEA GAS CALIENTE CAMARA 5A"},
{"descripcion":"{ AGP-09028.4 } LINEA DE LIQUIDO CAMARA 5A"},
{"descripcion":"{ AGP-09028.5 } LINEA SUCCION CAMARA 5A"},
{"descripcion":"{ AGP-09385.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA CAMARA 304 5B"},
{"descripcion":"{ AGP-09385.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA CAMARA 304 5B"},
{"descripcion":"{ AGP-09385.3 } LINEA DE LIQUIDO CAMARA 7A"},
{"descripcion":"{ AGP-09385.4 } LINEA DE GAS CALIENTE CAMARA 7A"},
{"descripcion":"{ AGP-09385.5 } LINEA DE SUCCION CAMARA 7A"},
{"descripcion":"{ AGP-09387.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA CAMARA 304 N 4"},
{"descripcion":"{ AGP-09387.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA CAMARA 304 N 4"},
{"descripcion":"{ AGP-09389.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA CAMARA 304 N 6"},
{"descripcion":"{ AGP-09389.2 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA CAMARA 304 N 6"},
{"descripcion":"{ AGP-09389.3 } LINEA DE LIQUIDO CAMARA 6A"},
{"descripcion":"{ AGP-09389.4 } LINEA DE SUCCION CAMARA 6A"},
{"descripcion":"{ AGP-09389.5 } LINEA DE GAS CALIENTE CAMARA 6A"},
{"descripcion":"{ AGP-09388.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA DOBLE CAMARA 304 N 5"},
{"descripcion":"{ AGP-09388.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA DOBLE CAMARA 304 N 5"},
{"descripcion":"{ AGP-09388.3 } MOTOR VENTILADOR N 3 UNIDAD EVAPORADORA DOBLE CAMARA 304 N 5"},
{"descripcion":"{ AGP-09388.4 } MOTOR VENTILADOR N 4 UNIDAD EVAPORADORA DOBLE CAMARA 304 N 5"},
{"descripcion":"{ AGP-09388.5 } LINEA DE GAS CALIENTE CAMARA 5B"},
{"descripcion":"{ AGP-09388.6 } LINEA DE SUCCION DE CAMARA 304 5B"},
{"descripcion":"{ AGP-09388.7 } LINEA DE LIQUIDO CAMARA 304 5B"},
{"descripcion":"{ AGP-09386.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA DOBLE CAMARA 304 6B"},
{"descripcion":"{ AGP-09386.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA DOBLE CAMARA 304 6B"},
{"descripcion":"{ AGP-09386.3 } MOTOR VENTILADOR N 3 UNIDAD EVAPORADORA DOBLE CAMARA 304 N 3"},
{"descripcion":"{ AGP-09386.4 } MOTOR VENTILADOR N 4 UNIDAD EVAPORADORA DOBLE CAMARA 304 N 3"},
{"descripcion":"{ AGP-09386.5 } LINEA DE GAS CALIENTE 6B"},
{"descripcion":"{ AGP-09386.6 } LINEA DE SUCCION CAMARA 6B"},
{"descripcion":"{ AGP-09386.7 } LINEA DE LIQUIDO CAMARA 6B"},
{"descripcion":"{ AGP-10109 } TABLEROS ELECTRICOS ENTRETECHO FAENACION DE PAVOS"},
{"descripcion":"{ AGP-10659 } UNIDAD DE FREON N 1 ORIENTE"},
{"descripcion":"{ AGP-10660 } UNIDAD DE FREON N 2 PONIENTE"},
{"descripcion":"{ AGP-03043 } LAVADORES DE BOTAS FILTRO PRINCIPAL"},
{"descripcion":"{ AGP-09427 } FANCOIL FILTRO PRINCIPAL"},
{"descripcion":"{ AGP-10607 } LAVADOR DE BOTAS AUTOMATICO ROSER"},
{"descripcion":"{ AGP-09427.1 } MOTOR VENTILADOR N 1 FANCOIL FILTRO PRINCIPAL"},
{"descripcion":"{ AGP-09427.2 } MOTOR VENTILADOR N 2 FANCOIL FILTRO PRINCIPAL"},
{"descripcion":"{ AGP-09427.3 } MOTOR VENTILADOR N 3 FANCOIL FILTRO PRINCIPAL"},
{"descripcion":"{ AGP-10607.1 } MOTORREDUCTOR INFERIOR PARA CEPILLO SUELA"},
{"descripcion":"{ AGP-10607.2 } MOTORREDUCTOR ORIENTE CEPILLO CAÑA"},
{"descripcion":"{ AGP-10607.3 } MOTORREDUCTOR PONIENTE CEPILLO CAÑA"},
{"descripcion":"{ AGP-03043.1 } MOTORREDUCTOR NORTE LAVADORES DE BOTAS NOR ORIENTE FILTRO PRINCIPAL"},
{"descripcion":"{ AGP-03043.10 } MOTORREDUCTOR SUR LAVADORES DE BOTAS SUR PONIENTE FILTRO PRINCIPAL"},
{"descripcion":"{ AGP-03043.2 } MOTORREDUCTOR SUR LAVADORES DE BOTAS NOR ORIENTE FILTRO PRINCIPAL"},
{"descripcion":"{ AGP-03043.3 } MOTORREDUCTOR NORTE LAVADORES DE BOTAS SUR ORIENTE FILTRO PRINCIPAL"},
{"descripcion":"{ AGP-03043.4 } MOTORREDUCTOR SUR LAVADORES DE BOTAS SUR ORIENTE FILTRO PRINCIPAL"},
{"descripcion":"{ AGP-03043.5 } MOTORREDUCTOR NORTE LAVADORES DE BOTAS NOR PONIENTE FILTRO PRINCIPAL"},
{"descripcion":"{ AGP-03043.6 } MOTORREDUCTOR CENTRO LAVADORES DE BOTAS NOR PONIENTE FILTRO PRINCIPAL"},
{"descripcion":"{ AGP-03043.7 } MOTORREDUCTOR SUR LAVADORES DE BOTAS NOR PONIENTE FILTRO PRINCIPAL"},
{"descripcion":"{ AGP-03043.8 } MOTORREDUCTOR NORTE LAVADORES DE BOTAS SUR PONIENTE FILTRO PRINCIPAL"},
{"descripcion":"{ AGP-03043.9 } MOTORREDUCTOR CENTRO LAVADORES DE BOTAS SUR PONIENTE FILTRO PRINCIPAL"},
{"descripcion":"{ AGP-03043.S1 } SENSOR SURPONIENTE"},
{"descripcion":"{ AGP-03043.S2 } SENSOR NORPONIENTE"},
{"descripcion":"{ AGP-03050 } PRENSA HIDRAULICA 10T"},
{"descripcion":"{ AGP-03051 } AFILADOR DE CUCHILLOS"},
{"descripcion":"{ AGP-03056 } PRENSA HIDRAULICA 55T"},
{"descripcion":"{ AGP-10065 } RADIOS TALLER"},
{"descripcion":"{ AGP-10362 } LAVADORA DE PIEZAS SMART"},
{"descripcion":"{ AGP-10648 } TABLEROS ELECTRICOS MANTENIMIENTO"},
{"descripcion":"{ AGP-10658 } ESTANQUE DE GAS ALIMENTACION CALEFONT MANTENIMIENTO"},
{"descripcion":"{ AGP-10716 } SISTEMA IOT AGROINDUSTRIAL PAICO"},
{"descripcion":"{ AGP-03051.1 } MOTORREDUCTOR AFILADOR DE CUCHILLOS"},
{"descripcion":"{ AGP-00100 } VENTILADORES ESPERA DE AVES"},
{"descripcion":"{ AGP-00100.1 } MOTOR VENTILADOR N 1 FILA 1 ESPERA DE AVES"},
{"descripcion":"{ AGP-00100.10 } MOTOR VENTILADOR N 2 FILA 2 ESPERA DE AVES"},
{"descripcion":"{ AGP-00100.11 } MOTOR VENTILADOR N 3 FILA 2 ESPERA DE AVES"},
{"descripcion":"{ AGP-00100.12 } MOTOR VENTILADOR N 4 FILA 2 ESPERA DE AVES"},
{"descripcion":"{ AGP-00100.13 } MOTOR VENTILADOR N 5 FILA 2 ESPERA DE AVES"},
{"descripcion":"{ AGP-00100.14 } MOTOR VENTILADOR N 6 FILA 2 ESPERA DE AVES"},
{"descripcion":"{ AGP-00100.15 } MOTOR VENTILADOR N 7 FILA 2 ESPERA DE AVES"},
{"descripcion":"{ AGP-00100.16 } MOTOR VENTILADOR N 8 FILA 2 ESPERA DE AVES"},
{"descripcion":"{ AGP-00100.17 } MOTOR VENTILADOR N 1 FILA 3 ESPERA DE AVES"},
{"descripcion":"{ AGP-00100.18 } MOTOR VENTILADOR N 2 FILA 3 ESPERA DE AVES"},
{"descripcion":"{ AGP-00100.19 } MOTOR VENTILADOR N 3 FILA 3 ESPERA DE AVES"},
{"descripcion":"{ AGP-00100.2 } MOTOR VENTILADOR N 2 FILA 1 ESPERA DE AVES"},
{"descripcion":"{ AGP-00100.20 } MOTOR VENTILADOR N 4 FILA 3 ESPERA DE AVES"},
{"descripcion":"{ AGP-00100.21 } MOTOR VENTILADOR N 5 FILA 3 ESPERA DE AVES"},
{"descripcion":"{ AGP-00100.22 } MOTOR VENTILADOR N 6 FILA 3 ESPERA DE AVES"},
{"descripcion":"{ AGP-00100.23 } MOTOR VENTILADOR N 7 FILA 3 ESPERA DE AVES"},
{"descripcion":"{ AGP-00100.24 } MOTOR VENTILADOR N 8 FILA 3 ESPERA DE AVES"},
{"descripcion":"{ AGP-00100.25 } MOTOR VENTILADOR N 1 FILA 4 ESPERA DE AVES"},
{"descripcion":"{ AGP-00100.26 } MOTOR VENTILADOR N 2 FILA 4 ESPERA DE AVES"},
{"descripcion":"{ AGP-00100.27 } MOTOR VENTILADOR N 3 FILA 4 ESPERA DE AVES"},
{"descripcion":"{ AGP-00100.28 } MOTOR VENTILADOR N 4 FILA 4 ESPERA DE AVES"},
{"descripcion":"{ AGP-00100.29 } MOTOR VENTILADOR N 5 FILA 4 ESPERA DE AVES"},
{"descripcion":"{ AGP-00100.3 } MOTOR VENTILADOR N 3 FILA 1 ESPERA DE AVES"},
{"descripcion":"{ AGP-00100.30 } MOTOR VENTILADOR N 6 FILA 4 ESPERA DE AVES"},
{"descripcion":"{ AGP-00100.31 } MOTOR VENTILADOR N 7 FILA 4 ESPERA DE AVES"},
{"descripcion":"{ AGP-00100.32 } MOTOR VENTILADOR N 8 FILA 4 ESPERA DE AVES"},
{"descripcion":"{ AGP-00100.4 } MOTOR VENTILADOR N 4 FILA 1 ESPERA DE AVES"},
{"descripcion":"{ AGP-00100.5 } MOTOR VENTILADOR N 5 FILA 1 ESPERA DE AVES"},
{"descripcion":"{ AGP-00100.6 } MOTOR VENTILADOR N 6 FILA 1 ESPERA DE AVES"},
{"descripcion":"{ AGP-00100.7 } MOTOR VENTILADOR N 7 FILA 1 ESPERA DE AVES"},
{"descripcion":"{ AGP-00100.8 } MOTOR VENTILADOR N 8 FILA 1 ESPERA DE AVES"},
{"descripcion":"{ AGP-00100.9 } MOTOR VENTILADOR N 1 FILA 2 ESPERA DE AVES"},
{"descripcion":"{ AGP-00100.PLC1 } PLC TABLERO PRINCIPAL VENTILADORES GAPON DE POLLOS"},
{"descripcion":"{ AGP-00100.S1 } SENSOR PUERTA NORTE 1(RECEPTOR)"},
{"descripcion":"{ AGP-00100.S2 } SENSOR PUERTA SUR 1 (EMISOR)"},
{"descripcion":"{ AGP-00100.S3 } SENSOR PUERTA NORTE 2 (RECEPTOR)"},
{"descripcion":"{ AGP-00100.S4 } SENSOR PUERTA SUR 2 (EMISOR)"},
{"descripcion":"{ AGP-00100.S5 } SENSOR PUERTA NORTE 3 (RECEPTOR)"},
{"descripcion":"{ AGP-00100.S6 } SENSOR PUERTA SUR 3 (EMISOR)"},
{"descripcion":"{ AGP-00100.S8 } SENSOR PUERTA SUR 4 (EMISOR)"},
{"descripcion":"{ AGP-01126 } VENTILADORES GALPON POLLOS"},
{"descripcion":"{ AGP-01143 } ENFRIAMIENTO EVAPORATIVO GALPON"},
{"descripcion":"{ AGP-01126.1 } MOTOR N 1 VENTILADORES GALPON POLLOS"},
{"descripcion":"{ AGP-01126.10 } MOTOR N 10 VENTILADORES GALPON POLLOS"},
{"descripcion":"{ AGP-01126.11 } MOTOR N 11 VENTILADORES GALPON POLLOS"},
{"descripcion":"{ AGP-01126.12 } MOTOR N 12 VENTILADORES GALPON POLLOS"},
{"descripcion":"{ AGP-01126.13 } MOTOR N 13 VENTILADORES GALPON POLLOS"},
{"descripcion":"{ AGP-01126.14 } MOTOR N 14 VENTILADORES GALPON POLLOS"},
{"descripcion":"{ AGP-01126.15 } MOTOR N 15 VENTILADORES GALPON POLLOS"},
{"descripcion":"{ AGP-01126.16 } MOTOR N 16 VENTILADORES GALPON POLLOS"},
{"descripcion":"{ AGP-01126.17 } MOTOR N 17 VENTILADORES GALPON POLLOS"},
{"descripcion":"{ AGP-01126.18 } MOTOR N 18 VENTILADORES GALPON POLLOS"},
{"descripcion":"{ AGP-01126.19 } MOTOR N 19 VENTILADORES GALPON POLLOS"},
{"descripcion":"{ AGP-01126.2 } MOTOR N 2 VENTILADORES GALPON POLLOS"},
{"descripcion":"{ AGP-01126.20 } MOTOR N 20 VENTILADORES GALPON POLLOS"},
{"descripcion":"{ AGP-01126.21 } MOTOR N 21 VENTILADORES GALPON POLLOS"},
{"descripcion":"{ AGP-01126.22 } MOTOR N 22 VENTILADORES GALPON POLLOS"},
{"descripcion":"{ AGP-01126.23 } MOTOR N 23 VENTILADORES GALPON POLLOS"},
{"descripcion":"{ AGP-01126.24 } MOTOR N 24 VENTILADORES GALPON POLLOS"},
{"descripcion":"{ AGP-01126.25 } MOTOR N 25 VENTILADORES GALPON POLLOS"},
{"descripcion":"{ AGP-01126.26 } MOTOR N 26 VENTILADORES GALPON POLLOS"},
{"descripcion":"{ AGP-01126.27 } MOTOR N 27 VENTILADORES GALPON POLLOS"},
{"descripcion":"{ AGP-01126.28 } BOMBA DE ASPERCION VENTILADORES GALPON POLLOS"},
{"descripcion":"{ AGP-01126.3 } MOTOR N 3 VENTILADORES GALPON POLLOS"},
{"descripcion":"{ AGP-01126.4 } MOTOR N 4 VENTILADORES GALPON POLLOS"},
{"descripcion":"{ AGP-01126.5 } MOTOR N 5 VENTILADORES GALPON POLLOS"},
{"descripcion":"{ AGP-01126.6 } MOTOR N 6 VENTILADORES GALPON POLLOS"},
{"descripcion":"{ AGP-01126.7 } MOTOR N 7 VENTILADORES GALPON POLLOS"},
{"descripcion":"{ AGP-01126.8 } MOTOR N 8 VENTILADORES GALPON POLLOS"},
{"descripcion":"{ AGP-01126.9 } MOTOR N 9 VENTILADORES GALPON POLLOS"},
{"descripcion":"{ AGP-09369 } AIRE AC OFICINA SUPERVISORES CALIDAD"},
{"descripcion":"{ AGP-09370 } AIRE AC OFICINA JEFE CALIDAD"},
{"descripcion":"{ AGP-10059 } RADIOS CONTROL DE CALIDAD"},
{"descripcion":"{ AGP-10092 } BALANZAS CONTROL DE CALIDAD"},
{"descripcion":"{ AGP-09362 } AIRE AC OFICINA BIENESTAR"},
{"descripcion":"{ AGP-09363 } AIRE AC OFICINA ASISTENTE SOCIAL"},
{"descripcion":"{ AGP-09351 } AIRE AC SALA CAPACITACION"},
{"descripcion":"{ AGP-09352 } AIRE AC CONTENEDOR CAPACITACION"},
{"descripcion":"{ AGP-09365 } AIRE AC CONTENEDOR INDUCCION N 1"},
{"descripcion":"{ AGP-09366 } AIRE AC CONTENEDOR INDUCCION N 1"},
{"descripcion":"{ AGP-09367 } AIRE AC CONTENEDOR INDUCCION N 2"},
{"descripcion":"{ AGP-09360 } AIRE AC OFICINA SUPERVISORES INFRAESTRUCTURA"},
{"descripcion":"{ AGP-09361 } AIRE AC OFICINA JEFE INFRAESTRUCTURA"},
{"descripcion":"{ AGP-09353 } AIRE AC OFICINA JEFE MANTENIMIENTO"},
{"descripcion":"{ AGP-09355 } AIRE AC SALA REUNIONES MANTENIMIENTO"},
{"descripcion":"{ AGP-09356 } AIRE AC OFICINA SUPERVISORES MANTENIMIENTO"},
{"descripcion":"{ AGP-09342 } AIRE AC OFICINA DESARROLLO"},
{"descripcion":"{ AGP-09339 } AIRE AC OFICINA ADMINISTRACION"},
{"descripcion":"{ AGP-09348 } AIRE AC OFICINA GERENTE MATADEROS"},
{"descripcion":"{ AGP-10633 } EXTRACTOR SUR OFICINA PERSONAL [N 71]"},
{"descripcion":"{ AGP-10634 } EXTRACTOR NORTE OFICINA PERSONAL [N 72]"},
{"descripcion":"{ AGP-09345 } AIRE AC OFICINA CONTROL GESTION"},
{"descripcion":"{ AGP-09371 } AIRE AC OFICINA SUPERVISORES FAENA"},
{"descripcion":"{ AGP-09372 } AIRE AC OFICINA JEFE FAENA"},
{"descripcion":"{ AGP-09354 } AIRE AC OFICINA JEFE MONTAJE"},
{"descripcion":"{ AGP-09340 } AIRE AC OFICINA PERSONAL N 1"},
{"descripcion":"{ AGP-09341 } AIRE AC OFICINA PERSONAL N 2"},
{"descripcion":"{ AGP-09364 } AIRE AC OFICINA PREVENCION DE RIESGOS"},
{"descripcion":"{ AGP-09378 } AIRE AC SALA PRIMEROS AUXILIOS"},
{"descripcion":"{ AGP-10066 } RADIOS PREVENCION DE RIESGOS"},
{"descripcion":"{ AGP-10683 } AIRE AC CASINO PLANTA"},
{"descripcion":"{ AGP-10312 } IMPRESORAS HONEYWELL STAND-BY"},
{"descripcion":"{ AGP-10312.1 } IMPRESORA STAND-BY (01)"},
{"descripcion":"{ AGP-10312.2 } IMPRESORA STAND-BY (02)"},
{"descripcion":"{ AGP-10312.3 } IMPRESORA STAND-BY (03)"},
{"descripcion":"{ AGP-10312.4 } IMPRESORA STAND-BY 80% (04)"},
{"descripcion":"{ AGP-09377 } AIRE AC OFICINA SALA PROYECTOS"},
{"descripcion":"{ AGP-09344 } AIRE AC OFICINA CONTROL OPERACIONES"},
{"descripcion":"{ AGP-09338 } AIRE AC SALA REUNIONES N 2"},
{"descripcion":"{ AGP-09343 } AIRE AC SALA REUNIONES N 1"},
{"descripcion":"{ AGP-09349 } AIRE AC OFICINA SUPERVISORA SAG"},
{"descripcion":"{ AGP-09350 } AIRE AC OFICINA JEFE SAG"},
{"descripcion":"{ AGP-09357 } AIRE AC OFICINA SADEMA"},
{"descripcion":"{ AGP-09358 } AIRE AC OFICINA REUNION SADEMA"},
{"descripcion":"{ AGP-10073 } RADIOS SALA DE MAQUINAS"},
{"descripcion":"{ AGP-10674 } TRASPALETA SALA DE MAQUINAS"},
{"descripcion":"{ AGP-09375 } AIRE AC OFICINA SUPERVISORES SSGG"},
{"descripcion":"{ AGP-09376 } AIRE AC OFICINA JEFE SSGG"},
{"descripcion":"{ AGP-10076 } RADIOS ASEO"},
{"descripcion":"{ AGP-10108 } TABLEROS ELECTRICOS PASILLO 1 NIVEL 3"},
{"descripcion":"{ AGP-10244 } SISTEMA VIDEOVIGILANCIA GENERAL"},
{"descripcion":"{ AGP-10257 } RED DATOS MTTO-PAICO"},
{"descripcion":"{ AGP-10258 } RED DATOS ARIZTIA"},
{"descripcion":"{ AGP-10627 } BOMBA ORIENTE AGUA CALIENTE APV"},
{"descripcion":"{ AGP-10628 } BOMBA PONIENTE AGUA CALIENTE APV"},
{"descripcion":"{ AGP-10669 } SISTEMA AGUA CALIENTE (MEZCLADOR HQ NORTE)"},
{"descripcion":"{ AGP-09084 } SECADOR REGENERATIVO KAESER KADE60"},
{"descripcion":"{ AGP-09085 } SECADOR COMPAIR (CALIBRADO)"},
{"descripcion":"{ AGP-09086 } COMPRESOR DE AIRE COMPAIR 6050N (EX1002)"},
{"descripcion":"{ AGP-09087 } SECADOR COMPAIR CBD45AA"},
{"descripcion":"{ AGP-09088 } COMPRESOR DE AIRE KAESER N 1 CSD125 (1150) STAND-BY"},
{"descripcion":"{ AGP-09089 } SECADOR REGENERATIVO KAESER DC50"},
{"descripcion":"{ AGP-09146 } ENFRIADOR DE PLACA N 1 SALA PROCESO"},
{"descripcion":"{ AGP-09147 } ENFRIADOR DE PLACA N 2 AGUA CHILLER"},
{"descripcion":"{ AGP-09148 } ENFRIADOR DE PLACA N 3"},
{"descripcion":"{ AGP-09175 } LINEA DE AGUA POTABLE"},
{"descripcion":"{ AGP-09239 } COMPRESOR DE AIRE KAESER N 2 CSD125 (1377)"},
{"descripcion":"{ AGP-09250 } COMPRESOR DE AIRE KAESER N 3 CSD125 (1350)"},
{"descripcion":"{ AGP-09382 } LINEA AGUA COGENERACION ASEO"},
{"descripcion":"{ AGP-10314 } ENFRIADOR DE AIRE N 1"},
{"descripcion":"{ AGP-10315 } ENFRIADOR DE AIRE N 2"},
{"descripcion":"{ AGP-10392 } SECADOR DE ADSORCION PARA AIRE"},
{"descripcion":"{ AGP-09086.1 } MOTOR COMPRESOR PONIENTE AIRE EX1002"},
{"descripcion":"{ AGP-09086.2 } MOTOR VENTILADOR COMPRESOR PONIENTE AIRE EX1002"},
{"descripcion":"{ AGP-09086.3 } BOMBA DE COMPRESOR PONIENTE AIRE EX1002"},
{"descripcion":"{ AGP-09146.1 } BOMBA N 1 DE ENFRIADOR AGUA PLACA N 1 SALA PROCESO"},
{"descripcion":"{ AGP-09146.2 } BOMBA N 2 DE ENFRIADOR AGUA PLACA N 1 SALA PROCESO"},
{"descripcion":"{ AGP-09146.3 } LINEA DE SUCCION ENFRIADOR DE AGUA PLACA N 1"},
{"descripcion":"{ AGP-09146.4 } LINEA DE LIQUIDO DE ENFRIADOR DE AGUA PLACA N 1"},
{"descripcion":"{ AGP-09147.1 } BOMBA N 1 DE ENFRIADOR AGUA PLACA N 2 AGUA CHILLER"},
{"descripcion":"{ AGP-09147.2 } BOMBA N 2 DE ENFRIADOR AGUA PLACA N 2 AGUA CHILLER"},
{"descripcion":"{ AGP-09147.3 } LINEA DE SUCCION DE ENFRIADOR DE AGUA PLACA N 2"},
{"descripcion":"{ AGP-09147.4 } LINEA DE LIQUIDO DE ENFRIADOR DE AGUA PLACA N 2"},
{"descripcion":"{ AGP-09148.1 } BOMBA N 1 DE ENFRIADOR AGUA PLACA N 3"},
{"descripcion":"{ AGP-09148.2 } BOMBA N 2 DE ENFRIADOR AGUA PLACA N 3"},
{"descripcion":"{ AGP-09148.3 } BOMBA N 3 DE ENFRIADOR AGUA PLACA N 3"},
{"descripcion":"{ AGP-09148.4 } BOMBA N 4 DE ENFRIADOR AGUA PLACA N 3"},
{"descripcion":"{ AGP-09148.5 } BOMBA N 5 DE ENFRIADOR AGUA PLACA N 3"},
{"descripcion":"{ AGP-09175.1 } BOMBA AGUA POTABLE LADO NORTE"},
{"descripcion":"{ AGP-09175.2 } BOMBA AGUA POTABLE LADO CENTRO NORTE"},
{"descripcion":"{ AGP-09175.3 } BOMBA AGUA POTABLE LADO CENTRO SUR"},
{"descripcion":"{ AGP-09175.4 } BOMBA AGUA POTABLE LADO SUR"},
{"descripcion":"{ AGP-09492 } UNIDAD EVAPORADORA PASILLO B N 1"},
{"descripcion":"{ AGP-09493 } UNIDAD EVAPORADORA PASILLO B N 2"},
{"descripcion":"{ AGP-09494 } UNIDAD EVAPORADORA PASILLO B N 3"},
{"descripcion":"{ AGP-09492.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA PASILLO B N 1"},
{"descripcion":"{ AGP-09492.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA PASILLO B N 1"},
{"descripcion":"{ AGP-09492.3 } MOTOR VENTILADOR N 3 UNIDAD EVAPORADORA PASILLO B N 1"},
{"descripcion":"{ AGP-09493.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA PASILLO B N 2"},
{"descripcion":"{ AGP-09493.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA PASILLO B N 2"},
{"descripcion":"{ AGP-09494.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA PASILLO B N 3"},
{"descripcion":"{ AGP-09494.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA PASILLO B N 3"},
{"descripcion":"{ AGP-09490 } UNIDAD EVAPORADORA PASILLO C"},
{"descripcion":"{ AGP-09490.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA PASILLO C"},
{"descripcion":"{ AGP-09490.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA PASILLO C"},
{"descripcion":"{ AGP-03042 } PURIFICADORES DE AIRE CALIDAD"},
{"descripcion":"{ AGP-09502 } UNIDAD EVAPORADORA PASILLO D N 1"},
{"descripcion":"{ AGP-09510 } UNIDAD EVAPORADORA PASILLO D N 2"},
{"descripcion":"{ AGP-09502.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA PASILLO D N 1"},
{"descripcion":"{ AGP-09502.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA PASILLO D N 1"},
{"descripcion":"{ AGP-09510.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA PASILLO D N 2"},
{"descripcion":"{ AGP-09510.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA PASILLO D N 2"},
{"descripcion":"{ AGP-09510.3 } MOTOR VENTILADOR N 3 UNIDAD EVAPORADORA PASILLO D N 2"},
{"descripcion":"{ AGP-09510.4 } MOTOR VENTILADOR N 4 UNIDAD EVAPORADORA PASILLO D N 2"},
{"descripcion":"{ AGP-10650 } TABLERO ELECTRICO PASILLO GERENCIA"},
{"descripcion":"{ AGP-10270 } SISTEMA DE MEGAFONIA"},
{"descripcion":"{ AGP-03044 } PURIFICADORES DE AIRE SAG"},
{"descripcion":"{ AGP-10022 } IMPULSOR PASILLO MATADERO DE POLLOS [N 38]"},
{"descripcion":"{ AGP-10022.1 } MOTOR IMPULSOR PASILLO MATADERO DE POLLOS"},
{"descripcion":"{ AGP-03040 } MONTACARGAS INTERIOR EDIFICIO PLANTA"},
{"descripcion":"{ AGP-03040.1 } CENTRAL HIDRAULICA MONTACARGAS INTERIOR EDIFICIO PLANTA"},
{"descripcion":"{ AGP-03040.S1 } SENSOR PRIMER PISO NORTE"},
{"descripcion":"{ AGP-03040.S10 } SENSOR POSICION 4"},
{"descripcion":"{ AGP-03040.S11 } SENSOR POSICION 5"},
{"descripcion":"{ AGP-03040.S12 } SENSOR POSICION 6"},
{"descripcion":"{ AGP-03040.S13 } SENSOR POSICION 7 (NORTE)"},
{"descripcion":"{ AGP-03040.S2 } SENSOR PRIMER PISO SUR"},
{"descripcion":"{ AGP-03040.S3 } SENSOR SEGUNDO PISO NORTE"},
{"descripcion":"{ AGP-03040.S4 } SENSOR SEGUNDO PISO SUR"},
{"descripcion":"{ AGP-03040.S5 } SENSOR TERCER PISO NORTE"},
{"descripcion":"{ AGP-03040.S6 } SENSOR TERCER PISO SUR"},
{"descripcion":"{ AGP-03040.S7 } SENSOR POSICION 1 (SUR)"},
{"descripcion":"{ AGP-03040.S8 } SENSOR POSICION 2"},
{"descripcion":"{ AGP-03040.S9 } SENSOR POSICION 3"},
{"descripcion":"{ AGP-00301 } DESCOLGADOR DE PAVOS"},
{"descripcion":"{ AGP-01129 } BOMBA LAVADO CAMIONES"},
{"descripcion":"{ AGP-01132 } BOMBA T4 PATIO AGUAS LLUVIAS"},
{"descripcion":"{ AGP-03000 } BOMBA T4 DREN N 1 NORTE"},
{"descripcion":"{ AGP-03001 } BOMBA T4 POZO CAMARA 208"},
{"descripcion":"{ AGP-03002 } BOMBA T4 SUR CAMIONES"},
{"descripcion":"{ AGP-03003 } BOMBA ALCANTARILLADO PRINCIPAL"},
{"descripcion":"{ AGP-03004 } BOMBA ALCANTARILLADO MATADERO"},
{"descripcion":"{ AGP-03005 } BOMBA ALCANTARILLADO MANTENCION"},
{"descripcion":"{ AGP-07033 } BOMBA POZO AHUMADO PONIENTE"},
{"descripcion":"{ AGP-09083 } LÃNEA MEDIA TENSION"},
{"descripcion":"{ AGP-09127 } POZO N 3"},
{"descripcion":"{ AGP-09128 } SISTEMA DE BOMBEO ABLANDADORES"},
{"descripcion":"{ AGP-09129 } POZO N 4"},
{"descripcion":"{ AGP-09130 } POZO N 5"},
{"descripcion":"{ AGP-09368 } AIRE AC PORTERIA"},
{"descripcion":"{ AGP-09379 } LINEA AGUA COGENERACION ESCALDADO PAVOS"},
{"descripcion":"{ AGP-09380 } LINEA AGUA COGENERACION ESCALDADO POLLOS"},
{"descripcion":"{ AGP-09442 } BOMBA AGUA BLANDA N 1 NORTE"},
{"descripcion":"{ AGP-09443 } BOMBA AGUA BLANDA N 3 SUR"},
{"descripcion":"{ AGP-10072 } RADIOS PATIO PLANTA"},
{"descripcion":"{ AGP-10087 } TRASPALETAS PATIO PLANTA"},
{"descripcion":"{ AGP-10090 } TRASPALETAS ASEO"},
{"descripcion":"{ AGP-10190 } PORTON INGRESO AVES VIVAS"},
{"descripcion":"{ AGP-10191 } PORTON SALIDA PRODUCTOS TERMINADOS"},
{"descripcion":"{ AGP-10348 } RED DE GAS PLANTA"},
{"descripcion":"{ AGP-10353 } ESTANQUE 25 M3"},
{"descripcion":"{ AGP-10397 } BOMBA CENTRIFUGA POZO CAMARA 208"},
{"descripcion":"{ AGP-10405 } ESTANQUE 30 MT3 LAVADO DE CAMIONES SUR"},
{"descripcion":"{ AGP-10406 } ESTANQUE DE 10 MT3 LAVADO DE CAMIONES NORTE"},
{"descripcion":"{ AGP-10557 } TABLERO DE FUERZA CARGA DE CAMIONES N 1"},
{"descripcion":"{ AGP-10558 } TABLERO DE FUERZA CARGA DE CAMIONES N 2"},
{"descripcion":"{ AGP-10559 } TABLERO DE FUERZA CARGA DE CAMIONES N 3"},
{"descripcion":"{ AGP-10560 } TABLERO DE FUERZA CARGA DE CAMIONES N 4"},
{"descripcion":"{ AGP-10561 } TABLERO DE FUERZA CARGA DE CAMIONES N 5"},
{"descripcion":"{ AGP-10562 } TABLERO DE FUERZA CARGA DE CAMIONES N 6"},
{"descripcion":"{ AGP-10644 } BOMBA AGUA BLANDA N 2 CENTRO"},
{"descripcion":"{ AGP-10652 } EMPALME 1"},
{"descripcion":"{ AGP-10653 } EMPALME 2"},
{"descripcion":"{ AGP-10654 } BOMBA SUMERGIBLE SARLIN PATIO CAMIONES LABBE"},
{"descripcion":"{ AGP-10682 } BOMBA T3 POZO AHUMADO ORIENTE"},
{"descripcion":"{ AGP-09442.1 } MOTOR DE BOMBA AGUA BLANDA N 1"},
{"descripcion":"{ AGP-09443.1 } MOTOR BOMBA DE AGUA BLANDA N 2"},
{"descripcion":"{ AGP-03005.1 } BOMBA ALCANTARILLADO MANTENCION"},
{"descripcion":"{ AGP-03004.1 } BOMBA ALCANTARILLADO MATADERO"},
{"descripcion":"{ AGP-03003.1 } BOMBA ALCANTARILLADO PRINCIPAL"},
{"descripcion":"{ AGP-03003.S1 } SENSOR NIVEL ALTO"},
{"descripcion":"{ AGP-03003.S2 } SENSOR NIVEL BAJO"},
{"descripcion":"{ AGP-01129.1 } MOTOR BOMBA LAVADO CAMIONES 1 (NORTE)"},
{"descripcion":"{ AGP-01129.2 } MOTOR BOMBA LAVADO CAMIONES 2 (SUR)"},
{"descripcion":"{ AGP-01129.PLC1 } PLC TABLERO PRINCIPAL BOMBA LAVADO DE CAMIONES"},
{"descripcion":"{ AGP-07033.1 } MOTOR ORIENTE BOMBA POZO AHUMADO"},
{"descripcion":"{ AGP-07033.2 } MOTOR PONIENTE BOMBA POZO AHUMADO"},
{"descripcion":"{ AGP-07033.PLC1 } PLC TABLERO PRINCIPAL POZO DE AHUMADO"},
{"descripcion":"{ AGP-07033.S1 } SENSOR NIVEL"},
{"descripcion":"{ AGP-03000.1 } MOTOR BOMBA DREN N 1 NORTE"},
{"descripcion":"{ AGP-03000.S1 } SENSOR NIVEL ALTO"},
{"descripcion":"{ AGP-03000.S2 } SENSOR NIVEL BAJO"},
{"descripcion":"{ AGP-01132.1 } MOTOR BOMBA T4 PATIO AGUAS LLUVIAS"},
{"descripcion":"{ AGP-01132.S1 } SENSOR NIVEL BAJO"},
{"descripcion":"{ AGP-01132.S2 } SENSOR NIVEL ALTO"},
{"descripcion":"{ AGP-03001.1 } MOTOR BOMBA T4 POZO CAMARA 208"},
{"descripcion":"{ AGP-03001.2 } BOMBA SUMERGIBLE CAMARA 208"},
{"descripcion":"{ AGP-03001.PLC1 } PLC TABLERO PRINCIPAL BOMBA POZO CAMARA 208"},
{"descripcion":"{ AGP-03001.S1 } SENSOR DE NIVEL"},
{"descripcion":"{ AGP-03002.1 } MOTOR BOMBA T4 SUR CAMIONES"},
{"descripcion":"{ AGP-10353.1 } BOMBA ANILLO AGUA CALIENTE FILTRO PRINCIPAL"},
{"descripcion":"{ AGP-10353.1.1 } BOMBA AGUA CALIENTE PONIENTE"},
{"descripcion":"{ AGP-10353.1.2 } BOMBA AGUA CALIENTE ORIENTE"},
{"descripcion":"{ AGP-10353.2 } BOMBA RELLENO AGUA CALIENTE POLLO"},
{"descripcion":"{ AGP-10353.3 } BOMBA RELLENO AGUA CALIENTE PAVO"},
{"descripcion":"{ AGP-10353.4 } BOMBA ALIMENTACION AGUA CALIENTE ASEO (NORTE)"},
{"descripcion":"{ AGP-10353.5 } BOMBA ALIMENTACION AGUA CALIENTE ASEO (CENTRO)"},
{"descripcion":"{ AGP-10353.6 } BOMBA ALIMENTACION AGUA CALIENTE ASEO (SUR)"},
{"descripcion":"{ AGP-10353.7 } TABLERO ELECTRICO ALIMENTACION DE BOMBA AGUA CALIENTE ASEO SALA PROCESOS"},
{"descripcion":"{ AGP-10353.8 } PLC SISTEMA DE AGUA CALIENTE ASEO SALA DE PROCESO"},
{"descripcion":"{ AGP-10353.9 } PANTALLA HMI"},
{"descripcion":"{ AGP-00475 } SOPLADOR LOBULOS GD SEMIL"},
{"descripcion":"{ AGP-00476 } SOPLADOR LOBULOS GD CENTRO MEYN"},
{"descripcion":"{ AGP-00477 } SOPLADOR LOBULOS DRESSER 45 KUCMAQ"},
{"descripcion":"{ AGP-09171 } TORRE DE ENFRIAMIENTO BENTON SUR"},
{"descripcion":"{ AGP-00477.1 } MOTOR SOPLADOR LOBULOS DRESSER 45 KUCMAQ"},
{"descripcion":"{ AGP-00476.1 } MOTOR SOPLADOR LOBULOS DRESSER 47 MEYN"},
{"descripcion":"{ AGP-00475.1 } MOTOR SOPLADOR LOBULOS GD SEMIL"},
{"descripcion":"{ AGP-09171.1 } MOTOR TORRE NORTE ENFRIAMIENTO BENTON"},
{"descripcion":"{ AGP-09171.2 } MOTOR TORRE SUR ENFRIAMIENTO BENTON"},
{"descripcion":"{ AGP-09171.3 } BOMBA N 1 TORRES DE ENFRIAMIENTO BENTON"},
{"descripcion":"{ AGP-09171.4 } BOMBA N 2 TORRES DE ENFRIAMIENTO BENTON"},
{"descripcion":"{ AGP-09171.5 } BOMBA N 3 TORRES DE ENFRIAMIENTO BENTON"},
{"descripcion":"{ AGP-10191.S2 } SENSOR SUR PORTON SALIDA PRODUCTOS TERMINADOS"},
{"descripcion":"{ AGP_09127.1 } FILTRO ANILLAS LINEA ALIMENTACION AGUA CALDERA"},
{"descripcion":"{ AGP-09127.1 } BOMBA POZO N 3"},
{"descripcion":"{ AGP-09129.1 } BOMBA POZO N 4"},
{"descripcion":"{ AGP-09130.1 } BOMBA POZO N 5"},
{"descripcion":"{ AGP-00807.2 } MOTORREDUCTOR PRINCIPAL STARFROST IQF N 1"},
{"descripcion":"{ AGP-10501.1 } MOTORREDUCTOR CINTA ENTRADA CAMARA PALETIZADO CALIBRADO MOSCA INNOTECH"},
{"descripcion":"{ AGP-09128.1 } BOMBA N 1 SISTEMA DE BOMBEO ABLANDADORES"},
{"descripcion":"{ AGP-09128.2 } BOMBA N 2 SISTEMA DE BOMBEO ABLANDADORES"},
{"descripcion":"{ AGP-09128.3 } BOMBA N 3 SISTEMA DE BOMBEO ABLANDADORES"},
{"descripcion":"{ AGP-10578 } COMPRESOR MYCOM N220JL-V 1201"},
{"descripcion":"{ AGP-10579 } COMPRESOR MYCOM N220JL-V 1202"},
{"descripcion":"{ AGP-10580 } COMPRESOR MYCOM N220JL-V 1203"},
{"descripcion":"{ AGP-10581 } COMPRESOR MYCOM N220JL-V 1204"},
{"descripcion":"{ AGP-10582 } COMPRESOR MYCOM N220JL-V 1205"},
{"descripcion":"{ AGP-10608 } PURGADOR DE AIRE D 4 PUNTOS"},
{"descripcion":"{ AGP-10609 } ESTANQUE INTERMEDIA"},
{"descripcion":"{ AGP-10610 } ESTANQUE RECIRCULADOR IQF"},
{"descripcion":"{ AGP-10611 } ESTANQUE ACUMULADOR TERMOCIFON"},
{"descripcion":"{ AGP-10612 } ESTANQUE ACUMULADOR PRINCIPAL SALA MAQUINAS NUEVA"},
{"descripcion":"{ AGP-10613 } CONDENSADOR 8"},
{"descripcion":"{ AGP-10618 } TRANSFORMADOR N 7"},
{"descripcion":"{ AGP-10619 } TABLEROS ELECTRICOS SUB ESTACION N 7"},
{"descripcion":"{ AGP-10620 } TABLEROS ELECTRICOS SALA DE MAQUINAS 2"},
{"descripcion":"{ AGP-10578.1 } ESTANQUE ACUMULADOR COMPRESOR MYCOM N220JL-V 1201"},
{"descripcion":"{ AGP-10578.2 } BOMBA DE ACEITE COMPRESOR MYCOM N220JL-V 1201"},
{"descripcion":"{ AGP-10578.3 } ENFRIADOR DE ACEITE COMPRESOR MYCOM N220JL-V 1201"},
{"descripcion":"{ AGP-10578.4 } BLOCK DE COMPRESOR MYCOM N220JL-V 1201"},
{"descripcion":"{ AGP-10579.1 } ESTANQUE ACUMULADOR COMPRESOR MYCOM N220JL-V 1202"},
{"descripcion":"{ AGP-10579.2 } BOMBA DE ACEITE COMPRESOR MYCOM N220JL-V 1202"},
{"descripcion":"{ AGP-10579.3 } ENFRIADOR DE ACEITE COMPRESOR MYCOM N220JL-V 1202"},
{"descripcion":"{ AGP-10579.4 } BLOCK DE COMPRESOR MYCOM N220JL-V 1202"},
{"descripcion":"{ AGP-10579.5 } MICROPROCESADOR DE COMPRESOR MYCOM N220JL-V 1202"},
{"descripcion":"{ AGP-10580.1 } ESTANQUE ACUMULADOR COMPRESOR MYCOM N220JL-V 1203"},
{"descripcion":"{ AGP-10580.2 } BOMBA DE ACEITE COMPRESOR MYCOM N220JL-V 1203"},
{"descripcion":"{ AGP-10580.3 } ENFRIADOR DE ACEITE COMPRESOR MYCOM N220JL-V 1203"},
{"descripcion":"{ AGP-10580.4 } BLOCK DE COMPRESOR MYCOM N220JL-V 1203"},
{"descripcion":"{ AGP-10581.1 } ESTANQUE ACUMULADOR COMPRESOR MYCOM N220JL-V 1204"},
{"descripcion":"{ AGP-10581.2 } BOMBA DE ACEITE COMPRESOR MYCOM N220JL-V 1204"},
{"descripcion":"{ AGP-10581.3 } ENFRIADOR DE ACEITE COMPRESOR MYCOM N220JL-V 1204"},
{"descripcion":"{ AGP-10581.4 } BLOCK DE COMPRESOR MYCOM N220JL-V 1204"},
{"descripcion":"{ AGP-10581.5 } MICROPROCESADOR DE COMPRESOR MYCOM N220JL-V 1204"},
{"descripcion":"{ AGP-10582.1 } ESTANQUE ACUMULADOR COMPRESOR MYCOM N220JL-V 1205"},
{"descripcion":"{ AGP-10582.2 } BOMBA DE ACEITE COMPRESOR MYCOM N220JL-V 1205"},
{"descripcion":"{ AGP-10582.3 } ENFRIADOR DE ACEITE COMPRESOR MYCOM N220JL-V 1205"},
{"descripcion":"{ AGP-10582.4 } BLOCK DE COMPRESOR MYCOM N220JL-V 1205"},
{"descripcion":"{ AGP-10613.1 } BOMBA PRINCIPAL PONIENTE"},
{"descripcion":"{ AGP-10613.1/1 } MOTOR BOMBA PRINCIPAL PONIENTE"},
{"descripcion":"{ AGP-10613.2 } BOMBA SECUNDARIA PONIENTE"},
{"descripcion":"{ AGP-10613.2/1 } MOTOR BOMBA SECUNDARIA ORIENTE"},
{"descripcion":"{ AGP-10613.3 } BOMBA PRINCIPAL ORIENTE"},
{"descripcion":"{ AGP-10613.3/1 } MOTOR BOMBA PRINCIPAL ORIENTE"},
{"descripcion":"{ AGP-10613.4 } BOMBA SECUNDARIA ORIENTE"},
{"descripcion":"{ AGP-10613.4/1 } MOTOR BOMBA PRINCIPAL ORIENTE"},
{"descripcion":"{ AGP-10609.1 } PURGADOR DE ACEITE"},
{"descripcion":"{ AGP-10609.2 } SISTEMA NIVEL DE AMONIACO"},
{"descripcion":"{ AGP-10610.1 } PURGADOR DE ACEITE"},
{"descripcion":"{ AGP-10610.2 } BOMBA DE AMONIACO NORTE"},
{"descripcion":"{ AGP-10610.3 } BOMBA AMONIACO CENTRO"},
{"descripcion":"{ AGP-10610.4 } BOMBA AMONIACO SUR CENTRO"},
{"descripcion":"{ AGP-10610.5 } BOMBA AMONIACO SUR"},
{"descripcion":"{ AGP-10610.6 } CONTROL DE NIVEL"},
{"descripcion":"{ AGP-10608.1 } ESTANQUE ACUMULADOR PURGADOR 1500 LITROS"},
{"descripcion":"{ AGP-00113 } ESTANQUE SANGRE PAVOS"},
{"descripcion":"{ AGP-01137 } BOMBA TRASVASIJE DE SANGRE"},
{"descripcion":"{ AGP-01138 } SISTEMA DE CITRATO"},
{"descripcion":"{ AGP-01141 } ESTANQUES ALMACENAMIENTO SANGRE"},
{"descripcion":"{ AGP-01137.1 } MOTOBOMBA TRASVASIJE SANGRE"},
{"descripcion":"{ AGP-00113.1 } MOTORREDUCTOR AGITADOR ESTANQUE SANGRE PAVOS"},
{"descripcion":"{ AGP-00113.PLC1 } PLC TABLERO PRINCIPAL SISTEMA DE ESTANQUE DE SANGRE"},
{"descripcion":"{ AGP-01138.1 } BOMBA N 1 NORTE SISTEMA DE CITRATO"},
{"descripcion":"{ AGP-01138.2 } BOMBA N 2 SUR SISTEMA DE CITRATO SUR"},
{"descripcion":"{ AGP-01138.S1 } SENSOR DE NIVEL SEGURIDAD"},
{"descripcion":"{ AGP-00612 } CLIPEADORA SALA BALANZAS"},
{"descripcion":"{ AGP-03020 } LINEA AEREA BANDEJAS LIMPIAS"},
{"descripcion":"{ AGP-03021 } SECADOR DE BANDEJAS"},
{"descripcion":"{ AGP-10049 } EXTRACTOR ORIENTE BANDEJAS LIMPIAS [N 24]"},
{"descripcion":"{ AGP-10050 } EXTRACTOR PONIENTE BANDEJAS LIMPIAS [N 23]"},
{"descripcion":"{ AGP-10649 } TABLEROS ELECTRICOS SALA LAVADO BANDEJAS"},
{"descripcion":"{ AGP-10049.1 } MOTOR EXTRACTOR ORIENTE BANDEJAS LIMPIAS"},
{"descripcion":"{ AGP-10050.1 } MOTOR EXTRACTOR PONIENTE BANDEJAS LIMPIAS"},
{"descripcion":"{ AGP-03020.1 } MOTORREDUCTOR LINEA AEREA BANDEJAS LIMPIAS"},
{"descripcion":"{ AGP-03020.S1 } SENSOR TENSOR"},
{"descripcion":"{ AGP-03021.1 } MOTOR NOR ORIENTE SECADOR DE BANDEJAS"},
{"descripcion":"{ AGP-03021.2 } MOTOR SUR ORIENTE SECADOR DE BANDEJAS"},
{"descripcion":"{ AGP-03021.3 } MOTOR NOR PONIENTE SECADOR DE BANDEJAS"},
{"descripcion":"{ AGP-03021.4 } MOTOR SUR PONIENTE SECADOR DE BANDEJAS"},
{"descripcion":"{ AGP-03022 } LINEA AEREA BANDEJAS SUCIAS"},
{"descripcion":"{ AGP-03023 } LAVADORA BANDEJAS NORTE"},
{"descripcion":"{ AGP-03024 } LAVADORA BANDEJAS SUR"},
{"descripcion":"{ AGP-03025 } BOMBA SALA BANDEJAS"},
{"descripcion":"{ AGP-03026 } CINTA TRANSPORTE BANDEJAS"},
{"descripcion":"{ AGP-03027 } SEPARADOR AGUA SOLIDOS LAVADORA BANDEJAS"},
{"descripcion":"{ AGP-10051 } EXTRACTOR LAVADORA BANDEJAS [N 25]"},
{"descripcion":"{ AGP-10052 } EXTRACTOR BANDEJAS SUCIAS NORTE [N 26]"},
{"descripcion":"{ AGP-10053 } EXTRACTOR BANDEJAS SUCIAS NORTE [N 27]"},
{"descripcion":"{ AGP-10054 } EXTRACTOR BANDEJAS SUCIAS SUR [N 28]"},
{"descripcion":"{ AGP-10055 } EXTRACTOR BANDEJAS SUCIAS SUR [N 29]"},
{"descripcion":"{ AGP-03025.1 } MOTOR DE BOMBA SALA BANDEJAS"},
{"descripcion":"{ AGP-03026.1 } MOTORREDUCTOR CINTA TRANSPORTE BANDEJAS"},
{"descripcion":"{ AGP-10052.1 } MOTOR EXTRACTOR BANDEJAS SUCIAS N 1"},
{"descripcion":"{ AGP-10053.1 } MOTOR EXTRACTOR BANDEJAS SUCIAS N 2"},
{"descripcion":"{ AGP-10054.1 } MOTOR EXTRACTOR BANDEJAS SUCIAS N 3"},
{"descripcion":"{ AGP-10055.1 } MOTOR EXTRACTOR BANDEJAS SUCIAS N 4"},
{"descripcion":"{ AGP-10051.1 } MOTOR EXTRACTOR LAVADORA BANDEJAS"},
{"descripcion":"{ AGP-03023.1 } MOTORREDUCTOR CINTA LAVADORA BANDEJAS NORTE"},
{"descripcion":"{ AGP-03023.3 } MOTOR BOMBA ORIENTE LAVADORA DE BANDEJAS NORTE"},
{"descripcion":"{ AGP-03023.4 } MOTOR BOMBA PONIENTE LAVADORA DE BANDEJAS NORTE"},
{"descripcion":"{ AGP-03024.1 } MOTORREDUCTOR CINTA LAVADORA BANDEJAS SUR"},
{"descripcion":"{ AGP-03024.2 } MOTOR BOMBA ORIENTE LAVADORA DE BANDEJAS SUR"},
{"descripcion":"{ AGP-03024.3 } MOTOR BOMBA PONIENTE LAVADORA DE BANDEJAS SUR"},
{"descripcion":"{ AGP-03024.4 } MOTOR SEPARADOR DE SOLIDOS LAVADORA DE BANDEJAS SUR"},
{"descripcion":"{ AGP-03022.1 } MOTORREDUCTOR N 1 LINEA AEREA BANDEJAS SUCIAS"},
{"descripcion":"{ AGP-03022.2 } MOTORREDUCTOR N 2 LINEA AEREA BANDEJAS SUCIAS"},
{"descripcion":"{ AGP-03022.S1 } SENSOR TENSOR"},
{"descripcion":"{ AGP-10645 } TABLEROS ELECTRICOS SALA DE BATERIAS"},
{"descripcion":"{ AGP-09101 } LÃNEA DE GLICOL N 1 GRAL."},
{"descripcion":"{ AGP-09102 } INTERCAMBIADOR DE GLICOL N 1"},
{"descripcion":"{ AGP-09103 } BOMBAS DE GLICOL N 1 (05)"},
{"descripcion":"{ AGP-09109 } LÃNEA DE GLICOL N 2 GRAL."},
{"descripcion":"{ AGP-09110 } INTERCAMBIADOR DE GLICOL N 2"},
{"descripcion":"{ AGP-09115 } BOMBA DE GLICOL N 2 (01)"},
{"descripcion":"{ AGP-09115.1 } BOMBAS DE GLICOL N 2"},
{"descripcion":"{ AGP-09103.1 } MOTOR DE BOMBA GLICOL N 1 (01) LADO ESTANQUE GLICOL"},
{"descripcion":"{ AGP-09103.2 } BOMBAS DE GLICOL N 1 (02)"},
{"descripcion":"{ AGP-09103.3 } BOMBAS DE GLICOL N 1 (03)"},
{"descripcion":"{ AGP-09103.4 } BOMBAS DE GLICOL N 1 (04)"},
{"descripcion":"{ AGP-09103.5 } BOMBAS DE GLICOL N 1 (05)"},
{"descripcion":"{ AGP-10380 } BOMBA DE AGUA SIN CLORO HACIA CALDERA SUR"},
{"descripcion":"{ AGP-10381 } BOMBA DE AGUA SIN CLORO HACIA CALDERA"},
{"descripcion":"{ AGP-10382 } BOMBA DE AGUA SIN CLORO HACIA CALDERA NORTE"},
{"descripcion":"{ AGP-09122 } SISTEMA BOMBEO PLANTA"},
{"descripcion":"{ AGP-09123 } TABLEROS ELÃ‰CTRICOS SALA DE BOMBA"},
{"descripcion":"{ AGP-09124 } SISTEMA DE CLORACION GRAL."},
{"descripcion":"{ AGP-09125 } BOMBA ACHIQUE"},
{"descripcion":"{ AGP-09126 } ESTANQUE ALMACENAMIENTO 50 M3"},
{"descripcion":"{ AGP-09131 } FILTROS DE POZOS"},
{"descripcion":"{ AGP-10342 } MOTOR DE BOMBA DE AGUA N 1 DE SALA DE BOMBAS"},
{"descripcion":"{ AGP-10343 } MOTOR DE BOMBA DE AGUA N 2 SALA DE BOMBAS"},
{"descripcion":"{ AGP-10344 } MOTOR DE BOMBA DE AGUA N 3 SALA DE BOMBA"},
{"descripcion":"{ AGP-10345 } MOTOR DE BOMBA DE AGUA N 4 SALA DE BOMBAS"},
{"descripcion":"{ AGP-10346 } MOTOR DE BOMBA DE AGUA N 5 SALA DE BOMBAS"},
{"descripcion":"{ AGP-10347 } MOTOR DE BOMBA DE AGUA N 6 SALA DE BOMBA"},
{"descripcion":"{ AGP-10359 } CONTROLADOR DE CLORO"},
{"descripcion":"{ AGP-09125.1 } BOMBA ACHIQUE"},
{"descripcion":"{ AGP-09122.1 } BOMBA N 1 SISTEMA BOMBEO PLANTA"},
{"descripcion":"{ AGP-09122.2 } BOMBA N 2 SISTEMA BOMBEO PLANTA"},
{"descripcion":"{ AGP-09122.3 } BOMBA N 3 SISTEMA BOMBEO PLANTA"},
{"descripcion":"{ AGP-09122.4 } BOMBA N 4 SISTEMA BOMBEO PLANTA"},
{"descripcion":"{ AGP-09122.5 } BOMBA N 5 SISTEMA BOMBEO PLANTA"},
{"descripcion":"{ AGP-09122.6 } BOMBA N 6 SISTEMA BOMBEO PLANTA"},
{"descripcion":"{ AGP-09124.1 } BOMBA N 1 SISTEMA DE CLOLARACION GENERAL"},
{"descripcion":"{ AGP-09124.2 } BOMBA N 2 SISTEMA DE CLOLARACION GENERAL"},
{"descripcion":"{ AGP-09124.3 } BOMBA N 3 SISTEMA DE CLOLARACION GENERAL"},
{"descripcion":"{ AGP-09124.4 } BOMBA N 4 SISTEMA DE CLOLARACION GENERAL"},
{"descripcion":"{ AGP-09137 } LÃNEA AGUA CALIENTE COGENERACION ALTA"},
{"descripcion":"{ AGP-09139 } LÃNEA AGUA CALIENTE COGENERACION BAJA"},
{"descripcion":"{ AGP-09156 } LINEA DE VAPOR GRAL."},
{"descripcion":"{ AGP-09158 } ABLANDADOR N 1"},
{"descripcion":"{ AGP-09159 } SISTEMA DE COGENERACION"},
{"descripcion":"{ AGP-09440 } ABLANDADOR N 2"},
{"descripcion":"{ AGP-09441 } ABLANDADOR N 3"},
{"descripcion":"{ AGP-09444 } ESTANQUE DE AGUA (3)"},
{"descripcion":"{ AGP-10208 } TABLEROS ELECTRICOS DE FUERZA Y CONTROL SALA CALDERA"},
{"descripcion":"{ AGP-10316 } PLANTA TERMICA CALDERA Y COGONERACION"},
{"descripcion":"{ AGP-10402 } BOMBA DE RECHAZO DE AGUA RETROLAVADO"},
{"descripcion":"{ AGP-10651 } TABLEROS ELECTRICOS SISTEMA DE COGENERACION"},
{"descripcion":"{ AGP-10662 } ESTANQUE PETROLEO N 1 ORIENTE (CALDERA)"},
{"descripcion":"{ AGP-10663 } ESTANQUE PETROLEO N 2 PONIENTE (CALDERA)"},
{"descripcion":"{ AGP-09139.1 } BOMBA IMPULSION AGUA CALIENTE OPERARIOS NORTE"},
{"descripcion":"{ AGP-09139.2 } BOMBA IMPULSION AGUA CALIENTE OPERARIOS SUR"},
{"descripcion":"{ AGP-09139.3 } BOMBA RECIRCULACION COGENERACION AGUA CALIENTE OPERARIOS ORIENTE"},
{"descripcion":"{ AGP-09139.4 } BOMBA RECIRCULACION COGENERACION AGUA CALIENTE OPERARIOS PONIENTE"},
{"descripcion":"{ AGP09156.1 } MEDIDOR DE FLUJO DE VAPOR"},
{"descripcion":"{ AGP-00700 } MULTICABEZAL MBP"},
{"descripcion":"{ AGP-00700.HMI2 } PLC TABLERO PRINCIPAL CABEZAL MBP PACMAC"},
{"descripcion":"{ AGP-00701 } MULTICABEZAL ISHIDA CALIBRADO"},
{"descripcion":"{ AGP-00703 } EMBOLSADORA INNOTECH"},
{"descripcion":"{ AGP-00706 } IMPRESORA TERMICA TTO INNOTECH"},
{"descripcion":"{ AGP-00707 } DETECTOR METALES CEIA INNOTECH"},
{"descripcion":"{ AGP-00709 } CHEQUEADOR DE PESO ISHIDA"},
{"descripcion":"{ AGP-00710 } EMBOLSADORA PACMAC"},
{"descripcion":"{ AGP-00711 } DETECTOR METALES CEIA LINEA CAJAS CALIBRADO"},
{"descripcion":"{ AGP-00712 } IMPRESORA TERMICA TTO PACMAC"},
{"descripcion":"{ AGP-00850 } CALIBRADORA LINCOFLEX NÂº1 NORTE"},
{"descripcion":"{ AGP-00851 } CALIBRADORA LINCOFLEX NÂº2 SUR"},
{"descripcion":"{ AGP-00852 } ENZUNCHADORA MOSCA CALIBRADO (103760)"},
{"descripcion":"{ AGP-00853 } CODIFICADOR INKJET LINX 6900"},
{"descripcion":"{ AGP-00854 } SELLADORA DE PIE"},
{"descripcion":"{ AGP-00856 } SELLADORA DE BOLSA AUTOMATICA CALIBRADO"},
{"descripcion":"{ AGP-08113 } CINTA SALIDA SUR TUNEL LINEA (INNOTECH/VETTA)"},
{"descripcion":"{ AGP-08114 } CINTA VERTICAL BAJADA (INNOTECH/VETTA)"},
{"descripcion":"{ AGP-08115 } CINTA LARGA ALIMENTACION (INNOTECH/VETTA)"},
{"descripcion":"{ AGP-08116 } CINTA ELEVADORA ISHIDA INNOTECH"},
{"descripcion":"{ AGP-08117 } CINTA SALIDA INNOTECH"},
{"descripcion":"{ AGP-08118 } CINTA DETECTOR DE METALES INNOTECH"},
{"descripcion":"{ AGP-08119 } CINTA SALIDA DE DETECTOR DE METALES INNOTECH"},
{"descripcion":"{ AGP-08120 } CINTA LARGA PONIENTE ALIMENTACION CALIBRADORA SUR"},
{"descripcion":"{ AGP-08121 } CINTA LARGA ORIENTE ALIMENTACION CALIBRADORA NORTE"},
{"descripcion":"{ AGP-08122 } CINTA SALIDA TUNEL A CALIBRADORA SUR"},
{"descripcion":"{ AGP-08123 } CINTA SALIDA TUNEL A CALIBRADORA NORTE"},
{"descripcion":"{ AGP-08124 } CINTA BAJADA NORTE"},
{"descripcion":"{ AGP-08125 } CINTA BAJADA SUR"},
{"descripcion":"{ AGP-08126 } CINTA BYPASS BAJADA NORTE C/ TRASPASO SUR"},
{"descripcion":"{ AGP-08127 } CINTA TRASPASO NORTE"},
{"descripcion":"{ AGP-08128 } CINTA TRASPASO SUR"},
{"descripcion":"{ AGP-08129 } CINTA CORTA ALIMENTACION CALIBRADORA NORTE"},
{"descripcion":"{ AGP-08130 } CINTA CORTA ALIMENTACION CALIBRADORA SUR"},
{"descripcion":"{ AGP-08131 } CINTA SELLADO MANUAL NORTE"},
{"descripcion":"{ AGP-08132 } CINTA SELLADO MANUAL SUR"},
{"descripcion":"{ AGP-08133 } CINTA RECEPTORA DE SELLADO MANUAL"},
{"descripcion":"{ AGP-08134 } CINTA ENCAJADO PARA SELLADO MANUAL"},
{"descripcion":"{ AGP-08135 } CINTA EVACUADORA N 1"},
{"descripcion":"{ AGP-08136 } CINTA EVACUADORA N 2"},
{"descripcion":"{ AGP-08137 } CINTA EVACUADORA N 3"},
{"descripcion":"{ AGP-08138 } CINTA EVACUADORA N 4"},
{"descripcion":"{ AGP-08139 } CINTA EVACUADORA N 5"},
{"descripcion":"{ AGP-08140 } CINTA ANTES DETECTOR CEIA"},
{"descripcion":"{ AGP-08141 } CINTA DETECTOR DE METALES CEIA"},
{"descripcion":"{ AGP-08142 } CINTA ETIQUETADO CAJAS"},
{"descripcion":"{ AGP-08143 } CINTA ALIMENTACION ENZUNCHADORA MOSCA"},
{"descripcion":"{ AGP-08144 } CINTA SALIDA MOSCA"},
{"descripcion":"{ AGP-08145 } CINTA VOLANTE BYPASS MOSCA"},
{"descripcion":"{ AGP-08146 } CINTA SALIDA DE CAJAS 1"},
{"descripcion":"{ AGP-08147 } CINTA PALETIZADO DE CAJAS"},
{"descripcion":"{ AGP-09514 } UNIDAD EVAPORADORA DOBLE EMPAQUE CALIBRADO"},
{"descripcion":"{ AGP-09516 } UNIDAD EVAPORADORA DOBLE CALIBRADO"},
{"descripcion":"{ AGP-09517 } UNIDAD EVAPORADORA CALIBRADO"},
{"descripcion":"{ AGP-10041 } EXTRACTOR SALA CALIBRADO PECHUGAS [N 33]"},
{"descripcion":"{ AGP-10042 } IMPULSOR ORIENTE SALA CALIBRADO PECHUGAS [N 52]"},
{"descripcion":"{ AGP-10043 } IMPULSOR PONIENTE SALA CALIBRADO PECHUGAS [N 53]"},
{"descripcion":"{ AGP-10219 } MESA GIRATORIA ORIENTE INNOTECH"},
{"descripcion":"{ AGP-10220 } MESA GIRATORIA PONIENTE"},
{"descripcion":"{ AGP-10240 } TABLEROS ELECTRICOS DE FUERZA Y CONTROL CINTAS DE CALIBRADO"},
{"descripcion":"{ AGP-10332 } DETECTOR METALES CEIA LINEA PACMAC"},
{"descripcion":"{ AGP-10357 } CHEQUEADOR DINAMICO MAREL"},
{"descripcion":"{ AGP-10383 } MULTICABEZAL DE PESAJE MAREL"},
{"descripcion":"{ AGP-10393 } CINTA ELEVADORA ALIMENTACION CABEZAL PACMAN"},
{"descripcion":"{ AGP-10394 } CINTA TRASPASO A MULTICABEZAL"},
{"descripcion":"{ AGP-10407 } ENZUNCHADORA MOSCA SONIXS MP-6-R-VA [122095]"},
{"descripcion":"{ AGP-10500 } CINTA ENTRADA CAMARA PALETIZADO CALIBRADO (MOSCA PACMAC)"},
{"descripcion":"{ AGP-10501 } CINTA ENTRADA CAMARA PALETIZADO CALIBRADO MOSCA INNOTECH"},
{"descripcion":"{ AGP-10514 } TABLEROS ELECTRICOS FUERZA Y CONTROL SALA CALIBRADO"},
{"descripcion":"{ AGP-10575 } DETECTOR METALES CEIA CALIBRADO LINEA CAJAS ORIENTE"},
{"descripcion":"{ AGP-10595 } SELLADORA LINEAL OK SEALER"},
{"descripcion":"{ AGP-10617 } SELLADORA CONTINUA PRIME"},
{"descripcion":"{ AGP-10667 } CONO PRODUCTO GRANEL ORIENTE"},
{"descripcion":"{ AGP-10668 } CONO PRODUCTO GRANEL PONIENTE"},
{"descripcion":"{ AGP-10680 } UNIDAD ULTRASONIDO LIMPIEZA AGUJAS CALIBRADO"},
{"descripcion":"{ AGP-00850.1 } MOTORREDUCTOR CINTA PALETAS LINCOFLEX NÂº1 NORTE"},
{"descripcion":"{ AGP-00850.2 } MOTORREDUCTOR CINTA ALIMENTACION LINCOFLEX NÂº1 NORTE"},
{"descripcion":"{ AGP-00850.3 } MOTORREDUCTOR CINTA PESAJE LINCOFLEX NÂº1 NORTE"},
{"descripcion":"{ AGP-00850.4 } MOTORREDUCTOR CINTA FLYPER LINCOFLEX NÂº1 NORTE"},
{"descripcion":"{ AGP-00850.S1 } SENSOR DE SEGURIDAD ORIENTE"},
{"descripcion":"{ AGP-00850.S2 } SENSOR DE SEGURIDAD PONIENTE"},
{"descripcion":"{ AGP-00850.S3 } SENSOR DE SEGURIDAD CINTA PALETAS"},
{"descripcion":"{ AGP-00850.S4 } SENSOR DE SEGURIDAD ORIENTE"},
{"descripcion":"{ AGP-00850.S5 } SENSOR DE SEGURIDAD PONIENTE"},
{"descripcion":"{ AGP-00850.S6 } SENSOR SEGURIDAD TABLERO ORIENTE"},
{"descripcion":"{ AGP-00850.S7 } SENSOR ENTRADA DE PRODUCTO"},
{"descripcion":"{ AGP-00850.S8 } SENSOR TACOMETRO CINTA FLIPER"},
{"descripcion":"{ AGP-00851.1 } MOTORREDUCTOR CINTA PALETAS LINCOFLEX NÂº2 SUR"},
{"descripcion":"{ AGP-00851.2 } MOTORREDUCTOR CINTA ALIMENTACION LINCOFLEX NÂº2 SUR"},
{"descripcion":"{ AGP-00851.3 } MOTORREDUCTOR CINTA PESAJE LINCOFLEX NÂº2 SUR"},
{"descripcion":"{ AGP-00851.4 } MOTORREDUCTOR CINTA FLYPER LINCOFLEX NÂº2 SUR"},
{"descripcion":"{ AGP-00851.S1 } SENSOR DE SEGURIDAD ORIENTE"},
{"descripcion":"{ AGP-00851.S2 } SENSOR DE SEGURIDAD PONIENTE"},
{"descripcion":"{ AGP-00851.S3 } SENSOR DE SEGURIDAD CINTA PALETAS"},
{"descripcion":"{ AGP-00851.S4 } SENSOR DE SEGURIDAD ORIENTE"},
{"descripcion":"{ AGP-00851.S5 } SENSOR DE SEGURIDAD PONIENTE"},
{"descripcion":"{ AGP-00851.S6 } SENSOR SEGURIDAD TABLERO ORIENTE"},
{"descripcion":"{ AGP-00851.S7 } SENSOR ENTRADA DE PRODUCTO"},
{"descripcion":"{ AGP-00851.S8 } SENSOR TACOMETRO CINTA FLIPER"},
{"descripcion":"{ AGP-08143.1 } MOTORREDUCTOR CINTA ALIMENTACION MOSCA"},
{"descripcion":"{ AGP-08143.S1 } SENSOR ENTRADA DE CAJA"},
{"descripcion":"{ AGP-08143.S2 } SENSOR SALIDA DE CAJA"},
{"descripcion":"{ AGP-08140.1 } MOTORREDUCTOR CINTA ANTES DETECTOR CEIA"},
{"descripcion":"{ AGP-08124.1 } MOTORREDUCTOR CINTA BAJADA NORTE"},
{"descripcion":"{ AGP-08125.1 } MOTORREDUCTOR CINTA BAJADA SUR"},
{"descripcion":"{ AGP-08126.1 } MOTORREDUCTOR CINTA BYPASS BAJADA NORTE C/ TRASPASO SUR"},
{"descripcion":"{ AGP-08129.1 } MOTORREDUCTOR CINTA CORTA ALIMENTACION CALIBRADORA NORTE"},
{"descripcion":"{ AGP-08130.1 } MOTORREDUCTOR CINTA CORTA ALIMENTACION CALIBRADORA SUR"},
{"descripcion":"{ AGP-08141.1 } MOTORREDUCTOR CINTA DETECTOR DE METALES"},
{"descripcion":"{ AGP-08118.1 } MOTORREDUCTOR CINTA DETECTOR DE METALES INNOTECH"},
{"descripcion":"{ AGP-08116.1 } MOTORREDUCTOR CINTA ELEVADORA INNOTECH"},
{"descripcion":"{ AGP-08134.1 } MOTORREDUCTOR CINTA ENCAJADO PARA SELLADO MANUAL"},
{"descripcion":"{ AGP-10500.1 } MOTORREDUCTOR CINTA ENTRADA CAMARA PALETIZADO CALIBRADO (MOSCA PACMAC)"},
{"descripcion":"{ AGP-08142.1 } MOTORREDUCTOR CINTA ETIQUETADO CAJAS"},
{"descripcion":"{ AGP-08135.1 } MOTORREDUCTOR CINTA EVACUADORA N 1"},
{"descripcion":"{ AGP-08136.1 } MOTORREDUCTOR CINTA EVACUADORA N 2"},
{"descripcion":"{ AGP-08137.1 } MOTORREDUCTOR CINTA EVACUADORA N 3"},
{"descripcion":"{ AGP-08138.1 } MOTORREDUCTOR CINTA EVACUADORA N 4"},
{"descripcion":"{ AGP-08139.1 } MOTORREDUCTOR CINTA EVACUADORA N 5"},
{"descripcion":"{ AGP-08115.1 } MOTORREDUCTOR CINTA LARGA ALIMENTACION (INNOTECH/VETTA)"},
{"descripcion":"{ AGP-08121.1 } MOTORREDUCTOR CINTA LARGA ORIENTE ALIMENTACION CALIBRADORA NORTE"},
{"descripcion":"{ AGP-08120.1 } MOTORREDUCTOR CINTA LARGA PONIENTE ALIMENTACION CALIBRADORA SUR"},
{"descripcion":"{ AGP-08120.HMI1 } HMI TABLERO CONTROL SISTEMA DE CINTAS CALIBRADO DE PECHUGAS OFICINA"},
{"descripcion":"{ AGP-08120.HMI2 } HMI TABLERO CONTROL SISTEMA DE CINTAS CALIBRADO DE PECHUGAS ENCAJADO"},
{"descripcion":"{ AGP-08120.HMI3 } HMI TABLERO CONTROL SISTEMA DE CINTAS CALIBRADO DE PECHUGAS EMBOLSADO"},
{"descripcion":"{ AGP-08120.PLC1 } PLC TABLERO PRINCIPAL SISTEMA DE CINTAS CALIBRADO DE PECHUGAS 1"},
{"descripcion":"{ AGP-08120.PLC2 } PLC TABLERO PRINCIPAL SISTEMA DE CINTAS CALIBRADO DE PECHUGAS 2"},
{"descripcion":"{ AGP-08147.1 } MOTORREDUCTOR CINTA PALETIZADO DE CAJAS"},
{"descripcion":"{ AGP-08133.1 } MOTORREDUCTOR CINTA RECEPTORA DE SELLADO MANUAL"},
{"descripcion":"{ AGP-08146.1 } MOTORREDUCTOR CINTA SALIDA DE CAJAS 1"},
{"descripcion":"{ AGP-08119.1 } MOTORREDUCTOR CINTA SALIDA DE DETECTOR DE METALES INNOTECH"},
{"descripcion":"{ AGP-08117.1 } MOTORREDUCTOR CINTA SALIDA INNOTECH"},
{"descripcion":"{ AGP-08144.1 } MOTORREDUCTOR CINTA SALIDA MOSCA"},
{"descripcion":"{ AGP-08113.1 } MOTORREDUCTOR CINTA SALIDA SUR TUNEL LÃNEA (INNOTECH/VETTA)"},
{"descripcion":"{ AGP-08123.1 } MOTORREDUCTOR CINTA SALIDA TUNEL A CALIBRADORA NORTE"},
{"descripcion":"{ AGP-08122.1 } MOTORREDUCTOR CINTA SALIDA TUNEL A CALIBRADORA SUR"},
{"descripcion":"{ AGP-08131.1 } MOTORREDUCTOR CINTA SELLADO MANUAL NORTE"},
{"descripcion":"{ AGP-08132.1 } MOTORREDUCTOR CINTA SELLADO MANUAL SUR"},
{"descripcion":"{ AGP-08127.1 } MOTORREDUCTOR CINTA TRASPASO NORTE"},
{"descripcion":"{ AGP-08128.1 } MOTORREDUCTOR CINTA TRASPASO SUR"},
{"descripcion":"{ AGP-08114.1 } MOTORREDUCTOR CINTA BAJADA (INNOTECH/VETTA)"},
{"descripcion":"{ AGP-08145.1 } MOTORREDUCTOR CINTA VOLANTE BYPASS MOSCA"},
{"descripcion":"{ AGP-00707.S1 } SENSOR PRESENCIA INGRESO PRODUCTO"},
{"descripcion":"{ AGP-00711.S1 } SENSOR ENTRADA"},
{"descripcion":"{ AGP-00711.S2 } SENSOR SALIDA"},
{"descripcion":"{ AGP-00703.1 } MOTORREDUCTOR ALIMENTACION DE BOLSA EMBOLSADORA INNOTECH"},
{"descripcion":"{ AGP-00703.2 } MOTORREDUCTOR LADO ORIENTE TROQUELES EMBOLSADORA INNOTECH"},
{"descripcion":"{ AGP-00703.3 } MOTORREDUCTOR LADO PONIENTE TROQUELES EMBOLSADORA INNOTECH"},
{"descripcion":"{ AGP-00703.4 } MOTORREDUCTOR GIRO POLIN ALIMENTACION DE BOLSA EMBOLSADORA INNOTECH"},
{"descripcion":"{ AGP-00703.5 } MOTORREDUCTOR BOBINA DE ZIPPER EMBOLSADORA INNOTECH"},
{"descripcion":"{ AGP-00703.6 } MOTOR BOMBA DE VACIO EMBOLSADORA INNOTECH"},
{"descripcion":"{ AGP-00703.HMI1 } HMI TABLERO PRINCIPAL INNOTECH"},
{"descripcion":"{ AGP-00703.PLC1 } PLC TABLERO PRINCIPAL INNOTECH"},
{"descripcion":"{ AGP-00703.S1 } SENSOR ALIMENTACION BOLSA"},
{"descripcion":"{ AGP-00703.S10 } SENSOR NIVEL INFERIOR ALIMENACION DE ZIPPER"},
{"descripcion":"{ AGP-00703.S11 } SENSOR TERMINO DE ZIPPER"},
{"descripcion":"{ AGP-00703.S12 } SENSOR PRESENCIA DE ZIPPER EN BOLSA"},
{"descripcion":"{ AGP-00703.S13 } SENSOR PROTECCION PUERTAS"},
{"descripcion":"{ AGP-00703.S14 } SENSOR SOBRE PRESION MORDAZAS TRANSVERSALES"},
{"descripcion":"{ AGP-00703.S15 } SENSOR SUPERIOR SOBRE PRESION MORDAZAS NEUMATICAS"},
{"descripcion":"{ AGP-00703.S16 } SENSOR TERMINO DE ROLLO"},
{"descripcion":"{ AGP-00703.S17 } SENSOR ENCODER DE LONGITUD DE BOLSA"},
{"descripcion":"{ AGP-00703.S2 } SENSOR ALIMENTACION ZIPPER"},
{"descripcion":"{ AGP-00703.S3 } SENSOR ARRANQUE ALIMENTACION ZIPPER"},
{"descripcion":"{ AGP-00703.S4 } SENSOR ATASCO PRODUCTO EN DOSIFICADOR"},
{"descripcion":"{ AGP-00703.S5 } SENSOR BAJO CERRADA MORDAZA"},
{"descripcion":"{ AGP-00703.S6 } SENSOR CANTO DE PLASTICO IZQUIERDO"},
{"descripcion":"{ AGP-00703.S7 } SENSOR CANTO DE PLASTICO DERECHO"},
{"descripcion":"{ AGP-00703.S8 } SENSOR ENTRADA BOLSA PESA DINAMICA"},
{"descripcion":"{ AGP-00703.S9 } SENSOR LECTOR TACA"},
{"descripcion":"{ AGP-00710.HMI1 } HMI TABLERO PRINCIPAL PACMAC"},
{"descripcion":"{ AGP-00710.PLC1 } PLC TABLERO PRINCIPAL PACMAC"},
{"descripcion":"{ AGP-10041.1 } MOTOR EXTRACTOR SALA CALIBRADO PECHUGAS"},
{"descripcion":"{ AGP-00706.HMI1 } HMI TABLERO PRINCIPAL IMPRESORA TTO PACMAC"},
{"descripcion":"{ AGP-00712.HMI1 } HMI TABLERO PRINCIPAL IMPRESORA TTO PACMAC"},
{"descripcion":"{ AGP-10042.1 } MOTOR IMPULSOR ORIENTE SALA CALIBRADO PECHUGAS"},
{"descripcion":"{ AGP-10043.1 } MOTOR IMPULSOR PONIENTE SALA CALIBRADO PECHUGAS"},
{"descripcion":"{ AGP-00701.HMI1 } HMI TABLERO CONTROL CABEZAL ISHIDA INNOTECH"},
{"descripcion":"{ AGP-00700.HMI1 } HMI TABLERO CONTROL CABEZAL MBP PACMAC"},
{"descripcion":"{ AGP-09517.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA CALIBRADO N 3"},
{"descripcion":"{ AGP-09517.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA CALIBRADO N 3"},
{"descripcion":"{ AGP-09517.3 } MOTOR VENTILADOR N 3 UNIDAD EVAPORADORA CALIBRADO N 3"},
{"descripcion":"{ AGP-09516.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA CALIBRADO N 2"},
{"descripcion":"{ AGP-09516.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA CALIBRADO N 2"},
{"descripcion":"{ AGP-09516.3 } MOTOR VENTILADOR N 3 UNIDAD EVAPORADORA CALIBRADO N 2"},
{"descripcion":"{ AGP-09514.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA EMPAQUE CALIBRADO N 1"},
{"descripcion":"{ AGP-09514.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA EMPAQUE CALIBRADO N 1"},
{"descripcion":"{ AGP-09514.3 } MOTOR VENTILADOR N 3 UNIDAD EVAPORADORA EMPAQUE CALIBRADO N 1"},
{"descripcion":"{ AGP-00900 } VOLTEADOR DE BINS PULPAS"},
{"descripcion":"{ AGP-00901 } ROSCA ELEVADORA PULPAS"},
{"descripcion":"{ AGP-00902 } DETECTOR METALES CEIA PRINCE"},
{"descripcion":"{ AGP-00903 } TORNILLO PRE MOLEDOR PRINCE"},
{"descripcion":"{ AGP-00904 } DETECTOR METALES SAFELINE (TUBO)"},
{"descripcion":"{ AGP-00905 } SEPARADOR DE PULPAS PRINCE"},
{"descripcion":"{ AGP-00906 } BOMBA LOBULOS WAUKESHA N 1"},
{"descripcion":"{ AGP-00907 } INTERCAMBIADOR VOTATOR"},
{"descripcion":"{ AGP-00908 } DESTENDONADORA BAADER"},
{"descripcion":"{ AGP-00909 } BOMBA LOBULOS WAUKESHA N 2"},
{"descripcion":"{ AGP-00910 } BOMBA LOBULOS WAUKESHA N 3"},
{"descripcion":"{ AGP-00952 } CONGELADOR PLACAS GRAM"},
{"descripcion":"{ AGP-00953 } CONGELADOR PLACAS ITALIANO"},
{"descripcion":"{ AGP-00954 } DETECTOR METALES LOCK BAADER"},
{"descripcion":"{ AGP-00955 } MEZCLADOR DE PULPAS"},
{"descripcion":"{ AGP-00956 } CONGELADOR DSI VERTICAL PLACAS NORTE"},
{"descripcion":"{ AGP-00957 } CONGELADOR DSI VERTICAL PLACAS SUR"},
{"descripcion":"{ AGP-08174 } CINTA ELEVADORA HACIA DESTENDONADORA BAADER"},
{"descripcion":"{ AGP-08175 } CINTA DETECTOR DE METALES BAADER"},
{"descripcion":"{ AGP-08176 } CINTA DETECTOR DE METALES LOCK"},
{"descripcion":"{ AGP-09410 } FANCOIL PULPAS N 1"},
{"descripcion":"{ AGP-09411 } FANCOIL PULPAS N 2"},
{"descripcion":"{ AGP-09470 } UNIDAD EVAPORADORA DOBLE CAMARA PULPAS"},
{"descripcion":"{ AGP-10047 } EXTRACTOR SALA PULPAS [N 5]"},
{"descripcion":"{ AGP-10048 } IMPULSOR SALA PULPAS [N 57]"},
{"descripcion":"{ AGP-10071 } RADIOS PULPAS"},
{"descripcion":"{ AGP-10085 } TRASPALETAS PULPAS"},
{"descripcion":"{ AGP-10101 } BALANZAS PULPAS"},
{"descripcion":"{ AGP-10186 } BASCULA DE PISO PULPAS 2000 KG"},
{"descripcion":"{ AGP-10305 } IMPRESORA PULPAS"},
{"descripcion":"{ AGP-10403 } CONGELADOR DE PLACA TUCAL ORIENTE"},
{"descripcion":"{ AGP-10404 } CONGELADOR DE PLACA TUCAL PONIENTE"},
{"descripcion":"{ AGP-10525 } TABLERO ELECTRICO CONTROL Y FUERZA SALA DE PULPAS"},
{"descripcion":"{ AGP-00906.1 } MOTORREDUCTOR BOMBA LOBULOS WAUKESHA"},
{"descripcion":"{ AGP-00909.1 } MOTORREDUCTOR BOMBA WAUKESHA"},
{"descripcion":"{ AGP-00910.1 } MOTORREDUCTOR BOMBA WAUKESHA"},
{"descripcion":"{ AGP-08175.1 } MOTORREDUCTOR CINTA DETECTOR DE METALES BAADER"},
{"descripcion":"{ AGP-08176.1 } MOTORREDUCTOR CINTA DETECTOR DE METALES LOCK"},
{"descripcion":"{ AGP-08174.1 } MOTORREDUCTOR CINTA ELEVADORA HACIA DESTENDONADORA BAADER"},
{"descripcion":"{ AGP-00956.1 } MOTOR CENTRAL HIDRAULICA CONGELADOR DSI VERTICAL PLACAS NORTE"},
{"descripcion":"{ AGP-00957.1 } MOTOR CENTRAL HIDRAULICA CONGELADOR DSI VERTICAL PLACAS SUR"},
{"descripcion":"{ AGP-00952.1 } MOTOR CENTRAL HIDRAULICA CONGELADOR PLACAS GRAM"},
{"descripcion":"{ AGP-00953.1 } MOTOR CENTRAL HIDRAULICA CONGELADOR PLACAS ITALIANO"},
{"descripcion":"{ AGP-00908.1 } MOTORREDUCTOR DESTENDONADORA BAADER"},
{"descripcion":"{ AGP-00908.2 } MOTOR CENTRAL HIDRAULICA DESTENDONADORA BAADER"},
{"descripcion":"{ AGP-00908.PLC1 } PLC TABLERO PRINCIPAL DESTENDONADORA BAADER"},
{"descripcion":"{ AGP-00908.S1 } SENSOR SEGURIDAD"},
{"descripcion":"{ AGP-10047.1 } MOTOR EXTRACTOR SALA PULPAS"},
{"descripcion":"{ AGP-09410.1 } MOTOR VENTILADOR N 1 FANCOIL PULPAS N 1"},
{"descripcion":"{ AGP-09411.1 } MOTOR VENTILADOR N 1 FANCOIL PULPAS N 2"},
{"descripcion":"{ AGP-09411.2 } MOTOR VENTILADOR N 2 FANCOIL PULPAS N 2"},
{"descripcion":"{ AGP-09411.3 } MOTOR VENTILADOR N 3 FANCOIL PULPAS N 2"},
{"descripcion":"{ AGP-10048.1 } MOTOR IMPULSOR SALA PULPAS"},
{"descripcion":"{ AGP-00907.1 } MOTORREDUCTOR NORTE INTERCAMBIADOR VOTATOR"},
{"descripcion":"{ AGP-00907.2 } MOTORREDUCTOR SUR INTERCAMBIADOR VOTATOR"},
{"descripcion":"{ AGP-00955.1 } MOTORREDUCTOR MEZCLADOR DE PULPAS"},
{"descripcion":"{ AGP-00901.1 } MOTORREDUCTOR ROSCA ELEVADORA PULPAS"},
{"descripcion":"{ AGP-00905.1 } MOTOR SEPARADOR DE PULPAS PRINCE"},
{"descripcion":"{ AGP-00905.2 } MOTOR CENTRAL HIDRAULICA SEPARADOR DE PULPAS PRINCE"},
{"descripcion":"{ AGP-00905.3 } MOTOR VENTILADOR ENFRIADOR DE ACEITE SEPARADOR DE PULPAS PRINCE"},
{"descripcion":"{ AGP-00905.HMI1 } HMI TABLERO PRINCIPAL SISTEMA DE PULPAS"},
{"descripcion":"{ AGP-00905.PLC1 } PLC TABLERO PRINCIPAL SISTEMA DE PULPAS"},
{"descripcion":"{ AGP-00903.1 } MOTORREDUCTOR TORNILLO MOLEDOR PRINCE"},
{"descripcion":"{ AGP-00903.2 } MOTOR VENTILADOR TORNILLO MOLEDOR PRINCE"},
{"descripcion":"{ AGP-00903.3 } MOTORREDUCTOR PALETA SUPERIOR TORNILLO MOLEDOR PRINCE"},
{"descripcion":"{ AGP-00903.S1 } SENSOR NIVEL"},
{"descripcion":"{ AGP-00900.1 } MOTOR CENTRAL HIDRAULICA VOLTEADOR DE BINS PULPAS"},
{"descripcion":"{ AGP-01106 } CINTA COLGADO DE AVES"},
{"descripcion":"{ AGP-10004 } EXTRACTOR COLGADO DE POLLOS [N 6]"},
{"descripcion":"{ AGP-10005 } IMPULSOR COLGADO DE POLLOS [N 56]"},
{"descripcion":"{ AGP-01106.1 } MOTORREDUCTOR CINTA COLGADO DE AVES"},
{"descripcion":"{ AGP-10004.1 } MOTOR EXTRACTOR COLGADO DE POLLOS"},
{"descripcion":"{ AGP-10005.1 } MOTOR IMPULSOR COLGADO DE POLLOS"},
{"descripcion":"{ AGP-09007 } BOMBA WITT N 1 RECIRCULADOR DE BAJA -35 N 1"},
{"descripcion":"{ AGP-09008 } BOMBA WITT N 2 RECIRCULADOR DE BAJA -35 N 1"},
{"descripcion":"{ AGP-09009 } LINEA LIQUIDO RECIRCULADOR DE BAJA -35 N 1"},
{"descripcion":"{ AGP-09010 } LINEA SUCCION HUMEDA RECIRCULADOR DE BAJA -35 N 1"},
{"descripcion":"{ AGP-09043 } RECIRCULADOR DE ALTA -10 N 1"},
{"descripcion":"{ AGP-09044 } BOMBA WITT N 1 RECIRCULADOR DE ALTA -10 N 1"},
{"descripcion":"{ AGP-09045 } BOMBA WITT N 2 RECIRCULADOR DE ALTA -10 N 1"},
{"descripcion":"{ AGP-09046 } BOMBA WITT N 3 RECIRCULADOR DE ALTA -10 N 1"},
{"descripcion":"{ AGP-09047 } LINEA LIQUIDO RECIRCULADOR DE ALTA -10 N 1"},
{"descripcion":"{ AGP-09048 } LINEA SUCCION RECIRCULADOR DE ALTA -10 N 1"},
{"descripcion":"{ AGP-09090 } COMPRESOR MYCOM N220 JL-V (EX1028)"},
{"descripcion":"{ AGP-09091 } COMPRESOR MYCOM N220 JL-V (EX1029) - (EX1104)"},
{"descripcion":"{ AGP-09092 } COMPRESOR FRICK RWFII 134Â (EX1030)"},
{"descripcion":"{ AGP-09093 } COMPRESOR GRAM GSV 185Â (EX1031)"},
{"descripcion":"{ AGP-10106 } TABLEROS ELECTRICOS NIVEL 1 COMPRESORES"},
{"descripcion":"{ AGP-09044.1 } MOTOR DE BOMBA WITT N 1 RECIRCULADOR DE ALTA -10 N 1"},
{"descripcion":"{ AGP-09007.1 } MOTOR DE BOMBA WITT N 1 RECIRCULADOR DE BAJA -35 N 1"},
{"descripcion":"{ AGP-09045.1 } MOTOR DE BOMBA WITT N 2 RECIRCULADOR DE ALTA -10 N 1"},
{"descripcion":"{ AGP-09008.1 } MOTOR DE BOMBA WITT N 2 RECIRCULADOR DE BAJA -35 N 1"},
{"descripcion":"{ AGP-09046.1 } MOTOR DE BOMBA WITT N 3 RECIRCULADOR DE ALTA -10 N 1"},
{"descripcion":"{ AGP-09092.1 } MOTOR DE COMPRESOR N 3 NH3 EX1030"},
{"descripcion":"{ AGP-09092.2 } BOMBA DE COMPRESOR N 3 NH3 EX1030"},
{"descripcion":"{ AGP-09093.1 } MOTOR DE COMPRESOR N 4 NH3 EX1031 (PONIENTE)"},
{"descripcion":"{ AGP-09093.2 } BOMBA DE COMPRESOR N 4 NH3 EX1031 (PONIENTE)"},
{"descripcion":"{ AGP-09090.1 } MOTOR DE COMPRESOR N 1 NH3 EX1028 (ORIENTE)"},
{"descripcion":"{ AGP-09090.2 } BOMBA DE COMPRESOR N 1 NH3 EX1028 (ORIENTE)"},
{"descripcion":"{ AGP-9090.3 } VALVULA DE SEGURIDAD"},
{"descripcion":"{ AGP-09091.1 } MOTOR DE COMPRESOR N 2 NH3 EX1029"},
{"descripcion":"{ AGP-09091.2 } BOMBA DE COMPRESOR N 2 NH3 EX1029"},
{"descripcion":"{ AGP-09043.1 } DESHIDRATADOR DE AMONIACO"},
{"descripcion":"{ AGP-10106.HMI1 } HMI FRIO ETAPA 1 TABLEROS ELECTRICOS NIVEL 1 COMPRESORES"},
{"descripcion":"{ AGP-10106.HMI2 } HMI CONDENSADORES TABLEROS ELECTRICOS NIVEL 1 COMPRESORES"},
{"descripcion":"{ AGP-10106.HMI3 } HMI FRIO AHUMADO TABLEROS ELECTRICOS NIVEL 1 COMPRESORES"},
{"descripcion":"{ AGP-10106.HMI4 } HMI NIVELES DE COMPRESORES TABLEROS ELECTRICOS NIVEL 1 COMPRESORES"},
{"descripcion":"{ AGP-10106.HMI5 } HMI COGENERACION TABLEROS ELECTRICOS NIVEL 1 COMPRESORES"},
{"descripcion":"{ AGP-09002 } PURGADOR DE AIRE"},
{"descripcion":"{ AGP-09003 } TRAMPA"},
{"descripcion":"{ AGP-09004 } LINEA RETORNO GAS CALIENTE"},
{"descripcion":"{ AGP-09005 } BOMBA WITT TRAMPA N 1"},
{"descripcion":"{ AGP-09006 } RECIRCULADOR DE BAJA -35 N 1"},
{"descripcion":"{ AGP-09017 } RECIRCULADOR DE BAJA -35 N 2"},
{"descripcion":"{ AGP-09018 } BOMBA WITT N 1 RECIRCULADOR DE BAJA -35 N 2"},
{"descripcion":"{ AGP-09019 } BOMBA WITT N 2 RECIRCULADOR DE BAJA -35 N 2"},
{"descripcion":"{ AGP-09020 } LINEA LIQUIDO RECIRCULADOR DE BAJA -35 N 2"},
{"descripcion":"{ AGP-09021 } LINEA SUCCION RECIRCULADOR DE BAJA -35 N 2"},
{"descripcion":"{ AGP-09027 } ESTANQUE ACUMULADOR BOOSTER"},
{"descripcion":"{ AGP-09033 } RECIRCULADOR DE STAR FROST -42"},
{"descripcion":"{ AGP-09034 } BOMBA WITT N 1 RECIRCULADOR DE STAR FROST -42"},
{"descripcion":"{ AGP-09035 } BOMBA WITT N 2 RECIRCULADOR DE STAR FROST -42"},
{"descripcion":"{ AGP-09036 } LINEA LIQUIDO RECIRCULADOR DE STAR FROST -42"},
{"descripcion":"{ AGP-09037 } LINEA SUCCION RECIRCULADOR DE STAR FROST -42"},
{"descripcion":"{ AGP-09055 } RECIRCULADOR DE ALTA -10 N 2"},
{"descripcion":"{ AGP-09056 } BOMBA WITT N 1 RECIRCULADOR DE ALTA -10 N 2"},
{"descripcion":"{ AGP-09057 } BOMBA WITT N 2 RECIRCULADOR DE ALTA -10 N 2"},
{"descripcion":"{ AGP-09058 } LINEA LIQUIDO RECIRCULADOR DE ALTA -10 N 2"},
{"descripcion":"{ AGP-09059 } LINEA SUCCION RECIRCULADOR DE ALTA -10 N 2"},
{"descripcion":"{ AGP-09094 } COMPRESOR FRICK RWBII 270HÂ (EX1057)"},
{"descripcion":"{ AGP-09095 } COMPRESOR FRICK RWB 222HÂ (EX1060)"},
{"descripcion":"{ AGP-09096 } COMPRESOR FRICK RWBII 270HÂ (EX1063)"},
{"descripcion":"{ AGP-09097 } COMPRESOR FRICK RWB TT 480H (EX1069)"},
{"descripcion":"{ AGP-09098 } COMPRESOR FRICK RWFII 222HÂ (EX1072)"},
{"descripcion":"{ AGP-09104 } COMPRESOR MYCOM N250VMD [NEW1063]"},
{"descripcion":"{ AGP-10408 } COMPRESOR MYCOM 250 VSD (NEW1072)"},
{"descripcion":"{ AGP-09056.1 } MOTOR DE BOMBA WITT N 1 RECIRCULADOR DE ALTA -10 N 2"},
{"descripcion":"{ AGP-09018.1 } MOTOR DE BOMBA WITT N 1 RECIRCULADOR DE BAJA -35 N 2"},
{"descripcion":"{ AGP-09034.1 } MOTOR DE BOMBA WITT N 1 RECIRCULADOR DE BAJA STAR FROST -42 N 3"},
{"descripcion":"{ AGP-09057.1 } MOTOR DE BOMBA WITT N 2 RECIRCULADOR DE ALTA -10 N 2"},
{"descripcion":"{ AGP-09019.1 } MOTOR DE BOMBA WITT N 2 RECIRCULADOR DE BAJA -35 N 2"},
{"descripcion":"{ AGP-09035.1 } MOTOR DE BOMBA WITT N 2 RECIRCULADOR DE BAJA STAR FROST -42 N 3"},
{"descripcion":"{ AGP-09005.1 } MOTOR DE BOMBA WITT TRAMPA N 1"},
{"descripcion":"{ AGP-09095.1 } MOTOR DE COMPRESOR N 2 NH3 EX1060 (NORTE PONIENTE)"},
{"descripcion":"{ AGP-09095.2 } BOMBA DE COMPRESOR N 2 NH3 EX1060 (NORTE PONIENTE)"},
{"descripcion":"{ AGP-09097.1 } MOTOR DE COMPRESOR N 4 NH3 EX1069 (CENTRO SUR)"},
{"descripcion":"{ AGP-09097.2 } BOMBA DE COMPRESOR N 4 NH3 EX1069 (CENTRO SUR)"},
{"descripcion":"{ AGP-09094.1 } MOTOR DE COMPRESOR N 1 NH3 EX1057 (NORTE ORIENTE)"},
{"descripcion":"{ AGP-09094.2 } BOMBA DE COMPRESOR N 1 NH3 EX1057 (NORTE ORIENTE)"},
{"descripcion":"{ AGP-09096.1 } MOTOR DE COMPRESOR N 3 NH3 EX1063 (SUR ORIENTE)"},
{"descripcion":"{ AGP-09096.2 } BOMBA DE COMPRESOR N 3 NH3 EX1063 (SUR ORIENTE)"},
{"descripcion":"{ AGP-09098.1 } MOTOR DE COMPRESOR N 5 NH3 EX1072 (SUR PONIENTE)"},
{"descripcion":"{ AGP-09098.2 } BOMBA DE COMPRESOR N 5 NH3 EX1072 (SUR PONIENTE)"},
{"descripcion":"{ AGP-09099 } COMPRESOR MYCOM 320 VMD-H (EX1106)"},
{"descripcion":"{ AGP-09100 } COMPRESOR MYCOM 250 VSD-H (EX1124)"},
{"descripcion":"{ AGP-10107 } TABLEROS ELECTRICOS NIVEL 2 COMPRESORES"},
{"descripcion":"{ AGP-09100.1 } MOTOR DE COMPRESOR NH3 EX1124 (ORIENTE)"},
{"descripcion":"{ AGP-09100.2 } BOMBA DE COMPRESOR NH3 EX1124 (ORIENTE)"},
{"descripcion":"{ AGP-09099.1 } MOTOR DE COMPRESOR NH3 EX1106 (PONIENTE)"},
{"descripcion":"{ AGP-09099.2 } BOMBA DE COMPRESOR NH3 EX1106 (PONIENTE)"},
{"descripcion":"{ AGP-01130 } BOMBA T6 GUANO"},
{"descripcion":"{ AGP-01134 } SEPARADOR DE AGUAS PLUMAS"},
{"descripcion":"{ AGP-01146 } CINTA ELEVADORA EVACUACION DE PLUMAS A CONTENDOR"},
{"descripcion":"{ AGP-01130.1 } MOTOR BOMBA T6 GUANO"},
{"descripcion":"{ AGP-01130.S1 } SENSOR NIVEL BAJO"},
{"descripcion":"{ AGP-01130.S2 } SENSOR NIVEL ALTO"},
{"descripcion":"{ AGP-01146.1 } MOTORREDUCTOR CINTA ELEVADORA EVACUACION DE PLUMAS A CONTENDOR"},
{"descripcion":"{ AGP-01134.1 } MOTORREDUCTOR SEPARADOR DE AGUAS PLUMAS"},
{"descripcion":"{ AGP-01127 } BOMBA CONO NORTE"},
{"descripcion":"{ AGP-01128 } BOMBA CONO SUR"},
{"descripcion":"{ AGP-01131 } BOMBA ACHIQUE POZO PLUMAS"},
{"descripcion":"{ AGP-01133 } BOMBAS PLUMAS NORTE"},
{"descripcion":"{ AGP-01139 } BOMBAS PLUMAS SUR"},
{"descripcion":"{ AGP-10241 } TABLEROS ELECTRICOS DE FUERZA Y CONTROL SISTEMA DE CONO"},
{"descripcion":"{ AGP-01131.1 } BOMBA ACHIQUE POZO PLUMAS"},
{"descripcion":"{ AGP-01127.1 } MOTOR BOMBA CONO NORTE"},
{"descripcion":"{ AGP-01127.S1 } SENSOR GUILLOTINA ARRIBA"},
{"descripcion":"{ AGP-01127.S2 } SENSOR GUILLOTINA ABAJO"},
{"descripcion":"{ AGP-01127.S3 } SENSOR DE NIVEL SEGURIDAD"},
{"descripcion":"{ AGP-01128.1 } MOTOR BOMBA CONO SUR"},
{"descripcion":"{ AGP-01128.S1 } SENSOR GUILLOTINA ARRIBA"},
{"descripcion":"{ AGP-01128.S2 } SENSOR GUILLOTINA ABAJO"},
{"descripcion":"{ AGP-01133.1 } MOTOR BOMBAS PLUMAS NORTE"},
{"descripcion":"{ AGP-01133.S1 } SENSOR DE NIVEL"},
{"descripcion":"{ AGP-01133.S2 } SENSOR PRESENCIA DE FLUJO"},
{"descripcion":"{ AGP-01139.1 } MOTOR BOMBAS PLUMAS SUR"},
{"descripcion":"{ AGP-00550 } DESHUESADORA HQ NORTE"},
{"descripcion":"{ AGP-00551 } DESHUESADORA HQ SUR"},
{"descripcion":"{ AGP-00553 } VOLTEADOR DE BINS DESHUESADO PECHUGA"},
{"descripcion":"{ AGP-00556 } SELLADORA DE BOLSA"},
{"descripcion":"{ AGP-00557 } SELLADORA DE PIE"},
{"descripcion":"{ AGP-08021 } CINTA CURVA ALIMENTACION HQ NÂº1"},
{"descripcion":"{ AGP-08022 } CINTA ALIMENTACION HQ NÂº1"},
{"descripcion":"{ AGP-08023 } CINTA TRASLADO PECHUGA SALIDA HQ NÂº 1"},
{"descripcion":"{ AGP-08024 } CINTA RECUPERACION FILETILLO CON TENDON 1 HQ NÂº 1"},
{"descripcion":"{ AGP-08025 } CINTA RECUPERACION FILETILLO SIN TENDON HQ NÂº 1"},
{"descripcion":"{ AGP-08026 } CINTA RECUPERACION FILETILLO CON TENDON 2 HQ NÂº 1"},
{"descripcion":"{ AGP-08027 } CINTA CLAVÃCULA"},
{"descripcion":"{ AGP-08028 } CINTA PIEL"},
{"descripcion":"{ AGP-08029 } CINTA CARCASA"},
{"descripcion":"{ AGP-08030 } CINTA TRIMING"},
{"descripcion":"{ AGP-08031 } CINTA TENDON"},
{"descripcion":"{ AGP-08032 } CINTA CURVA ALIMENTACION HQ NÂº2"},
{"descripcion":"{ AGP-08033 } CINTA ALIMENTACION HQ NÂº2"},
{"descripcion":"{ AGP-08034 } CINTA TRASLADO PECHUGA SALIDA HQ NÂº 2"},
{"descripcion":"{ AGP-08035 } CINTA RECEPTORA FILETILLO CON TENDON HQ NÂº2"},
{"descripcion":"{ AGP-08036 } CINTA LARGA RECEPTORA DE FILETILLO CON Y SIN TENDON"},
{"descripcion":"{ AGP-08037 } CINTA TRASLADO DE PECHUGAS HQ NÂº1 Y NÂº2 A CINTA DOBLE"},
{"descripcion":"{ AGP-08038 } CINTA SUPERIOR CINTA DOBLE NORTE"},
{"descripcion":"{ AGP-08039 } CINTA INFERIOR MODULAR NORTE (PROLIJADO)"},
{"descripcion":"{ AGP-08040 } CINTA TRIMING CINTA DOBLE NORTE N 1"},
{"descripcion":"{ AGP-08041 } CINTA TRIMING CINTA DOBLE NORTE N 2"},
{"descripcion":"{ AGP-08042 } CINTA SUPERIOR CINTA DOBLE SUR"},
{"descripcion":"{ AGP-08043 } CINTA INFERIOR MODULAR SUR (PROLIJADO)"},
{"descripcion":"{ AGP-08044 } CINTA TRIMING CINTA DOBLE SUR N 1"},
{"descripcion":"{ AGP-08045 } CINTA TRIMING CINTA DOBLE SUR N 2"},
{"descripcion":"{ AGP-08046 } CINTA ALIMENTACION DE FILETE LINCOFLEX"},
{"descripcion":"{ AGP-08047 } CINTA DESCARGA HACIA BINS (PECHUGA LIMPIA)"},
{"descripcion":"{ AGP-08048 } CINTA SALIDA PECHUGA CORTADA (PECHUGA LIMPIA)"},
{"descripcion":"{ AGP-08049 } CINTA ELEVADORA ORIENTE PECHUGA CORTADA (PECHUGA LIMPIA)"},
{"descripcion":"{ AGP-08050 } CINTA MODULAR DE PIEL"},
{"descripcion":"{ AGP-08051 } CINTA DE BLOQUE"},
{"descripcion":"{ AGP-08052 } CINTA ELEVADORA DE PECHUGA DE BINS A LINEA ALIMENTACION HQ"},
{"descripcion":"{ AGP-09401 } FANCOIL DESHUESADO N 1"},
{"descripcion":"{ AGP-09402 } FANCOIL DESHUESADO N 2"},
{"descripcion":"{ AGP-09403 } FANCOIL DESHUESADO N 3"},
{"descripcion":"{ AGP-09404 } FANCOIL DESHUESADO N 4"},
{"descripcion":"{ AGP-09405 } FANCOIL DESHUESADO N 5"},
{"descripcion":"{ AGP-09406 } FANCOIL DESHUESADO N 6"},
{"descripcion":"{ AGP-09429 } MEZCLADORES AGUA VAPOR HQ N 1"},
{"descripcion":"{ AGP-09430 } MEZCLADORES AGUA VAPOR HQ N 2"},
{"descripcion":"{ AGP-10060 } RADIOS DESHUESADO DE PECHUGAS"},
{"descripcion":"{ AGP-10077 } TRASPALETAS DESHUESADO DE PECHUGAS"},
{"descripcion":"{ AGP-10093 } BALANZAS DESHUESADO DE PECHUGAS"},
{"descripcion":"{ AGP-10231 } TABLEROS ELECTRICOS DE FUERZA Y CONTROL DESHUESADORA HQ NORTE"},
{"descripcion":"{ AGP-10232 } TABLEROS ELECTRICOS DE FUERZA Y CONTROL DESHUESADORA HQ SUR"},
{"descripcion":"{ AGP-10510 } TABLEROS ELECTRICOS FUERZA Y CONTROL SALA DESHUESADO PECHUGAS"},
{"descripcion":"{ AGP-08046.1 } MOTORREDUCTOR CINTA ALIMENTACION DE FILETE LINCOFLEX"},
{"descripcion":"{ AGP-08022.1 } MOTORREDUCTOR CINTA ALIMENTACION HQ NÂº1"},
{"descripcion":"{ AGP-08033.1 } MOTORREDUCTOR CINTA ALIMENTACION HQ NÂº2"},
{"descripcion":"{ AGP-08029.1 } MOTORREDUCTOR CINTA CARCASA"},
{"descripcion":"{ AGP-08027.1 } MOTORREDUCTOR CINTA CLAVÃCULA"},
{"descripcion":"{ AGP-08021.1 } MOTORREDUCTOR CINTA CURVA ALIMENTACION HQ NÂº1"},
{"descripcion":"{ AGP-08032.1 } MOTORREDUCTOR CINTA CURVA ALIMENTACION HQ NÂº2"},
{"descripcion":"{ AGP-08051.1 } MOTORREDUCTOR CINTA DE BLOQUE"},
{"descripcion":"{ AGP-08047.1 } MOTORREDUCTOR CINTA DESCARGA HACIA BINS (PECHUGA LIMPIA)"},
{"descripcion":"{ AGP-08047.S1 } SENSOR TACOMETRO"},
{"descripcion":"{ AGP-08052.1 } MOTORREDUCTOR CINTA ELEVADORA DE PECHUGA DE BINS A LÃNEA ALIMENTACION HQ"},
{"descripcion":"{ AGP-08049.1 } MOTORREDUCTOR CINTA ELEVADORA ORIENTE PECHUGA CORTADA (PECHUGA LIMPIA)"},
{"descripcion":"{ AGP-08039.1 } MOTORREDUCTOR CINTA INFERIOR CINTA DOBLE NORTE (TELA)"},
{"descripcion":"{ AGP-08043.1 } MOTORREDUCTOR CINTA INFERIOR CINTA DOBLE SUR (TELA)"},
{"descripcion":"{ AGP-08036.1 } MOTORREDUCTOR CINTA LARGA RECEPTORA DE FILETILLO CON Y SIN TENDON"},
{"descripcion":"{ AGP-08050.1 } MOTORREDUCTOR CINTA MODULAR DE PIEL"},
{"descripcion":"{ AGP-08028.1 } MOTORREDUCTOR CINTA PIEL"},
{"descripcion":"{ AGP-08035.1 } MOTORREDUCTOR CINTA RECEPTORA FILETILLO CON TENDON HQ NÂº2"},
{"descripcion":"{ AGP-08024.1 } MOTORREDUCTOR CINTA RECUPERACION FILETILLO CON TENDON 1 HQ NÂº 1"},
{"descripcion":"{ AGP-08026.1 } MOTORREDUCTOR CINTA RECUPERACION FILETILLO CON TENDON 2 HQ NÂº 1"},
{"descripcion":"{ AGP-08025.1 } MOTORREDUCTOR CINTA RECUPERACION FILETILLO SIN TENDON HQ NÂº 1"},
{"descripcion":"{ AGP-08048.1 } MOTORREDUCTOR CINTA SALIDA PECHUGA CORTADA (PECHUGA LIMPIA)"},
{"descripcion":"{ AGP-08038.1 } MOTORREDUCTOR CINTA SUPERIOR CINTA DOBLE NORTE"},
{"descripcion":"{ AGP-08042.1 } MOTORREDUCTOR CINTA SUPERIOR CINTA DOBLE SUR"},
{"descripcion":"{ AGP-08031.1 } MOTORREDUCTOR CINTA TENDON"},
{"descripcion":"{ AGP-08037.1 } MOTORREDUCTOR CINTA TRASLADO DE PECHUGAS HQ NÂº1 Y NÂº2 A CINTA DOBLE"},
{"descripcion":"{ AGP-08023.1 } MOTORREDUCTOR CINTA TRASLADO PECHUGA SALIDA HQ NÂº 1"},
{"descripcion":"{ AGP-08034.1 } MOTORREDUCTOR CINTA TRASLADO PECHUGA SALIDA HQ NÂº 2"},
{"descripcion":"{ AGP-08040.1 } MOTORREDUCTOR CINTA TRIMING CINTA DOBLE NORTE N 1"},
{"descripcion":"{ AGP-08041.1 } MOTORREDUCTOR CINTA TRIMING CINTA DOBLE NORTE N 2"},
{"descripcion":"{ AGP-08044.1 } MOTORREDUCTOR CINTA TRIMING CINTA DOBLE SUR N 1"},
{"descripcion":"{ AGP-08045.1 } MOTORREDUCTOR CINTA TRIMING CINTA DOBLE SUR N 2"},
{"descripcion":"{ AGP-08030.1 } MOTORREDUCTOR CINTA TRIMING"},
{"descripcion":"{ AGP-00550.1 } MOTORREDUCTOR CARRUSEL ORIENTE HQ NORTE"},
{"descripcion":"{ AGP-00550.10 } MOTORREDUCTOR UNIDAD CORTE PECHUGA HQ NORTE"},
{"descripcion":"{ AGP-00550.11 } MOTORREDUCTOR UNIDAD COSECHADORA HQ NORTE"},
{"descripcion":"{ AGP-00550.12 } MOTORREDUCTOR UNIDAD CORTE FILETILLO HQ NORTE"},
{"descripcion":"{ AGP-00550.13 } MOTOR UNIDAD CORTE TENDON HQ NORTE"},
{"descripcion":"{ AGP-00550.14 } MOTOTAMBOR UNIDAD CEPILLO FILETILLO HQ NORTE"},
{"descripcion":"{ AGP-00550.15 } MOTORREDUCTOR RODILLO CARCAZA HQ NORTE"},
{"descripcion":"{ AGP-00550.16 } MOTOTAMBOR UNIDAD CEPILLO BOTADOR CARCAZA HQ NORTE"},
{"descripcion":"{ AGP-00550.2 } MOTORREDUCTOR MESA N 1 HQ NORTE"},
{"descripcion":"{ AGP-00550.3 } MOTORREDUCTOR MESA N 2 HQ NORTE"},
{"descripcion":"{ AGP-00550.4 } MOTORREDUCTOR MESA N 3 HQ NORTE"},
{"descripcion":"{ AGP-00550.5 } MOTORREDUCTOR MESA N 4 HQ NORTE"},
{"descripcion":"{ AGP-00550.6 } MOTORREDUCTOR MESA N 5 HQ NORTE"},
{"descripcion":"{ AGP-00550.7 } MOTORREDUCTOR MESA N 6 HQ NORTE"},
{"descripcion":"{ AGP-00550.8 } MOTORREDUCTOR CARRUSEL PONIENTE HQ NORTE"},
{"descripcion":"{ AGP-00550.9 } MOTORREDUCTOR UNIDAD DESPIELADORA HQ NORTE"},
{"descripcion":"{ AGP-00550.HMI1 } HMI TABLERO CONTROL DESHUESADORA HQ NORTE"},
{"descripcion":"{ AGP-00550.PLC1 } PLC TABLERO PRINCIPAL DESHUESADORA HQ NORTE"},
{"descripcion":"{ AGP-00550.PLC2 } PLC TABLERO CONTROL DESHUESADORA HQ NORTE"},
{"descripcion":"{ AGP-00550.S1 } SENSOR PROTECCION DESPIELADORA"},
{"descripcion":"{ AGP-00550.S10 } SENSOR PROTECCION SEGMENTO ENTRADA CARRUSEL PONIENTE"},
{"descripcion":"{ AGP-00550.S11 } SENSOR PRESENCIA TACO SUPERIOR CARRUSEL PONIENTE"},
{"descripcion":"{ AGP-00550.S12 } SENSOR ATURA DE CUCHILLO CORTADOR DE TENDON FILETILLO"},
{"descripcion":"{ AGP-00550.S13 } SENSOR PROTECCION CORTADO TENDON FILETILLO"},
{"descripcion":"{ AGP-00550.S14 } SENSOR CORTE TENDON CARCAZA"},
{"descripcion":"{ AGP-00550.S15 } SENSOR CONTADOR DE CARRO"},
{"descripcion":"{ AGP-00550.S16 } SENSOR ENCODER MOTORREDUCTOR CARRUSEL ORIENTE"},
{"descripcion":"{ AGP-00550.S17 } SENSOR ENCODER MOTORREDUCTOR MESA N 1"},
{"descripcion":"{ AGP-00550.S18 } SENSOR ENCODER MOTORREDUCTOR MESA N 2"},
{"descripcion":"{ AGP-00550.S19 } SENSOR ENCODER MOTORREDUCTOR MESA N 3"},
{"descripcion":"{ AGP-00550.S2 } SENSOR 1 POSICION DE CARRO SUPERIOR"},
{"descripcion":"{ AGP-00550.S20 } SENSOR ENCODER MOTORREDUCTOR MESA N 4"},
{"descripcion":"{ AGP-00550.S21 } SENSOR ENCODER MOTORREDUCTOR MESA N 5"},
{"descripcion":"{ AGP-00550.S22 } SENSOR ENCODER MOTORREDUCTOR MESA N 6"},
{"descripcion":"{ AGP-00550.S23 } SENSOR ENCODER MOTORREDUCTOR CARRUSEL PONIENTE"},
{"descripcion":"{ AGP-00550.S3 } SENSOR 1 POSICION DE CARRO INFERIOR"},
{"descripcion":"{ AGP-00550.S4 } SENSOR ENTRADA PECHUGA CARRUSEL"},
{"descripcion":"{ AGP-00550.S5 } SENSOR PROTECCION SEGMENTO ENTRADA CARRUSEL ORIENTE"},
{"descripcion":"{ AGP-00550.S6 } SENSOR PRESENCIA TACO SUPERIOR CARRUSEL ORIENTE"},
{"descripcion":"{ AGP-00550.S7 } SENSOR PROTECCION COSECHADORA"},
{"descripcion":"{ AGP-00550.S8 } SENSOR 2 POSICION DE CARRO SUPERIOR"},
{"descripcion":"{ AGP-00550.S9 } SENSOR 2 POSICION DE CARRO INFERIOR"},
{"descripcion":"{ AGP-00551.1 } MOTORREDUCTOR CARRUSEL ORIENTE HQ SUR"},
{"descripcion":"{ AGP-00551.10 } MOTORREDUCTOR UNIDAD COSECHADORA HQ SUR"},
{"descripcion":"{ AGP-00551.11 } MOTORREDUCTOR UNIDAD CORTE FILETILLO HQ SUR"},
{"descripcion":"{ AGP-00551.12 } MOTORREDUCTOR RODILLO CARCAZA HQ SUR"},
{"descripcion":"{ AGP-00551.13 } MOTOTAMBOR UNIDAD CEPILLO BOTADOR CARCAZA HQ SUR"},
{"descripcion":"{ AGP-00551.2 } MOTORREDUCTOR MESA N 1 HQ SUR"},
{"descripcion":"{ AGP-00551.3 } MOTORREDUCTOR MESA N 2 HQ SUR"},
{"descripcion":"{ AGP-00551.4 } MOTORREDUCTOR MESA N 3 HQ SUR"},
{"descripcion":"{ AGP-00551.5 } MOTORREDUCTOR MESA N 4 HQ SUR"},
{"descripcion":"{ AGP-00551.6 } MOTORREDUCTOR MESA N 5 HQ SUR"},
{"descripcion":"{ AGP-00551.7 } MOTORREDUCTOR MESA N 6 HQ SUR"},
{"descripcion":"{ AGP-00551.8 } MOTORREDUCTOR UNIDAD DESPIELADORA HQ SUR"},
{"descripcion":"{ AGP-00551.9 } MOTORREDUCTOR UNIDAD CORTE PECHUGA HQ SUR"},
{"descripcion":"{ AGP-00551.HMI1 } HMI TABLERO CONTROL DESHUESADORA HQ SUR"},
{"descripcion":"{ AGP-00551.PLC1 } PLC TABLERO PRINCIPAL DESHUESADORA HQ NORTE"},
{"descripcion":"{ AGP-00551.PLC2 } PLC TABLERO CONTROL DESHUESADORA HQ NORTE"},
{"descripcion":"{ AGP-00551.S1 } SENSOR PROTECCION DESPIELADORA"},
{"descripcion":"{ AGP-00551.S10 } SENSOR ENCODER MOTORREDUCTOR CARRUSEL ORIENTE"},
{"descripcion":"{ AGP-00551.S11 } SENSOR ENCODER MOTORREDUCTOR MESA N 1"},
{"descripcion":"{ AGP-00551.S12 } SENSOR ENCODER MOTORREDUCTOR MESA N 2"},
{"descripcion":"{ AGP-00551.S13 } SENSOR ENCODER MOTORREDUCTOR MESA N 3"},
{"descripcion":"{ AGP-00551.S14 } SENSOR ENCODER MOTORREDUCTOR MESA N 4"},
{"descripcion":"{ AGP-00551.S15 } SENSOR ENCODER MOTORREDUCTOR MESA N 5"},
{"descripcion":"{ AGP-00551.S16 } SENSOR ENCODER MOTORREDUCTOR MESA N 6"},
{"descripcion":"{ AGP-00551.S2 } SENSOR 1 POSICION DE CARRO SUPERIOR"},
{"descripcion":"{ AGP-00551.S3 } SENSOR 1 POSICION DE CARRO INFERIOR"},
{"descripcion":"{ AGP-00551.S4 } SENSOR ENTRADA PECHUGA CARRUSEL"},
{"descripcion":"{ AGP-00551.S5 } SENSOR PROTECCION SEGMENTO ENTRADA CARRUSEL ORIENTE"},
{"descripcion":"{ AGP-00551.S6 } SENSOR PRESENCIA TACO SUPERIOR CARRUSEL ORIENTE"},
{"descripcion":"{ AGP-00551.S7 } SENSOR PROTECCION COSECHADORA"},
{"descripcion":"{ AGP-00551.S8 } SENSOR CORTE TENDON CARCAZA"},
{"descripcion":"{ AGP-00551.S9 } SENSOR CONTADOR DE CARRO"},
{"descripcion":"{ AGP-09401.1 } MOTOR VENTILADOR N 1 FANCOIL DESHUESADO N 1"},
{"descripcion":"{ AGP-09401.2 } MOTOR VENTILADOR N 2 FANCOIL DESHUESADO N 1"},
{"descripcion":"{ AGP-09401.3 } MOTOR VENTILADOR N 3 FANCOIL DESHUESADO N 1"},
{"descripcion":"{ AGP-09402.1 } MOTOR VENTILADOR N 1 FANCOIL DESHUESADO N 2"},
{"descripcion":"{ AGP-09402.2 } MOTOR VENTILADOR N 2 FANCOIL DESHUESADO N 2"},
{"descripcion":"{ AGP-09403.1 } MOTOR VENTILADOR N 1 FANCOIL DESHUESADO N 3"},
{"descripcion":"{ AGP-09403.2 } MOTOR VENTILADOR N 2 FANCOIL DESHUESADO N 3"},
{"descripcion":"{ AGP-09404.1 } MOTOR VENTILADOR N 1 FANCOIL DESHUESADO N 4"},
{"descripcion":"{ AGP-09404.2 } MOTOR VENTILADOR N 2 FANCOIL DESHUESADO N 4"},
{"descripcion":"{ AGP-09405.1 } MOTOR VENTILADOR N 1 FANCOIL DESHUESADO N 5"},
{"descripcion":"{ AGP-09405.2 } MOTOR VENTILADOR N 2 FANCOIL DESHUESADO N 5"},
{"descripcion":"{ AGP-09406.1 } MOTOR VENTILADOR N 1 FANCOIL DESHUESADO N 6"},
{"descripcion":"{ AGP-09406.2 } MOTOR VENTILADOR N 2 FANCOIL DESHUESADO N 6"},
{"descripcion":"{ AGP-09406.3 } MOTOR VENTILADOR N 3 FANCOIL DESHUESADO N 6"},
{"descripcion":"{ AGP-00553.1 } MOTOR CENTRAL HIDRAULICA VOLTEADOR DE BINS DESHUESADO PECHUGA"},
{"descripcion":"{ AGP-05050 } ENVASADORA RETRACTIL POLY-PACK"},
{"descripcion":"{ AGP-05051 } DETECTOR METALES CEIA ENCAJADO TRUTROS (POLY-PACK)."},
{"descripcion":"{ AGP-06000 } DETECTOR METALES LOCK (SMIPACK)"},
{"descripcion":"{ AGP-06001 } TUNEL TERMORETRACTIL MONTESA"},
{"descripcion":"{ AGP-06002 } EMBOLSADORA DE CAJAS"},
{"descripcion":"{ AGP-06003 } ENZUNCHADORA AKEBONO"},
{"descripcion":"{ AGP-06004 } ENZUNCHADORA MOSCA ENCAJADO (105976)"},
{"descripcion":"{ AGP-06005 } DETECTOR METALES CEIA ENCAJADO (LINEA SUR)"},
{"descripcion":"{ AGP-08096 } CINTA MAQUINA DE EMBOLSAR CAJAS"},
{"descripcion":"{ AGP-08097 } CINTA ENTRADA TUNEL RETRACTIL MONTESA"},
{"descripcion":"{ AGP-08098 } CINTA DETECTOR LOCK"},
{"descripcion":"{ AGP-08099 } CINTA ENZUNCHADO"},
{"descripcion":"{ AGP-08173 } CINTA CAJAS VACÃAS"},
{"descripcion":"{ AGP-08210 } CAPACHO DOSIFICADOR ORIENTE L1"},
{"descripcion":"{ AGP-08220 } CAPACHO DOSIFICADOR PONIENTE L2"},
{"descripcion":"{ AGP-09421 } FANCOIL DROOP POINT EQUIPO N 40"},
{"descripcion":"{ AGP-09422 } FANCOIL DROOP POINT EQUIPO N 41"},
{"descripcion":"{ AGP-09423 } FANCOIL DROOP POINT EQUIPO N 43"},
{"descripcion":"{ AGP-09424 } FANCOIL DROP POINT EQUIPO N 42"},
{"descripcion":"{ AGP-10068 } RADIOS ENCAJADO DE PRODUCTOS"},
{"descripcion":"{ AGP-10082 } TRASPALETAS ENCAJADO DE PRODUCTOS"},
{"descripcion":"{ AGP-10188 } BASCULA DE PISO REPORTE CAJAS 2000KG"},
{"descripcion":"{ AGP-10324 } ENFAJADORA DE FILM TERMORRETRAIBLE SMIPACK"},
{"descripcion":"{ AGP-10388 } CINTA SALIDA DETECTOR METALES CEIA ENCAJADO TRUTROS (POLY-PACK)."},
{"descripcion":"{ AGP-10524 } TABLERO ELECTRICO DE CONTROL Y FUERZA SALA EMBALAJE Y ETIQUETADO"},
{"descripcion":"{ AGP-10528 } CINTA ALIMENTACION INYECTORA FOMACO"},
{"descripcion":"{ AGP-10529 } CINTA TINA SANITIZADO LINEA FRESCO"},
{"descripcion":"{ AGP-10530 } CINTA DOBLE PONIENTE / ORIENTE"},
{"descripcion":"{ AGP-10531 } CINTA NORTE ELEVADORA A CABEZAL DE PESAJE ORIENTE"},
{"descripcion":"{ AGP-10532 } CINTA SUR ELEVADORA A CABEZAL DE PESAJE PONIENTE"},
{"descripcion":"{ AGP-10535 } CAPACHO NORPONIENTE [SISTEMA DE PESAJE PONIENTE] TOLVA N 3"},
{"descripcion":"{ AGP-10536 } CAPACHO SURPONIENTE [SISTEMA DE PESAJE PONIENTE] TOLVA N 4"},
{"descripcion":"{ AGP-10537 } CINTA CAJAS VACIAS LINEA FRESCO"},
{"descripcion":"{ AGP-10538 } CINTA BAJO CAPACHO DE PESAJE ORIENTE"},
{"descripcion":"{ AGP-10539 } CINTA BAJO CAPACHOS PESAJE PONIENTE"},
{"descripcion":"{ AGP-10540 } CINTA ROLLER LINEA FRESCO"},
{"descripcion":"{ AGP-10629 } TOLVA DISTRIBUIDORA PONIENTE"},
{"descripcion":"{ AGP-10630 } TOLVA DISTRIBUIDORA ORIENTE"},
{"descripcion":"{ AGP-10684 } ENFAJADORA DE FILM TERMORRETRAIBLE SMIPACK LINEA BYPASS EX MONTEZA"},
{"descripcion":"{ AGP-10686 } DETECTOR METALES CEIA LINEA FRESCO MANUAL"},
{"descripcion":"{ AGP-10687 } DETECTOR METALES CEIA LINEA FRESCO (SMIPACK SUR)"},
{"descripcion":"{ AGP-08210.1 } CELDA DE PESAJE LADO ORIENTE L1"},
{"descripcion":"{ AGP-08210.2 } CELDA DE PESAJE LADO PONIENTE L1"},
{"descripcion":"{ AGP-08220.1 } CELDA DE PESAJE LADO ORIENTE L2"},
{"descripcion":"{ AGP-08220.2 } CELDA DE PESAJE LADO PONIENTE L2"},
{"descripcion":"{ AGP-08173.1 } MOTORREDUCTOR CINTA CAJAS VACÃAS"},
{"descripcion":"{ AGP-08173.S1 } SENSOR PRESENCIA CAJAS VACIAS LADO ORIENTE"},
{"descripcion":"{ AGP-08173.S2 } SENSOR DESCARGA EN CAJAS LADO ORIENTE"},
{"descripcion":"{ AGP-08098.1 } MOTORREDUCTOR CINTA DETECTOR LOCK"},
{"descripcion":"{ AGP-08097.1 } MOTORREDUCTOR CINTA SALIDA TUNEL RETRACTIL MONTESA"},
{"descripcion":"{ AGP-08099.1 } MOTORREDUCTOR CINTA ENZUNCHADO"},
{"descripcion":"{ AGP-08096.1 } MOTORREDUCTOR CINTA MAQUINA DE EMBOLSAR CAJAS"},
{"descripcion":"{ AGP-05051.S1 } SENSOR PRESENCIA INGRESO PRODUCTO"},
{"descripcion":"{ AGP-06002.1 } MOTORREDUCTOR CINTA ENTRADA EMBOLSADORA DE CAJAS"},
{"descripcion":"{ AGP-06002.2 } MOTORREDUCTOR CINTA SALIDA EMBOLSADORA DE CAJAS"},
{"descripcion":"{ AGP-06002.3 } MOTORREDUCTOR ALIMENTACION BOLSA SUPERIOR EMBOLSADORA DE CAJAS"},
{"descripcion":"{ AGP-06002.4 } MOTORREDUCTOR ALIMENTACION BOLSA INFERIOR EMBOLSADORA DE CAJAS"},
{"descripcion":"{ AGP-06002.S1 } SENSOR ALIMENTACION FILM"},
{"descripcion":"{ AGP-06002.S2 } SENSOR ENTRADA CAJA"},
{"descripcion":"{ AGP-06002.S3 } SENSOR ESTADO SUPERIOR GUILLOTINA"},
{"descripcion":"{ AGP-06002.S4 } SENSOR ESTADO INFERIOR GUILLOTINA"},
{"descripcion":"{ AGP-10324.1 } MOTORREDUCTOR CINTA ENTRADA ENFAJADORA DE FILM TERMORRETRAIBLE SMIPACK"},
{"descripcion":"{ AGP-10324.2 } MOTORREDUCTOR DE CINTA TERMORRETRAIBLE SMIPACK"},
{"descripcion":"{ AGP-10324.3 } MOTORREDUCTOR ALIMENTACION DE BOLSA SUPERIOR ENFAJADORA DE FILM SMIPACK"},
{"descripcion":"{ AGP-10324.4 } MOTORREDUCTOR ALIMENTACION DE BOLSA INFERIOR ENFAJADORA DE FILM SMIPACK"},
{"descripcion":"{ AGP-10324.5 } MOTORREDUCTOR CINTA SALIDA ENFAJADORA DE FILM SMIPACK"},
{"descripcion":"{ AGP-05050.1 } MOTORREDUCTOR CINTA ENTRADA ENVASADORA RETRACTIL POLY-PACK"},
{"descripcion":"{ AGP-05050.2 } MOTORREDUCTOR CINTA SALIDA ENVASADORA RETRACTIL POLY-PACK"},
{"descripcion":"{ AGP-05050.3 } MOTORREDUCTOR ALIMENTACION BOLSA SUPERIOR ENVASADORA RETRACTIL POLY-PACK"},
{"descripcion":"{ AGP-05050.4 } MOTORREDUCTOR ALIMENTACION BOLSA INFERIOR ENVASADORA RETRACTIL POLY-PACK"},
{"descripcion":"{ AGP-05050.5 } MOTORREDUCTOR CINTA TUNEL ENVASADORA RETRACTIL POLY-PACK"},
{"descripcion":"{ AGP-05050.6 } MOTOR VENTILADOR ENVASADORA RETRACTIL POLY-PACK"},
{"descripcion":"{ AGP-05050.7 } MOTOR SECADOR NORTE SALIDA ENVASADORA RETRACTIL POLY-PACK"},
{"descripcion":"{ AGP-05050.8 } MOTOR SECADOR SUR SALIDA ENVASADORA RETRACTIL POLY-PACK"},
{"descripcion":"{ AGP-05050.HMI1 } HMI TABLERO PRINCIPAL POLY-PACK"},
{"descripcion":"{ AGP-05050.PLC1 } PLC TABLERO PRINCIPAL POLY-PACK"},
{"descripcion":"{ AGP-05050.S1 } SENSOR ENTRADA CAJA"},
{"descripcion":"{ AGP-05050.S2 } SENSOR RODILLO SUPERIOR"},
{"descripcion":"{ AGP-05050.S3 } SENSOR RODILLO INFERIOR"},
{"descripcion":"{ AGP-05050.S4 } SENSOR GUILLOTINA NORTE"},
{"descripcion":"{ AGP-05050.S5 } SENSOR GUILLOTINA SUR"},
{"descripcion":"{ AGP-05050.S6 } SENSOR SUPERIOR DE RUEDA VENTILACION TUNEL"},
{"descripcion":"{ AGP-05050.S7 } SENSOR POSICION ALTURA GUILLOTINA"},
{"descripcion":"{ AGP-05050.S8 } SENSOR DE TEMPERATURA BARRA SELLADO"},
{"descripcion":"{ AGP-09421.1 } MOTOR VENTILADOR N 1 FANCOIL ENCAJADO FRESCO NOR PONIENTE"},
{"descripcion":"{ AGP-09421.2 } MOTOR VENTILADOR N 2 FANCOIL ENCAJADO FRESCO NOR PONIENTE"},
{"descripcion":"{ AGP-09421.3 } MOTOR VENTILADOR N 3 FANCOIL ENCAJADO FRESCO NOR PONIENTE"},
{"descripcion":"{ AGP-09422.1 } MOTOR VENTILADOR N 1 FANCOIL ENCAJADO FRESCO SUR PONIENTE"},
{"descripcion":"{ AGP-09422.2 } MOTOR VENTILADOR N 2 FANCOIL ENCAJADO FRESCO SUR PONIENTE"},
{"descripcion":"{ AGP-09422.3 } MOTOR VENTILADOR N 3 FANCOIL ENCAJADO FRESCO SUR PONIENTE"},
{"descripcion":"{ AGP-09423.1 } MOTOR VENTILADOR N 1 FANCOIL ENCAJADO FRESCO NOR ORIENTE"},
{"descripcion":"{ AGP-09423.2 } MOTOR VENTILADOR N 2 FANCOIL ENCAJADO FRESCO NOR ORIENTE"},
{"descripcion":"{ AGP-09423.3 } MOTOR VENTILADOR N 3 FANCOIL ENCAJADO FRESCO NOR ORIENTE"},
{"descripcion":"{ AGP-09424.1 } MOTOR VENTILADOR N 1 FANCOIL ENCAJADO FRESCO SUR ORIENTE"},
{"descripcion":"{ AGP-09424.2 } MOTOR VENTILADOR N 2 FANCOIL ENCAJADO FRESCO SUR ORIENTE"},
{"descripcion":"{ AGP-09424.3 } MOTOR VENTILADOR N 3 FANCOIL ENCAJADO FRESCO SUR ORIENTE"},
{"descripcion":"{ AGP-10533 } CAPACHO NORORIENTE [SISTEMA DE PESAJE ORIENTE] TOLVA N 1"},
{"descripcion":"{ AGP-10534 } CAPACHO SURPONIENTE [SISTEMA DE PESAJE ORIENTE] TOLVA N 2"},
{"descripcion":"{ AGP-06001.1 } MOTORREDUCTOR CINTA TUNEL TERMORETRACTIL MONTESA"},
{"descripcion":"{ AGP-06001.2 } MOTOR VENTILADOR ORIENTE TUNEL TERMORETRACTIL MONTESA"},
{"descripcion":"{ AGP-06001.3 } MOTOR VENTILADOR PONIENTE TUNEL TERMORETRACTIL MONTESA"},
{"descripcion":"{ AGP-07030 } TERMORETRACTIL AHUMADO"},
{"descripcion":"{ AGP-07031 } CODIFICADOR INKJET LINX 6900"},
{"descripcion":"{ AGP-07032 } DETECTOR METALES BEOKELS AHUMADO"},
{"descripcion":"{ AGP-07034 } CHEQUEADOR DINAMICO AHUMADO"},
{"descripcion":"{ AGP-07035 } CLIPEADORA AHUMADO N 1 MODELO EZ7080"},
{"descripcion":"{ AGP-07036 } ENZUNCHADORAS AHUMADO"},
{"descripcion":"{ AGP-07037 } SELLADORA AL VACIO TURBOVAC"},
{"descripcion":"{ AGP-07038 } ESTERILIZADORES DE CUCHILLOS"},
{"descripcion":"{ AGP-07039 } CLIPEADORA AHUMADO N 2"},
{"descripcion":"{ AGP-07040 } CLIPEADORA AHUMADO N 3 MODELO 800"},
{"descripcion":"{ AGP-07041 } SELLADORA DE PIE"},
{"descripcion":"{ AGP-08108 } CINTA PESA DINAMICA"},
{"descripcion":"{ AGP-08109 } CINTA IMPRESORA LINX"},
{"descripcion":"{ AGP-08110 } CINTA DETECTOR DE METALES BEOKELS"},
{"descripcion":"{ AGP-08111 } CINTA SALIDA TERMORETRACTIL CRYOVAC"},
{"descripcion":"{ AGP-08112 } CINTA RETORNO DE PAVOS"},
{"descripcion":"{ AGP-09416 } FANCOIL ANTE HORNOS N 1"},
{"descripcion":"{ AGP-09417 } FANCOIL ANTETUNEL N 1"},
{"descripcion":"{ AGP-09418 } FANCOIL EMPAQUE N 1"},
{"descripcion":"{ AGP-09419 } FANCOIL EMPAQUE N 2"},
{"descripcion":"{ AGP-09420 } FANCOIL EMPAQUE N 3"},
{"descripcion":"{ AGP-10037 } EXTRACTOR LAVADO CARROS AHUMADO [N 30]"},
{"descripcion":"{ AGP-10038 } EXTRACTOR AHUMADO DE PAVOS [N 31]"},
{"descripcion":"{ AGP-10039 } EXTRACTOR TERMORETRACTIL AHUMADO [N 32]"},
{"descripcion":"{ AGP-10040 } IMPULSOR PAVOS AHUMADO [N 54]"},
{"descripcion":"{ AGP-10070 } RADIOS PAVOS AHUMADOS"},
{"descripcion":"{ AGP-10084 } TRASPALETAS PAVOS AHUMADOS"},
{"descripcion":"{ AGP-10100 } BALANZAS PAVOS AHUMADOS"},
{"descripcion":"{ AGP-10187 } BASCULA DE PISO PAVOS AHUMADOS 1500KG"},
{"descripcion":"{ AGP-10248 } ENZUNCHADORA MERCURY (ROJA)"},
{"descripcion":"{ AGP-10301 } DETECTOR METALES LOCK AHUMADO"},
{"descripcion":"{ AGP-10311 } IMPRESORA AHUMADO"},
{"descripcion":"{ AGP-07034.1 } MOTORREDUCTOR CHEQUEADOR DINAMICO"},
{"descripcion":"{ AGP-07034.S1 } SENSOR PRECENCIA INGRESO PRODUCTO"},
{"descripcion":"{ AGP-08110.1 } MOTORREDUCTOR CINTA DETECTOR DE METALES BEOKELS"},
{"descripcion":"{ AGP-08109.1 } MOTORREDUCTOR CINTA IMPRESORA LINX"},
{"descripcion":"{ AGP-08108.1 } MOTORREDUCTOR CINTA PESA DINAMICA"},
{"descripcion":"{ AGP-08112.1 } MOTORREDUCTOR CINTA RETORNO DE PAVOS"},
{"descripcion":"{ AGP-08111.1 } MOTORREDUCTOR CINTA SALIDA TERMORETRACTIL CRYOVAC"},
{"descripcion":"{ AGP-07031.S1 } SENSOR PRESENCIA INGRESO PRODUCTO INKJET LINX 6900"},
{"descripcion":"{ AGP-10038.1 } MOTOR EXTRACTOR AHUMADO DE PAVOS"},
{"descripcion":"{ AGP-10037.1 } MOTOR EXTRACTOR LAVADO CARROS AHUMAR"},
{"descripcion":"{ AGP-10039.1 } MOTOR EXTRACTOR EMBOLSADO PAVOS AHUMAR"},
{"descripcion":"{ AGP-09416.1 } MOTOR VENTILADOR N 1 FANCOIL AHUMADO N 1 PONIENTE"},
{"descripcion":"{ AGP-09416.2 } MOTOR VENTILADOR N 2 FANCOIL AHUMADO N 1 PONIENTE"},
{"descripcion":"{ AGP-09417.1 } MOTOR VENTILADOR N 1 FANCOIL AHUMADO N 2 ORIENTE"},
{"descripcion":"{ AGP-09417.2 } MOTOR VENTILADOR N 2 FANCOIL AHUMADO N 2 ORIENTE"},
{"descripcion":"{ AGP-10040.1 } MOTOR IMPULSOR PAVOS AHUMAR"},
{"descripcion":"{ AGP-07037.1 } BOMBA DE VACIO SELLADORA AL VACIO TURBOVAC"},
{"descripcion":"{ AGP-07030.1 } MOTORREDUCTOR CINTA TERMORETRACTIL"},
{"descripcion":"{ AGP-07030.2 } BOMBA TERMORETRACTIL"},
{"descripcion":"{ AGP-00650 } TERMORETRACTIL DE PAVOS"},
{"descripcion":"{ AGP-00651 } CODIFICADOR INKJET EMPAQUE PAVO"},
{"descripcion":"{ AGP-00652 } CHEQUEADOR DINAMICO TROZADO DE PAVOS"},
{"descripcion":"{ AGP-00653 } SELLADORA AL VACIO TURBOVAC BIO"},
{"descripcion":"{ AGP-00652.1 } MOTOTAMBOR CHEQUEADOR DINAMICO"},
{"descripcion":"{ AGP-00652.S1 } SENSOR FOTO-ELÃ‰CTRICO"},
{"descripcion":"{ AGP-00653.1 } MOTOR BOMBA VACIO SELLADORA AL VACIO TURBOVAC BIO"},
{"descripcion":"{ AGP-00650.1 } MOTORREDUCTOR TERMORETRACTIL DE PAVOS"},
{"descripcion":"{ AGP-00650.2 } BOMBA TERMORETRACTIL DE PAVOS"},
{"descripcion":"{ AGP-01002 } DETECTOR METALES LOCK ENCAJADO"},
{"descripcion":"{ AGP-01004 } ENVOLVEDORA DE PALLETS ORION"},
{"descripcion":"{ AGP-08177 } CINTA TRANSPORTE CAJAS NÂº 1"},
{"descripcion":"{ AGP-08178 } CINTA DETECTORA METALES LOCK"},
{"descripcion":"{ AGP-09407 } FANCOIL EMPAQUE CONGELADO N 1"},
{"descripcion":"{ AGP-09408 } FANCOIL EMPAQUE CONGELADO N 2"},
{"descripcion":"{ AGP-09409 } FANCOIL EMPAQUE CONGELADO N 3"},
{"descripcion":"{ AGP-10064 } RADIOS DESPACHO"},
{"descripcion":"{ AGP-10080 } TRASPALETAS DESPACHO"},
{"descripcion":"{ AGP-10215 } DETECTOR METALES LOMA FRIGORIFICO"},
{"descripcion":"{ AGP-10247 } ENZUNCHADORA ENCAJADO BLOQUE MANUAL/PEDAL [18039]"},
{"descripcion":"{ AGP-10304 } IMPRESORA REPORTE CONGELADO"},
{"descripcion":"{ AGP-08178.1 } MOTORREDUCTOR CINTA DETECTORA METALES LOCK"},
{"descripcion":"{ AGP-08177.1 } MOTORREDUCTOR CINTA TRANSPORTE CAJAS NÂº 1"},
{"descripcion":"{ AGP-10215.S1 } SENSOR ENTRADA"},
{"descripcion":"{ AGP-10215.S2 } SENSOR SALIDA"},
{"descripcion":"{ AGP-09407.1 } MOTOR VENTILADOR N 1 FANCOIL EMPAQUE CONGELADO N 1"},
{"descripcion":"{ AGP-09407.2 } MOTOR VENTILADOR N 2 FANCOIL EMPAQUE CONGELADO N 1"},
{"descripcion":"{ AGP-09408.1 } MOTOR VENTILADOR N 1 FANCOIL EMPAQUE CONGELADO N 2"},
{"descripcion":"{ AGP-09408.2 } MOTOR VENTILADOR N 2 FANCOIL EMPAQUE CONGELADO N 2"},
{"descripcion":"{ AGP-09409.1 } MOTOR VENTILADOR N 1 FANCOIL EMPAQUE CONGELADO N 3"},
{"descripcion":"{ AGP-09409.2 } MOTOR VENTILADOR N 2 FANCOIL EMPAQUE CONGELADO N 3"},
{"descripcion":"{ AGP-10306 } IMPRESORA (01) ISHIDA TRUTROS"},
{"descripcion":"{ AGP-10307 } IMPRESORA (02) ISHIDA TRUTROS"},
{"descripcion":"{ AGP-00400 } CHILLER COGOTE DE PAVOS"},
{"descripcion":"{ AGP-00401 } CHILLER CONTRE DE PAVOS"},
{"descripcion":"{ AGP-00402 } CHILLER PANA DE PAVOS"},
{"descripcion":"{ AGP-00410 } CHILLER DE AGUA COPE"},
{"descripcion":"{ AGP-00410.1 } MOTORREDUCTOR PALETA CHILLER COPE"},
{"descripcion":"{ AGP-00420 } CHILLER AGUA KUCMAQ"},
{"descripcion":"{ AGP-00420.3 } BOMBA RECIRCULADORA CHILLER AGUA 2 A CHILLER AGUA 3"},
{"descripcion":"{ AGP-00430 } CHILLER MENUDO SEMIL N 1 PANA"},
{"descripcion":"{ AGP-00431 } CHILLER MENUDO SEMIL N 2 COGOTE"},
{"descripcion":"{ AGP-00432 } CHILLER MENUDO SEMIL N 3 CORAZON"},
{"descripcion":"{ AGP-00433 } CHILLER MENUDO SEMIL N 4 CONTRES"},
{"descripcion":"{ AGP-00434 } CHILLER MENUDO SEMIL N 5 GARRAS"},
{"descripcion":"{ AGP-00450 } LINEA AEREA CALIBRADO DE PAVOS"},
{"descripcion":"{ AGP-00451 } CALIBRADORA DE PAVOS LINCO"},
{"descripcion":"{ AGP-00452 } BOTADORES NEUMATICOS PAVOS"},
{"descripcion":"{ AGP-00460 } LINEA AEREA CALIBRADO DE POLLOS"},
{"descripcion":"{ AGP-00462 } TRANSFERIDOR CALIBRADOR LINCO"},
{"descripcion":"{ AGP-00470 } CHILLER AGUA SEMIL"},
{"descripcion":"{ AGP-00471 } CHILLER AGUA MEYN"},
{"descripcion":"{ AGP-00472 } CINTA ELEVADORA CHILLER SALIDA MEYN (MODULAR)"},
{"descripcion":"{ AGP-00473 } CINTA TRASPASO CHILLER ENTRADA KUCMAQ (METALICA)"},
{"descripcion":"{ AGP-00474 } SECADOR DE AVES"},
{"descripcion":"{ AGP-00480 } ROSCA DE HIELO N 2 INFERIOR"},
{"descripcion":"{ AGP-00481 } ROSCA DE HIELO SEMIL"},
{"descripcion":"{ AGP-00482 } ROSCA DE HIELO MEYN"},
{"descripcion":"{ AGP-00483 } ROSCA DE HIELO N 1 SUPERIOR PRINCIPAL"},
{"descripcion":"{ AGP-00484 } VENTILADOR AXIAL PONIENTE"},
{"descripcion":"{ AGP-00485 } VENTILADOR AXIAL ORIENTE"},
{"descripcion":"{ AGP-00486 } VENTILADOR AXIAL CENTRO"},
{"descripcion":"{ AGP-08009 } CINTA BAJO BOTADORES DE PAVOS"},
{"descripcion":"{ AGP-08010 } CINTA ELEVADORA SALIDA SECADOR POLLOS"},
{"descripcion":"{ AGP-08011 } CINTA COLGADO LINEA CHILLER DE AIRE"},
{"descripcion":"{ AGP-08012 } CINTA CLASIFICADO DE GARRAS CURVA"},
{"descripcion":"{ AGP-08013 } CINTA EVACUADORA DE PAVOS A CARROS"},
{"descripcion":"{ AGP-08014 } CINTA COLGADO A CALIBRADORA DE PAVOS"},
{"descripcion":"{ AGP-08015 } CINTA DESCARGA CHILLER PAVOS"},
{"descripcion":"{ AGP-08016 } CINTA COLGADO DE PAVO"},
{"descripcion":"{ AGP-08017 } CINTA MENUDENCIA PAVOS"},
{"descripcion":"{ AGP-08179 } CINTA ALIMENTACION POLLOS CHILLER COPE"},
{"descripcion":"{ AGP-08180 } CINTA ALIMENTACION PAVOS CHILLER COPE"},
{"descripcion":"{ AGP-08180.1 } MOTORREDUCTOR CINTA ALIMENTACION PAVOS CHILLER COPE"},
{"descripcion":"{ AGP-08181 } CINTA ALIMENTACION POLLOS Y PAVOS CHILLER SEMIL"},
{"descripcion":"{ AGP-08181.1 } MOTORREDUCTOR CINTA ALIMENTACION POLLOS Y PAVOS CHILLER SEMIL"},
{"descripcion":"{ AGP-08182 } CINTA SALIDA CHILLER PANAS POLLO"},
{"descripcion":"{ AGP-08182.1 } MOTORREDUCTOR CINTA SALIDA CHILLER PANAS POLLO"},
{"descripcion":"{ AGP-09435 } MEZCLADORES AGUA VAPOR CHILLER AGUA N 1"},
{"descripcion":"{ AGP-09436 } MEZCLADORES AGUA VAPOR CHILLER AGUA N 2"},
{"descripcion":"{ AGP-10024 } EXTRACTOR SALA CHILLER DE AGUA [N 15]"},
{"descripcion":"{ AGP-10025 } EXTRACTOR PONIENTE COPE [N 22]"},
{"descripcion":"{ AGP-10026 } EXTRACTOR ORIENTE COPE [N 21]"},
{"descripcion":"{ AGP-10027 } IMPULSOR ORIENTE SALA CHILLER DE AGUA [N 45]"},
{"descripcion":"{ AGP-10028 } IMPULSOR PONIENTE SALA CHILLER DE AGUA [N 46]"},
{"descripcion":"{ AGP-10029 } EXTRACTOR NORTE CHILLER DE MENUDENCIAS [N 19]"},
{"descripcion":"{ AGP-10030 } EXTRACTOR SUR CHILLER DE MENUDENCIAS [N 20]"},
{"descripcion":"{ AGP-10031 } EXTRACTOR PASILLO ESCALERA SADEMA [N 81]"},
{"descripcion":"{ AGP-10061 } RADIOS CHILLER DE AGUA POLLOS"},
{"descripcion":"{ AGP-10078 } TRASPALETAS CHILLER AGUA DE PAVOS"},
{"descripcion":"{ AGP-10079 } TRASPALETAS CHILLER DE AGUA POLLOS"},
{"descripcion":"{ AGP-10095 } BALANZAS CHILLER DE AGUA POLLOS"},
{"descripcion":"{ AGP-10238 } TABLEROS ELECTRICOS DE FUERZA Y CONTROL DE CHILLER DE AGUA"},
{"descripcion":"{ AGP-10329 } SOPLADOR CHILLER DE AGUA ORIENTE"},
{"descripcion":"{ AGP-10330 } SOPLADOR CHILLER DE AGUA PONIENTE"},
{"descripcion":"{ AGP-10360 } PUERTA ELECTRICA CHILLER DE AGUA"},
{"descripcion":"{ AGP-10361 } PUERTA ELECTRICA TROZADO DE POLLO"},
{"descripcion":"{ AGP-10387 } CHILLER DE AGUA MORRIS"},
{"descripcion":"{ AGP-10395 } SELLADORA AUTOMATICA CHILLER DE AGUA"},
{"descripcion":"{ AGP-10515 } TABLEROS ELECTRICOS FUERZA Y CONTROL SALA CHILLER DE AGUA"},
{"descripcion":"{ AGP-00451.S1 } SENSOR START"},
{"descripcion":"{ AGP-00451.S2 } SENSOR STOP"},
{"descripcion":"{ AGP-00451.S3 } SENSOR RESET"},
{"descripcion":"{ AGP-00420.1 } MOTORREDUCTOR PALETA CHILLER AGUA KUCMAQ"},
{"descripcion":"{ AGP-00420.2 } MOTORREDUCTOR ROSCA CHILLER AGUA KUCMAQ"},
{"descripcion":"{ AGP-00471.1 } MOTORREDUCTOR PALETA CHILLER AGUA MEYN"},
{"descripcion":"{ AGP-00471.2 } MOTORREDUCTOR ROSCA CHILLER AGUA MEYN"},
{"descripcion":"{ AGP-00470.1 } MOTORREDUCTOR PALETA CHILLER AGUA SEMIL"},
{"descripcion":"{ AGP-00470.2 } MOTORREDUCTOR ROSCA CHILLER AGUA SEMIL"},
{"descripcion":"{ AGP-00470.HMI1 } HMITABLERO CONTROL SISTEMA CHILLER DE AGUA CHILLER MENUDOS"},
{"descripcion":"{ AGP-00470.HMI2 } HMI TABLERO CONTROL SISTEMA CHILLER DE AGUA CHILLER DE AGUA"},
{"descripcion":"{ AGP-00470.PLC1 } PLC TABLERO PRINCIPAL SISTEMA CHILLER DE AGUA"},
{"descripcion":"{ AGP-00400.1 } MOTORREDUCTOR CHILLER COGOTE DE PAVOS"},
{"descripcion":"{ AGP-00401.1 } MOTORREDUCTOR CHILLER CONTRE DE PAVOS"},
{"descripcion":"{ AGP-00430.1 } MOTOR CHILLER MENUDO SEMIL N 1 PANA"},
{"descripcion":"{ AGP-00431.1 } MOTOR CHILLER MENUDO SEMIL N 2 COGOTE"},
{"descripcion":"{ AGP-00432.1 } MOTOR CHILLER MENUDO SEMIL N 3 CORAZON"},
{"descripcion":"{ AGP-00433.1 } MOTOR CHILLER MENUDO SEMIL N 4 CONTRES"},
{"descripcion":"{ AGP-00434.1 } MOTOR CHILLER MENUDO SEMIL N 5 GARRAS"},
{"descripcion":"{ AGP-00434.2 } BOMBA RECIRCULADORA AGUA DE GARRAS Y PATAS"},
{"descripcion":"{ AGP-00402.1 } MOTORREDUCTOR CHILLER PANA DE PAVOS"},
{"descripcion":"{ AGP-08179.1 } MOTORREDUCTOR CINTA ALIMENTACION POLLOS CHILLER COPE"},
{"descripcion":"{ AGP-08009.1 } MOTORREDUCTOR CINTA BAJO BOTADORES DE PAVOS"},
{"descripcion":"{ AGP-08012.1 } MOTORREDUCTOR CINTA CLASIFICADO DE GARRAS CURVA"},
{"descripcion":"{ AGP-08014.1 } MOTORREDUCTOR CINTA COLGADO A CALIBRADORA DE PAVOS"},
{"descripcion":"{ AGP-08016.1 } MOTORREDUCTOR CINTA COLGADO DE PAVO"},
{"descripcion":"{ AGP-08011.1 } MOTORREDUCTOR CINTA COLGADO LÃNEA CHILLER DE AIRE"},
{"descripcion":"{ AGP-08015.1 } MOTORREDUCTOR CINTA DESCARGA CHILLER PAVOS"},
{"descripcion":"{ AGP-00472.1 } MOTORREDUCTOR CINTA TRASPASO CHILLER SALIDA MEYN"},
{"descripcion":"{ AGP-08010.1 } MOTORREDUCTOR CINTA ELEVADORA SALIDA SECADOR POLLOS"},
{"descripcion":"{ AGP-08013.1 } MOTORREDUCTOR CINTA EVACUADORA DE PAVOS A CARROS"},
{"descripcion":"{ AGP-08017.1 } MOTORREDUCTOR CINTA MENUDENCIA PAVOS"},
{"descripcion":"{ AGP-00473.1 } MOTORREDUCTOR CINTA TRASPADO CHILLER ENTRADA KUCMAQ"},
{"descripcion":"{ AGP-10029.1 } MOTOR EXTRACTOR PONIENTE CHILLER DE MENUDENCIAS"},
{"descripcion":"{ AGP-10026.1 } MOTOR EXTRACTOR PONIENTE LAVADO DE CARROS"},
{"descripcion":"{ AGP-10031.1 } MOTOR IMPULSOR CHILLER DE MENUDENCIAS"},
{"descripcion":"{ AGP-10025.1 } MOTOR EXTACTOR ORIENTE LAVADO DE CARROS"},
{"descripcion":"{ AGP-10024.1 } MOTOR EXTRACTOR SALA CHILLER DE AGUA"},
{"descripcion":"{ AGP-10030.1 } MOTOR EXTRACTOR NORTE CHILLER DE MENUDENCIAS"},
{"descripcion":"{ AGP-10027.1 } MOTOR IMPULSOR ORIENTE SALA CHILLER DE AGUA"},
{"descripcion":"{ AGP-10028.1 } MOTOR IMPULSOR PONIENTE SALA CHILLER DE AGUA"},
{"descripcion":"{ AGP-00450.1 } MOTORREDUCTOR N 1 LINEA AEREA CALIBRADO DE PAVOS"},
{"descripcion":"{ AGP-00450.2 } MOTORREDUCTOR N 2 LINEA AEREA CALIBRADO DE PAVOS"},
{"descripcion":"{ AGP-00450.S1 } SENSOR TENSOR DE LINEA"},
{"descripcion":"{ AGP-00460.1 } MOTORREDUCTOR N 1 LINEA AEREA CALIBRADO DE POLLOS"},
{"descripcion":"{ AGP-00460.2 } MOTORREDUCTOR N 2 LINEA AEREA CALIBRADO DE POLLOS"},
{"descripcion":"{ AGP-10360.1 } MOTORREDUCTOR PUERTA ELECTRICA CHILLER DE AGUA"},
{"descripcion":"{ AGP-10360.S1 } SENSOR NIVEL ALTO CORTINA CHILLER DE AGUA"},
{"descripcion":"{ AGP-10360.S2 } SENSOR NIVEL BAJO CORTINA CHILLER DE AGUA"},
{"descripcion":"{ AGP-10360.S3 } SENSOR EMERGENCIA CORTINA CHILLER DE AGUA"},
{"descripcion":"{ AGP-10361.1 } MOTORREDUCTOR PUERTA ELECTRICA TROZADO DE POLLO"},
{"descripcion":"{ AGP-10361.S1 } SENSOR PUERTA ELECTRICA NIVEL ALTO TROZADO DE POLLO"},
{"descripcion":"{ AGP-10361.S2 } SENSOR PUERTA ELECTRICA NIVEL MEDIO TROZADO DE POLLO"},
{"descripcion":"{ AGP-10361.S3 } SENSOR PUERTA ELECTRICA EMERGENCIA TROZADO DE POLLO"},
{"descripcion":"{ AGP-00482.1 } MOTORREDUCTOR ROSCA DE HIELO MEYN"},
{"descripcion":"{ AGP-00483.1 } MOTORREDUCTOR ROSCA DE HIELO N 1 SUPERIOR"},
{"descripcion":"{ AGP-00480.1 } MOTORREDUCTOR ROSCA DE HIELO N 2 INFERIOR"},
{"descripcion":"{ AGP-00481.1 } MOTORREDUCTOR ROSCA DE HIELO SEMIL"},
{"descripcion":"{ AGP-00474.1 } MOTORREDUCTOR SECADOR DE AVES"},
{"descripcion":"{ AGP-00474.2 } BOMBA CENTRIFUGA ARCO SANITARIO SECADOR DE AVES"},
{"descripcion":"{ AGP-10329.1 } MOTOR SOPLADOR CHILLER DE AGUA ORIENTE"},
{"descripcion":"{ AGP-10330.1 } MOTOR SOPLADOR CHILLER DE AGUA PONIENTE"},
{"descripcion":"{ AGP-00486.1 } MOTOR VENTILADOR AXIAL CENTRO"},
{"descripcion":"{ AGP-00485.1 } MOTOR VENTILADOR AXIAL ORIENTE"},
{"descripcion":"{ AGP-00484.1 } MOTOR VENTILADOR AXIAL PONIENTE"},
{"descripcion":"{ AGP-00440 } LINEA AEREA CHILLER DE AIRE"},
{"descripcion":"{ AGP-09052 } UNIDAD EVAPORADORA CHILLER DE AIRE N 1"},
{"descripcion":"{ AGP-09217 } UNIDAD EVAPORADORA CHILLER DE AIRE N 2"},
{"descripcion":"{ AGP-09218 } UNIDAD EVAPORADORA CHILLER DE AIRE N 3"},
{"descripcion":"{ AGP-09219 } UNIDAD EVAPORADORA CHILLER DE AIRE N 4"},
{"descripcion":"{ AGP-09220 } UNIDAD EVAPORADORA CHILLER DE AIRE N 5"},
{"descripcion":"{ AGP-09221 } UNIDAD EVAPORADORA CHILLER DE AIRE N 6"},
{"descripcion":"{ AGP-09222 } UNIDAD EVAPORADORA CHILLER DE AIRE N 7"},
{"descripcion":"{ AGP-09223 } UNIDAD EVAPORADORA CHILLER DE AIRE N 8"},
{"descripcion":"{ AGP-09224 } UNIDAD EVAPORADORA CHILLER DE AIRE N 9"},
{"descripcion":"{ AGP-09225 } UNIDAD EVAPORADORA CHILLER DE AIRE N 10"},
{"descripcion":"{ AGP-09226 } UNIDAD EVAPORADORA CHILLER DE AIRE N 11"},
{"descripcion":"{ AGP-09227 } UNIDAD EVAPORADORA CHILLER DE AIRE N 12"},
{"descripcion":"{ AGP-09228 } UNIDAD EVAPORADORA CHILLER DE AIRE N 13"},
{"descripcion":"{ AGP-09229 } UNIDAD EVAPORADORA CHILLER DE AIRE N 14"},
{"descripcion":"{ AGP-09230 } UNIDAD EVAPORADORA CHILLER DE AIRE N 15"},
{"descripcion":"{ AGP-09439 } MEZCLADORES AGUA VAPOR CHILLER DE AIRE"},
{"descripcion":"{ AGP-10229 } TABLEROS ELECTRICOS DE FUERZA Y CONTROL CHILLER DE AIRE ( LINEA )"},
{"descripcion":"{ AGP-10239 } TABLEROS ELECTRICOS DE FUERZA Y CONTROL CHILLER DE AIRE ( REFRIGERACION )"},
{"descripcion":"{ AGP-00440.1 } MOTORREDUCTOR N 1 LINEA AEREA CHILLER DE AIRE"},
{"descripcion":"{ AGP-00440.10 } MOTORREDUCTOR N 10 LINEA AEREA CHILLER DE AIRE"},
{"descripcion":"{ AGP-00440.11 } MOTORREDUCTOR N 11 LINEA AEREA CHILLER DE AIRE"},
{"descripcion":"{ AGP-00440.12 } MOTORREDUCTOR N 12 LINEA AEREA CHILLER DE AIRE"},
{"descripcion":"{ AGP-00440.13 } MOTORREDUCTOR N 13 LINEA AEREA CHILLER DE AIRE"},
{"descripcion":"{ AGP-00440.14 } MOTORREDUCTOR N 14 LINEA AEREA CHILLER DE AIRE"},
{"descripcion":"{ AGP-00440.15 } MOTORREDUCTOR N 15 LINEA AEREA CHILLER DE AIRE"},
{"descripcion":"{ AGP-00440.16 } MOTORREDUCTOR N 16 LINEA AEREA CHILLER DE AIRE"},
{"descripcion":"{ AGP-00440.17 } MOTORREDUCTOR N 17 LINEA AEREA CHILLER DE AIRE"},
{"descripcion":"{ AGP-00440.2 } MOTORREDUCTOR N 2 LINEA AEREA CHILLER DE AIRE"},
{"descripcion":"{ AGP-00440.3 } MOTORREDUCTOR N 3 LINEA AEREA CHILLER DE AIRE"},
{"descripcion":"{ AGP-00440.4 } MOTORREDUCTOR N 4 LINEA AEREA CHILLER DE AIRE"},
{"descripcion":"{ AGP-00440.5 } MOTORREDUCTOR N 5 LINEA AEREA CHILLER DE AIRE"},
{"descripcion":"{ AGP-00440.6 } MOTORREDUCTOR N 6 LINEA AEREA CHILLER DE AIRE"},
{"descripcion":"{ AGP-00440.7 } MOTORREDUCTOR N 7 LINEA AEREA CHILLER DE AIRE"},
{"descripcion":"{ AGP-00440.8 } MOTORREDUCTOR N 8 LINEA AEREA CHILLER DE AIRE"},
{"descripcion":"{ AGP-00440.9 } MOTORREDUCTOR N 9 LINEA AEREA CHILLER DE AIRE"},
{"descripcion":"{ AGP-00440.HMI1 } HMI TABLERO PRINCIPAL LINEA AEREA CHILLER DE AIRE"},
{"descripcion":"{ AGP-00440.PLC1 } PLC TABLERO PRINCIPAL LINEA AEREA CHILLER DE AIRE"},
{"descripcion":"{ AGP-00440.S1 } SENSOR TENSOR SUPERIOR"},
{"descripcion":"{ AGP-00440.S2 } SENSOR TENSOR INFERIOR"},
{"descripcion":"{ AGP-00440.S3 } SENSOR TACOMETRO"},
{"descripcion":"{ AGP-09052.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA CHILLER DE AIRE N 1"},
{"descripcion":"{ AGP-09052.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA CHILLER DE AIRE N 1"},
{"descripcion":"{ AGP-09052.3 } MOTOR VENTILADOR N 3 UNIDAD EVAPORADORA CHILLER DE AIRE N 1"},
{"descripcion":"{ AGP-09052.4 } MOTOR VENTILADOR N 4 UNIDAD EVAPORADORA CHILLER DE AIRE N 1"},
{"descripcion":"{ AGP-09225.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA CHILLER DE AIRE N 10"},
{"descripcion":"{ AGP-09225.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA CHILLER DE AIRE N 10"},
{"descripcion":"{ AGP-09225.3 } MOTOR VENTILADOR N 3 UNIDAD EVAPORADORA CHILLER DE AIRE N 10"},
{"descripcion":"{ AGP-09225.4 } MOTOR VENTILADOR N 4 UNIDAD EVAPORADORA CHILLER DE AIRE N 10"},
{"descripcion":"{ AGP-09226.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA CHILLER DE AIRE N 11"},
{"descripcion":"{ AGP-09226.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA CHILLER DE AIRE N 11"},
{"descripcion":"{ AGP-09226.3 } MOTOR VENTILADOR N 3 UNIDAD EVAPORADORA CHILLER DE AIRE N 11"},
{"descripcion":"{ AGP-09226.4 } MOTOR VENTILADOR N 4 UNIDAD EVAPORADORA CHILLER DE AIRE N 11"},
{"descripcion":"{ AGP-09227.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA CHILLER DE AIRE N 12"},
{"descripcion":"{ AGP-09227.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA CHILLER DE AIRE N 12"},
{"descripcion":"{ AGP-09227.3 } MOTOR VENTILADOR N 3 UNIDAD EVAPORADORA CHILLER DE AIRE N 12"},
{"descripcion":"{ AGP-09227.4 } MOTOR VENTILADOR N 4 UNIDAD EVAPORADORA CHILLER DE AIRE N 12"},
{"descripcion":"{ AGP-09228.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA CHILLER DE AIRE N 13"},
{"descripcion":"{ AGP-09228.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA CHILLER DE AIRE N 13"},
{"descripcion":"{ AGP-09228.3 } MOTOR VENTILADOR N 3 UNIDAD EVAPORADORA CHILLER DE AIRE N 13"},
{"descripcion":"{ AGP-09228.4 } MOTOR VENTILADOR N 4 UNIDAD EVAPORADORA CHILLER DE AIRE N 13"},
{"descripcion":"{ AGP-09229.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA CHILLER DE AIRE N 14"},
{"descripcion":"{ AGP-09229.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA CHILLER DE AIRE N 14"},
{"descripcion":"{ AGP-09229.3 } MOTOR VENTILADOR N 3 UNIDAD EVAPORADORA CHILLER DE AIRE N 14"},
{"descripcion":"{ AGP-09229.4 } MOTOR VENTILADOR N 4 UNIDAD EVAPORADORA CHILLER DE AIRE N 14"},
{"descripcion":"{ AGP-09230.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA CHILLER DE AIRE N 15"},
{"descripcion":"{ AGP-09230.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA CHILLER DE AIRE N 15"},
{"descripcion":"{ AGP-09230.3 } MOTOR VENTILADOR N 3 UNIDAD EVAPORADORA CHILLER DE AIRE N 15"},
{"descripcion":"{ AGP-09230.4 } MOTOR VENTILADOR N 4 UNIDAD EVAPORADORA CHILLER DE AIRE N 15"},
{"descripcion":"{ AGP-09217.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA CHILLER DE AIRE N 2"},
{"descripcion":"{ AGP-09217.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA CHILLER DE AIRE N 2"},
{"descripcion":"{ AGP-09217.3 } MOTOR VENTILADOR N 3 UNIDAD EVAPORADORA CHILLER DE AIRE N 2"},
{"descripcion":"{ AGP-09217.4 } MOTOR VENTILADOR N 4 UNIDAD EVAPORADORA CHILLER DE AIRE N 2"},
{"descripcion":"{ AGP-09218.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA CHILLER DE AIRE N 3"},
{"descripcion":"{ AGP-09218.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA CHILLER DE AIRE N 3"},
{"descripcion":"{ AGP-09218.3 } MOTOR VENTILADOR N 3 UNIDAD EVAPORADORA CHILLER DE AIRE N 3"},
{"descripcion":"{ AGP-09218.4 } MOTOR VENTILADOR N 4 UNIDAD EVAPORADORA CHILLER DE AIRE N 3"},
{"descripcion":"{ AGP-09219.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA CHILLER DE AIRE N 4"},
{"descripcion":"{ AGP-09219.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA CHILLER DE AIRE N 4"},
{"descripcion":"{ AGP-09219.3 } MOTOR VENTILADOR N 3 UNIDAD EVAPORADORA CHILLER DE AIRE N 4"},
{"descripcion":"{ AGP-09219.4 } MOTOR VENTILADOR N 4 UNIDAD EVAPORADORA CHILLER DE AIRE N 4"},
{"descripcion":"{ AGP-09220.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA CHILLER DE AIRE N 5"},
{"descripcion":"{ AGP-09220.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA CHILLER DE AIRE N 5"},
{"descripcion":"{ AGP-09220.3 } MOTOR VENTILADOR N 3 UNIDAD EVAPORADORA CHILLER DE AIRE N 5"},
{"descripcion":"{ AGP-09220.4 } MOTOR VENTILADOR N 4 UNIDAD EVAPORADORA CHILLER DE AIRE N 5"},
{"descripcion":"{ AGP-09221.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA CHILLER DE AIRE N 6"},
{"descripcion":"{ AGP-09221.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA CHILLER DE AIRE N 6"},
{"descripcion":"{ AGP-09221.3 } MOTOR VENTILADOR N 3 UNIDAD EVAPORADORA CHILLER DE AIRE N 6"},
{"descripcion":"{ AGP-09221.4 } MOTOR VENTILADOR N 4 UNIDAD EVAPORADORA CHILLER DE AIRE N 6"},
{"descripcion":"{ AGP-09222.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA CHILLER DE AIRE N 7"},
{"descripcion":"{ AGP-09222.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA CHILLER DE AIRE N 7"},
{"descripcion":"{ AGP-09222.3 } MOTOR VENTILADOR N 3 UNIDAD EVAPORADORA CHILLER DE AIRE N 7"},
{"descripcion":"{ AGP-09222.4 } MOTOR VENTILADOR N 4 UNIDAD EVAPORADORA CHILLER DE AIRE N 7"},
{"descripcion":"{ AGP-09223.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA CHILLER DE AIRE N 8"},
{"descripcion":"{ AGP-09223.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA CHILLER DE AIRE N 8"},
{"descripcion":"{ AGP-09223.3 } MOTOR VENTILADOR N 3 UNIDAD EVAPORADORA CHILLER DE AIRE N 8"},
{"descripcion":"{ AGP-09223.4 } MOTOR VENTILADOR N 4 UNIDAD EVAPORADORA CHILLER DE AIRE N 8"},
{"descripcion":"{ AGP-09224.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA CHILLER DE AIRE N 9"},
{"descripcion":"{ AGP-09224.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA CHILLER DE AIRE N 9"},
{"descripcion":"{ AGP-09224.3 } MOTOR VENTILADOR N 3 UNIDAD EVAPORADORA CHILLER DE AIRE N 9"},
{"descripcion":"{ AGP-09224.4 } MOTOR VENTILADOR N 4 UNIDAD EVAPORADORA CHILLER DE AIRE N 9"},
{"descripcion":"{ AGP-02350 } ESCALDADORA DE GARRAS"},
{"descripcion":"{ AGP-02351 } PELADOR DE GARRAS"},
{"descripcion":"{ AGP-02352 } BOMBA DE PATAS MURZAN"},
{"descripcion":"{ AGP-02353 } BOTADOR DE PATAS"},
{"descripcion":"{ AGP-02354 } CORTADOR NUDILLOS Y ACOMODADOR"},
{"descripcion":"{ AGP-02355 } CHILLER DE GARRAS"},
{"descripcion":"{ AGP-02356 } PELADOR DE GARRAS (FRINOX)"},
{"descripcion":"{ AGP-02357 } ESCALDADORA DE NUDILLOS SHANK"},
{"descripcion":"{ AGP-02357.1 } MOTORREDUCTOR ESCALDADORA DE NUDILLOS SHANK"},
{"descripcion":"{ AGP-02358 } PELADORA DE NUDILLOS SHANK"},
{"descripcion":"{ AGP-02359 } BOMBA VACIO NUDILLOS SHANK (FRINOX)"},
{"descripcion":"{ AGP-02360 } BOMBA DE PATAS MURZAN NO.230115017"},
{"descripcion":"{ AGP-02361 } BOMBA DE PATAS MURZAN NO.230115018"},
{"descripcion":"{ AGP-04004 } BOMBA DE PISTON VIRTUAL"},
{"descripcion":"{ AGP-08020 } CINTA SANITIZADO DE GARRAS"},
{"descripcion":"{ AGP-10006 } EXTRACTOR SALA GARRAS [N 65]"},
{"descripcion":"{ AGP-10007 } IMPULSOR SALA GARRAS [N 64]"},
{"descripcion":"{ AGP-10097 } BALANZAS PROCESOS DE GARRAS"},
{"descripcion":"{ AGP-10339 } EXTRACTOR SALA GARRAS [N 7]"},
{"descripcion":"{ AGP-10340 } EXTRACTOR CASINO [N 73]"},
{"descripcion":"{ AGP-08020.1 } MOTORREDUCTOR CINTA TINA SANITARIA GARRAS"},
{"descripcion":"{ AGP-02354.1 } MOTORREDUCTOR ACOMODADOR DE GARRAS"},
{"descripcion":"{ AGP-02354.2 } MOTOR CORTADOR DE NUDILLOS"},
{"descripcion":"{ AGP-02350.1 } MOTORREDUCTOR ESCALDADORA DE GARRAS"},
{"descripcion":"{ AGP-02350.2 } MOTOR SOPLADOR ESCALDADORA DE GARRAS"},
{"descripcion":"{ AGP-10006.1 } MOTOR EXTRACTOR SALA GARRAS Y PATAS"},
{"descripcion":"{ AGP-10007.1 } MOTOR IMPULSOR SALA GARRAS Y PATAS"},
{"descripcion":"{ AGP-02356.1 } MOTORREDUCTOR PELADORA DE GARRAS FRINOX"},
{"descripcion":"{ AGP-02351.1 } MOTOR PELADOR DE GARRAS"},
{"descripcion":"{ AGP-00300 } LINEA AEREA EVISCERADO DE PAVOS"},
{"descripcion":"{ AGP-00303 } CORTADOR DE PIEL PAVOS"},
{"descripcion":"{ AGP-00304 } CONVEYOR DE PAVOS"},
{"descripcion":"{ AGP-00305 } CUCHILLO CORTADOR CABEZAS PAVOS"},
{"descripcion":"{ AGP-00306 } SEPARADOR DE TRIPAS"},
{"descripcion":"{ AGP-00307 } LAVADOR DESENGRASADOR"},
{"descripcion":"{ AGP-00308 } ELEVADOR TORNILLO CONTRES"},
{"descripcion":"{ AGP-00309 } LAVADOR DE CONTRES SEMIL"},
{"descripcion":"{ AGP-00310 } MESAS CONTRES LINCO SUR-PONIENTE"},
{"descripcion":"{ AGP-00311 } MESAS CONTRES LINCO NOR-PONIENTE"},
{"descripcion":"{ AGP-00313 } BOMBA NEUMATICA CONTRES"},
{"descripcion":"{ AGP-00314 } BOMBA NEUMATICA PANA"},
{"descripcion":"{ AGP-00315 } DUCHA DE PAVOS"},
{"descripcion":"{ AGP-00316 } TIJERA JARVIS N 1"},
{"descripcion":"{ AGP-00317 } PISTOLA JARVIS"},
{"descripcion":"{ AGP-00318 } TIJERA JARVIS N 2"},
{"descripcion":"{ AGP-00321 } ESTERILIZADORES DE EVISCERADO PAVOS"},
{"descripcion":"{ AGP-08005 } CINTA COLGADO EVISCERADO PAVO"},
{"descripcion":"{ AGP-08006 } CINTA ELEVADORA DE CONTRES"},
{"descripcion":"{ AGP-08007 } CINTA MENUDENCIAS (02)"},
{"descripcion":"{ AGP-08008 } CINTA TRANSPOTADORA DE COGOTES"},
{"descripcion":"{ AGP-10008 } EXTRACTOR NORTE EVISCERADO DE PAVOS [N 8]"},
{"descripcion":"{ AGP-10009 } IMPULSOR SALA EVISCERADO DE PAVOS [N 44]"},
{"descripcion":"{ AGP-10094 } BALANZAS EVISCERADO DE PAVOS"},
{"descripcion":"{ AGP-10355 } FLUJOMETRO DUCHA DE PAVOS"},
{"descripcion":"{ AGP-08005.1 } MOTORREDUCTOR CINTA COLGADO EVISCERADO PAVO"},
{"descripcion":"{ AGP-08006.1 } MOTORREDUCTOR CINTA ELEVADORA DE CONTRES"},
{"descripcion":"{ AGP-08007.1 } MOTORREDUCTOR CINTA MENUDENCIAS (02)"},
{"descripcion":"{ AGP-08008.1 } MOTORREDUCTOR CINTA COGOTES"},
{"descripcion":"{ AGP-00304.1 } MOTORREDUCTOR CONVEYOR DE PAVOS"},
{"descripcion":"{ AGP-00303.1 } MOTOR CENTRAL HIDRAULICA CORTADOR DE PIEL PAVOS"},
{"descripcion":"{ AGP-00305.1 } MOTOR CUCHILLO CORTADOR CABEZAS"},
{"descripcion":"{ AGP-00315.1 } BOMBA DUCHA DE PAVOS"},
{"descripcion":"{ AGP-00315.S1 } SENSOR TORSION"},
{"descripcion":"{ AGP-00308.1 } MOTORREDUCTOR ELEVADOR TORNILLO CONTRES"},
{"descripcion":"{ AGP-00321.1 } MOTOR EXTRACTOR NORTE EVISCERADO DE PAVOS"},
{"descripcion":"{ AGP-10008.1 } MOTOR IMPULSOR SALA EVISCERADO DE PAVOS"},
{"descripcion":"{ AGP-00309.1 } MOTOR LAVADOR DE CONTRES SEMIL"},
{"descripcion":"{ AGP-00307.1 } MOTOR LAVADOR DESENGRASADOR"},
{"descripcion":"{ AGP-00300.1 } MOTORREDUCTOR N 1 LINEA AEREA EVISCERADO DE PAVOS"},
{"descripcion":"{ AGP-00300.2 } MOTORREDUCTOR N 2 LINEA AEREA EVISCERADO DE PAVOS"},
{"descripcion":"{ AGP-00300.3 } MOTORREDUCTOR N 3 LINEA AEREA EVISCERADO DE PAVOS"},
{"descripcion":"{ AGP-00300.HMI1 } HMI TABLERO CONTROL LINEA AEREA EVISCERADO DE PAVOS"},
{"descripcion":"{ AGP-00300.HMI2 } HMI TABLERO CONTROL LINEA AEREA EVISCERADO DE PAVOS"},
{"descripcion":"{ AGP-00300.PLC1 } PLC TABLERO PRINCIPAL LINEA AEREA EVISCERADO DE PAVOS"},
{"descripcion":"{ AGP-00300.S1 } SENSOR TENSOR DE LINEA"},
{"descripcion":"{ AGP-00311.1 } MOTORREDUCTOR MESA CONTRE LINCO NOR-PONIENTE"},
{"descripcion":"{ AGP-00310.1 } MOTORREDUCTOR MESA CONTRE LINCO SUR-PONIENTE"},
{"descripcion":"{ AGP-00306.1 } MOTORREDUCTOR SEPARADOR DE TRIPAS"},
{"descripcion":"{ AGP-00306.S1 } SENSOR TORSION"},
{"descripcion":"{ AGP-00855 } ENZUNCHADORA MOSCA STANDBY (110355)"},
{"descripcion":"{ AGP-09176 } UNIDAD REFRIGERACION CAMARA PASILLO PULPAS"},
{"descripcion":"{ AGP-09475 } EVAPORADOR EX SALA DE GARRAS"},
{"descripcion":"{ AGP-09475.1 } MOTOR VENTILADOR N 1 EVAPORADOR EX SALA DE GARRAS"},
{"descripcion":"{ AGP-09475.2 } MOTOR VENTILADOR N 2 EVAPORADOR EX SALA DE GARRAS"},
{"descripcion":"{ AGP-09475.3 } MOTOR VENTILADOR N 3 EVAPORADOR EX SALA DE GARRAS"},
{"descripcion":"{ AGP-09475.4 } MOTOR VENTILADOR N 4 EVAPORADOR EX SALA DE GARRAS"},
{"descripcion":"{ AGP-10254 } ENVOLVEDORA DE PALLET"},
{"descripcion":"{ AGP-09071 } GRUPO GENERADOR N 1"},
{"descripcion":"{ AGP-09072 } GRUPO GENERADOR N 2"},
{"descripcion":"{ AGP-09073 } GRUPO GENERADOR N 3"},
{"descripcion":"{ AGP-09074 } GRUPO GENERADOR N 4"},
{"descripcion":"{ AGP-09075 } TABLEROS ELÃ‰CTRICOS GRUPOS GENERADORES"},
{"descripcion":"{ AGP-09076 } TRANSFORMADOR ELEVADOR SALA GENERACION"},
{"descripcion":"{ AGP-10661 } ESTANQUE PETROLEO SALA GENERADORES 9 M3"},
{"descripcion":"{ AGP-09071.1 } BATERIA 1 NOR ORIENTE GRUPO GENERADOR N 1"},
{"descripcion":"{ AGP-09071.2 } BATERIA 2 NOR PONIENTE GRUPO GENERADOR N 1"},
{"descripcion":"{ AGP-09071.3 } BATERIA 3 SUR ORIENTE GRUPO GENERADOR N 1"},
{"descripcion":"{ AGP-09071.4 } BATERIA 4 SUR PONIENTE GRUPO GENERADOR N 1"},
{"descripcion":"{ AGP-09072.1 } BATERIA 1 NOR ORIENTE GRUPO GENERADOR N 2"},
{"descripcion":"{ AGP-09072.2 } BATERIA 2 NOR PONIENTE GRUPO GENERADOR N 2"},
{"descripcion":"{ AGP-09072.3 } BATERIA 3 SUR ORIENTE GRUPO GENERADOR N 2"},
{"descripcion":"{ AGP-09072.4 } BATERIA 4 SUR PONIENTE GRUPO GENERADOR N 2"},
{"descripcion":"{ AGP-09073.1 } BATERIA 1 NOR ORIENTE GRUPO GENERADOR N 3"},
{"descripcion":"{ AGP-09073.2 } BATERIA 2 NOR PONIENTE GRUPO GENERADOR N 3"},
{"descripcion":"{ AGP-09073.3 } BATERIA 3 SUR ORIENTE GRUPO GENERADOR N 3"},
{"descripcion":"{ AGP-09073.4 } BATERIA 4 SUR PONIENTE GRUPO GENERADOR N 3"},
{"descripcion":"{ AGP-09074.1 } BATERIA 1 NOR ORIENTE GRUPO GENERADOR N 4"},
{"descripcion":"{ AGP-09074.2 } BATERIA 2 NOR PONIENTE GRUPO GENERADOR N 4"},
{"descripcion":"{ AGP-09074.3 } BATERIA 3 SUR ORIENTE GRUPO GENERADOR N 4"},
{"descripcion":"{ AGP-09074.4 } BATERIA 4 SUR PONIENTE GRUPO GENERADOR N 4"},
{"descripcion":"{ AGP-10036 } EXTRACTOR SALA DE HIELO [N 82]"},
{"descripcion":"{ AGP-10036.1 } MOTOR EXTRACTOR SALA HERRAMIENTAS PAVOS"},
{"descripcion":"{ AGP-09149 } MADEF N 1 NOR-PONIENTE"},
{"descripcion":"{ AGP-09150 } MADEF N 2 NOR-ORIENTE"},
{"descripcion":"{ AGP-09150.1 } BOMBA MADEF N 2 NOR-ORIENTE"},
{"descripcion":"{ AGP-09151 } MADEF N 3 SUR-PONIENTE"},
{"descripcion":"{ AGP-09152 } MADEF N 4 SUR-ORIENTE"},
{"descripcion":"{ AGP-09153 } MOLEDOR DE HIELO MADEF NORTE"},
{"descripcion":"{ AGP-09154 } MOLEDOR DE HIELO MADEF SUR"},
{"descripcion":"{ AGP-09155 } TABLEROS ELÃ‰CTRICOS MAQUINAS HIELO"},
{"descripcion":"{ AGP-10354 } FLUJOMETRO SECTOR MAQUINA DE HIELO"},
{"descripcion":"{ AGP-09149.1 } MOTOR BOMBA MADEF N 1 NOR-PONIENTE"},
{"descripcion":"{ AGP-09151.1 } MOTOR BOMBA MADEF N 3 SUR-PONIENTE"},
{"descripcion":"{ AGP-9152.1 } MOTOR BOMBA MADEF N 4 SUR-ORIENTE"},
{"descripcion":"{ AGP-09153.1 } MOTOR TRITURADOR DE HIELO MADEF NORTE"},
{"descripcion":"{ AGP-09154.1 } MOTOR TRITURADOR DE HIELO MADEF SUR"},
{"descripcion":"{ AGP-09155.HMI1 } HMI SISTEMA MAQUINAS HIELO"},
{"descripcion":"{ AGP-09155.PLC1 } PLC SISTEMA MAQUINAS HIELO"},
{"descripcion":"{ AGP-07020 } HORNO FESSMAN NORTE"},
{"descripcion":"{ AGP-07021 } HORNO FESSMAN SUR"},
{"descripcion":"{ AGP-07020.1 } MOTOR IMPULSOR HORNO FESSMAN NORTE"},
{"descripcion":"{ AGP-07020.2 } MOTORREDUCTOR COMPUERTA HORNO FESSMAN NORTE"},
{"descripcion":"{ AGP-07020.3 } MOTOR BOMBA DE HUMO LIQUIDO HORNO NORTE"},
{"descripcion":"{ AGP-07021.1 } MOTOR IMPULSOR HORNO FESSMAN SUR"},
{"descripcion":"{ AGP-07021.2 } MOTORREDUCTOR COMPUERTA HORNO FESSMAN SUR"},
{"descripcion":"{ AGP-07021.3 } MOTOR BOMBA DE HUMO LIQUIDO HORNO SUR"},
{"descripcion":"{ AGP-01123 } MATADOR DE POLLOS HALAL"},
{"descripcion":"{ AGP-01124 } ATONTADOR DE POLLOS MEYN"},
{"descripcion":"{ AGP-01125 } ELECTRO ESTIMULADOR"},
{"descripcion":"{ AGP-10389 } ATONTADOR DE POLLOS LINCO"},
{"descripcion":"{ AGP-01124.S1 } SENSOR PUERTA #1"},
{"descripcion":"{ AGP-01124.S2 } SENSOR PUERTA #2"},
{"descripcion":"{ AGP-01124.S3 } SENSOR PUERTA #3"},
{"descripcion":"{ AGP-01125.S1 } SENSOR PUERTA #1 ENTRADA"},
{"descripcion":"{ AGP-01125.S10 } SENSOR PUERTA #9"},
{"descripcion":"{ AGP-01125.S11 } SENSOR PUERTA #10"},
{"descripcion":"{ AGP-01125.S12 } SENSOR PUERTA #11"},
{"descripcion":"{ AGP-01125.S13 } SENSOR PUERTA #12"},
{"descripcion":"{ AGP-01125.S14 } SENSOR PUERTA #13"},
{"descripcion":"{ AGP-01125.S15 } SENSOR PUERTA #14"},
{"descripcion":"{ AGP-01125.S16 } SENSOR PUERTA #2 SALIDA"},
{"descripcion":"{ AGP-01125.S2 } SENSOR PUERTA #1"},
{"descripcion":"{ AGP-01125.S3 } SENSOR PUERTA #2"},
{"descripcion":"{ AGP-01125.S4 } SENSOR PUERTA #3"},
{"descripcion":"{ AGP-01125.S5 } SENSOR PUERTA #4"},
{"descripcion":"{ AGP-01125.S6 } SENSOR PUERTA #5"},
{"descripcion":"{ AGP-01125.S7 } SENSOR PUERTA #6"},
{"descripcion":"{ AGP-01125.S8 } SENSOR PUERTA #7"},
{"descripcion":"{ AGP-01125.S9 } SENSOR PUERTA #8"},
{"descripcion":"{ AGP-01123.1 } MOTOR ORIENTE CUCHILLO MATADOR DE POLLOS HALAL"},
{"descripcion":"{ AGP-01123.2 } MOTOR PONIENTE CUCHILLO MATADOR DE POLLOS HALAL"},
{"descripcion":"{ AGP-07000 } INYECTORA BELAM"},
{"descripcion":"{ AGP-07001 } ESTANQUE SALMUERA"},
{"descripcion":"{ AGP-09412 } FANCOIL INYECTADO N 4"},
{"descripcion":"{ AGP-09413 } FANCOIL INYECTADO N 3"},
{"descripcion":"{ AGP-09414 } FANCOIL INYECTADO N 2"},
{"descripcion":"{ AGP-09415 } FANCOIL INYECTADO N 1"},
{"descripcion":"{ AGP-07001.1 } BOMBA ESTANQUE SALMUERA"},
{"descripcion":"{ AGP-07001.S1 } SENSOR NIVEL"},
{"descripcion":"{ AGP-09415.1 } MOTOR VENTILADOR N 1 FANCOIL INYECTADO AHUMADO N 4"},
{"descripcion":"{ AGP-09415.2 } MOTOR VENTILADOR N 2 FANCOIL INYECTADO AHUMADO N 4"},
{"descripcion":"{ AGP-09412.1 } MOTOR VENTILADOR N 1 FANCOIL INYECTADO AHUMADO N 1"},
{"descripcion":"{ AGP-09412.2 } MOTOR VENTILADOR N 2 FANCOIL INYECTADO AHUMADO N 1"},
{"descripcion":"{ AGP-09414.1 } MOTOR VENTILADOR N 1 FANCOIL INYECTADO AHUMADO N 3"},
{"descripcion":"{ AGP-09414.2 } MOTOR VENTILADOR N 2 FANCOIL INYECTADO AHUMADO N 3"},
{"descripcion":"{ AGP-09413.1 } MOTOR VENTILADOR N 1 FANCOIL INYECTADO AHUMADO N 2"},
{"descripcion":"{ AGP-09413.2 } MOTOR VENTILADOR N 2 FANCOIL INYECTADO AHUMADO N 2"},
{"descripcion":"{ AGP-07000.1 } MOTOR CENTRAL HIDRAULICA INYECTORA BELAM"},
{"descripcion":"{ AGP-07000.2 } BOMBA INYECTORA BELAM"},
{"descripcion":"{ AGP-07000.HMI1 } HMI TABLERO PRINCIPAL BELAM"},
{"descripcion":"{ AGP-07000.PLC1 } PLC TABLERO PRINCIPAL BELAM"},
{"descripcion":"{ AGP-07000.S1 } SENSOR CILINDRO SUPERIOR NORTE"},
{"descripcion":"{ AGP-07000.S2 } SENSOR CILINDRO INFERIOR NORTE"},
{"descripcion":"{ AGP-07000.S3 } SENSOR CILINDRO SUPERIOR SUR"},
{"descripcion":"{ AGP-07000.S4 } SENSOR CILINDRO SUPERIOR SUR"},
{"descripcion":"{ AGP-07000.S5 } SENSOR CABEZAL ARRIBA"},
{"descripcion":"{ AGP-07000.S6 } SENSOR CABEZAL ABAJO"},
{"descripcion":"{ AGP-00800 } VOLTEADOR DE BINS IQF N 1"},
{"descripcion":"{ AGP-00802 } ZARANDA ENTRADA INYECTORA CFS450"},
{"descripcion":"{ AGP-00803 } INYECTORA CFS450 IQF 2"},
{"descripcion":"{ AGP-00804 } SUPERCHILL IQF N 1 [E050990105156]"},
{"descripcion":"{ AGP-00805 } ZARANDA SALIDA CINTA SANITIZADO IQF1"},
{"descripcion":"{ AGP-00806 } SUPERCONTAC IQF STARFROST N 1"},
{"descripcion":"{ AGP-00807 } CONGELADOR IQF STARFROST N 1"},
{"descripcion":"{ AGP-00808 } CHILLER IQF N 1"},
{"descripcion":"{ AGP-00809 } VOLTEADOR DE BINS IQF N 4"},
{"descripcion":"{ AGP-00811 } ZARANDA ENTRADA INYECTORA CFS650"},
{"descripcion":"{ AGP-00812 } INYECTORA CFS 650 IQF 4"},
{"descripcion":"{ AGP-00813 } SUPERCHILL FOMACO TRUTRO SUR [102]"},
{"descripcion":"{ AGP-00815 } SUPERCONTAC IQF STARFROST N 2"},
{"descripcion":"{ AGP-00816 } CONGELADOR IQF STARFROST N 2"},
{"descripcion":"{ AGP-00819 } ESTANQUE SALMUERA INYECTORA CFS 650 IQF N 2"},
{"descripcion":"{ AGP-00821 } CONGELADOR IQF N 4 SKAGINN"},
{"descripcion":"{ AGP-00822 } ZARANDA SALIDA INYECTORA CFS650"},
{"descripcion":"{ AGP-00823 } BOMBA ALTA PRESION LAVADO"},
{"descripcion":"{ AGP-00824 } BOMBA MEDIA PRESION LAVADO"},
{"descripcion":"{ AGP-05016 } INYECTORA CFS 650 IQF2"},
{"descripcion":"{ AGP-05017 } SUPERCHILL IQF 4 [56]"},
{"descripcion":"{ AGP-08100 } CINTA HOPPER HORIZONTAL Y ELEVADORA IQF N 1"},
{"descripcion":"{ AGP-08101 } CINTA TRASPASO DE CHILLER A ZARANDA IQF N 1"},
{"descripcion":"{ AGP-08102 } CINTA TRASPASO DE ZARANDA A SUPERCONTAC IQF N 1"},
{"descripcion":"{ AGP-08103 } CINTA CORTA SUPERCONTAC IQF N 1"},
{"descripcion":"{ AGP-08104 } CINTA CURVA A STARFROST IQF N 1"},
{"descripcion":"{ AGP-08105 } CINTA ELEVADORA SALIDA CHILLER IQF N 1"},
{"descripcion":"{ AGP-08106 } CINTA DESCARGA DE IQF N 1 A CALIBRADO"},
{"descripcion":"{ AGP-08107 } CINTA HOPPER HORIZONTAL Y ELEVADORA IQF N 4"},
{"descripcion":"{ AGP-08190 } CINTA SANITIZADO IQF 1"},
{"descripcion":"{ AGP-09157 } MEZCLADORES AGUA VAPOR IQF N 1"},
{"descripcion":"{ AGP-09172 } CINTA SALIDA IQF 1 ELEVADORA"},
{"descripcion":"{ AGP-09172.1 } CINTA SALIDA IQF 1 ELEVADORA"},
{"descripcion":"{ AGP-09428 } MEZCLADORES AGUA VAPOR IQF N 4"},
{"descripcion":"{ AGP-10044 } EXTRACTOR SECTOR IQF N 1 [N 34]"},
{"descripcion":"{ AGP-10045 } EXTRACTOR SECTOR IQF N 2 [N 35]"},
{"descripcion":"{ AGP-10046 } EXTRACTOR SECTOR IQF N 3 [N 36]"},
{"descripcion":"{ AGP-10067 } RADIOS CONGELADO IQF"},
{"descripcion":"{ AGP-10081 } TRASPALETAS CONGELADO IQF"},
{"descripcion":"{ AGP-10098 } BALANZAS CONGELADO IQF"},
{"descripcion":"{ AGP-10192 } CINTA SANITIZADO IQF 4"},
{"descripcion":"{ AGP-10193 } CINTA ELEVADORA NORTE IQF N 4 SKAGINN"},
{"descripcion":"{ AGP-10194 } CINTA BIDIRECCIONAL IQF N 4 SKAGINN"},
{"descripcion":"{ AGP-10195 } CINTA AZUL ALIMENTACION A ENTRADA PONIENTE IQF N 4 SKAGINN"},
{"descripcion":"{ AGP-10196 } CINTA ELEVADORA SUR IQF N 4 SKAGINN"},
{"descripcion":"{ AGP-10197 } CINTA AZUL ALIMENTACION A ENTRADA CENTRAL IQF N 4 SKAGINN"},
{"descripcion":"{ AGP-10197.1 } MOTORREDUCTOR CINTA AZUL ALIMENTACION A ENTRADA CENTRAL IQF N 4 SKAGINN"},
{"descripcion":"{ AGP-10198 } CINTA ENTRADA CENTRAL IQF N 4 SKAGINN"},
{"descripcion":"{ AGP-10199 } CINTA AZUL ALIMENTACION A ENTRADA ORIENTE IQF N 4 SKAGINN"},
{"descripcion":"{ AGP-10200 } CINTA SALIDA IQF N 4 SKAGINN"},
{"descripcion":"{ AGP-10201 } GLACEADOR IQF4"},
{"descripcion":"{ AGP-10202 } CINTA ELEVADORA DE SKAGINN A CALIBRADO"},
{"descripcion":"{ AGP-10203 } CINTA LARGA HACIA CALIBRADO 1"},
{"descripcion":"{ AGP-10204 } CINTA LARGA HACIA CALIBRADO 2"},
{"descripcion":"{ AGP-10205 } CINTA LARGA HACIA CALIBRADO 3 THERMODRIVE"},
{"descripcion":"{ AGP-10221 } VOLTEADOR DE BINS IQF N 2"},
{"descripcion":"{ AGP-10222 } CINTA ELEVADORA ALIMENTACION CINTA ENTRADA SUPERCONTAC STARFROST N 2"},
{"descripcion":"{ AGP-10223 } CINTA ALIMENTACION SUPERCONTAC STARFROST N 2"},
{"descripcion":"{ AGP-10224 } CINTA SALIDA STARFROST N 2"},
{"descripcion":"{ AGP-10225 } CINTA BAJADA ALTILLO SALIDA STARFROST N 2"},
{"descripcion":"{ AGP-10245 } TABLEROS DE FUERZA Y CONTROL SKAGINN"},
{"descripcion":"{ AGP-10260 } TABLEROS DE FUERZA Y CONTROL IQF STARFROST N 2"},
{"descripcion":"{ AGP-10308 } IMPRESORA (01) EMPAQUE IQF"},
{"descripcion":"{ AGP-10309 } IMPRESORA (02) EMPAQUE IQF"},
{"descripcion":"{ AGP-10310 } IMPRESORA (03) EMPAQUE IQF"},
{"descripcion":"{ AGP-10378 } INYECTORA IQF1 (FOMACO)"},
{"descripcion":"{ AGP-10379 } ESTANQUE LATERAL INYECTORA IQF1 FOMACO"},
{"descripcion":"{ AGP-10384 } GLACEADOR IQF 1"},
{"descripcion":"{ AGP-10385 } CINTA GLACEADOR IQF1 ENTRADA"},
{"descripcion":"{ AGP-10386 } CINTA GLACEADOR IQF1 SALIDA"},
{"descripcion":"{ AGP-10391 } CINTA SALIDA CHILLER SANITIZADO IQF1"},
{"descripcion":"{ AGP-10511 } TABLEROS ELECTRICOS FUERZA Y CONTROL SALA IQF"},
{"descripcion":"{ AGP-10522 } CINTA BUFFER IQF2"},
{"descripcion":"{ AGP-10522.1 } MOTORREDUCTOR CINTA BUFFER IQF2"},
{"descripcion":"{ AGP-10586 } CINTA HOPPER ANTES INYECTORA CFS 650 IQF 2"},
{"descripcion":"{ AGP-10587 } TINA SANITIZADO IQF 2"},
{"descripcion":"{ AGP-10588 } CINTA ELEVADORA SALIDA TINA SANITIZADO IQF 2"},
{"descripcion":"{ AGP-10589 } CINTA TRANSVERSAL IQF 2"},
{"descripcion":"{ AGP-10590 } CINTA AZUL ALIMENTACION SUPERCONTACT PORIENTE IQF 2"},
{"descripcion":"{ AGP-10591 } CINTA AZUL ALIMENTACION SUPERCONTACT ORIENTE IQF 2"},
{"descripcion":"{ AGP-10592 } CINTA BLANCA ALIMENTACION ORIENTE STARFROST N 2 IQF 2"},
{"descripcion":"{ AGP-10593 } CINTA BLANCA ALIMENTACION PONIENTE STARFROST N 2 IQF 2"},
{"descripcion":"{ AGP-10596 } GLACEADOR IQF2"},
{"descripcion":"{ AGP-10597 } CINTA LARGA N 1 SALIDA GLACEADOR IQF2 (COSTADO ALTILLO)"},
{"descripcion":"{ AGP-10598 } CINTA ELEVADORA N 2 SALIDA GLACEADOR IQF2 (COSTADO ALTILLO)"},
{"descripcion":"{ AGP-10599 } CINTA ALTILLO N 3 IQF2 SALIDA A CALIBRADO"},
{"descripcion":"{ AGP-10615 } SUPERCHILL IQF 2 [E050990105146]"},
{"descripcion":"{ AGP-5016.5 } BOMBA SALMUERA INYECTORA CFS 650 IQF2"},
{"descripcion":"{ AGP-00823.1 } BOMBA ALTA PRESION LAVADO SALA IQF 4"},
{"descripcion":"{ AGP-00824.1 } MOTOR BOMBA MEDIA PRESION LAVADO SALA IQF 4"},
{"descripcion":"{ AGP-00808.1 } MOTORREDUCTOR CHILLER IQF N 1"},
{"descripcion":"{ AGP-00808.PLC1 } PLC TABLERO PRINCIPAL SISTEMA PERACETICO CHILLER DE IQF N 1"},
{"descripcion":"{ AGP-10223.1 } MOTORREDUCTOR CINTA ALIMENTACION SUPERCONTAC STARFROST N 2"},
{"descripcion":"{ AGP-10599.1 } MOTORREDUCTOR CINTA ALTILLO N 3 IQF2 SALIDA A CALIBRADO"},
{"descripcion":"{ AGP-10199.1 } MOTORREDUCTOR CINTA ALIMENTACION A ENTRADA ORIENTE IQF N 4 SKAGINN"},
{"descripcion":"{ AGP-10195.1 } MOTORREDUCTOR CINTA ALIMENTACION A ENTRADA PONIENTE IQF N 4 SKAGINN"},
{"descripcion":"{ AGP-10591.1 } MOTORREDUCTOR CINTA AZUL ALIMENTACION SUPERCONTACT ORIENTE IQF 2"},
{"descripcion":"{ AGP-10590.1 } MOTORREDUCTOR CINTA AZUL ALIMENTACION SUPERCONTACT PORIENTE IQF 2"},
{"descripcion":"{ AGP-10225.1 } MOTORREDUCTOR CINTA BAJADA ALTILLO SALIDA STARFROST N 2"},
{"descripcion":"{ AGP-10194.1 } MOTORREDUCTOR CINTA BIDIRECCIONAL IQF N 4 SKAGINN"},
{"descripcion":"{ AGP-10592.1 } MOTORREDUCTOE CINTA BLANCA ALIMENTACION ORIENTE STARFROST N 2 IQF 2"},
{"descripcion":"{ AGP-10593.1 } MOTORREDUCTOR CINTA BLANCA ALIMENTACION PONIENTE STARFROST N 2 IQF 2"},
{"descripcion":"{ AGP-08103.1 } MOTORREDUCTOR CINTA CORTA SUPERCONTAC IQF N 1"},
{"descripcion":"{ AGP-08104.1 } MOTORREDUCTOR CINTA CURVA A STARFROST IQF N 1"},
{"descripcion":"{ AGP-08106.1 } MOTORREDUCTOR CINTA DESCARGA DE IQF N 1 A CALIBRADO"},
{"descripcion":"{ AGP-10222.1 } MOTORREDUCTOR CINTA ELEVADORA ALIMENTACION CINTA ENTRADA STARFROST N 2"},
{"descripcion":"{ AGP-10202.1 } MOTORREDUCTOR CINTA ELEVADORA DE SKAGINN A CALIBRADO"},
{"descripcion":"{ AGP-10598.1 } MOTORREDUCTOS CINTA ELEVADORA N 2 SALIDA GLACEADOR IQF2 (COSTADO ALTILLO)"},
{"descripcion":"{ AGP-10193.1 } MOTORREDUCTOR CINTA ELEVADORA NORTE IQF N 4 SKAGINN"},
{"descripcion":"{ AGP-08105.1 } MOTORREDUCTOR CINTA ELEVADORA SALIDA CHILLER IQF N 1"},
{"descripcion":"{ AGP-10588.1 } MOTORREDUCTOR CINTA ELEVADORA SALIDA TINA SANITIZADO IQF 2"},
{"descripcion":"{ AGP-10196.1 } MOTORREDUCTOR CINTA ELEVADORA SUR IQF N 4 SKAGINN"},
{"descripcion":"{ AGP-10198.1 } MOTORREDUCTOR CINTA ENTRADA CENTRAL IQF N 4 SKAGINN"},
{"descripcion":"{ AGP-10385.1 } MOTORREDUCTOR CINTA GLACEADOR IQF1 ENTRADA"},
{"descripcion":"{ AGP-10386.1 } MOTORREDUCTOR CINTA GLACEADOR IQF1 SALIDA"},
{"descripcion":"{ AGP-10586.1 } MOTORREDUCTOR CINTA HOPPER ANTES INYECTORA CFS 650 IQF 2"},
{"descripcion":"{ AGP-08100.1 } MOTORREDUCTOR CINTA HOPPER ELEVADORA IQF N 1"},
{"descripcion":"{ AGP-08100.2 } MOTORREDUCTOR CINTA HOPPER HORIZONTAL IQF N 1"},
{"descripcion":"{ AGP-08100.S1 } SENSOR NIVEL PRODUCTO"},
{"descripcion":"{ AGP-08107.1 } MOTORREDUCTOR CINTA HOPPER ELEVADORA IQF N 4"},
{"descripcion":"{ AGP-08107.2 } MOTORREDUCTOR CINTA HOPPER HORIZONTAL IQF N 4"},
{"descripcion":"{ AGP-08107.S1 } SENSOR NIVEL PRODUCTO"},
{"descripcion":"{ AGP-08107.S2 } SENSOR PRODUCTO"},
{"descripcion":"{ AGP-10205.1 } MOTORREDUCTOR CINTA LARGA HACIA CALIBRADO 3 THERMODRIVE"},
{"descripcion":"{ AGP-10597.1 } MOTORREDUCTOR CINTA LARGA N 1 SALIDA GLACEADOR IQF2 (COSTADO ALTILLO)"},
{"descripcion":"{ AGP-10391.1 } MOTORREDUCTOR CINTA SALIDA CHILLER SANITIZADO IQF1"},
{"descripcion":"{ AGP-10200.1 } MOTORREDUCTOR CINTA SALIDA IQF N 4 SKAGINN"},
{"descripcion":"{ AGP-10224.1 } MOTORREDUCTOR CINTA SALIDA STARFROST N 2"},
{"descripcion":"{ AGP-08190.1 } MOTORREDUCTOR CINTA SANITIZADO IQF 1"},
{"descripcion":"{ AGP-10192.1 } MOTORREDUCTOR CINTA SANITIZADO IQF4"},
{"descripcion":"{ AGP-10192.PLC1 } PLC TABLERO PRINCIPAL CINTA SANITIZACION IQF N 4"},
{"descripcion":"{ AGP-10589.1 } MOTORREDUCTOR CINTA TRANSVERSAL IQF 2"},
{"descripcion":"{ AGP-08101.1 } MOTORREDUCTOR CINTA TRASPASO DE CHILLER A ZARANDA IQF N 1"},
{"descripcion":"{ AGP-08102.1 } MOTORREDUCTOR CINTA TRASPASO DE ZARANDA A SUPERCONTAC IQF N 1"},
{"descripcion":"{ AGP-00821.1 } MOTORREDUCTOR CINTA ELEVADORA ORIENTE CONGELADOR IQF N 4 SKAGINN (DUPLICADO)"},
{"descripcion":"{ AGP-00821.10 } MOTORREDUCTOR CINTA CONGELADO CENTROCONGELADOR IQF N 4 SKAGINN"},
{"descripcion":"{ AGP-00821.11 } MOTORREDUCTOR CINTA CONGELADO INFERIOR CONGELADOR IQF N 4 SKAGINN"},
{"descripcion":"{ AGP-00821.12 } MOTOR VENTILADOR N 1 CONGELADOR IQF N 4 SKAGINN"},
{"descripcion":"{ AGP-00821.13 } MOTOR VENTILADOR N 2 CONGELADOR IQF N 4 SKAGINN"},
{"descripcion":"{ AGP-00821.14 } MOTOR VENTILADOR N 3 CONGELADOR IQF N 4 SKAGINN"},
{"descripcion":"{ AGP-00821.15 } MOTOR VENTILADOR N 4 CONGELADOR IQF N 4 SKAGINN"},
{"descripcion":"{ AGP-00821.16 } MOTOR VENTILADOR N 5 CONGELADOR IQF N 4 SKAGINN"},
{"descripcion":"{ AGP-00821.17 } MOTOR VENTILADOR N 6 CONGELADOR IQF N 4 SKAGINN"},
{"descripcion":"{ AGP-00821.18 } MOTOR VENTILADOR N 7 CONGELADOR IQF N 4 SKAGINN"},
{"descripcion":"{ AGP-00821.19 } MOTOR VENTILADOR N 8 CONGELADOR IQF N 4 SKAGINN"},
{"descripcion":"{ AGP-00821.2 } MOTORREDUCTOR CINTA ELEVADORA PONIENTE CONGELADOR IQF N 4 SKAGINN IQF N 4 (DUPLICADO)"},
{"descripcion":"{ AGP-00821.20 } MOTOR VENTILADOR N 9 CONGELADOR IQF N 4 SKAGINN"},
{"descripcion":"{ AGP-00821.21 } MOTOR VENTILADOR N 10 CONGELADOR IQF N 4 SKAGINN"},
{"descripcion":"{ AGP-00821.22 } MOTORREDUCTOR CINTA SALIDA CONGELADOR IQF N 4 SKAGINN(DUPLICADO)"},
{"descripcion":"{ AGP-00821.3 } MOTORREDUCTOR CINTA DISTRIBUCION ALIMENTACION CINTAS LATERALES CONGELADOR IQF N 4 SKAGINN(DUPLICADO)"},
{"descripcion":"{ AGP-00821.4 } MOTORREDUCTOR CINTA ALIMENTACION LADO ORIENTE CINTA PRINCIPAL CONGELADOR IQF N 4 SKAGINN(DUPLICADO)"},
{"descripcion":"{ AGP-00821.5 } MOTORREDUCTOR CINTA ALIMENTACION LADO PONIENTE CINTA PRINCIPAL CONGELADOR IQF N 4 SKAGINN(DUPLICADO)"},
{"descripcion":"{ AGP-00821.6 } MOTORREDUCTOR CINTA AZUL ALIMENTACION CONGELADOR IQF N 4 SKAGINN(DUPLICADO)"},
{"descripcion":"{ AGP-00821.7 } MOTORREDUCTOR CINTA DE LAGRIMAS SUPERIOR CONGELADOR IQF N 4 SKAGINN"},
{"descripcion":"{ AGP-00821.8 } MOTORREDUCTOR CINTA DE LAGRIMAS INFERIOR CONGELADOR IQF N 4 SKAGINN"},
{"descripcion":"{ AGP-00821.9 } MOTORREDUCTOR CINTA CONGELADO SUPERIOR CONGELADOR IQF N 4 SKAGINN"},
{"descripcion":"{ AGP-00821.HMI1 } HMI TABLERO PRINCIPAL SKAGINN"},
{"descripcion":"{ AGP-00821.PLC1 } PLC TABLERO PRINCIPAL SKAGINN"},
{"descripcion":"{ AGP-00821.S1 } SENSOR NIVEL PRODUCTO CAPACHO ORIENTE"},
{"descripcion":"{ AGP-00821.S10 } SENSOR BAJO CINTA ENTRADA DOWN"},
{"descripcion":"{ AGP-00821.S11 } SENSOR DE TEMPERATURA PT100 ANTES"},
{"descripcion":"{ AGP-00821.S12 } SENSOR DE TEMPERATURA PT100 DESPUES"},
{"descripcion":"{ AGP-00821.S2 } SENSOR NIVEL PRODUCTO CAPACHO PONIENTE"},
{"descripcion":"{ AGP-00821.S3 } SENSOR ORIENTE ARRIBA CINTA ENTRADA UP"},
{"descripcion":"{ AGP-00821.S4 } SENSOR ORIENTE ARRIBA CINTA ENTRADA DOWN"},
{"descripcion":"{ AGP-00821.S5 } SENSOR TACOMETRO SUR PONIENTE"},
{"descripcion":"{ AGP-00821.S6 } SENSOR TACOMETRO SUR ORIENTE"},
{"descripcion":"{ AGP-00821.S7 } SENSOR POSICION ASEO"},
{"descripcion":"{ AGP-00821.S8 } SENSOR POSICION PRODUCCION"},
{"descripcion":"{ AGP-00821.S9 } SENSOR BAJO CINTA ENTRADA UP"},
{"descripcion":"{ AGP-10506 } EVAPORADOR IQF N 4 SKAGGIN"},
{"descripcion":"{ AGP-00807.1 } MOTORREDUCTOR SOBRE IMPULSO STARFROST IQF N 1"},
{"descripcion":"{ AGP-00807.3 } MOTOR VENTILADOR ORIENTE STARFROST IQF N 1"},
{"descripcion":"{ AGP-00807.4 } MOTOR VENTILADOR CENTRO STARFROST IQF N 2"},
{"descripcion":"{ AGP-00807.5 } MOTOR VENTILADOR PONIENTE STARFROST IQF N 3"},
{"descripcion":"{ AGP-00807.6 } MOTORREDUCTOR PRINCIPAL STARFROST IQF N 1"},
{"descripcion":"{ AGP-00807.PLC1 } PLC TABLERO PRINCIPAL CONGELADOR IQF STARFROST N 1"},
{"descripcion":"{ AGP-00807.S1 } SENSOR TENSOR SUPERIOR"},
{"descripcion":"{ AGP-00807.S2 } SENSOR TENSOR INFERIOR"},
{"descripcion":"{ AGP-00807.S3 } SENSOR ALTURA PRODUCTO EXTERNO"},
{"descripcion":"{ AGP-00807.S4 } SENSOR ALTURA PRODUCTO INTERNO"},
{"descripcion":"{ AGP-00807.S5 } SENSOR TACOMETRO"},
{"descripcion":"{ AGP-00807.S6 } SENSOR LEVANTAMIENTO DE CINTA ORNIENTE"},
{"descripcion":"{ AGP-00807.S7 } SENSOR LEVANTAMIENTO DE CINTA PONIENTE"},
{"descripcion":"{ AGP-00807.S8 } SENSOR LIQUIDO (PT100)"},
{"descripcion":"{ AGP-00807.S9 } SENSOR SUCCION (PT100)"},
{"descripcion":"{ AGP-807.6 } CONJUNTO DE VALVULAS IQF N 1"},
{"descripcion":"{ AGP-807.6.1 } LINEA DE INYECCION DE LIQUIDO IQF N 1"},
{"descripcion":"{ AGP-00816.1 } REDUCTOR PRINCIPAL IQF STARFROST N 2"},
{"descripcion":"{ AGP-00816.1.1 } REDUCTOR PRINCIPAL IQF STARFROST N 2"},
{"descripcion":"{ AGP-00816.2 } MOTORREDUCTOR CINTA SOBRE IMPULSO LADO ORIENTE IQF STARFROST N 2"},
{"descripcion":"{ AGP-00816.3 } MOTORREDUCTOR CINTA SOBRE IMPULSO LADO PONIENTE IQF STARFROST N 2"},
{"descripcion":"{ AGP-00816.4 } MOTOR VENTILADOR N 1 ORIENTE STARFROST N 2"},
{"descripcion":"{ AGP-00816.5 } MOTOR VENTILADOR N 2 CENTRO ORIENTE STARFROST N 2"},
{"descripcion":"{ AGP-00816.6 } MOTOR VENTILADOR N 3 CENTRO PONIENTE STARFROST N 2"},
{"descripcion":"{ AGP-00816.7 } MOTOR VENTILADOR N 4 PONIENTE STARFROST N 2"},
{"descripcion":"{ AGP-00816.PLC1 } PLC TABLERO PRINCIPAL CONGELADOR IQF STARFROST N 2"},
{"descripcion":"{ AGP-10577 } MOTOR PRINCIPAL CONGELADOR STARFROST N 2 (TAMBOR)"},
{"descripcion":"{ AGP-00819.1 } MOTORREDUCTOR AGITADOR ESTANQUE SALMUERA IQF N 4"},
{"descripcion":"{ AGP-00819.2 } BOMBA AGITADOR ESTANQUE SALMUERA IQF N 4 1500 LT"},
{"descripcion":"{ AGP-10044.1 } MOTOR EXTRACTOR SECTOR IQF N 1"},
{"descripcion":"{ AGP-10045.1 } MOTOR EXTRACTOR SECTOR IQF N 2"},
{"descripcion":"{ AGP-10046.1 } MOTOR EXTRACTOR SECTOR IQF N 3"},
{"descripcion":"{ AGP-10596.1 } MOTORREDUCTOR CINTA GLACEADOR IQF2"},
{"descripcion":"{ AGP-10201.1 } MOTORREDUCTOR GLACEADOR IQF 4"},
{"descripcion":"{ AGP-10201.HMI1 } HMI TABLERO CONTROL CINTAS SALIDA SKAGINN"},
{"descripcion":"{ AGP-10201.PLC1 } PLC TABLERO PRINCIPAL CINTAS SALIDA SKAGINN"},
{"descripcion":"{ AGP-00812.1 } MOTORREDUCTOR CINTA INYECTORA CFS 650"},
{"descripcion":"{ AGP-00812.2 } MOTORREDUCTOR CABEZAL INYECTORA CFS 650"},
{"descripcion":"{ AGP-00812.3 } MOTORREDUCTOR FILTRO ROTATORIO INYECTORA CFS 650"},
{"descripcion":"{ AGP-00812.4 } BOMBA PACKO SALMUERA INYECTORA CFS 650 IQF 4"},
{"descripcion":"{ AGP-00812.5 } BOMBA SPX SALMUERA INYECTORA CFS 650 IQF 4"},
{"descripcion":"{ AGP-00812.HMI1 } HMI TABLERO PRINCIPAL INYECTORA CFS 650 IQF 4"},
{"descripcion":"{ AGP-00812.PLC1 } PLC TABLERO PRINCIPAL INYECTORA CFS 650 IQF 4"},
{"descripcion":"{ AGP-00812.S1 } SENSOR PUERTA #1"},
{"descripcion":"{ AGP-00812.S10 } TRANSDUCTOR DE PRESION"},
{"descripcion":"{ AGP-00812.S2 } SENSOR PUERTA #2"},
{"descripcion":"{ AGP-00812.S3 } SENSOR PUERTA #3"},
{"descripcion":"{ AGP-00812.S4 } SENSOR PUERTA #4"},
{"descripcion":"{ AGP-00812.S5 } SENSOR PROTECCION CINTA"},
{"descripcion":"{ AGP-00812.S6 } SENSOR NIVEL"},
{"descripcion":"{ AGP-00812.S7 } SENSOR CABEZAL NIVEL ALTO"},
{"descripcion":"{ AGP-00812.S8 } SENSOR CABEZAL NIVEL BAJO"},
{"descripcion":"{ AGP-00812.S9 } SENSOR VUELTA DE CINTA"},
{"descripcion":"{ AGP-05016.1 } MOTORREDUCTOR CINTA INYECTORA CFS 650 SUR"},
{"descripcion":"{ AGP-05016.2 } MOTORREDUCTOR CABEZAL INYECTORA CFS 650 SUR"},
{"descripcion":"{ AGP-05016.3 } MOTORREDUCTOR FILTRO ROTATORIO INYECTORA CFS 650 IQF2"},
{"descripcion":"{ AGP-05016.4 } BOMBA SALMUERA INYECTORA CFS 650 SUR"},
{"descripcion":"{ AGP-05016.HMI1 } HMI TABLERO PRINCIPAL INYECTORA CFS 650 TRUTROS SUR"},
{"descripcion":"{ AGP-05016.PLC1 } PLC TABLERO PRINCIPAL INYECTORA CFS 650 TRUTROS SUR"},
{"descripcion":"{ AGP-05016.S1 } SENSOR PUERTA #1"},
{"descripcion":"{ AGP-05016.S10 } SENSOR RASPADOR"},
{"descripcion":"{ AGP-05016.S11 } SENSOR NIVEL NORTE"},
{"descripcion":"{ AGP-05016.S12 } SENSOR NIVEL SUR"},
{"descripcion":"{ AGP-05016.S13 } SENSOR NIVEL SEGURIDAD"},
{"descripcion":"{ AGP-05016.S14 } TRANSDUCTOR DE PRESION"},
{"descripcion":"{ AGP-05016.S2 } SENSOR PUERTA #2"},
{"descripcion":"{ AGP-05016.S3 } SENSOR PUERTA #3"},
{"descripcion":"{ AGP-05016.S4 } SENSOR PUERTA #4"},
{"descripcion":"{ AGP-05016.S5 } SENSOR CINTA"},
{"descripcion":"{ AGP-05016.S6 } SENSOR UP"},
{"descripcion":"{ AGP-05016.S7 } SENSOR DOWN"},
{"descripcion":"{ AGP-05016.S8 } SENSOR AMORTIGUADOR"},
{"descripcion":"{ AGP-05016.S9 } SENSOR VUELTA CINTA"},
{"descripcion":"{ AGP-00803.1 } MOTORREDUCTOR CINTA INYECTORA CFS450"},
{"descripcion":"{ AGP-00803.2 } MOTORREDUCTOR CABEZAL INYECTORA CFS450"},
{"descripcion":"{ AGP-00803.3 } MOTORREDUCTOR FILTRO ROTATORIO INYECTORA CFS 450"},
{"descripcion":"{ AGP-00803.4 } BOMBA SALMUERA INYECTORA CFS 450"},
{"descripcion":"{ AGP-00803.HMI1 } HMI TABLERO PRINCIPAL INYECTORA CFS 450 IQF 2"},
{"descripcion":"{ AGP-00803.PLC1 } PLC TABLERO PRINCIPAL INYECTORA CFS 450 IQF 2"},
{"descripcion":"{ AGP-00803.S1 } SENSOR PUERTA #1"},
{"descripcion":"{ AGP-00803.S10 } TRANSDUCTOR DE PRESION"},
{"descripcion":"{ AGP-00803.S2 } SENSOR PUERTA #2"},
{"descripcion":"{ AGP-00803.S3 } SENSOR PUERTA #3"},
{"descripcion":"{ AGP-00803.S4 } SENSOR PROTECCION CINTA"},
{"descripcion":"{ AGP-00803.S5 } SENSOR NIVEL"},
{"descripcion":"{ AGP-00803.S6 } SENSOR CABEZAL NIVEL ALTO"},
{"descripcion":"{ AGP-00803.S7 } SENSOR CABEZAL NIVEL BAJO"},
{"descripcion":"{ AGP-00803.S8 } SENSOR VUELTA DE CINTA"},
{"descripcion":"{ AGP-00803.S9 } SENSOR NIVEL SEGURIDAD"},
{"descripcion":"{ AGP-10378.1 } SERVOMOTOR FILTRO INYECTORA IQF1 (FOMACO)"},
{"descripcion":"{ AGP-10378.2 } SERVOMOTOR CABEZAL INYECTORA IQF1 (FOMACO)"},
{"descripcion":"{ AGP-10378.3 } MOTOTAMBOR CINTA ESTANQUE LATERAL INYECTORA IQF1 (FOMACO)"},
{"descripcion":"{ AGP-10378.4 } MOTORREDUCTOR RASPADOR CINTA ESTANQUE LATERAL INYECTORA IQF1 (FOMACO)"},
{"descripcion":"{ AGP-10378.5 } SERVOMOTOR CINTA INYECTORA IQF1 (FOMACO)"},
{"descripcion":"{ AGP-10378.6 } BOMBA INYECTORA IQF1 (FOMACO)"},
{"descripcion":"{ AGP-00813.1 } BOMBA GLICOL SUPER CHILL IQF N 4"},
{"descripcion":"{ AGP-00813.2 } BOMBA SALMUERA SUPER CHILL IQF N 4"},
{"descripcion":"{ AGP-05017.1 } BOMBA GLICOL SUPER CHILL SUR"},
{"descripcion":"{ AGP-05017.2 } BOMBA SALMUERA SUPER CHILL SUR"},
{"descripcion":"{ AGP-00804.1 } BOMBA GLICOL SUPER CHILL IQF N 1"},
{"descripcion":"{ AGP-00804.2 } BOMBA SALMUERA SUPER CHILL IQF N 1"},
{"descripcion":"{ AGP-00806.1 } MOTORREDUCTOR SUPERCONTAC IQF N 1"},
{"descripcion":"{ AGP-00815.1 } MOTORREDUCTOR SUPERCONTAC STARFROST N 2"},
{"descripcion":"{ AGP-10587.1 } MOTORREDUCTOR TINA SANITIZADO IQF 2"},
{"descripcion":"{ AGP-00800.1 } MOTOR CENTRAL HIDRAULICA VOLTEADOR DE BINS IQF1 N 1"},
{"descripcion":"{ AGP-10221.1 } MOTOR CENTRAL HIDRAULICA VOLTEADOR DE BINS STARFROST N 2"},
{"descripcion":"{ AGP-00809.1 } MOTOR CENTRAL HIDRAULICA VOLTEADOR DE BINS IQF4 N 2"},
{"descripcion":"{ AGP-00802.1 } MOTOR ORIENTE ZARANDA ENTRADA INYECTORA CFS450"},
{"descripcion":"{ AGP-00802.2 } MOTOR PONIENTE ZARANDA ENTRADA INYECTORA CFS450"},
{"descripcion":"{ AGP-00811.1 } MOTOR ORIENTE ZARANDA ENTRADA INYECTORA CFS650"},
{"descripcion":"{ AGP-00811.2 } MOTOR PONIENTE ZARANDA ENTRADA INYECTORA CFS650"},
{"descripcion":"{ AGP-00805.1 } MOTOR LADO ORIENTE ZARANDA SALIDA INYECTORA CFS450"},
{"descripcion":"{ AGP-00805.2 } MOTOR LADO PONIENTE ZARANDA SALIDA INYECTORA CFS450"},
{"descripcion":"{ AGP-00822.1 } MOTOR ORIENTE ZARANDA SALIDA INYECTORA CFS650"},
{"descripcion":"{ AGP-00822.2 } MOTOR PONIENTE ZARANDA SALIDA INYECTORA CFS650"},
{"descripcion":"{ AGP-07022 } LAVADOR DE CARROS"},
{"descripcion":"{ AGP-07022.1 } MOTORREDUCTOR CINTA LAVADOR DE CARROS"},
{"descripcion":"{ AGP-07022.2 } MOTORREDUCTOR FILTRO LAVADO DE CARROS"},
{"descripcion":"{ AGP-07022.3 } BOMBA LAVADO DE CARROS"},
{"descripcion":"{ AGP-07022.HMI1 } HMI TABLERO PRINCIPAL LAVADO DE CARROS"},
{"descripcion":"{ AGP-07022.PLC1 } PLC TABLERO PRINCIPAL LAVADO DE CARROS"},
{"descripcion":"{ AGP-10313 } ESTACION ABLANDADORES DE AGUA LAVANDERÃA"},
{"descripcion":"{ AGP-10363 } TABLEROS ELECTRICOS DE FUERZA Y CONTROL DE LAVANDERIA"},
{"descripcion":"{ AGP-10635 } EXTRACTOR SUR LAVANDERIA [N 74]"},
{"descripcion":"{ AGP-10636 } EXTRACTOR NORTE LAVANDERIA [N 75]"},
{"descripcion":"{ AGP-10637 } EXTRACTOR ORIENTE LAVANDERIA [N 76]"},
{"descripcion":"{ AGP-09142 } UNIDAD DE OSMOSIS INVERSA"},
{"descripcion":"{ AGP-09143 } LÃNEA DE AGUA FRÃA OSMOSIS"},
{"descripcion":"{ AGP-09144 } LÃNEA DE AGUA NATURAL OSMOSIS"},
{"descripcion":"{ AGP-09145 } LÃNEA DE AGUA RECHAZO OSMOSIS"},
{"descripcion":"{ AGP-09240 } ESTANQUE ALMACENAMIENTO AGUA FRIA"},
{"descripcion":"{ AGP-09241 } ESTANQUE ALMACENAMIENTO OSMOSIS"},
{"descripcion":"{ AGP-09242 } ESTANQUE ALMACENAMIENTO STANDBY"},
{"descripcion":"{ AGP-09243 } SISTEMA DE CLORACION OSMOSIS"},
{"descripcion":"{ AGP-09244 } TABLEROS ELECTRICOS OSMOSIS"},
{"descripcion":"{ AGP-10398 } BOMBA DOSIFICADORA DE CLORO POZO N 5"},
{"descripcion":"{ AGP-10631 } BOMBA CENTRIFUGA PONIENTE POZO OSMOSIS"},
{"descripcion":"{ AGP-10632 } BOMBA AUTOCEBANTE ORIENTE POZO OSMOSIS T4"},
{"descripcion":"{ AGP-09143.1 } BOMBA N 1 AGUA FRIA OSMOSIS RECIRCULADORA"},
{"descripcion":"{ AGP-09143.2 } BOMBA N 2 AGUA FRIA OSMOSIS RECIRCULADORA"},
{"descripcion":"{ AGP-09143.3 } BOMBA DE AGUA VERTICAL DE AGUA FRIA OSMOSIS (GLASCIADORES IQF N 4)"},
{"descripcion":"{ AGP-09143.4 } BOMBA N 1 AGUA FRIA OSMOSIS (SALMUERA)ORIENTE"},
{"descripcion":"{ AGP-09143.5 } BOMBA N 2 AGUA FRIA OSMOSIS (SALMUERA)PONIENTE"},
{"descripcion":"{ AGP-09144.1 } BOMBA NORTE AGUA NATURAL OSMOSIS HACIA CALDERA"},
{"descripcion":"{ AGP-09144.2 } BOMBA SUR AGUA NATURAL OSMOSIS HACIA CALDERA"},
{"descripcion":"{ AGP-09144.3 } BOMBA N 1 AGUA NATURAL OSMOSIS"},
{"descripcion":"{ AGP-09144.4 } BOMBA N 2 AGUA NATURAL OSMOSIS"},
{"descripcion":"{ AGP-09145.1 } BOMBA N 1 AGUA RECHAZO OSMOSIS"},
{"descripcion":"{ AGP-09145.2 } BOMBA N 2 AGUA RECHAZO OSMOSIS"},
{"descripcion":"{ AGP-09145.3 } BOMBA DE AGUA RECHAZO BOMBA DE OSMOSIS N 1 (LADO ORIENTE)"},
{"descripcion":"{ AGP-09243.1 } BOMBA SISTEMA DE CLORACION OSMOSIS"},
{"descripcion":"{ AGP-01003 } BASCULA DE PESAJE DINAMICO DESPACHO CONGELADO"},
{"descripcion":"{ AGP-01140 } BASCULA DE PESAJE ESTATICO AVES VIVAS"},
{"descripcion":"{ AGP-10191.S1 } SENSOR NORTE PORTON SALIDA PRODUCTOS TERMINADOS"},
{"descripcion":"{ AGP-10349 } RODALUVIO (ORIENTE)"},
{"descripcion":"{ AGP-10350 } RODALUVIO (PONIENTE)"},
{"descripcion":"{ AGP-10351 } PEDILUVIO PEATONAL"},
{"descripcion":"{ AGP-10351.1 } BOMBA PEDILUVIO PEATONAL"},
{"descripcion":"{ AGP-00820 } PREPARACION Y ALMACENAMIENTO SALMUERA IQF N 1"},
{"descripcion":"{ AGP-05000 } PREPARACION Y ALMACENAMIENTO SALMUERA TRUTROS"},
{"descripcion":"{ AGP-05001 } UNIDAD ULTRASONIDO LIMPIEZA AGUJAS"},
{"descripcion":"{ AGP-09070 } ESTANQUES SCANBRINE CFS"},
{"descripcion":"{ AGP-00820.1 } MOTORREDUCTOR AGITADOR ESTANQUE PREPARACION SALMUERA IQF N 1 Y 4"},
{"descripcion":"{ AGP-00820.2 } MOTORREDUCTOR AGITADOR ESTANQUE ACUMULACION SALMUERA IQF N 1 Y 4"},
{"descripcion":"{ AGP-00820.3 } BOMBA ESTANQUE PREPARACION SALMUERA IQF N 1 Y 4"},
{"descripcion":"{ AGP-00820.4 } BOMBA ESTANQUE ACUMULACION SALMUERA IQF N 1 Y 4"},
{"descripcion":"{ AGP-05000.1 } MOTORREDUCTOR AGITADOR ESTANQUE PREPARACION SALMUERA LINEA DE TRUTROS LINEA 1 Y 2"},
{"descripcion":"{ AGP-05000.2 } MOTORREDUCTOR AGITADOR ESTANQUE ACUMULACION SALMUERA LINEA DE TRUTROS LINEA 1 Y 2"},
{"descripcion":"{ AGP-05000.3 } BOMBA ESTANQUE PREPARACION SALMUERA LINEA DE TRUTROS 1 Y 2"},
{"descripcion":"{ AGP-05000.4 } BOMBA ESTANQUE ACUMULACION SALMUERA LINEA DE TRUTROS LINEA 1 Y 2"},
{"descripcion":"{ AGP-00524 } LINEA AEREA EXPURGO TROZADO DE POLLOS"},
{"descripcion":"{ AGP-00529 } PROCESADOR ALTO RINDE EXPURGO"},
{"descripcion":"{ AGP-00555 } REBANADORA KSL"},
{"descripcion":"{ AGP-00613 } CHILLER DE SALIDA INYECTORA METALQUIMIA"},
{"descripcion":"{ AGP-08095 } CINTA ELEVADORA SALIDA CHILLER METALQUIMIA"},
{"descripcion":"{ AGP-09390 } FANCOIL SALA JAPON N 1"},
{"descripcion":"{ AGP-09391 } FANCOIL SALA JAPON N 2"},
{"descripcion":"{ AGP-09392 } FANCOIL SALA JAPON N 3"},
{"descripcion":"{ AGP-10399 } CINTA SALIDA REBANADORA KSL"},
{"descripcion":"{ AGP-10400 } FANCOIL SALA PROCESOS CARNICOS (EX JAPON)"},
{"descripcion":"{ AGP-10409 } VOLTEADOR DE BINS EX JAPON"},
{"descripcion":"{ AGP-10410 } TOLVA RECEPTORA VOLTEADOR DE BINS"},
{"descripcion":"{ AGP-10411 } CINTA ELEVADORA A TOLVA DESCARGA"},
{"descripcion":"{ AGP-10412 } TOLVA DESCARGA CINTA TRASPASO"},
{"descripcion":"{ AGP-10413 } CINTA TRASPASO"},
{"descripcion":"{ AGP-10414 } CINTA ALIMENTACION REBANADORA KSL"},
{"descripcion":"{ AGP-10415 } CINTA LIMPIEZA SUPERIOR"},
{"descripcion":"{ AGP-10416 } CINTA CLASIFICION INFERIOR"},
{"descripcion":"{ AGP-10417 } MESON DE TECHNYL"},
{"descripcion":"{ AGP-10418 } TOBOGAN DISTRIBUIDOR"},
{"descripcion":"{ AGP-10419 } CINTA ELEVADORA ORIENTE"},
{"descripcion":"{ AGP-10420 } CINTA ELEVADORA PONIENTE"},
{"descripcion":"{ AGP-10421 } CAPACHO DESCARGA ORIENTE (SALA EX JAPON)"},
{"descripcion":"{ AGP-10422 } CAPACHO DESCARGA PONIENTE (SALA EX JAPON)"},
{"descripcion":"{ AGP-10423 } CINTA RECEPTORA SUR"},
{"descripcion":"{ AGP-10424 } CINTA RECEPTORA NORTE"},
{"descripcion":"{ AGP-10425 } CINTA PALETIZADO"},
{"descripcion":"{ AGP-10426 } SALIDA DE EMERGENCIA EX JAPON"},
{"descripcion":"{ AGP-10585 } SELLADORA AUTOMATICA EX SALA JAPON"},
{"descripcion":"{ AGP-00613.1 } MOTORREDUCTOR CHILLER DE SALIDA INYECTORA"},
{"descripcion":"{ AGP-10419.1 } MOTORREDUCTOR CINTA ELEVADORA ORIENTE"},
{"descripcion":"{ AGP-10420.1 } MOTORREDUCTOR CINTA ELEVADORA PONIENTE"},
{"descripcion":"{ AGP-08095.1 } MOTORREDUCTOR CINTA ELEVADORA SALIDA CHILLER METALQUIMIA"},
{"descripcion":"{ AGP-10424.1 } MOTORREDUCTOR CINTA RECEPTORA NORTE"},
{"descripcion":"{ AGP-10423.1 } MOTORREDUCTOR CINTA RECEPTORA SUR"},
{"descripcion":"{ AGP-10399.1 } MOTORREDUCTOR CINTA SALIDA REBANADORA KSL"},
{"descripcion":"{ AGP-09390.1 } MOTOR VENTILADOR N 1 FANCOIL SALA JAPON N 1"},
{"descripcion":"{ AGP-09390.2 } MOTOR VENTILADOR N 2 FANCOIL SALA JAPON N 1"},
{"descripcion":"{ AGP-09391.1 } MOTOR VENTILADOR N 1 FANCOIL SALA JAPON N 2"},
{"descripcion":"{ AGP-09391.2 } MOTOR VENTILADOR N 2 FANCOIL SALA JAPON N 2"},
{"descripcion":"{ AGP-09392.1 } MOTOR VENTILADOR N 1 FANCOIL SALA JAPON N 3"},
{"descripcion":"{ AGP-09392.2 } MOTOR VENTILADOR N 2 FANCOIL SALA JAPON N 3"},
{"descripcion":"{ AGP-10400.1 } MOTOR VENTILADOR N 1 PONIENTE FANCOIL SALA PROCESOS CARNICOS (EX JAPON)"},
{"descripcion":"{ AGP-10400.2 } MOTOR VENTILADOR N 2 ORIIENTE FANCOIL SALA PROCESOS CARNICOS (EX JAPON)"},
{"descripcion":"{ AGP-00525 } CORTADOR ALA TRUTRO EXPURGO"},
{"descripcion":"{ AGP-00526 } CORTADOR DE PECHUGAS EXPURGO"},
{"descripcion":"{ AGP-00527 } CORTADOR PUNTA LAPIZ EXPURGO"},
{"descripcion":"{ AGP-00528 } PROCESADOR DE TRUTROS EXPURGO"},
{"descripcion":"{ AGP-00526.1 } MOTOR CORTADOR DE PECHUGAS EXPURGO"},
{"descripcion":"{ AGP-01100 } CINTA RECEPTORA DE PALLET"},
{"descripcion":"{ AGP-01101 } CINTA MODULAR TRANSPORTE DE JABAS PONIENTE"},
{"descripcion":"{ AGP-01102 } CINTA ENTRADA DESAPILADOR"},
{"descripcion":"{ AGP-01103 } DESAPILADOR DE JABAS"},
{"descripcion":"{ AGP-01104 } CINTA SALIDA DESAPILADOR"},
{"descripcion":"{ AGP-01105 } CINTA CURVA ENTRADA A COLGADO"},
{"descripcion":"{ AGP-01107 } CINTA CORTA ANTES LAVADORA LINCO"},
{"descripcion":"{ AGP-01108 } LAVADORA DE JABAS LINCO"},
{"descripcion":"{ AGP-01109 } CINTA SALIDA LAVADORA LINCO"},
{"descripcion":"{ AGP-01110 } CINTA CURVA N 2 DESPUES LAVADORA JABAS LINCO"},
{"descripcion":"{ AGP-01112 } LAVADORA DE JABAS SEMIL"},
{"descripcion":"{ AGP-01114 } CINTA CURVA ANTES APILADOR"},
{"descripcion":"{ AGP-01115 } CINTA ENTRADA APILADOR"},
{"descripcion":"{ AGP-01116 } APILADOR DE JABAS"},
{"descripcion":"{ AGP-01117 } CINTA SALIDA APILADOR"},
{"descripcion":"{ AGP-01118 } CENTRAL HIDRAULICA DES/APILADOR"},
{"descripcion":"{ AGP-01119 } CENTRAL HIDRAULICA CINTAS CADENA"},
{"descripcion":"{ AGP-01120 } LINEA AEREA FAENACION/DESPLUMADO"},
{"descripcion":"{ AGP-10063 } RADIOS RECEPCION DE POLLOS"},
{"descripcion":"{ AGP-10226 } TABLEROS ELECTRICOS DE FUERZA Y CONTROL RECEPCION DE POLLOS"},
{"descripcion":"{ AGP-10237 } TABLEROS ELECTRICOS DE FUERZA Y CONTROL EQUIPOS AUXILIARES DE FAENA ( DOBLE PUERTA )"},
{"descripcion":"{ AGP-10302 } SEPARADOR DE PLUMAS (REACONDICIONADO)"},
{"descripcion":"{ AGP-10507 } BOMBA T2"},
{"descripcion":"{ AGP-10523 } TABLERO ELECTRICO CONTROL Y FUERZA SALA RECEPCION DE POLLOS"},
{"descripcion":"{ AGP-10527 } BOMBA PONIENTE DESAGUE IQF Y DESHUESADO"},
{"descripcion":"{ AGP-10565 } ATONTADOR DE POLLOS MEYN N 2"},
{"descripcion":"{ AGP-10566 } CINTA MODULAR TRANSPORTE DE JABAS ORIENTE (NUEVA)"},
{"descripcion":"{ AGP-10567 } CINTA CURVA S ANTES ENTRADA DESAPILADOR ORIENTE"},
{"descripcion":"{ AGP-10568 } CINTA RECTA ANTES DESAPILADOR ORIENTE"},
{"descripcion":"{ AGP-10569 } DESAPILADOR DE JABAS ORIENTE (NUEVO)"},
{"descripcion":"{ AGP-10570 } CINTA CURVA SALIDA DESAPILADOR ORIENTE (NUEVO)"},
{"descripcion":"{ AGP-10571 } CINTA MODULAR NORTE ENTRADA COLGADO DE AVES"},
{"descripcion":"{ AGP-10572 } CINTA MODULAR SUR ENTRADA COLGADO DE AVES"},
{"descripcion":"{ AGP-10573 } CINTA MODULAR DECOMISO DE AVES"},
{"descripcion":"{ AGP-10606 } TABLERO DE CONTROL Y FUERZA CINTAS DESAPILADOR NUEVO"},
{"descripcion":"{ AGP-10657 } ESTANQUE DE GAS LICUADO ALIMENTACION GRUAS HORQUILLA FAENA"},
{"descripcion":"{ AGP-01116.1 } MOTORREDUCTOR CINTA APILADOR DE JABAS"},
{"descripcion":"{ AGP-01116.2 } MOTORREDUCTOR CARRO LEVANTE APILADOR DE JABAS"},
{"descripcion":"{ AGP-01116.S1 } SENSOR PEDAL ENTRADA #1"},
{"descripcion":"{ AGP-01116.S2 } SENSOR PEDAL #2"},
{"descripcion":"{ AGP-01116.S3 } SENSOR PEDAL #3"},
{"descripcion":"{ AGP-01116.S4 } SENSOR PEDAL SALIDA #4"},
{"descripcion":"{ AGP-01116.S5 } SENSOR FIN DE CICLO"},
{"descripcion":"{ AGP-01116.S6 } SENSOR NIVEL BAJO"},
{"descripcion":"{ AGP-01116.S7 } SENSOR NIVEL ALTO"},
{"descripcion":"{ AGP-01119.1 } MOTOR CENTRAL HIDRAULICA CINTAS CADENAS"},
{"descripcion":"{ AGP-01119.2 } MOTOR CENTRAL HIDRAULICA CINTA COLGADO DE POLLOS"},
{"descripcion":"{ AGP-01118.1 } MOTOR CENTRAL HIDRAULICA DESAPILADOR"},
{"descripcion":"{ AGP-01118.2 } MOTOR CENTRAL HIDRAULICA APILADOR"},
{"descripcion":"{ AGP-01105.1 } MOTORREDUCTOR CINTA CURVA ENTRADA A COLGADO"},
{"descripcion":"{ AGP-10567.1 } MOTORREDUCTOR CINTA CURVA SALIDA TRANSPORTADORA JABAS DESAPILADOR NUEVO"},
{"descripcion":"{ AGP-10570.1 } MOTORREDUCTOR CINTA CURVA SALIDA DESAPILADOR ORIENTE (NUEVO)"},
{"descripcion":"{ AGP-01115.1 } MOTORREDUCTOR CINTA ENTRADA APILADOR"},
{"descripcion":"{ AGP-01102.1 } MOTORREDUCTOR CINTA ENTRADA DESAPILADOR"},
{"descripcion":"{ AGP-01102.S1 } SENSOR PEDAL ENTRADA"},
{"descripcion":"{ AGP-01102.S2 } SENSOR PEDAL SALIDA"},
{"descripcion":"{ AGP-10573.1 } MOTORREDUCTOR CINTA MODULAR DECOMISO DE AVES"},
{"descripcion":"{ AGP-10571.1 } MOTORREDUCTOR CINTA MODULAR UNION BYPASS LINEA DESAPILADOR ORIENTE (NUEVA)"},
{"descripcion":"{ AGP-10566.1 } MOTORREDUCTOR CINTA MODULAR TRANSPORTE DE JABAS ORIENTE (NUEVA)"},
{"descripcion":"{ AGP-01101.1 } MOTORREDUCTOR CINTA MODULAR TRANSPORTE DE JABAS PONIENTE"},
{"descripcion":"{ AGP-01100.01 } MOTOREDURCTOR 5 KW"},
{"descripcion":"{ AGP-01100.1 } MOTORREDUCTOR CINTA RECEPTORA DE PALLET"},
{"descripcion":"{ AGP-01100.2 } MOTOR DE BOMBA LAVADO DE PALLET"},
{"descripcion":"{ AGP-01100.S1 } SENSOR PRESENCIA PALLET JABAS"},
{"descripcion":"{ AGP-01100.S2 } SENSOR PRESENCIA PALLET FINAL SUPERIOR"},
{"descripcion":"{ AGP-01100.S3 } SENSOR PRESENCIA PALLET FINAL INFERIOR"},
{"descripcion":"{ AGP-10568.1 } MOTORREDUCTOR CINTA ANTES DESAPILADOR NUEVO"},
{"descripcion":"{ AGP-10568.S1 } SENSOR LASER SUR CINTA ANTES DESAPILADOR NUEVO"},
{"descripcion":"{ AGP-10568.S2 } SENSOR LASER NORTE CINTA ANTES DESAPILADOR NUEVO"},
{"descripcion":"{ AGP-01117.1 } MOTORREDUCTOR CINTA SALIDA APILADOR"},
{"descripcion":"{ AGP-01104.1 } MOTORREDUCTOR CINTA SALIDA DESAPILADOR"},
{"descripcion":"{ AGP-1056.PLC1 } PLC 1 SISTEMA DESAPILADOR ORIENTE"},
{"descripcion":"{ AGP-10569.1 } MOTORREDUCTOR LEVANTE JABAS ORIENTE DESAPILADOR NUEVO"},
{"descripcion":"{ AGP-10569.2 } MOTORREDUCTOR LEVANTE JABAS PONIENTE DESAPILADOR NUEVO"},
{"descripcion":"{ AGP-10569.3 } MOTORREDUCTOR CINTA DESAPILADOR NUEVO"},
{"descripcion":"{ AGP-10569.HMI1 } HMI 1 SISTEMA DESAPILADOR ORIENTE"},
{"descripcion":"{ AGP-10569.HMI2 } HMI 2 SISTEMA DESAPILADOR ORIENTE"},
{"descripcion":"{ AGP-10569.S1 } SENSOR LASER POSICION DE JABAS N 1 SUR DESAPILADOR NUEVO"},
{"descripcion":"{ AGP-10569.S10 } SENSOR INDUCTIVO MACIZO NIVEL SEGURIDAD ALTO SISTEMA LEVANTE JABAS PONIENTE DESAPILADOR"},
{"descripcion":"{ AGP-10569.S11 } SENSOR INDUCTIVO MACIZO NIVEL SEGURIDAD ALTO SISTEMA LEVANTE JABAS ORIENTE DESAPILADOR"},
{"descripcion":"{ AGP-10569.S12 } SENSOR LASER DE ALTURA DESAPILADOS NUEVO"},
{"descripcion":"{ AGP-10569.S13 } SENSOR INDUCTIVO CILINDRO NEUMATICO POSICION ABIERTO SISTEMA LEVANTE DE JABAS ORIENTE DESAPILADOR"},
{"descripcion":"{ AGP-10569.S14 } SENSOR INDUCTIVO CILINDRO NEUMATICO POSICION CERRADO SISTEMA LEVANTE DE JABAS ORIENTE DESAPILADOR"},
{"descripcion":"{ AGP-10569.S15 } SENSOR INDUCTIVO CILINDRO NEUMATICO POSICION ABIERTO SISTEMA LEVANTE DE JABAS PONIENTE DESAPILADOR"},
{"descripcion":"{ AGP-10569.S16 } SENSOR INDUCTIVO CILINDRO NEUMATICO POSICION CERRADO SISTEMA LEVANTE DE JABAS PONIENTE DESAPILADOR"},
{"descripcion":"{ AGP-10569.S2 } SENSOR LASER POSICION DE JABAS N 2 DESAPILADOR NUEVO"},
{"descripcion":"{ AGP-10569.S3 } SENSOR LASER POSICION DE JABAS N 3 DESAPILADOR NUEVO"},
{"descripcion":"{ AGP-10569.S4 } SENSOR LASER POSICION DE JABAS N 4 NORTE DESAPILADOR NUEVO"},
{"descripcion":"{ AGP-10569.S5 } SENSOR INDUCTIVO NIVEL ALTO SISTEMA LEVANTE JABAS ORIENTE DESAPILADOR NUEVO"},
{"descripcion":"{ AGP-10569.S6 } SENSOR INDUCTIVO NIVEL ALTO SISTEMA LEVANTE JABAS PONIENTE DESAPILADOR NUEVO"},
{"descripcion":"{ AGP-10569.S7 } SENSOR INDUCTIVO NIVEL BAJO RESET SISTEMA LEVANTE JABAS ORIENTE DESAPILADOR NUEVO"},
{"descripcion":"{ AGP-10569.S8 } SENSOR INDUCTIVO NIVEL BAJO RESET SISTEMA LEVANTE JABAS PONIENTE DESAPILADOR NUEVO"},
{"descripcion":"{ AGP-10569.S9 } SENSOR INDUCTIVO NIVEL BAJO SEGURIDAD SISTEMA LEVANTE JABAS PONIENTE DESAPILADOR NUEVO"},
{"descripcion":"{ AGP-01103.1 } MOTORREDUCTOR CINTA DESAPILADOR DE JABAS"},
{"descripcion":"{ AGP-01103.HMI1 } HMI TABLERO CONTROL SISTEMA DE RECEPCION DE POLLOS"},
{"descripcion":"{ AGP-01103.PLC1 } PLC TABLERO PRINCIPAL SISTEMA DE RECEPCION DE POLLOS"},
{"descripcion":"{ AGP-01103.S1 } SENSOR PEDAL ENTRADA #1"},
{"descripcion":"{ AGP-01103.S2 } SENSOR PEDAL #2"},
{"descripcion":"{ AGP-01103.S3 } SENSOR PEDAL #3"},
{"descripcion":"{ AGP-01103.S4 } SENSOR PEDAL SALIDA #4"},
{"descripcion":"{ AGP-01103.S5 } SENSOR PARRILLA"},
{"descripcion":"{ AGP-01103.S6 } SENSOR NIVEL BAJO"},
{"descripcion":"{ AGP-01103.S7 } SENSOR NIVEL MEDIO"},
{"descripcion":"{ AGP-01103.S8 } SENSOR NIVEL ALTO"},
{"descripcion":"{ AGP-1103.S10 } SENSOR ULTRASONICO #2"},
{"descripcion":"{ AGP-1103.S11 } SENSOR ULTRASONICO #3"},
{"descripcion":"{ AGP-1103.S12 } SENSOR ULTRASONICO #4"},
{"descripcion":"{ AGP-1103.S9 } SENSOR ULTRASONICO #1"},
{"descripcion":"{ AGP-01108.1 } MOTOR IMPULSOR NORTE LAVADORA DE JABAS LINCO"},
{"descripcion":"{ AGP-01108.2 } MOTOR IMPULSOR SUR LAVADORA DE JABAS LINCO"},
{"descripcion":"{ AGP-01108.3 } BOMBA CENTRO SUR LAVADORA DE JABAS LINCO"},
{"descripcion":"{ AGP-01108.4 } BOMBA SUR LAVADORA DE JABAS LINCO"},
{"descripcion":"{ AGP-01108.5 } BOMBA T3 ORIENTE LAVADORA DE JABAS LINCO"},
{"descripcion":"{ AGP-01108.6 } BOMBA CENTRO NORTE LAVADORA DE JABAS LINCO"},
{"descripcion":"{ AGP-01108.7 } BOMBA NORTE LAVADORA DE JABAS LINCO"},
{"descripcion":"{ AGP-01112.1 } MOTORREDUCTOR CINTA LAVADORA DE JABAS SEMIL"},
{"descripcion":"{ AGP-01112.2 } MOTORREDUCTOR AGITADOR LAVADORA DE JABAS SEMIL"},
{"descripcion":"{ AGP-01112.3 } MOTORREDUCTOR FILTROS ROTATORIOS LAVADORA DE JABAS SEMIL"},
{"descripcion":"{ AGP-01112.4 } BOMBA LADO NORTE LAVADORA DE JABAS SEMIL"},
{"descripcion":"{ AGP-01112.5 } BOMBA LADO SUR LAVADORA DE JABAS SEMIL"},
{"descripcion":"{ AGP-01120.1 } MOTORREDUCTOR N 1 LINEA AEREA FAENACION/DESPLUMADO"},
{"descripcion":"{ AGP-01120.2 } MOTORREDUCTOR N 2 LINEA AEREA FAENACION/DESPLUMADO"},
{"descripcion":"{ AGP-01120.3 } MOTORREDUCTOR N 3 LINEA AEREA FAENACION/DESPLUMADO"},
{"descripcion":"{ AGP-01120.4 } MOTORREDUCTOR N 4 LINEA AEREA FAENACION/DESPLUMADO"},
{"descripcion":"{ AGP-01120.5 } MOTORREDUCTOR N 5 LINEA AEREA FAENACION/DESPLUMADO"},
{"descripcion":"{ AGP-01120.6 } MOTORREDUCTOR N 6 LINEA AEREA FAENACION/DESPLUMADO"},
{"descripcion":"{ AGP-01120.HMI1 } HMI TABLERO PRINCIPAL LINEA AEREA FAENACION/DESPLUMADO SUB ESTACION"},
{"descripcion":"{ AGP-01120.HMI2 } HMI TABLERO CONTROL LINEA AEREA FAENACION/DESPLUMADO EN SALA"},
{"descripcion":"{ AGP-01120.PLC1 } PLC TABLERO PRINCIPAL LINEA AEREA FAENACION/DESPLUMADO"},
{"descripcion":"{ AGP-01120.S1 } SENSOR TENSOR DE LINEA"},
{"descripcion":"{ AGP-01120.S2 } SENSOR TACOMETRO"},
{"descripcion":"{ AGP-01120.S3 } SENSOR GUILLOTINA"},
{"descripcion":"{ AGP-10302.1 } MOTORREDUCTOR SEPARADOR DE PLUMAS"},
{"descripcion":"{ AGP-00101 } LINEA AEREA MATANZA DE PAVOS"},
{"descripcion":"{ AGP-00105 } BOMBA NEUMATICA ARO SANGRE PAVOS"},
{"descripcion":"{ AGP-00114 } ESTERILIZADOR SANGRADO DE PAVOS"},
{"descripcion":"{ AGP-10000 } EXTRACTOR NORTE SALA COLGADO PAVOS [N 3]"},
{"descripcion":"{ AGP-10001 } EXTRACTOR SUR SALA COLGADO PAVOS [N 4]"},
{"descripcion":"{ AGP-10230 } TABLEROS ELECTRICOS DE FUERZA Y CONTROL FAENA DE PAVOS"},
{"descripcion":"{ AGP-10000.1 } MOTOR EXTRACTOR NORTE SALA COLGADO PAVOS"},
{"descripcion":"{ AGP-10001.1 } MOTOR EXTRACTOR SUR SALA COLGADO PAVOS"},
{"descripcion":"{ AGP-00101.1 } MOTORREDUCTOR N 1 LINEA AEREA MATANZA DE PAVOS"},
{"descripcion":"{ AGP-00101.2 } MOTORREDUCTOR N 2 LINEA AEREA MATANZA DE PAVOS"},
{"descripcion":"{ AGP-00101.3 } MOTORREDUCTOR N 3 LINEA AEREA MATANZA DE PAVOS"},
{"descripcion":"{ AGP-00101.HMI1 } HMI TABLERO CONTROL LINEA AEREA MATANZA DE PAVOS"},
{"descripcion":"{ AGP-00101.PLC1 } PLC TABLERO PRINCIPAL LINEA AEREA MATANZA DE PAVOS"},
{"descripcion":"{ AGP-00101.S1 } SENSOR TENSOR"},
{"descripcion":"{ AGP-00101.S2 } SENSOR GUILLOTINA CONTADOR"},
{"descripcion":"{ AGP-09161 } SISTEMA DE BOMBEO (RED HUMEDA)"},
{"descripcion":"{ AGP-09162 } TABLEROS DE CONTROL SALA RED CONTRA INCENDIO"},
{"descripcion":"{ AGP-09163 } LINEA DE RED HUMEDA"},
{"descripcion":"{ AGP-09163.1 } BOMBA LINEA DE RED HUMEDA"},
{"descripcion":"{ AGP-09161.1 } BOMBA DIESEL SISTEMA DE BOMBEO"},
{"descripcion":"{ AGP-01121 } CONTADOR DE POLLOS"},
{"descripcion":"{ AGP-01135 } BOMBA NEUMATICA ARO N 1 NORTE"},
{"descripcion":"{ AGP-01136 } BOMBA NEUMATICA ARO N 2 SUR"},
{"descripcion":"{ AGP-01142 } ESTERILIZADORES RECEPCION POLLOS"},
{"descripcion":"{ AGP-10002 } EXTRACTOR ORIENTE RECEPCION DE POLLOS [N 2]"},
{"descripcion":"{ AGP-10003 } EXTRACTOR PONIENTE RECEPCION DE POLLOS [N 1]"},
{"descripcion":"{ AGP-01121.HMI1 } HMI TABLERO CONTROL CONTADOR DE POLLOS"},
{"descripcion":"{ AGP-01121.PLC1 } PLC TABLERO CONTROL CONTADOR DE POLLOS"},
{"descripcion":"{ AGP-01121.S1 } SENSOR ESTRELLA #1"},
{"descripcion":"{ AGP-01121.S2 } SENSOR BRAZO"},
{"descripcion":"{ AGP-10002.1 } MOTOR EXTRACTOR ORIENTE SALA SANGRE"},
{"descripcion":"{ AGP-10003.1 } MOTOR EXTRACTOR PONIENTE SALA SANGRE"},
{"descripcion":"{ AGP-00112 } SEPARADOR DE ETIQUETAS"},
{"descripcion":"{ AGP-00112.1 } MOTORREDUCTOR SEPARADOR DE ETIQUETAS"},
{"descripcion":"{ AGP-00107 } MOLEDOR DECOMISO THOR NORTE"},
{"descripcion":"{ AGP-00108 } MOLEDOR DECOMISO THOR SUR"},
{"descripcion":"{ AGP-00109 } ROSCA DECOMISO SUPERIOR E INFERIOR"},
{"descripcion":"{ AGP-00111 } SEPARADOR SOLIDOS/LIQUIDO NAHUELCO"},
{"descripcion":"{ AGP-01144 } BOMBA ALCANTARILLADO DE PLUMAS ORIENTE"},
{"descripcion":"{ AGP-01145 } BOMBA ALCANTARILLADO DE PLUMAS PONIENTE"},
{"descripcion":"{ AGP-08000 } CINTA ELEVADORA DE PAVOS (THOR)"},
{"descripcion":"{ AGP-01144.1 } MOTOR ORIENTE DE BOMBA ALCANTARILLADO DE PLUMAS"},
{"descripcion":"{ AGP-01145.1 } MOTOR PONIENTE DE BOMBA ALCANTARILLADO DE PLUMAS"},
{"descripcion":"{ AGP-08000.1 } MOTORREDUCTOR CINTA ELEVADORA DE PAVOS (THOR)"},
{"descripcion":"{ AGP-00107.1 } MOTOR NORTE MOLEDOR DECOMISO THOR"},
{"descripcion":"{ AGP-00108.1 } MOTOR SUR MOLEDOR DECOMISO THOR"},
{"descripcion":"{ AGP-00109.1 } MOTORREDUCTOR ROSCA DECOMISO SUPERIOR"},
{"descripcion":"{ AGP-00109.2 } MOTORREDUCTOR ROSCA DECOMISO INFERIOR"},
{"descripcion":"{ AGP-00111.1 } MOTORREDUCTOR SEPARADOR SOLIDOS/LIQUIDO NAHUELCO"},
{"descripcion":"{ AGP-00111.HMI1 } HMI TABLERO PRINCIPAL SISTEMA DE CONO"},
{"descripcion":"{ AGP-00111.PLC1 } PLC TABLERO PRINCIPAL SISTEMA DE CONO"},
{"descripcion":"{ AGP-09336 } AIRE AC SALA COMPUTACION N 1"},
{"descripcion":"{ AGP-09337 } AIRE AC SALA COMPUTACION N 2"},
{"descripcion":"{ AGP-09081 } TRANSFORMADOR N 5"},
{"descripcion":"{ AGP-09238 } TABLEROS ELECTRICOS SUB ESTACION N 5"},
{"descripcion":"{ AGP-10056 } IMPULSOR SUB ESTACION N 5 [N 51]"},
{"descripcion":"{ AGP-10056.1 } MOTOR IMPULSOR SUB ESTACION N 5"},
{"descripcion":"{ AGP-09077 } TRANSFORMADOR N 1"},
{"descripcion":"{ AGP-09078 } TRANSFORMADOR N 2"},
{"descripcion":"{ AGP-09079 } TRANSFORMADOR N 3"},
{"descripcion":"{ AGP-09080 } TRANSFORMADOR N 4"},
{"descripcion":"{ AGP-09077.1 } MOTOR VENTILADOR TRANSFORMADOR N 1"},
{"descripcion":"{ AGP-09078.1 } MOTOR VENTILADOR TRANSFORMADOR N 2"},
{"descripcion":"{ AGP-09080.1 } MOTOR VENTILADOR TRANSFORMADOR N 4"},
{"descripcion":"{ AGP-09082 } TRANSFORMADOR N 6"},
{"descripcion":"{ AGP-09132 } PLANTA DE TRATAMIENTO GRAL."},
{"descripcion":"{ AGP-10105 } MEDIDOR CAMARA DE CONTACTO"},
{"descripcion":"{ AGP-10110 } TABLERO DE FUERZA Y CONTROL PLANTA TRATAMIENTO DE AGUA"},
{"descripcion":"{ AGP-10111 } COMPRESOR DE AIRE"},
{"descripcion":"{ AGP-10112 } BOMBA HIDROPACK SISTEMA AROMATIZANTE"},
{"descripcion":"{ AGP-10113 } BOMBA ELEVACION N 3 ESTANQUE ECUALIZADOR"},
{"descripcion":"{ AGP-10114 } INDICADOR DE NIVEL CLORURO FÃ‰RRICO"},
{"descripcion":"{ AGP-10115 } AGITADOR DE POLIMERO DAF"},
{"descripcion":"{ AGP-10116 } SISTEMA DE PREPARACION DE POLÃMERO DAF"},
{"descripcion":"{ AGP-10117 } EQUIPO DE FLOTACION POR AIRE DISUELTO (DAF)"},
{"descripcion":"{ AGP-10118 } BOMBA EXTRACCION DE LODO A DAF N 2"},
{"descripcion":"{ AGP-10119 } BOMBA DOSIFICADORA #1 POLÃMERO DAF"},
{"descripcion":"{ AGP-10120 } BOMBA NEUMATICA TRASVASIJE PREPARACION POLÃMERO"},
{"descripcion":"{ AGP-10121 } TRANSMISOR DE FLUJO ALIMENTACION SEFT"},
{"descripcion":"{ AGP-10122 } BOMBA SATURACION DAF VOGT N 624 MRS"},
{"descripcion":"{ AGP-10123 } CENTRAL OLEOHIDRAULICA DAF"},
{"descripcion":"{ AGP-10124 } BOMBA DE CLORURO FERRICO N 2"},
{"descripcion":"{ AGP-10125 } BOMBA ELEVACION N 2-B ECUALIZADOR SAER"},
{"descripcion":"{ AGP-10126 } BOMBA SUMERGIBLE RECIRCULACION TQ ECUALIZADOR"},
{"descripcion":"{ AGP-10127 } BOMBA DOSIFICADORA #2 POLÃMERO DAF"},
{"descripcion":"{ AGP-10128 } AGITADOR SUMERGIBLE TQ ECUALIZADOR"},
{"descripcion":"{ AGP-10129 } BOMBA ELEVACION N 2-A ECUALIZADOR"},
{"descripcion":"{ AGP-10130 } BOMBA ELEVACION N 1 ECUALIZADOR"},
{"descripcion":"{ AGP-10131 } BOMBA DE CLORURO FERRICO N 1"},
{"descripcion":"{ AGP-10132 } BOMBA EXTRACCION DE LODO A DAF N 1"},
{"descripcion":"{ AGP-10133 } CONTROLADO DE PH DAF"},
{"descripcion":"{ AGP-10134 } BOMBA DOSIFICADORA POLÃMERO TQ ANOXICO"},
{"descripcion":"{ AGP-10135 } REDUCTOR OLEO-HIDRAULICO SKIMMER"},
{"descripcion":"{ AGP-10136 } AGITADOR DE POLIMERO MADURACION (SPP-101)"},
{"descripcion":"{ AGP-10137 } AGITADOR DE POLIMERO PREPARACION (SPP-101)"},
{"descripcion":"{ AGP-10138 } MOTOREDUCTOR TSF DESCARGA ARENA EQUIPO SEFT"},
{"descripcion":"{ AGP-10139 } INTERRUPTORES DE NIVEL (SPP-101)"},
{"descripcion":"{ AGP-10140 } TABLERO DE FUERZA Y CONTROL PRINCIPAL SALA SEFT"},
{"descripcion":"{ AGP-10141 } BOMBA RECIRCULACION N 2 LODO CENTRO"},
{"descripcion":"{ AGP-10142 } BOMBA RECIRCULACION INTERNA REACTOR N 1"},
{"descripcion":"{ AGP-10143 } BOMBA RECIRCULACION N 1 LODO ORIENTE"},
{"descripcion":"{ AGP-10144 } MOTORREDUCTOR BRAZO ESPESADOR DE LODO"},
{"descripcion":"{ AGP-10145 } BOMBA RECIRCULACION INTERNA REACTOR N 2"},
{"descripcion":"{ AGP-10146 } VENTILADOR N 1 SALA DE SOPLADORES REACTOR"},
{"descripcion":"{ AGP-10147 } VENTILADOR N 2 SALA DE SOPLADORES REACTOR"},
{"descripcion":"{ AGP-10148 } BOMBA DOSIFICADORA #1 DE CLORURO FERRICO A DAF"},
{"descripcion":"{ AGP-10149 } SOPLADOR 3 REACTOR DRESSER ROOTS 412 RAM"},
{"descripcion":"{ AGP-10150 } SOPLADOR 2 REACTOR DRESSER ROOTS 412 RAM"},
{"descripcion":"{ AGP-10151 } TANQUE SEDIMENTADOR"},
{"descripcion":"{ AGP-10152 } BOMBA CAVIDAD PROGRESIVA # 2 EXTRACCION DE LODO A DAF"},
{"descripcion":"{ AGP-10153 } MOTOREDUCTOR DOSIFICADOR POLOMERO (SPP-201)"},
{"descripcion":"{ AGP-10154 } AGITADOR SUMERGIBLE ESTANQUE ANOXICO FLYGT"},
{"descripcion":"{ AGP-10155 } SOPLADOR 1 REACTOR AERZEN GM 35S"},
{"descripcion":"{ AGP-10156 } TRANSMISOR DE FLUJO ENTRADA DAF"},
{"descripcion":"{ AGP-10157 } BOMBA CAVIDAD PROGRESIVA #1 EXTRACCION DE LODO A DAF"},
{"descripcion":"{ AGP-10158 } TRANSMISOR FLUJO PURGA LODO BIOLOGICO SEDIMENTADOR"},
{"descripcion":"{ AGP-10159 } BOMBA RECIRCULACION N 3 LODO PONIENTE"},
{"descripcion":"{ AGP-10160 } SOPLADOR 4 REACTOR"},
{"descripcion":"{ AGP-10161 } BOMBA DOSIFICADORA #2 POLÃMERO DESHIDRATADO"},
{"descripcion":"{ AGP-10162 } BOMBA DOSIFICADORA DE POLIMERO DESHIDRATADO NÂº 2"},
{"descripcion":"{ AGP-10163 } BOMBA DOSIFICADORA DE CLORO POZO N 4"},
{"descripcion":"{ AGP-10164 } CENTRIFUGA DE LODO N 2 ALFA LAVAL ALDEC 404"},
{"descripcion":"{ AGP-10165 } BOMBA LODO BIOLOGICO N 1"},
{"descripcion":"{ AGP-10166 } BOMBA LODO BIOLOGICO N 2"},
{"descripcion":"{ AGP-10167 } AGITADOR SUMERGIBLE ESTANQUE LODO FISICO-QUIMICO"},
{"descripcion":"{ AGP-10168 } BOMBA DE LODO FISICO-QUIMICO N 2"},
{"descripcion":"{ AGP-10169 } BOMBA DE LODO FISICO-QUIMICO N 1"},
{"descripcion":"{ AGP-10170 } TRANSMISOR DE FLUJO BOMBAS RECIRCULACION LODO"},
{"descripcion":"{ AGP-10171 } TABLERO FUERZA Y CONTROL DECANTER N 2"},
{"descripcion":"{ AGP-10172 } TABLERO FUERZA Y CONTROL DECANTER N 1"},
{"descripcion":"{ AGP-10173 } BOMBA DOSIFICADORA DE POLIMERO DESHIDRATADO NÂº 1"},
{"descripcion":"{ AGP-10174 } BOMBA CAMARA DE CONTACTO VOGT"},
{"descripcion":"{ AGP-10175 } BOMBA DOSIFICADORA DE CLORO POZO N 3"},
{"descripcion":"{ AGP-10176 } SISTEMA DE PREPARACION DE POLÃMERO DESHIDRATADO"},
{"descripcion":"{ AGP-10177 } TRANSMISOR DE NIVEL ANOXICO (LIT-102A)"},
{"descripcion":"{ AGP-10178 } CENTRÃFUGA DE LODO N 1"},
{"descripcion":"{ AGP-10179 } BOMBA DOSIFICADORA #1 POLÃMERO DESHIDRATADO"},
{"descripcion":"{ AGP-10180 } INTERRUPTOR DE NIVEL POLÃMERO PREPARADOR (SPP-301)"},
{"descripcion":"{ AGP-10181 } MOTOREDUCTOR DOSIFICADOR POLÃMERO (SPP-301)"},
{"descripcion":"{ AGP-10182 } AGITADOR DE POLIMERO MADURACION (SPP-301)"},
{"descripcion":"{ AGP-10183 } AGITADOR DE POLIMERO DOSIFICACION (SPP-301)"},
{"descripcion":"{ AGP-10184 } AGITADOR DE POLIMERO PREPARACION (SPP-301)"},
{"descripcion":"{ AGP-10185 } TABLERO DE FUERZA Y CONTROL SOPLADOR #1"},
{"descripcion":"{ AGP-10216 } BOMBA FOG ODORIZANTE ECUALIZADOR NUEVO (TC1958-19) [DE BAJA!]"},
{"descripcion":"{ AGP-10217 } BOMBA FOG ODORIZANTE ECUALIZADOR (TC0028-18) [DE BAJA!]"},
{"descripcion":"{ AGP-10218 } BOMBA FOG ODORIZANTE STANDBY (TC1055-16)"},
{"descripcion":"{ AGP-10300 } SOPLADOR DE AIRE KAESER REACTOR BIOLOGICO (PLANTA TRATAMIENTO)"},
{"descripcion":"{ AGP-10327 } SOPLADOR DE AIRE KAESER DB 236 (REPETIDO AGP-10300)"},
{"descripcion":"{ AGP-10364 } BOMBA FOG ODORIZANTE STANDBY (TC1625-21)"},
{"descripcion":"{ AGP-10605 } BOMBA FOG ODORIZANTE STANDBY (EC307051) [DE BAJA!]"},
{"descripcion":"{ AGP-10640 } COMPRESOR DE AIRE KAESER PREMIUM W (PTA RILES)"},
{"descripcion":"{ AGP-10685 } BOMBA FOG ODORIZANTE STANDBY (TC 1582-19)"},
{"descripcion":"{ AGP-10622 } BOMBA SUMERGIBLE RIL CRUDO #1 (P501)"},
{"descripcion":"{ AGP-10623 } BOMBA SUMERGIBLE RIL CRUDO #2 (P502)"},
{"descripcion":"{ AGP-10624 } BOMBA SUMERGIBLE RIL FILTRADO #1 (P521)"},
{"descripcion":"{ AGP-10624.PS1 } PARTIDOR SUAVE BOMBA SUMERGIBLE RIL FILTRADO #1 (P521)"},
{"descripcion":"{ AGP-10625 } BOMBA SUMERGIBLE RIL FILTRADO #2 (P522)"},
{"descripcion":"{ AGP-10625.PS1 } PARTIDOR SUAVE BOMBA SUMERGIBLE RIL FILTRADO #2 (P522)"},
{"descripcion":"{ AGP-10655 } AGITADOR ORIENTE GRUNDFOS ECUALIZADOR"},
{"descripcion":"{ AGP-10670 } AGITADOR FLYGT REACTOR BIOLOGICO"},
{"descripcion":"{ AGP-00500 } LINEA AEREA TROZADO N 1"},
{"descripcion":"{ AGP-00501 } CORTADOR DE COLA L1"},
{"descripcion":"{ AGP-00502 } ESTIRADOR DE ALA L1"},
{"descripcion":"{ AGP-00503 } CORTADOR PUNTILLA L1"},
{"descripcion":"{ AGP-00504 } CORTADOR DE ALA MEDIA L1"},
{"descripcion":"{ AGP-00505 } CORTADOR DE ALA TRUTRO L1"},
{"descripcion":"{ AGP-00506 } CORTADOR DE PECHUGA L1"},
{"descripcion":"{ AGP-00507 } CORTADOR PUNTA LAPIZ L1"},
{"descripcion":"{ AGP-00508 } PROCESADOR ALTO RINDE TRUTROS L1"},
{"descripcion":"{ AGP-00509 } PROCESADOR BAJO RINDE TRUTROS L1"},
{"descripcion":"{ AGP-00510 } CORTADOR TRUTRO CORTO/LARGO"},
{"descripcion":"{ AGP-00511 } LINEA AEREA TROZADO N 2"},
{"descripcion":"{ AGP-00512 } ESTIRADOR DE ALA L2"},
{"descripcion":"{ AGP-00513 } CORTADOR PUNTILLA L2"},
{"descripcion":"{ AGP-00514 } CORTADOR DE ALA MEDIA L2"},
{"descripcion":"{ AGP-00515 } CORTADOR DE ALA TRUTRO L2"},
{"descripcion":"{ AGP-00516 } CORTADOR PECHUGA L2"},
{"descripcion":"{ AGP-00517 } CORTADOR PUNTA LAPIZ L2"},
{"descripcion":"{ AGP-00519 } CORTADOR DE COLA L2"},
{"descripcion":"{ AGP-00520 } PROCESADOR ALTO RINDE TRUTROS L2"},
{"descripcion":"{ AGP-00521 } MOLINOS DE ALA POLLOS"},
{"descripcion":"{ AGP-00522 } MOLINO N 2 DE ALA POLLOS"},
{"descripcion":"{ AGP-00523 } CUCHILLOS CIRCULARES"},
{"descripcion":"{ AGP-00530 } LINEA AEREA TROZADO N 1 (NUEVA)"},
{"descripcion":"{ AGP-00531 } CORTADOR DE COLA L1 NUEVO"},
{"descripcion":"{ AGP-00532 } ESTIRADOR DE ALA L1 ESTATICO"},
{"descripcion":"{ AGP-00533 } CORTADOR DE MONTURA (TRUTRO 1/4) LINEA 1"},
{"descripcion":"{ AGP-00540 } CORTADOR TRUTRO CORTO/LARGO NUEVO L1"},
{"descripcion":"{ AGP-00541 } BOTADOR DE TRUTROS L1 NUEVO"},
{"descripcion":"{ AGP-00542 } CORTADOR DE MONTURA (TRUTRO 1/4) LINEA 2"},
{"descripcion":"{ AGP-00543 } CORTADOR DE ALA"},
{"descripcion":"{ AGP-00544 } ESTIRADOR DE ALA L2 ESTATICO"},
{"descripcion":"{ AGP-08053 } CINTA COLGADO L1"},
{"descripcion":"{ AGP-08054 } CINTA COLGADO L2"},
{"descripcion":"{ AGP-08055 } CINTA RECEPTORA TRUTRO L1"},
{"descripcion":"{ AGP-08056 } CINTA TRASPORTE TRUTRO L1 HACIA ELEVADORAS"},
{"descripcion":"{ AGP-08057 } CINTA ALA TRUTRO"},
{"descripcion":"{ AGP-08058 } CINTA RECEPTORA DE ALA PUNTILLA/ ALA MEDIA"},
{"descripcion":"{ AGP-08059 } CINTA RECEPTORA TRUTRO L2"},
{"descripcion":"{ AGP-08060 } CINTA ELEVADORA DE CARCAZA L1-L2"},
{"descripcion":"{ AGP-08061 } CINTA CARCAZA PROCESADOR BAJO RENDIMIENTO"},
{"descripcion":"{ AGP-08062 } CINTA CARCAZA PROCESADOR ALTO RENDIMIENTO"},
{"descripcion":"{ AGP-08063 } CINTA ELEVADORA TRUTROS L1"},
{"descripcion":"{ AGP-08064 } CINTA ELEVADORA TRUTROS L2"},
{"descripcion":"{ AGP-08065 } CINTA ELEVADORA PECHUGAS L1 NORTE"},
{"descripcion":"{ AGP-08066 } CINTA ELEVADORA PECHUGAS L2 SUR"},
{"descripcion":"{ AGP-08067 } CINTA AEREA PECHUGAS L1 Y L2"},
{"descripcion":"{ AGP-08224 } CINTA SANITIZADORA DE ALAS NORTE"},
{"descripcion":"{ AGP-08224.1 } MOTORREDUCTOR CINTA SANITIZADORA DE ALAS NORTE"},
{"descripcion":"{ AGP-08225 } CINTA SANITIZADORA DE ALAS SUR"},
{"descripcion":"{ AGP-08225.1 } MOTORREDUCTOR SANITIZADORA DE ALAS SUR"},
{"descripcion":"{ AGP-09395 } FANCOIL TROZADO DE POLLOS N 1"},
{"descripcion":"{ AGP-09396 } FANCOIL TROZADO DE POLLOS N 2"},
{"descripcion":"{ AGP-09397 } FANCOIL TROZADO DE POLLOS N 3"},
{"descripcion":"{ AGP-09398 } FANCOIL TROZADO DE POLLOS N 4"},
{"descripcion":"{ AGP-09399 } FANCOIL TROZADO DE POLLOS N 5"},
{"descripcion":"{ AGP-09400 } FANCOIL TROZADO DE POLLOS N 6"},
{"descripcion":"{ AGP-09433 } MEZCLADORES AGUA VAPOR TROZADO POLLOS"},
{"descripcion":"{ AGP-10075 } RADIOS TROZADO DE POLLOS"},
{"descripcion":"{ AGP-10089 } TRASPALETAS TROZADO DE POLLOS"},
{"descripcion":"{ AGP-10104 } BALANZAS TROZADO DE POLLOS"},
{"descripcion":"{ AGP-10233 } TABLEROS ELECTRICOS DE FUERZA Y CONTROL TROZADO AUTOMATICO LINEA 1"},
{"descripcion":"{ AGP-10234 } TABLEROS ELECTRICOS DE FUERZA Y CONTROL TROZADO AUTOMATICO LINEA 2"},
{"descripcion":"{ AGP-10401 } CORTADOR PUNTA LAPIZ L2 [NUEVO]"},
{"descripcion":"{ AGP-10401.1 } MOTOR NORTE CORTADOR PUNTA LAPIZ L2"},
{"descripcion":"{ AGP-10401.2 } MOTOR SUR CORTADOR PUNTA LAPIZ L2"},
{"descripcion":"{ AGP-10526 } TABLERO ELECTRICO DE CONTROL Y FUERZA SALA DE TROZADO AUTOMATICO"},
{"descripcion":"{ AGP-10563 } CINTA RECEPTORA ALA TRUTRO SUR L1 Y L2"},
{"descripcion":"{ AGP-10564 } BOTADOR NEUMATICO TROZADO AUTOMATICO"},
{"descripcion":"{ AGP-10576 } CORTADOR PUNTA LAPIZ L1[NUEVO]"},
{"descripcion":"{ AGP-10576.1 } MOTOR NORTE CORTADOR PUNTA LAPIZ L1"},
{"descripcion":"{ AGP-10576.2 } MOTOR SUR CORTADOR PUNTA LAPIZ L1"},
{"descripcion":"{ AGP-8068 } CINTA SANITIZADO ALA TRUTRO LADO NORTE"},
{"descripcion":"{ AGP-08067.1 } MOTORREDCUTOR CINTA AÃ‰REA PECHUGAS L1 Y L2"},
{"descripcion":"{ AGP-08057.1 } MOTORREDUCTOR CINTA ALA TRUTRO"},
{"descripcion":"{ AGP-08062.1 } MOTORREDUCTOR CARCAZA PROCESADOR ALTO RENDIMIENTO"},
{"descripcion":"{ AGP-08061.1 } MOTORREDUCTOR CARCAZA PROCESADOR BAJO RENDIMIENTO"},
{"descripcion":"{ AGP-08053.1 } MOTORREDUCTOR CINTA COLGADO L1"},
{"descripcion":"{ AGP-08053.HMI1 } HMI TABLERO CONTROL SISTEMA CINTAS TROZADO AUTOMATICO"},
{"descripcion":"{ AGP-08053.PLC1 } PLC TABLERO PRINCIPAL SISTEMA CINTAS TROZADO AUTOMATICO"},
{"descripcion":"{ AGP-08054.1 } MOTORREDUCTOR CINTA COLGADO L2"},
{"descripcion":"{ AGP-08060.1 } MOTORREDUCTOR CINTA ELEVADORA DE CARCAZA L1-L2"},
{"descripcion":"{ AGP-08065.1 } MOTORREDUCTOR CINTA ELEVADORA PECHUGAS L1"},
{"descripcion":"{ AGP-08066.1 } MOTORREDUCTOR CINTA ELEVADORA PECHUGAS L2"},
{"descripcion":"{ AGP-08063.1 } MOTORREDUCTOR CINTA ELEVADORA TRUTROS L1"},
{"descripcion":"{ AGP-08064.1 } MOTORREDUCTOR CINTA ELEVADORA TRUTROS L2"},
{"descripcion":"{ AGP-10563.1 } MOTORREDUCTOR CINTA RECEPTORA ALA TRUTRO SUR L1 Y L2"},
{"descripcion":"{ AGP-08058.1 } MOTORREDUCTOR CINTA RECEPTORA DE ALA PUNTILLA/ ALA MEDIA"},
{"descripcion":"{ AGP-08055.1 } MOTORREDUCTOR CINTA RECEPTORA TRUTRO L1"},
{"descripcion":"{ AGP-08059.1 } MOTORREDUCTOR CINTA RECEPTORA TRUTRO L2"},
{"descripcion":"{ AGP-08056.1 } MOTORREDUCTOR CINTA TRASPORTE TRUTRO L1 HACIA ELEVADORAS"},
{"descripcion":"{ AGP-00507.1 } MOTOR CORTADOR PUNTA LAPIZ L 1"},
{"descripcion":"{ AGP-00504.1 } MOTOR NORTE CORTADOR ALA MEDIA L 1"},
{"descripcion":"{ AGP-00504.2 } MOTOR SUR CORTADOR ALA MEDIA L 1"},
{"descripcion":"{ AGP-00514.1 } MOTOR NORTE CORTADOR ALA MEDIA L 2"},
{"descripcion":"{ AGP-00514.2 } MOTOR SUR CORTADOR ALA MEDIA L 2"},
{"descripcion":"{ AGP-00505.1 } MOTOR NORTE CORTADOR ALA TRUTRO L 1"},
{"descripcion":"{ AGP-00505.2 } MOTOR SUR CORTADOR ALA TRUTRO L 1"},
{"descripcion":"{ AGP-00515.1 } MOTOR NORTE CORTADOR ALA TRUTRO L 2"},
{"descripcion":"{ AGP-00515.2 } MOTOR SUR CORTADOR ALA TRUTRO L 2"},
{"descripcion":"{ AGP-00531.1 } MOTOR CORTADOR DE COLA L1 NUEVO"},
{"descripcion":"{ AGP-00501.1 } MOTOR CORTADOR DE COLAS L 1"},
{"descripcion":"{ AGP-00519.1 } MOTOR CORTADOR DE COLAS L 2"},
{"descripcion":"{ AGP-00533.1 } MOTOR CORTADOR DE MONTURAS (TRUTRO 1/4)"},
{"descripcion":"{ AGP-00542.1 } MOTOR CORTADOR DE MONTURA (TRUTRO 1/4) LINEA 2"},
{"descripcion":"{ AGP-00506.1 } MOTOR CORTADOR DE PECHUGAS L 1"},
{"descripcion":"{ AGP-00516.1 } MOTOR CORTADOR DE PECHUGAS L 2"},
{"descripcion":"{ AGP-00517.1 } MOTOR CORTADOR PUNTA LAPIZ L 2"},
{"descripcion":"{ AGP-00503.1 } MOTOR NORTE CORTADOR DE PUNTILLAS L 1"},
{"descripcion":"{ AGP-00503.2 } MOTOR SUR CORTADOR DE PUNTILLAS L 1"},
{"descripcion":"{ AGP-00513.1 } MOTOR NORTE CORTADOR DE PUNTILLAS L 2"},
{"descripcion":"{ AGP-00513.2 } MOTOR SUR CORTADOR DE PUNTILLAS L 2"},
{"descripcion":"{ AGP-00540.1 } MOTOR CORTADOR TRUTRO CORTO LARGO LADO PONIENTE"},
{"descripcion":"{ AGP-00540.2 } MOTOR CORTADOR TRUTRO CORTO LARGO LADO ORIENTE"},
{"descripcion":"{ AGP-00540.S1 } SENSOR SEGURIDAD PUERTA ORIENTE"},
{"descripcion":"{ AGP-00540.S2 } SENSOR SEGURIDAD PUERTA PONIENTE"},
{"descripcion":"{ AGP-00540.S3 } SENSOR TORSION"},
{"descripcion":"{ AGP-00510.1 } MOTOR CUCHILLO CORTADOR TRUTRO CORTO LARGO"},
{"descripcion":"{ AGP-00523.1 } MOTOR CUCHILLO CIRCULAR N 1"},
{"descripcion":"{ AGP-00512.1 } MOTORREDUCTOR NORTE ESTIRADOR DE ALAS L 2"},
{"descripcion":"{ AGP-00512.2 } MOTORREDUCTOR SUR ESTIRADOR DE ALAS L 2"},
{"descripcion":"{ AGP-00502.1 } MOTORREDUCTOR NORTE ESTIRADOR DE ALAS L 1"},
{"descripcion":"{ AGP-00502.2 } MOTORREDUCTOR SUR ESTIRADOR DE ALAS L 1"},
{"descripcion":"{ AGP-09395.1 } MOTOR VENTILADOR N 1 DE FANCOIL TROZADO DE POLLOS N 1"},
{"descripcion":"{ AGP-09396.1 } MOTOR VENTILADOR N 1 DE FANCOIL TROZADO DE POLLOS N 2"},
{"descripcion":"{ AGP-09397.1 } MOTOR VENTILADOR N 1 DE FANCOIL TROZADO DE POLLOS N 3"},
{"descripcion":"{ AGP-09398.1 } MOTOR VENTILADOR N 1 DE FANCOIL TROZADO DE POLLOS N 4"},
{"descripcion":"{ AGP-09399.1 } MOTOR VENTILADOR N 1 DE FANCOIL TROZADO DE POLLOS N 5"},
{"descripcion":"{ AGP-09400.1 } MOTOR VENTILADOR N 1 DE FANCOIL TROZADO DE POLLOS N 6"},
{"descripcion":"{ AGP-00530.1 } MOTORREDUCTOR N 1 LINEA AEREA TROZADO N 1 (NUEVA)"},
{"descripcion":"{ AGP-00530.2 } MOTORREDUCTOR N 1 LINEA AEREA TROZADO N 1 (NUEVA)"},
{"descripcion":"{ AGP-00530.HMI1 } HMI TABLERO PRINCIPAL LINEA AEREA TROZADO N 1 (NUEVA)"},
{"descripcion":"{ AGP-00530.PLC1 } PLC TABLERO PRINCIPAL LINEA AEREA TROZADO N 1 (NUEVA)"},
{"descripcion":"{ AGP-00530.S3 } SENSOR CONTADOR DE POLLOS"},
{"descripcion":"{ AGP-00500.1 } MOTORREDUCTOR N 1 LINEA TROZADOS DE POLLOS N 1"},
{"descripcion":"{ AGP-00500.2 } MOTORREDUCTOR N 2 LINEA TROZADOS DE POLLOS N 1"},
{"descripcion":"{ AGP-00500.S1 } SENSOR TENSOR DE LINEA"},
{"descripcion":"{ AGP-00500.S2 } SENSOR PROTECTOR DE GANCHO"},
{"descripcion":"{ AGP-00500.S4 } SENSOR TACOMETRO"},
{"descripcion":"{ AGP-00511.1 } MOTORREDUCTOR N 1 LINEA TROZADOS DE POLLOS N 2 (SOBRE CINTA COLGADO)"},
{"descripcion":"{ AGP-00511.2 } MOTORREDUCTOR N 2 LINEA TROZADOS DE POLLOS N 2 SUPERIOR COSTADO TENSOR"},
{"descripcion":"{ AGP-00511.HMI1 } HMI TABLERO PRINCIPAL LINEA AEREA TROZADO N 2"},
{"descripcion":"{ AGP-00511.PLC1 } PLC TABLERO PRINCIPAL LINEA AEREA TROZADO N 2"},
{"descripcion":"{ AGP-00511.S1 } SENSOR TENSOR DE LINEA"},
{"descripcion":"{ AGP-00511.S2 } SENSOR TACOMETRO"},
{"descripcion":"{ AGP-00511.S3 } SENSOR CONTADOR DE POLLOS"},
{"descripcion":"{ AGP-00511.S4 } SENSOR PROTECCION DE GANCHO"},
{"descripcion":"{ AGP-00511.S5 } SENSOR PROTECCION DE GANCHO"},
{"descripcion":"{ AGP-00511.S6 } SENSOR PROTECCION DE GANCHO"},
{"descripcion":"{ AGP-00521.1 } MOTORREDUTOR MOLINO N 1 DE ALA POLLOS"},
{"descripcion":"{ AGP-00521.S1 } SENSOR PROTECCION SUPERIOR"},
{"descripcion":"{ AGP-00521.S2 } SENSOR PROTECCION INFERIOR"},
{"descripcion":"{ AGP-00508.1 } MOTOTAMBOR N 1 PROCESARO ALTO RINDE L 1"},
{"descripcion":"{ AGP-00508.2 } MOTOTAMBOR N 2 PROCESARO ALTO RINDE L 1"},
{"descripcion":"{ AGP-00520.1 } MOTOTAMBOR N 1 PROCESARO ALTO RINDE L 2"},
{"descripcion":"{ AGP-00520.2 } MOTOTAMBOR N 2 PROCESARO ALTO RINDE L 2"},
{"descripcion":"{ AGP-00509.1 } MOTOTAMBOR N 1 PROCESARO BAJO RINDE L 1"},
{"descripcion":"{ AGP-00600 } LINEA AEREA TROZADO DE PAVOS"},
{"descripcion":"{ AGP-00601 } DESPIELADORA DE PAVOS TOWNSEND N 1"},
{"descripcion":"{ AGP-00602 } SIERRA DE HUINCHA N 1"},
{"descripcion":"{ AGP-00604 } SELLADORA AL VACIO TURBOVAC N 1"},
{"descripcion":"{ AGP-00606 } DETECTOR METALES LOCK PAVOS"},
{"descripcion":"{ AGP-00607 } CUBETEADORA FELIX"},
{"descripcion":"{ AGP-00608 } CUCHILLOS CIRCULAR N 1"},
{"descripcion":"{ AGP-00609 } INYECTORA METALQUIMIA"},
{"descripcion":"{ AGP-00610 } SUPERCHILL CFS NORTE [51]"},
{"descripcion":"{ AGP-00611 } ESTANQUE SALMUERA INTERMEDIO"},
{"descripcion":"{ AGP-00614 } ESTERILIZADORES DE CUCHILLOS"},
{"descripcion":"{ AGP-00615 } CINTA ALIMENTACION METALQUIMIA"},
{"descripcion":"{ AGP-00616 } VOLTEADOR DE BINS LINEA FRESCO"},
{"descripcion":"{ AGP-00617 } CUCHILLOS CIRCULAR N 2"},
{"descripcion":"{ AGP-00618 } CLIPEADORA TROZADO PAVOS"},
{"descripcion":"{ AGP-00619 } PREPARACION Y ALMACENAMIENTO SALMUERA"},
{"descripcion":"{ AGP-00620 } CLIPEADORA EMBOLSADO N 3"},
{"descripcion":"{ AGP-00621 } CLIPEADORA EMBOLSADO N 4"},
{"descripcion":"{ AGP-00622 } CLIPEADORA EMBOLSADO N 5"},
{"descripcion":"{ AGP-08072 } CINTA ELEVADORA DE CARCASA A BINS"},
{"descripcion":"{ AGP-08073 } CINTA ELEVADORA DE ALA (ALA PUNTILLA-ALA MEDIA)"},
{"descripcion":"{ AGP-08074 } CINTA TRASFERENCIA DE ALA (ALA PUNTILLA-ALA MEDIA)"},
{"descripcion":"{ AGP-08075 } CINTA ELEVADORA DE ALA TRUTRO"},
{"descripcion":"{ AGP-08076 } CINTA ELEVADORA MEDALLON"},
{"descripcion":"{ AGP-08077 } CINTA ELEVADORA TRUTROS"},
{"descripcion":"{ AGP-08078 } CINTA DESHUESADO CENTRAL DE TRUTRO"},
{"descripcion":"{ AGP-08079 } CINTA TRASPASO SUPERIOR TRUTROS L1 L2"},
{"descripcion":"{ AGP-08080 } CINTA INFERIOR TRASLADO DE HUESOS"},
{"descripcion":"{ AGP-08081 } CINTA ELEVADORA DE HUESO"},
{"descripcion":"{ AGP-08082 } CINTA ALIMENTACION DESPIELADORA TOWSEND"},
{"descripcion":"{ AGP-08083 } CINTA CENTRAL LIMPIEZA DE TRUTRO"},
{"descripcion":"{ AGP-08084 } CINTA SUPERIOR LIMPIEZA DE TRUTRO"},
{"descripcion":"{ AGP-08085 } CINTA ELEVADORA DE PECHUGAS"},
{"descripcion":"{ AGP-08086 } CINTA CENTRAL DE PECHUGAS"},
{"descripcion":"{ AGP-08087 } CINTA SUPERIOR DE PECHUGAS"},
{"descripcion":"{ AGP-08088 } CINTA ALIMENTACION DETECTOR DE METALES"},
{"descripcion":"{ AGP-08089 } CINTA DETECTOR DE METALES"},
{"descripcion":"{ AGP-08090 } CINTA DE PESADO DE PECHUGAS"},
{"descripcion":"{ AGP-08091 } CINTA VOLANTE HACIA TERMORETRACTIL"},
{"descripcion":"{ AGP-08092 } CINTA SALIDA DE TERMORETRACTIL"},
{"descripcion":"{ AGP-08093 } CINTA PESA DINAMICA"},
{"descripcion":"{ AGP-08094 } CINTA EMPALETIZADO"},
{"descripcion":"{ AGP-09425 } FANCOIL TROZADO DE PAVO NORTE"},
{"descripcion":"{ AGP-09426 } FANCOIL TROZADO DE PAVO SUR"},
{"descripcion":"{ AGP-09434 } MEZCLADORES AGUA VAPOR TROZADO PAVOS"},
{"descripcion":"{ AGP-10032 } EXTRACTOR TERMORETRACTIL TROZADO PAVOS [N 17]"},
{"descripcion":"{ AGP-10074 } RADIOS TROZADO DE PAVOS"},
{"descripcion":"{ AGP-10088 } TRASPALETAS TROZADO DE PAVOS"},
{"descripcion":"{ AGP-10103 } BALANZAS TROZADO DE PAVOS"},
{"descripcion":"{ AGP-10235 } TABLEROS ELECTRICOS DE FUERZA Y CONTROL TROZADO DE PAVOS 1"},
{"descripcion":"{ AGP-10236 } TABLEROS ELECTRICOS DE FUERZA Y CONTROL TROZADO DE PAVOS 2"},
{"descripcion":"{ AGP-10321 } CINTA DE PESAJE METALQUIMIA"},
{"descripcion":"{ AGP-10322 } CINTA SALIDA METALQUIMIA TRANSPORTADORA Y ELEVADORA"},
{"descripcion":"{ AGP-10323 } CINTA ENTRADA MAQUINA ENFAJADORA DE FILM TERMORETRAIBLE SMIPACK"},
{"descripcion":"{ AGP-10341 } CAPACHO DE PESAJE FOMACO ENCAJADO FRESCO"},
{"descripcion":"{ AGP-10509 } INYECTORA LINEA ENCAJADO FRESCO (FOMACO)"},
{"descripcion":"{ AGP-10512 } TABLEROS ELECTRICOS FUERZA Y CONTROL SALA TROZADO DE PAVOS"},
{"descripcion":"{ AGP-10518 } SUPERCHILL FOMACO LINEA FRESCO [E050990105152]"},
{"descripcion":"{ AGP-10574 } DETECTOR METALES CEIA LINEA FRESCO (SMIPACK NORTE)"},
{"descripcion":"{ AGP-10583 } SALIDA DE EMERGENCIA TROZADO DE PAVOS"},
{"descripcion":"{ AGP-10341.1 } CELDA DE PESAJE FOMACO ENCAJADO FRESCO(NORTE)"},
{"descripcion":"{ AGP-10341.2 } CELDA DE PESAJE FOMACO ENCAJADO FRESCO (SUR)"},
{"descripcion":"{ AGP-10341.3 } TABLERO CAPACHO DE PESAJE FOMACO ENCAJADO FRESCO"},
{"descripcion":"{ AGP-10341.4 } PLC PESAJE FOMACO ENCAJADO FRESCO"},
{"descripcion":"{ AGP-10341.5 } HMI PESAJE FOMACO ENCAJADO FRESCO"},
{"descripcion":"{ AGP-08082.1 } MOTORREDUCTOR CINTA ALIMENTACION DESPIELADORA TOWSEND"},
{"descripcion":"{ AGP-08088.1 } MOTORREDUCTOR CINTA ALIMENTACION DETECTOR DE METALES"},
{"descripcion":"{ AGP-0615.1 } MOTOREDUCTOR CINTA ALIMENTACION METALQUIMIA"},
{"descripcion":"{ AGP-08086.1 } MOTORREDUCTOR CINTA CENTRAL DE PECHUGAS"},
{"descripcion":"{ AGP-08083.1 } MOTORREDUCTOR CINTA CENTRAL LIMPIEZA DE TRUTRO"},
{"descripcion":"{ AGP-08090.1 } MOTORREDUCTOR CINTA DE PESADO DE PECHUGAS"},
{"descripcion":"{ AGP-10321.1 } MOTOREDUCTOR CINTA DE PASAJE METALQUIMIA"},
{"descripcion":"{ AGP-08078.1 } MOTORREDUCTOR CINTA DESHUESADO CENTRAL DE TRUTRO"},
{"descripcion":"{ AGP-08089.1 } MOTORREDUCTOR CINTA DETECTOR DE METALES"},
{"descripcion":"{ AGP-08076.1 } MOTORREDUCTOR CINTA ELEVADORA MEDALLON"},
{"descripcion":"{ AGP-08073.1 } MOTORREDUCTOR CINTA ELEVADORA DE ALA (ALA PUNTILLA-ALA MEDIA)"},
{"descripcion":"{ AGP-08075.1 } MOTORREDUCTOR CINTA ELEVADORA DE ALA TRUTRO"},
{"descripcion":"{ AGP-08072.1 } MOTORREDUCTOR CINTA ELEVADORA DE CARCASA A BINS"},
{"descripcion":"{ AGP-08081.1 } MOTORREDUCTOR CINTA ELEVADORA DE HUESO"},
{"descripcion":"{ AGP-08085.1 } MOTORREDUCTOR CINTA ELEVADORA DE PECHUGAS"},
{"descripcion":"{ AGP-08077.1 } MOTORREDUCTOR CINTA ELEVADORA TRUTROS"},
{"descripcion":"{ AGP-08094.1 } MOTORREDUCTOR CINTA EMPALETIZADO"},
{"descripcion":"{ AGP-10323.1 } MOTORREDUCTOR CINTA ENTRADA MAQUINA ENFAJADORA DE FILM TERMORRETRAIBLE SMIPACK"},
{"descripcion":"{ AGP-08080.1 } MOTORREDUCTOR CINTA INFERIOR TRASLADO DE HUESOS"},
{"descripcion":"{ AGP-08093.1 } MOTORREDUCTOR CINTA PESA DINAMICA"},
{"descripcion":"{ AGP-08092.1 } MOTORREDUCTOR CINTA SALIDA DE TERMORETRACTIL"},
{"descripcion":"{ AGP-10322.1 } MOTORREDUCTOR DE CINTA TRANSPORTADORA Y ELEVADORA"},
{"descripcion":"{ AGP-08087.1 } MOTORREDUCTOR CINTA SUPERIOR DE PECHUGAS"},
{"descripcion":"{ AGP-08087.HMI1 } HMI TABLERO CONTROL SISTEMA CINTAS TROZADO DE PAVOS 2"},
{"descripcion":"{ AGP-08087.PLC1 } PLC TABLERO PRINCIPAL SISTEMA CINTAS TROZADO DE PAVOS 1"},
{"descripcion":"{ AGP-08087.PLC2 } PLC TABLERO PRINCIPAL SISTEMA CINTAS TROZADO DE PAVOS 2"},
{"descripcion":"{ AGP-08084.1 } MOTORREDUCTOR CINTA SUPERIOR LIMPIEZA DE TRUTRO"},
{"descripcion":"{ AGP-08074.1 } MOTORREDUCTOR CINTA TRASFERENCIA DE ALA (ALA PUNTILLA-ALA MEDIA)"},
{"descripcion":"{ AGP-08079.1 } MOTORREDUCTOR CINTA TRASPASO SUPERIOR TRUTROS L1 L2"},
{"descripcion":"{ AGP-08091.1 } MOTORREDUCTOR CINTA VOLANTE HACIA TERMORETRACTIL"},
{"descripcion":"{ AGP-00607.1 } MOTOR CETRAL HIDRAULICA CUBETEADORA FELIX"},
{"descripcion":"{ AGP-00607.S1 } SENSOR MAGNETICO SUPERIOR"},
{"descripcion":"{ AGP-00607.S2 } SENSOR MAGNETICO INFERIOR"},
{"descripcion":"{ AGP-00608.1 } MOTOR CUCHILLOS CIRCULAR N 1"},
{"descripcion":"{ AGP-00617.1 } MOTOR CUCHILLOS CIRCULAR N 2"},
{"descripcion":"{ AGP-00601.S1 } SENSOR PROTECCION"},
{"descripcion":"{ AGP-00611.2 } MOTOR AGITADOR ESTANQUE SALMUERA METALQUIMIA"},
{"descripcion":"{ AGP-00611.S1 } SENSOR NIVEL"},
{"descripcion":"{ AGP-611.1 } BOMBA DE TRASLADO DE SALMUERA A METALQUIMIA"},
{"descripcion":"{ AGP-10032.1 } MOTOR EXTRACTOR EMBOLSADO DE PAVOS"},
{"descripcion":"{ AGP-09425.1 } MOTOR VENTILADOR N 1 FANCOIL TROZADO DE PAVO NORTE"},
{"descripcion":"{ AGP-09425.2 } MOTOR VENTILADOR N 2 FANCOIL TROZADO DE PAVO NORTE"},
{"descripcion":"{ AGP-09426.1 } MOTOR VENTILADOR N 1 FANCOIL TROZADO DE PAVO SUR"},
{"descripcion":"{ AGP-09426.2 } MOTOR VENTILADOR N 2 FANCOIL TROZADO DE PAVO SUR"},
{"descripcion":"{ AGP-10509.1 } MOTOR FILTRO LINEA INYECTORA LINEA ENCAJADO FRESCO (FOMACO)"},
{"descripcion":"{ AGP-10509.6 } BOMBA INYECTORA LINEA ENCAJADO FRESCO (FOMACO)"},
{"descripcion":"{ AGP-10614 } ZARANDA SALIDA INYECTORA FOMACO FRESCO"},
{"descripcion":"{ AGP-10614.1 } MOTORREDUCTOR ZARANDA SALIDA INYECTORA FOMACO FRESCO"},
{"descripcion":"{ AGP-00609.1 } MOTORREDUCTOR CINTA INYECTORA METALQUIMIA"},
{"descripcion":"{ AGP-00609.2 } MOTORREDUCTOR CABEZAL INYECTORA METALQUIMIA"},
{"descripcion":"{ AGP-00609.3 } BOMBA ESTANQUE SALMUERA INYECTORA METALQUIMIA"},
{"descripcion":"{ AGP-00609.4 } MOTORREDUCTOR FILTRO ROTATORIO INYECTORA METALQUIMIA"},
{"descripcion":"{ AGP-00609.HMI1 } HMI TABLERO PRINCIPAL METALQUIMIA"},
{"descripcion":"{ AGP-00609.PLC1 } PLC TABLERO PRINCIPAL METALQUIMIA"},
{"descripcion":"{ AGP-00609.S1 } SENSOR SEGURIDAD PUERTA PONIENTE"},
{"descripcion":"{ AGP-00609.S2 } SENSOR SEGURIDAD PUERTA ORIENTE"},
{"descripcion":"{ AGP-00609.S3 } SENSOR SEGURIDAD PUERTA NORTE"},
{"descripcion":"{ AGP-00609.S4 } SENSOR SEGURIDAD PUERTA SUR"},
{"descripcion":"{ AGP-00609.S5 } SENSOR DE NIVEL"},
{"descripcion":"{ AGP-00609.S6 } SENSOR DE NIVEL"},
{"descripcion":"{ AGP-00609.S7 } SENSOR DE CABEZAL"},
{"descripcion":"{ AGP-00609.S8 } SENSOR ENCODER"},
{"descripcion":"{ AGP-00600.1 } MOTORREDUCTOR N 1 LINEA AEREA TROZADO DE PAVOS"},
{"descripcion":"{ AGP-00600.2 } MOTORREDUCTOR N 2 LINEA AEREA TROZADO DE PAVOS"},
{"descripcion":"{ AGP-00600.S1 } SENSOR TENSOR DE LINEA"},
{"descripcion":"{ AGP-00619.1 } BOMBA PREPARACION Y ALMACENAMIENTO SALMUERA A METALQUIMIA"},
{"descripcion":"{ AGP-00604.1 } MOTOR SELLADORA AL VACIO TURBOVAC N 1"},
{"descripcion":"{ AGP-00602.1 } MOTOR SIERRA DE HUINCHA N 1"},
{"descripcion":"{ AGP-00610.1 } BOMBA GLICOL SUPERCHILL METALQUIMIA"},
{"descripcion":"{ AGP-00610.2 } BOMBA SALMUERA SUPERCHILL METALQUIMIA"},
{"descripcion":"{ AGP-0616.1 } MOTOR CENTRAL HIDRAHULICA VOLTEADOR DE BINS METALQUIMIA"},
{"descripcion":"{ AGP-00603 } LINEA DE CONOS"},
{"descripcion":"{ AGP-08068 } CINTA ALIMENTACION A LINEA DE CONO 1 Y 2"},
{"descripcion":"{ AGP-08069 } CINTA PECHUGAS ENTRE AMBAS LÃNEA DE CONO"},
{"descripcion":"{ AGP-08070 } CINTA CARCASA ENTRE AMBAS LINEA DE CONO TELA"},
{"descripcion":"{ AGP-08071 } CINTA DE TRASLADO CARCAZA (ORIENTE)"},
{"descripcion":"{ AGP-08068.1 } MOTORREDUCTOR CINTA ALIMENTACION A LÃNEA DE CONO 1 Y 2"},
{"descripcion":"{ AGP-08070.1 } MOTORREDUCTOR CINTA CARCASA ENTRE AMBAS LÃNEA DE CONO TELA"},
{"descripcion":"{ AGP-08071.1 } MOTORREDUCTOR CINTA DE TRASLADO CARCASA (ORIENTE)"},
{"descripcion":"{ AGP-08069.1 } MOTORREDUCTOR CINTA PECHUGAS ENTRE AMBAS LÃNEA DE CONO"},
{"descripcion":"{ AGP-00603.1 } MOTORREDUCTOR ORIENTE LINEA DE CONOS"},
{"descripcion":"{ AGP-00603.2 } MOTORREDUCTOR PONIENTE LINEA DE CONOS"},
{"descripcion":"{ AGP-05003 } VOLTEADOR DE BINS TRUTROS NORTE"},
{"descripcion":"{ AGP-05005 } ZARANDA ENTRADA INYECTORA CFS 650 NORTE"},
{"descripcion":"{ AGP-05006 } INYECTORA DE TRUTROS CFS 650 NORTE"},
{"descripcion":"{ AGP-05007 } SUPERCHILL IQF1 (SECUNDARIO) [55]"},
{"descripcion":"{ AGP-05008 } CHILLER DE TRUTROS NORTE"},
{"descripcion":"{ AGP-05009 } ZARANDA SALIDA CHILLER TRUTRO NORTE"},
{"descripcion":"{ AGP-05011 } MULTICABEZAL ISHIDA N 1 PONIENTE"},
{"descripcion":"{ AGP-05013 } VOLTEADOR DE BINS TRUTROS SUR"},
{"descripcion":"{ AGP-05015 } ZARANDA ENTRADA INYECTORA FOMACO SUR"},
{"descripcion":"{ AGP-05018 } CHILLER DE TRUTROS SUR"},
{"descripcion":"{ AGP-05019 } ZARANDA SALIDA CHILLER TRUTRO SUR"},
{"descripcion":"{ AGP-05021 } MULTICABEZAL ISHIDA N 2 ORIENTE"},
{"descripcion":"{ AGP-05022 } CINTA SALIDA CHILLER TRUTROS SUR (NUEVA)"},
{"descripcion":"{ AGP-05023 } LAVADOR DE CINTAS"},
{"descripcion":"{ AGP-05024 } CINTA RECEPTORA ALIMENTACION HOPPER"},
{"descripcion":"{ AGP-05025 } CINTA SANITIZADO SUR"},
{"descripcion":"{ AGP-05026 } CINTA SANITIZADO NORTE"},
{"descripcion":"{ AGP-05026.1 } MOTORREDUCTOR CINTA SANITIZADO NORTE"},
{"descripcion":"{ AGP-05027 } CINTA BUFFER SUR"},
{"descripcion":"{ AGP-05028 } CINTA TRASPASO SALIDA BUFFER"},
{"descripcion":"{ AGP-05029 } CINTA SANITIZADO NORTE SALIDA INYECTORA"},
{"descripcion":"{ AGP-05030 } TABLERO CONTROL PRINCIPAL SALA TRUTROS"},
{"descripcion":"{ AGP-08149 } CINTA AEREA TRUTROS L1 Y L2"},
{"descripcion":"{ AGP-08150 } CINTA ALIMENTACION BUFFER L1"},
{"descripcion":"{ AGP-08151 } CINTA HOPPER NORTE HORIZONTAL Y ELEVADORA"},
{"descripcion":"{ AGP-08152 } CINTA ELEVADORA SALIDA CHILLER L1"},
{"descripcion":"{ AGP-08153 } CINTA BUFFER ISHIDA L1 (NORTE)"},
{"descripcion":"{ AGP-08154 } CINTA ELEVADORA DE TRUTRO ALIM. CABEZAL ISHIDA L1"},
{"descripcion":"{ AGP-08155 } CINTA BAJO CABEZAL TRUTRO 10 KG"},
{"descripcion":"{ AGP-08156 } CINTA ELEVADORA TRUTROS 10 KG L1"},
{"descripcion":"{ AGP-08157 } CINTA DESCARGA 10 KG AREA L1"},
{"descripcion":"{ AGP-08158 } CINTA TRASPASO CAJAS VACIAS 10 KG"},
{"descripcion":"{ AGP-08159 } CINTA TRANSPORTE DE CAJAS CIERRE NYLON MANUAL ROLLER"},
{"descripcion":"{ AGP-08160 } CINTA ALIMENTACION POLY-PACK"},
{"descripcion":"{ AGP-08161 } CINTA CORTA REPORTE DE CAJAS"},
{"descripcion":"{ AGP-08162 } CINTA CURVA ANTES DETECTOR POLYPACK"},
{"descripcion":"{ AGP-08163 } CINTA DETECTOR DE METALES"},
{"descripcion":"{ AGP-08164 } CINTA PALETIZADO"},
{"descripcion":"{ AGP-08165 } CINTA ALIMENTACION BUFFER L2"},
{"descripcion":"{ AGP-08166 } CINTA HOPPER SUR HORIZONTAL Y ELEVADORA"},
{"descripcion":"{ AGP-08167 } CINTA ELEVADORA SALIDA CHILLER L2"},
{"descripcion":"{ AGP-08168 } CINTA BUFFER ISHIDA L2 SUR"},
{"descripcion":"{ AGP-08169 } CINTA ELEVADORA DE TRUTRO ALIM. CABEZAL ISHIDA L2"},
{"descripcion":"{ AGP-08170 } CINTA ELEVADORA TRUTROS 10 KG L2"},
{"descripcion":"{ AGP-08171 } CINTA DESCARGA 10 KG AREA L2"},
{"descripcion":"{ AGP-08213.S1 } SENSOR PRESENCIA DE CAJA EN DESCARGA L1"},
{"descripcion":"{ AGP-08213.S2 } SENSOR PRESENCIA DE CAJA SALIDA DE L1"},
{"descripcion":"{ AGP-08223.S1 } SENSOR PRESENCIA DE CAJA EN DESCARGA"},
{"descripcion":"{ AGP-08223.S2 } SENSOR PRESENCIA DE CAJA SALIDA DE L2"},
{"descripcion":"{ AGP-09393 } FANCOIL ISHIDA PONIENTE"},
{"descripcion":"{ AGP-09394 } FANCOIL ISHIDA ORIENTE"},
{"descripcion":"{ AGP-09431 } MEZCLADORES AGUA VAPOR LINEA TRUTROS N 1"},
{"descripcion":"{ AGP-09432 } MEZCLADORES AGUA VAPOR LINEA TRUTROS N 2"},
{"descripcion":"{ AGP-10069 } RADIOS TRUTROS DE POLLOS"},
{"descripcion":"{ AGP-10083 } TRASPALETAS TRUTROS DE POLLOS"},
{"descripcion":"{ AGP-10099 } BALANZAS TRUTROS DE POLLOS"},
{"descripcion":"{ AGP-10255 } CINTA CAJAS VACIAS PONIENTE"},
{"descripcion":"{ AGP-10318 } CABEZAL DE INYECCION A"},
{"descripcion":"{ AGP-10319 } CABEZAL DE INYECCION B"},
{"descripcion":"{ AGP-10320 } CINTA RECHAZO DECTOR DE METALES TRUTROS"},
{"descripcion":"{ AGP-10326 } CABEZAL DE INYECCION C"},
{"descripcion":"{ AGP-10368 } CINTA CAJAS VACIAS ORIENTE"},
{"descripcion":"{ AGP-10508 } INYECTORA DE TRUTROS SUR (FOMACO)"},
{"descripcion":"{ AGP-10513 } TABLEROS ELECTRICOS FUERZA Y CONTROL SALA TRUTROS"},
{"descripcion":"{ AGP-10616 } SUPERCHILL FOMACO FRESO (SECUNDARIO) [E050990105164]"},
{"descripcion":"{ AGP-10671 } CABEZAL DE INYECCION D"},
{"descripcion":"{ AGP-05008.1 } MOTORREDUCTOR CHILLER DE TRUTROS NORTE"},
{"descripcion":"{ AGP-05018.1 } MOTORREDUCTOR CHILLER DE TRUTROS SUR"},
{"descripcion":"{ AGP-05018.PLC1 } PLC TABLERO PRINCIPAL SISTEMA PERACETICO CHILLER DE TRUTROS"},
{"descripcion":"{ AGP-08149.1 } MOTORREDUCTOR CINTA AEREA TRUTROS L1 Y L2"},
{"descripcion":"{ AGP-08150.1 } MOTORREDUCTOR CINTA ALIMENTACION BUFFER L1"},
{"descripcion":"{ AGP-08165.1 } MOTORREDUCTOR CINTA ALIMENTACION BUFFER L2"},
{"descripcion":"{ AGP-08160.1 } MOTORREDUCTOR CINTA ALIMENTACION POLY-PACK"},
{"descripcion":"{ AGP-08155.1 } MOTORREDUCTOR CINTA BAJO CABEZAL TRUTRO 10 KG"},
{"descripcion":"{ AGP-08155.HMI1 } HMI TABLERO PRINCIPAL SISTEMA DE CINTA BAJO CABEZALES"},
{"descripcion":"{ AGP-08155.PLC1 } PLC TABLERO PRINCIPAL SISTEMA DE CINTA BAJO CABEZALES"},
{"descripcion":"{ AGP-08155.S1 } SENSOR TACOMETRO CINTA BAJO CABEZALES"},
{"descripcion":"{ AGP-08153.1 } MOTORREDUCTOR CINTA BUFFER ISHIDA L1"},
{"descripcion":"{ AGP-08168.1 } MOTORREDUCTOR CINTA BUFFER ISHIDA L2 SUR"},
{"descripcion":"{ AGP-05027.1 } MOTORREDUCTOR CINTA BUFFER SUR"},
{"descripcion":"{ AGP-10255.1 } MOTORREDUCTOR PONIENTE CINTA CAJAS VACIAS"},
{"descripcion":"{ AGP-10255.S1 } SENSOR PRESENCIA CAJAS VACIAS LADO PONIENTE"},
{"descripcion":"{ AGP-10255.S2 } SENSOR DESCARGA EN CAJAS LADO PONIENTE"},
{"descripcion":"{ AGP-08161.1 } MOTORREDUCTOR CINTA CORTA REPORTE DE CAJAS"},
{"descripcion":"{ AGP-08162.1 } MOTORREDUCTOR CINTA CURVA SALIDA CINTA CORTA REPORTE DE CAJAS"},
{"descripcion":"{ AGP-08157.1 } MOTORREDUCTOR CINTA DESCARGA 10 KG AREA L1"},
{"descripcion":"{ AGP-08157.S1 } SENSOR TACOMETRO CINTA DESCARGA 10KG AEREA L1"},
{"descripcion":"{ AGP-08171.1 } MOTORREDUCTOR CINTA DESCARGA 10 KG AREA L2"},
{"descripcion":"{ AGP-08171.S1 } SENSOR TACOMETRO CINTA DESCARGA 10KG AEREA L2"},
{"descripcion":"{ AGP-08163.1 } MOTORREDUCTOR CINTA DETECTOR DE METALES"},
{"descripcion":"{ AGP-08154.1 } MOTORREDUCTOR CINTA ELEVADORA DE TRUTRO ALIM. CABEZAL ISHIDA L1"},
{"descripcion":"{ AGP-08169.1 } MOTORREDUCTOR CINTA ELEVADORA DE TRUTRO ALIM. CABEZAL ISHIDA L2"},
{"descripcion":"{ AGP-08152.1 } MOTORREDUCTOR CINTA ELEVADORA SALIDA CHILLER L1"},
{"descripcion":"{ AGP-08167.1 } MOTORREDUCTOR CINTA ELEVADORA SALIDA CHILLER L2"},
{"descripcion":"{ AGP-08156.1 } MOTORREDUCTOR CINTA ELEVADORA TRUTROS 10 KG L1"},
{"descripcion":"{ AGP-08156.S1 } SENSOR TACOMETRO CINTA ELEVADORA TRUTROS 10KG L1"},
{"descripcion":"{ AGP-08156.S2 } SENSOR PRESENCIA PALETA CINTA ELEVADORA TRUTROS 10KG L1"},
{"descripcion":"{ AGP-08170.1 } MOTORREDUCTOR CINTA ELEVADORA TRUTROS 10 KG L2"},
{"descripcion":"{ AGP-08170.S1 } SENSOR TACOMETRO CINTA ELEVADORA TRUTROS 10KG L2"},
{"descripcion":"{ AGP-08170.S2 } SENSOR PRESENCIA PALETA CINTA ELEVADORA TRUTJROS 10KG L2"},
{"descripcion":"{ AGP-08151.1 } MOTORREDUCTOR CINTA HOPPER NORTE ELEVADORA"},
{"descripcion":"{ AGP-08151.2 } MOTORREDUCTOR CINTA HOPPER NORTE HORIZONTAL"},
{"descripcion":"{ AGP-08151.S1 } SENSOR NIVEL PRODUCTO HOPPER NORTE"},
{"descripcion":"{ AGP-08166.1 } MOTORREDUCTOR CINTA HOPPER SUR ELEVADORA"},
{"descripcion":"{ AGP-08166.2 } MOTORREDUCTOR CINTA HOPPER SUR HORIZONTAL"},
{"descripcion":"{ AGP-08166.S1 } SENSOR NIVEL PRODUCTO HOPPER SUR"},
{"descripcion":"{ AGP-08164.1 } MOTORREDUCTOR CINTA PALETIZADO"},
{"descripcion":"{ AGP-05024.1 } MOTORREDUCTOR CINTA RECEPTORA ALIMENTACION HOPPER"},
{"descripcion":"{ AGP-05022.1 } MOTORREDUCTOR CINTA SALIDA CHILLER TRUTROS SUR"},
{"descripcion":"{ AGP-05029.1 } MOTORREDUCTOR CINTA SANITIZADO NORTE SALIDA INYECTORA"},
{"descripcion":"{ AGP-05025.1 } MOTORREDUCTOR CINTA SANITIZADO SUR"},
{"descripcion":"{ AGP-08159.1 } MOTORREDUCTOR CINTA TRANSPORTE DE CAJAS CIERRE NYLON MANUAL"},
{"descripcion":"{ AGP-08159.HMI1 } HMITABLERO PRINCIPAL SISTEMA DE CINTAS DESCARGA 10 KG"},
{"descripcion":"{ AGP-08159.PLC1 } PLC TABLERO PRINCIPAL SISTEMA DE CINTAS DESCARGA 10 KG"},
{"descripcion":"{ AGP-08159.S1 } SENSOR PRESENCIA DE CAJAS LADO PONIENTE CINTA TRANSPORTE DE CAJAS CIERRE NYLON MANUAL"},
{"descripcion":"{ AGP-08159.S2 } SENSOR PRESENCIA DE CAJAS LADO ORIENTE CINTA TRANSPORTE DE CAJAS CIERRE NYLON MANUAL"},
{"descripcion":"{ AGP-08158.1 } MOTORREDUCTOR CINTA TRASPASO CAJAS VACÃAS 10 KG"},
{"descripcion":"{ AGP-05028.1 } MOTORREDUCTOR CINTA TRASPASO SALIDA BUFFER"},
{"descripcion":"{ AGP-09394.1 } MOTOR VENTILADOR N 1 FANCOIL ISHIDA ORIENTE"},
{"descripcion":"{ AGP-09394.2 } MOTOR VENTILADOR N 2 FANCOIL ISHIDA ORIENTE"},
{"descripcion":"{ AGP-09394.3 } MOTOR VENTILADOR N 3 FANCOIL ISHIDA ORIENTE"},
{"descripcion":"{ AGP-09393.1 } MOTOR VENTILADOR N 1 FANCOIL ISHIDA PONIENTE"},
{"descripcion":"{ AGP-09393.2 } MOTOR VENTILADOR N 2 FANCOIL ISHIDA PONIENTE"},
{"descripcion":"{ AGP-09393.3 } MOTOR VENTILADOR N 3 FANCOIL ISHIDA PONIENTE"},
{"descripcion":"{ AGP-05006.1 } MOTORREDUCTOR CINTA INYECTORA CFS 650 NORTE"},
{"descripcion":"{ AGP-05006.14 } TRANSDUCTOR DE PRESION"},
{"descripcion":"{ AGP-05006.2 } MOTORREDUCTOR CABEZAL INYECTORA CFS 650 NORTE"},
{"descripcion":"{ AGP-05006.3 } MOTORREDUCTOR FILTRO ROTATORIO INYECTORA CFS 650 NORTE"},
{"descripcion":"{ AGP-05006.4 } BOMBA SALMUERA INYECTORA CFS 650 NORTE"},
{"descripcion":"{ AGP-05006.HMI1 } HMI TABLERO PRINCIPAL INYECTORA CFS 650 TRUTROS NORTE"},
{"descripcion":"{ AGP-05006.PLC1 } PLC TABLERO PRINCIPAL INYECTORA CFS 650 TRUTROS NORTE"},
{"descripcion":"{ AGP-05006.S1 } SENSOR PUERTA #1"},
{"descripcion":"{ AGP-05006.S10 } SENSOR RASPADOR"},
{"descripcion":"{ AGP-05006.S11 } SENSOR NIVEL NORTE"},
{"descripcion":"{ AGP-05006.S12 } SENSOR NIVEL SUR"},
{"descripcion":"{ AGP-05006.S13 } SENSOR NIVEL SEGURIDAD"},
{"descripcion":"{ AGP-05006.S2 } SENSOR PUERTA #2"},
{"descripcion":"{ AGP-05006.S3 } SENSOR PUERTA #3"},
{"descripcion":"{ AGP-05006.S4 } SENSOR PUERTA #4"},
{"descripcion":"{ AGP-05006.S5 } SENSOR CINTA"},
{"descripcion":"{ AGP-05006.S6 } SENSOR UP"},
{"descripcion":"{ AGP-05006.S7 } SENSOR DOWN"},
{"descripcion":"{ AGP-05006.S8 } SENSOR AMORTIGUADOR"},
{"descripcion":"{ AGP-05006.S9 } SENSOR CUENTA CINTA"},
{"descripcion":"{ AGP-10508.6 } BOMBA INYECTORA DE TRUTROS SUR (FOMACO)"},
{"descripcion":"{ AGP-05023.1 } BOMBA LAVADOR DE CINTAS"},
{"descripcion":"{ AGP-05011.HMI1 } HMI TABLERO CONTROL CABEZAL DE TRUTROS PONIENTE"},
{"descripcion":"{ AGP-05011.PLC1 } PLC TABLERO PRINCIPAL CABEZAL DE TRUTROS PONIENTE"},
{"descripcion":"{ AGP-05021.HMI1 } HMI TABLERO CONTROL CABEZAL DE TRUTROS ORIENTE"},
{"descripcion":"{ AGP-05021.PLC1 } PLC TABLERO PRINCIPAL CABEZAL DE TRUTROS ORIENTE"},
{"descripcion":"{ AGP-05007.1 } BOMBA GLICOL SUPER CHILL NORTE"},
{"descripcion":"{ AGP-05007.2 } BOMBA SALMUERA SUPER CHILL NORTE"},
{"descripcion":"{ AGP-05003.1 } MOTOR CENTRAL HIDRAULICA VOLTEADOR DE BINS LINEA DE TRUTROS NORTE"},
{"descripcion":"{ AGP-05013.1 } MOTOR CENTRAL HIDRAULICA VOLTEADOR DE BINS LINEA DE TRUTROS SUR"},
{"descripcion":"{ AGP-05005.1 } MOTOR NORTE ZARANDA ENTRADA INYECTORA CFS 650 NORTE"},
{"descripcion":"{ AGP-05005.2 } MOTOR SUR ZARANDA ENTRADA INYECTORA CFS 650 NORTE"},
{"descripcion":"{ AGP-05015.1 } MOTOR NORTE ZARANDA ENTRADA FOMACO SUR"},
{"descripcion":"{ AGP-05015.2 } MOTOR SUR ZARANDA ENTRADA FOMACO SUR"},
{"descripcion":"{ AGP-05009.1 } MOTOR NORTE ZARANDA SALIDA CHILLER TRUTRO NORTE"},
{"descripcion":"{ AGP-05009.2 } MOTOR SUR ZARANDA SALIDA CHILLER TRUTRO NORTE"},
{"descripcion":"{ AGP-05019.1 } MOTOR NORTE ZARANDA SALIDA CHILLER TRUTRO SUR"},
{"descripcion":"{ AGP-05019.2 } MOTOR SUR ZARANDA SALIDA CHILLER TRUTRO SUR"},
{"descripcion":"{ AGP-04000 } MASAJEADOR LUTETIA T400 CHICO"},
{"descripcion":"{ AGP-04001 } MASAJEADOR LUTETIA T6 GRANDE"},
{"descripcion":"{ AGP-04002 } ESTANQUE MEZCLADOR TUMBLER"},
{"descripcion":"{ AGP-04003 } VOLTEADOR DE BINS TUMBLER"},
{"descripcion":"{ AGP-08148 } CINTA ELEVADORA PARA MASAJEADORES"},
{"descripcion":"{ AGP-10086 } TRASPALETAS PROCESO TUMBLER"},
{"descripcion":"{ AGP-10102 } BALANZAS PROCESO TUMBLER"},
{"descripcion":"{ AGP-08148.1 } MOTORREDUCTOR CINTA ELEVADORA PARA MASAJEADORES"},
{"descripcion":"{ AGP-04002.1 } MOTORREDUCTOR AGITADOR ESTANQUE MEZCLADOR TUMBLER"},
{"descripcion":"{ AGP-04002.2 } BOMBA ESTANQUE MEZCLADOR TUMBLER"},
{"descripcion":"{ AGP-04000.1 } MOTORREDUCTOR LADO NORTE MASAJEADOR LUTETIA T400 CHICO"},
{"descripcion":"{ AGP-04000.2 } MOTORREDUCTOR LADO SUR MASAJEADOR LUTETIA T400 CHICO"},
{"descripcion":"{ AGP-04001.1 } MOTORREDUCTOR LADO NORTE MASAJEADOR LUTETIA T6 GRANDE"},
{"descripcion":"{ AGP-04001.2 } MOTORREDUCTOR LADO SUR MASAJEADOR LUTETIA T6 GRANDE"},
{"descripcion":"{ AGP-04001.3 } BOMBA DE VACIO CENTRAL MASAJEADOR LUTETIA T6 GRANDE"},
{"descripcion":"{ AGP-04001.4 } BOMBA DE VACIO CENTRAL MASAJEADOR LUTETIA T6 GRANDE"},
{"descripcion":"{ AGP-04003.1 } MOTOR CENTRAL HIDRAULICA VOLTEADOR DE BINS TUMBLER"},
{"descripcion":"{ AGP-00207 } CENTRAL HIDRAULICA CINTAS DE PLUMAS"},
{"descripcion":"{ AGP-00217 } CINTA DE PLUMAS DESCARGA CONO"},
{"descripcion":"{ AGP-00320 } BOMBA DE VACIO SIHI LPHX [183918]"},
{"descripcion":"{ AGP-02214 } BOMBA DE VACIO SIHI LPHX [314689]"},
{"descripcion":"{ AGP-02215 } BOMBA DE VACIO SIHI LPHX [301874]"},
{"descripcion":"{ AGP-02221 } BOMBA DE VACIO SIHI LPHX [306850]"},
{"descripcion":"{ AGP-10502 } BOMBA VACIO POR GARRAS SUR"},
{"descripcion":"{ AGP-10502.1 } MOTOR BOMBA VACIO POR GARRAS SUR"},
{"descripcion":"{ AGP-10503 } BOMBA VACIO POR GARRAS CENTRO SUR"},
{"descripcion":"{ AGP-10504 } BOMBA VACIO POR GARRAS CENTRO NORTE"},
{"descripcion":"{ AGP-10505 } BOMBA VACIO POR GARRAS NORTE"},
{"descripcion":"{ AGP-10675 } BOMBA DE VACIO SIHI LPHX [353340]"},
{"descripcion":"{ AGP-10676 } ESTANQUE ACUMULACION VACIO N 2 ORIENTE"},
{"descripcion":"{ AGP-10677 } ESTANQUE ACUMULACION RESIDUOS N 1 PONIENTE"},
{"descripcion":"{ AGP-10678 } ESTANQUE ACUMULACION VACIO N 2 ORIENTE"},
{"descripcion":"{ AGP-10679 } ESTANQUE ACUMULACION RESIDUOS N 1 PONIENTE"},
{"descripcion":"{ AGP-10681 } BOMBA VACIO POR GARRAS STAND BY"},
{"descripcion":"{ AGP-00320.1 } MOTOR BOMBA DE VACIO CENTRO"},
{"descripcion":"{ AGP-02215.1 } MOTOR BOMBA VACIO ORIENTE"},
{"descripcion":"{ AGP-02214.1 } MOTOR BOMBA VACIO PONIENTE"},
{"descripcion":"{ AGP-00207.1 } MOTOR CENTRAL HIDRAULICA CINTAS DE PLUMAS"},
{"descripcion":"{ AGP-00200 } ESCALDADORA PAVO ENTRADA"},
{"descripcion":"{ AGP-00201 } ESCALDADORA PAVO SALIDA"},
{"descripcion":"{ AGP-00202 } ESCALDADORA DE ALAS"},
{"descripcion":"{ AGP-00203 } DESPLUMADORA CONTRAROTANTE NORTE"},
{"descripcion":"{ AGP-00204 } DESPLUMADORA CONTRAROTANTE SUR"},
{"descripcion":"{ AGP-00205 } DESPLUMADORA LINCO NORTE"},
{"descripcion":"{ AGP-00206 } DESPLUMADORA LINCO SUR"},
{"descripcion":"{ AGP-00208 } LINEA AEREA CORTA TENDONERA"},
{"descripcion":"{ AGP-00209 } TENDONERA DE PAVOS"},
{"descripcion":"{ AGP-00210 } BOTADOR DE PATAS"},
{"descripcion":"{ AGP-00211 } CORTADOR PATAS PAVOS"},
{"descripcion":"{ AGP-00214 } EXTRACTOR DE COLAS DE PAVOS"},
{"descripcion":"{ AGP-00215 } CINTA DE PLUMAS BAJO DESPLUMADORA"},
{"descripcion":"{ AGP-00216 } CINTA DE PLUMAS ELEVADORA"},
{"descripcion":"{ AGP-00218 } DESCOLGADOR DE PAVOS"},
{"descripcion":"{ AGP-08001 } CINTA COLGADO PAVOS"},
{"descripcion":"{ AGP-08002 } CINTA SALIDA TENDONERA"},
{"descripcion":"{ AGP-08003 } CINTA EXTRACTOR DE COLA"},
{"descripcion":"{ AGP-08004 } CINTA EVACUADORA DE GARRAS"},
{"descripcion":"{ AGP-10015 } EXTRACTOR NORTE DESPLUMADO DE PAVOS [N 11]"},
{"descripcion":"{ AGP-10016 } EXTRACTOR SUR DESPLUMADO DE PAVOS [N 12]"},
{"descripcion":"{ AGP-10017 } IMPULSOR SALA DE GARRAS POLLOS [N 39]"},
{"descripcion":"{ AGP-10018 } IMPULSOR NORTE DESPLUMADO DE PAVOS [N 40]"},
{"descripcion":"{ AGP-10019 } IMPULSOR SUR DESPLUMADO DE PAVOS [N 41]"},
{"descripcion":"{ AGP-00210.1 } MOTORREDUCTOR BOTADOR DE PATAS"},
{"descripcion":"{ AGP-08001.1 } MOTORREDUCTOR CINTA COLGADO PAVOS"},
{"descripcion":"{ AGP-00215.1 } MOTORREDUCTOR CINTA DE PLUMAS BAJO DESPLUMADORA"},
{"descripcion":"{ AGP-08004.1 } MOTORREDUCTOR CINTA EVACUADORA DE GARRAS"},
{"descripcion":"{ AGP-08003.1 } MOTORREDUCTOR CINTA EXTRACTOR DE COLA"},
{"descripcion":"{ AGP-08002.1 } MOTORREDUCTOR CINTA SALIDA TENDONERA"},
{"descripcion":"{ AGP-00211.1 } MOTOR CUCHILLO CORTADOR PATAS PAVOS"},
{"descripcion":"{ AGP-00203.1 } MOTOR NOR PONIENTE DESPLUMADORA CONTRA ROTANTE NORTE"},
{"descripcion":"{ AGP-00203.2 } MOTOR NOR ORIENTE DESPLUMADORA CONTRA ROTANTE NORTE"},
{"descripcion":"{ AGP-00203.3 } MOTOR SUR ORIENTE DESPLUMADORA CONTRA ROTANTE NORTE"},
{"descripcion":"{ AGP-00203.4 } MOTOR SUR PONIENTE DESPLUMADORA CONTRA ROTANTE NORTE"},
{"descripcion":"{ AGP-00203.5 } MOTOR NORTE EJE CENTRAL DESPLUMADORA CONTRA ROTANTE NORTE"},
{"descripcion":"{ AGP-00203.6 } MOTOR CENTRO EJE CENTRAL DESPLUMADORA CONTRA ROTANTE NORTE"},
{"descripcion":"{ AGP-00203.7 } MOTOR SUR EJE CENTRAL DESPLUMADORA CONTRA ROTANTE NORTE"},
{"descripcion":"{ AGP-00203.8 } MOTOR CENTRAL HIDRAULICA CENTRAL DESPLUMADORA CONTRA ROTANTE NORTE"},
{"descripcion":"{ AGP-00204.1 } MOTOR NOR PONIENTE DESPLUMADORA CONTRA ROTANTE SUR"},
{"descripcion":"{ AGP-00204.2 } MOTOR NOR ORIENTE DESPLUMADORA CONTRA ROTANTE SUR"},
{"descripcion":"{ AGP-00204.3 } MOTOR SUR ORIENTE DESPLUMADORA CONTRA ROTANTE SUR"},
{"descripcion":"{ AGP-00204.4 } MOTOR SUR PONIENTE DESPLUMADORA CONTRA ROTANTE SUR"},
{"descripcion":"{ AGP-00204.5 } MOTOR NORTE EJE CENTRAL DESPLUMADORA CONTRA ROTANTE SUR"},
{"descripcion":"{ AGP-00204.6 } MOTOR CENTRO EJE CENTRAL DESPLUMADORA CONTRA ROTANTE SUR"},
{"descripcion":"{ AGP-00204.7 } MOTOR SUR EJE CENTRAL DESPLUMADORA CONTRA ROTANTE SUR"},
{"descripcion":"{ AGP-00204.8 } MOTOR CENTRAL HIDRAULICA CENTRAL DESPLUMADORA CONTRA ROTANTE SUR"},
{"descripcion":"{ AGP-00205.1 } MOTOR N 1 EJE ORIENTE DESPLUMADORA LINCO NORTE"},
{"descripcion":"{ AGP-00205.10 } MOTOR N 2 EJE PONIENTE DESPLUMADORA LINCO NORTE"},
{"descripcion":"{ AGP-00205.11 } MOTOR N 3 EJE PONIENTE DESPLUMADORA LINCO NORTE"},
{"descripcion":"{ AGP-00205.12 } MOTOR N 4 EJE PONIENTE DESPLUMADORA LINCO NORTE"},
{"descripcion":"{ AGP-00205.13 } MOTOR N 5 EJE PONIENTE DESPLUMADORA LINCO NORTE"},
{"descripcion":"{ AGP-00205.14 } MOTOR N 6 EJE PONIENTE DESPLUMADORA LINCO NORTE"},
{"descripcion":"{ AGP-00205.15 } MOTOR N 7 EJE PONIENTE DESPLUMADORA LINCO NORTE"},
{"descripcion":"{ AGP-00205.16 } MOTOR N 8 EJE PONIENTE DESPLUMADORA LINCO NORTE"},
{"descripcion":"{ AGP-00205.17 } MOTOR CENTRAL HIDRAULICA DESPLUMADORA LINCO NORTE"},
{"descripcion":"{ AGP-00205.2 } MOTOR N 2 EJE ORIENTE DESPLUMADORA LINCO NORTE"},
{"descripcion":"{ AGP-00205.3 } MOTOR N 3 EJE ORIENTE DESPLUMADORA LINCO NORTE"},
{"descripcion":"{ AGP-00205.4 } MOTOR N 4 EJE ORIENTE DESPLUMADORA LINCO NORTE"},
{"descripcion":"{ AGP-00205.5 } MOTOR N 5 EJE ORIENTE DESPLUMADORA LINCO NORTE"},
{"descripcion":"{ AGP-00205.6 } MOTOR N 6 EJE ORIENTE DESPLUMADORA LINCO NORTE"},
{"descripcion":"{ AGP-00205.7 } MOTOR N 7 EJE ORIENTE DESPLUMADORA LINCO NORTE"},
{"descripcion":"{ AGP-00205.8 } MOTOR N 8 EJE ORIENTE DESPLUMADORA LINCO NORTE"},
{"descripcion":"{ AGP-00205.9 } MOTOR N 1 EJE PONIENTE DESPLUMADORA LINCO NORTE"},
{"descripcion":"{ AGP-00206.1 } MOTOR N 1 EJE ORIENTE DESPLUMADORA LINCO SUR"},
{"descripcion":"{ AGP-00206.10 } MOTOR N 4 EJE PONIENTE DESPLUMADORA LINCO SUR"},
{"descripcion":"{ AGP-00206.11 } MOTOR N 5 EJE PONIENTE DESPLUMADORA LINCO SUR"},
{"descripcion":"{ AGP-00206.12 } MOTOR N 6 EJE PONIENTE DESPLUMADORA LINCO SUR"},
{"descripcion":"{ AGP-00206.13 } MOTOR CENTRAL HIDRAULICA DESPLUMADORA LINCO SUR"},
{"descripcion":"{ AGP-00206.2 } MOTOR N 2 EJE ORIENTE DESPLUMADORA LINCO SUR"},
{"descripcion":"{ AGP-00206.3 } MOTOR N 3 EJE ORIENTE DESPLUMADORA LINCO SUR"},
{"descripcion":"{ AGP-00206.4 } MOTOR N 4 EJE ORIENTE DESPLUMADORA LINCO SUR"},
{"descripcion":"{ AGP-00206.5 } MOTOR N 5 EJE ORIENTE DESPLUMADORA LINCO SUR"},
{"descripcion":"{ AGP-00206.6 } MOTOR N 6 EJE ORIENTE DESPLUMADORA LINCO SUR"},
{"descripcion":"{ AGP-00206.7 } MOTOR N 1 EJE PONIENTE DESPLUMADORA LINCO SUR"},
{"descripcion":"{ AGP-00206.8 } MOTOR N 2 EJE PONIENTE DESPLUMADORA LINCO SUR"},
{"descripcion":"{ AGP-00206.9 } MOTOR N 3 EJE PONIENTE DESPLUMADORA LINCO SUR"},
{"descripcion":"{ AGP-00202.1 } MOTOR ESCALDADORA DE ALAS"},
{"descripcion":"{ AGP-00200.1 } MOTOR SOPLADOR N 1 ESCALDADORA PAVO ENTRADA"},
{"descripcion":"{ AGP-00200.2 } MOTOR SOPLADOR N 2 ESCALDADORA PAVO ENTRADA"},
{"descripcion":"{ AGP-00200.3 } MOTOR SOPLADOR N 3 ESCALDADORA PAVO ENTRADA"},
{"descripcion":"{ AGP-00200.4 } MOTOR SOPLADOR N 4 ESCALDADORA PAVO ENTRADA"},
{"descripcion":"{ AGP-00200.5 } MOTOR SOPLADOR N 5 ESCALDADORA PAVO ENTRADA"},
{"descripcion":"{ AGP-00201.1 } MOTOR SOPLADOR N 1 ESCALDADORA PAVO SALIDA"},
{"descripcion":"{ AGP-00201.2 } MOTOR SOPLADOR N 2 ESCALDADORA PAVO SALIDA"},
{"descripcion":"{ AGP-00201.3 } MOTOR SOPLADOR N 3 ESCALDADORA PAVO SALIDA"},
{"descripcion":"{ AGP-00201.4 } MOTOR SOPLADOR N 4 ESCALDADORA PAVO SALIDA"},
{"descripcion":"{ AGP-00201.5 } MOTOR SOPLADOR N 5 ESCALDADORA PAVO SALIDA"},
{"descripcion":"{ AGP-00214.1 } MOTORREDUCTOR EXTRACTOR DE COLAS DE PAVOS"},
{"descripcion":"{ AGP-10015.1 } MOTOR EXTRACTOR NORTE DESPLUMADO DE PAVOS"},
{"descripcion":"{ AGP-10016.1 } MOTOR EXTRACTOR SUR DESPLUMADO DE PAVOS"},
{"descripcion":"{ AGP-10018.1 } MOTOR IMPULSOR NORTE DESPLUMADO DE PAVOS"},
{"descripcion":"{ AGP-10017.1 } MOTOR EXTRACTOR PASILLO DESPLUMADO DE PAVOS"},
{"descripcion":"{ AGP-10019.1 } MOTOR IMPULSOR SUR DESPLUMADO DE PAVOS"},
{"descripcion":"{ AGP-00208.1 } MOTORREDUCTOR N 1 LINEA AEREA CORTA TENDONERA"},
{"descripcion":"{ AGP-00208.S1 } SENSOR TACOMETRO"},
{"descripcion":"{ AGP-00209.1 } MOTOR CUCHILLO CORTADOR DE TENDORNES TENDONERA DE PAVOS"},
{"descripcion":"{ AGP-01200 } LAVADOR DE POLLOS ESCALDADO"},
{"descripcion":"{ AGP-01201 } ESCALDADORA MEYN N 1 ENTRADA"},
{"descripcion":"{ AGP-01202 } ESCALDADORA MEYN N 2 CENTRO"},
{"descripcion":"{ AGP-01203 } ESCALDADORA MEYN N 3 SALIDA"},
{"descripcion":"{ AGP-01204 } ESCALDADORA DE ALAS"},
{"descripcion":"{ AGP-01205 } DESPLUMADORA CONTRAROTANTE"},
{"descripcion":"{ AGP-01206 } DESPLUMADORA REPASADORA IMPIANTI"},
{"descripcion":"{ AGP-01207 } DESPLUMADORA MEYN NORTE"},
{"descripcion":"{ AGP-01208 } DESPLUMADORA MEYN SUR"},
{"descripcion":"{ AGP-01209 } CORTADOR DE CABEZAS POLLOS"},
{"descripcion":"{ AGP-01210 } LIMPIADOR DE GARRAS PRIME"},
{"descripcion":"{ AGP-01211 } PRECORTADOR DE GARRAS PRIME"},
{"descripcion":"{ AGP-01211.1 } MOTORREDUCTOR PRECORTADOR DE GARRAS PRIME"},
{"descripcion":"{ AGP-01212 } DESPLUMADORA DE POLLOS MEYN N 3"},
{"descripcion":"{ AGP-10010 } EXTRACTOR NORTE DESPLUMADO DE POLLOS [N 9]"},
{"descripcion":"{ AGP-10011 } EXTRACTOR ORIENTE DESPLUMADO DE POLLOS [N 58]"},
{"descripcion":"{ AGP-10012 } EXTRACTOR SUR DESPLUMADO DE POLLOS [N 10]"},
{"descripcion":"{ AGP-10013 } EXTRACTOR PONIENTE DESPLUMADO DE POLLOS [N 59]"},
{"descripcion":"{ AGP-10014 } IMPULSOR DESPLUMADO DE POLLOS [N 42]"},
{"descripcion":"{ AGP-10228 } TABLEROS ELECTRICOS DE FUERZA Y CONTROL DESPLUMADO DE POLLOS"},
{"descripcion":"{ AGP-10336 } UMA SALA DESPLUMADO DE POLLOS (N 63)"},
{"descripcion":"{ AGP-10337 } IMPULSOR ORIENTE SALA DE DESPLUMADO POLLOS [N 63]"},
{"descripcion":"{ AGP-10338 } IMPULSOR PONIENTE SALA EVISCERADO POLLOS [N 62]"},
{"descripcion":"{ AGP-10352 } CINTA THERMODRIVE BAJO DESPLUMADORAS"},
{"descripcion":"{ AGP-10369 } CINTA PLUMAS SALIDA SALA DESPLUMADO"},
{"descripcion":"{ AGP-10370 } CINTA CADENA ELEVADORA HACIA DETECTOR DE METALES"},
{"descripcion":"{ AGP-10371 } CINTA DETECTOR DE METALES PLUMAS"},
{"descripcion":"{ AGP-10372 } DETECTOR METALES PARA PLUMAS"},
{"descripcion":"{ AGP-10373 } COMPACTADOR DE PLUMAS"},
{"descripcion":"{ AGP-10374 } CINTA SALIDA COMPACTADOR DE PLUMAS"},
{"descripcion":"{ AGP-10375 } CINTA BIDIRECCIONAL DESCARGA A CONTENEDORES"},
{"descripcion":"{ AGP-10376 } CINTA RECHAZO DETECTOR METALES BYPASS COMPACTADOR"},
{"descripcion":"{ AGP-10377 } BOMBA POZO SALA CONTENEDOR DE PLUMAS (SISTEMA NUEVO)"},
{"descripcion":"{ AGP-10390 } BOMBA DE DIAFRAGMA NUDILLO SHANK"},
{"descripcion":"{ AGP-10517 } TABLEROS ELECTRICOS FUERZA Y CONTROL SALA DESPLUMADO DE POLLOS"},
{"descripcion":"{ AGP-10594 } EXTRACTOR DE AIRE SALA DE DESPLUMADO (N 10)"},
{"descripcion":"{ AGP-10377.1 } MOTOR BOMBA T3 POZO SALA CONTENEDOR DE PLUMAS"},
{"descripcion":"{ AGP-10375.1 } MOTORREDUCTOR CINTA BIDIRECCIONAL DESCARGA A CONTENEDORES"},
{"descripcion":"{ AGP-10370.1 } MOTORREDUCTOR CINTA CADENA ELEVADORA HACIA DETECTOR DE METALES"},
{"descripcion":"{ AGP-10371.1 } MOTORREDUCTORCINTA DETECTOR DE METALES PLUMAS"},
{"descripcion":"{ AGP-10369.1 } MOTORREDUCTORCINTA PLUMAS SALIDA SALA DESPLUMADO"},
{"descripcion":"{ AGP-10374.1 } MOTORREDUCTOR CINTA SALIDA COMPACTADOR DE PLUMAS"},
{"descripcion":"{ AGP-10352.1 } MOTORREDUCTOR CINTA THERMODRIVE BAJO DESPLUMADORAS"},
{"descripcion":"{ AGP-10373.1 } MOTORREDUCTOR COMPACTADOR DE PLUMAS"},
{"descripcion":"{ AGP-01209.1 } MOTOR CUCHILLO CORTADOR DE CABEZAS"},
{"descripcion":"{ AGP-01205.1 } MOTOR N 1 EJE ORIENTE ENTRADA DESPLUMADORA CONTRAROTANTE"},
{"descripcion":"{ AGP-01205.2 } MOTOR N 2 EJE PONIENTE ENTRADA DESPLUMADORA CONTRAROTANTE"},
{"descripcion":"{ AGP-01205.3 } MOTOR N 3 EJE ORIENTE SALIDA DESPLUMADORA CONTRAROTANTE"},
{"descripcion":"{ AGP-01205.4 } MOTOR N 4 EJE PONIENTE SALIDA DESPLUMADORA CONTRAROTANTE"},
{"descripcion":"{ AGP-01205.5 } MOTOR CENTRAL HIDRAULICA DESPLUMADORA CONTRAROTANTE"},
{"descripcion":"{ AGP-01212.1 } MOTOR N 1 DESPLUMADORA DE POLLOS MEYN N 3"},
{"descripcion":"{ AGP-01212.2 } MOTOR N 2 DESPLUMADORA DE POLLOS MEYN N 3"},
{"descripcion":"{ AGP-01212.3 } MOTOR N 3 DESPLUMADORA DE POLLOS MEYN N 3"},
{"descripcion":"{ AGP-01212.4 } MOTOR N 4 DESPLUMADORA DE POLLOS MEYN N 3"},
{"descripcion":"{ AGP-01212.5 } MOTOR N 5 DESPLUMADORA DE POLLOS MEYN N 3"},
{"descripcion":"{ AGP-01212.6 } MOTOR N 6 DESPLUMADORA DE POLLOS MEYN N 3"},
{"descripcion":"{ AGP-01212.7 } MOTOR N 7 DESPLUMADORA DE POLLOS MEYN N 3"},
{"descripcion":"{ AGP-01212.8 } MOTOR N 8 DESPLUMADORA DE POLLOS MEYN N 3"},
{"descripcion":"{ AGP-01207.1 } MOTOR N 1 DESPLUMADORA MEYN NORTE"},
{"descripcion":"{ AGP-01207.2 } MOTOR N 2 DESPLUMADORA MEYN NORTE"},
{"descripcion":"{ AGP-01207.3 } MOTOR N 3 DESPLUMADORA MEYN NORTE"},
{"descripcion":"{ AGP-01207.4 } MOTOR N 4 DESPLUMADORA MEYN NORTE"},
{"descripcion":"{ AGP-01207.5 } MOTOR N 5 DESPLUMADORA MEYN NORTE"},
{"descripcion":"{ AGP-01207.6 } MOTOR N 6 DESPLUMADORA MEYN NORTE"},
{"descripcion":"{ AGP-01207.7 } MOTOR N 7 DESPLUMADORA MEYN NORTE"},
{"descripcion":"{ AGP-01207.8 } MOTOR N 8 DESPLUMADORA MEYN NORTE"},
{"descripcion":"{ AGP-01208.1 } MOTOR N 1 DESPLUMADORA MEYN SUR"},
{"descripcion":"{ AGP-01208.2 } MOTOR N 2 DESPLUMADORA MEYN SUR"},
{"descripcion":"{ AGP-01208.3 } MOTOR N 3 DESPLUMADORA MEYN SUR"},
{"descripcion":"{ AGP-01208.4 } MOTOR N 4 DESPLUMADORA MEYN SUR"},
{"descripcion":"{ AGP-01208.5 } MOTOR N 5 DESPLUMADORA MEYN SUR"},
{"descripcion":"{ AGP-01208.6 } MOTOR N 6 DESPLUMADORA MEYN SUR"},
{"descripcion":"{ AGP-01208.7 } MOTOR N 7 DESPLUMADORA MEYN SUR"},
{"descripcion":"{ AGP-01208.8 } MOTOR N 8 DESPLUMADORA MEYN SUR"},
{"descripcion":"{ AGP-01206.1 } MOTOR N 1 EJE PONIENTE INFERIOR DESPLUMADORA REPASADORA"},
{"descripcion":"{ AGP-01206.10 } MOTOR N 10 EJE CENTRAL DESPLUMADORA REPASADORA"},
{"descripcion":"{ AGP-01206.11 } MOTOR N 11 EJE CENTRAL DESPLUMADORA REPASADORA"},
{"descripcion":"{ AGP-01206.12 } MOTOR N 12 EJE CENTRAL DESPLUMADORA REPASADORA"},
{"descripcion":"{ AGP-01206.13 } MOTOR N 13 EJE CENTRAL DESPLUMADORA REPASADORA"},
{"descripcion":"{ AGP-01206.14 } MOTOR N 14 EJE CENTRAL DESPLUMADORA REPASADORA"},
{"descripcion":"{ AGP-01206.15 } MOTOR CENTRAL HIDRAULICA DESPLUMADORA REPASADORA"},
{"descripcion":"{ AGP-01206.2 } MOTOR N 2 EJE ORIENTE INFERIOR DESPLUMADORA REPASADORA"},
{"descripcion":"{ AGP-01206.3 } MOTOR N 3 EJE PONIENTE SUPERIOR DESPLUMADORA REPASADORA"},
{"descripcion":"{ AGP-01206.4 } MOTOR N 4 EJE ORIENTE SUPERIOR DESPLUMADORA REPASADORA"},
{"descripcion":"{ AGP-01206.5 } MOTOR N 5 EJE PONIENTE INFERIOR DESPLUMADORA REPASADORA"},
{"descripcion":"{ AGP-01206.6 } MOTOR N 6 EJE ORIENTE INFERIOR DESPLUMADORA REPASADORA"},
{"descripcion":"{ AGP-01206.7 } MOTOR N 7 EJE PONIENTE SUPERIOR DESPLUMADORA REPASADORA"},
{"descripcion":"{ AGP-01206.8 } MOTOR N 8 EJE ORIENTE SUPERIOR DESPLUMADORA REPASADORA"},
{"descripcion":"{ AGP-01206.9 } MOTOR N 9 EJE CENTRAL DESPLUMADORA REPASADORA"},
{"descripcion":"{ AGP-01204.1 } MOTOBOMBA ESCALDADORA DE ALAS ORIENTE"},
{"descripcion":"{ AGP-01204.2 } MOTOBOMBA ESCALDADORA DE ALAS CENTRO"},
{"descripcion":"{ AGP-01204.3 } MOTOBOMBA ESCALDADORA DE ALAS PONIENTE"},
{"descripcion":"{ AGP-01201.1 } MOTOR N 1 ESCALDADORA MEYN N 1 ENTRADA"},
{"descripcion":"{ AGP-01201.2 } MOTOR N 2 ESCALDADORA MEYN N 1 ENTRADA"},
{"descripcion":"{ AGP-01201.3 } MOTOR N 3 ESCALDADORA MEYN N 1 ENTRADA"},
{"descripcion":"{ AGP-01201.4 } MOTOR N 4 ESCALDADORA MEYN N 1 ENTRADA"},
{"descripcion":"{ AGP-01201.5 } MOTOR N 5 ESCALDADORA MEYN N 1 ENTRADA"},
{"descripcion":"{ AGP-01202.1 } MOTOR N 1 ESCALDADORA MEYN N 2 CENTRO"},
{"descripcion":"{ AGP-01202.2 } MOTOR N 2 ESCALDADORA MEYN N 2 CENTRO"},
{"descripcion":"{ AGP-01202.3 } MOTOR N 3 ESCALDADORA MEYN N 2 CENTRO"},
{"descripcion":"{ AGP-01202.4 } MOTOR N 4 ESCALDADORA MEYN N 2 CENTRO"},
{"descripcion":"{ AGP-01202.5 } MOTOR N 5 ESCALDADORA MEYN N 2 CENTRO"},
{"descripcion":"{ AGP-01203.1 } MOTOR N 1 ESCALDADORA MEYN N 3 SALIDA"},
{"descripcion":"{ AGP-01203.2 } MOTOR N 2 ESCALDADORA MEYN N 3 SALIDA"},
{"descripcion":"{ AGP-01203.3 } MOTOR N 3 ESCALDADORA MEYN N 3 SALIDA"},
{"descripcion":"{ AGP-01203.4 } MOTOR N 4 ESCALDADORA MEYN N 3 SALIDA"},
{"descripcion":"{ AGP-01203.5 } MOTOR N 5 ESCALDADORA MEYN N 3 SALIDA"},
{"descripcion":"{ AGP-10594.1 } MOTOR EXTRACTOR DE AIRE SALA DE DESPLUMADO (N 10)"},
{"descripcion":"{ AGP-10010.1 } MOTOR EXTRACTOR ORIENTE DESPLUMADO DE POLLOS INFERIOR"},
{"descripcion":"{ AGP-10011.2 } MOTOR EXTRACTOR ORIENTE DESPLUMADO DE POLLOS SUPERIOR"},
{"descripcion":"{ AGP-10013.4 } MOTOR EXTRACTOR PONIENTE DESPLUMADO DE POLLOS SUPERIOR"},
{"descripcion":"{ AGP-10012.3 } MOTOR EXTRACTOR PONIENTE DESPLUMADO DE POLLOS [N 59]"},
{"descripcion":"{ AGP-10014.5 } MOTOR UMA IMPULSOR DESPLUMADO DE POLLOS"},
{"descripcion":"{ AGP-01200.1 } MOTORREDUCTOR NORTE LAVADOR DE POLLOS ESCALDADO"},
{"descripcion":"{ AGP-01200.2 } MOTORREDUCTOR SUR LAVADOR DE POLLOS ESCALDADO"},
{"descripcion":"{ AGP-01210.1 } MOTORREDUCTOR RODILLOS LIMPIADOR DE GARRAS"},
{"descripcion":"{ AGP-01210.2 } MOTORREDUCTOR CORREA LIMPIADOR DE GARRAS PRIME"},
{"descripcion":"{ AGP-09195 } LINEA ACIDO PERACETICO"},
{"descripcion":"{ AGP-09445 } TABLERO ELECTRICO SISTEMA PERACETICO"},
{"descripcion":"{ AGP-09446 } ESTANQUE AGUA FRIA"},
{"descripcion":"{ AGP-09447 } BOMBA ALTA PRESION N 1"},
{"descripcion":"{ AGP-09448 } BOMBA ALTA PRESION N 2"},
{"descripcion":"{ AGP-09449 } BOMBA ALTA PRESION N 3"},
{"descripcion":"{ AGP-09450 } BOMBA CENTRIFUGA N 4"},
{"descripcion":"{ AGP-09451 } ESTANQUE AGUA RED"},
{"descripcion":"{ AGP-09452 } BOMBA ALTA PRESION N 5"},
{"descripcion":"{ AGP-09453 } BOMBA ALTA PRESION N 6"},
{"descripcion":"{ AGP-09454 } BOMBA ALTA PRESION N 7"},
{"descripcion":"{ AGP-09455 } BOMBA PULSO PERACETICO N 1 ORIENTE (GARRAS Y CHILLER AIRE)"},
{"descripcion":"{ AGP-09456 } BOMBA PULSO PERACETICO N 2 CENTRO N 1 CHILLER AGUA"},
{"descripcion":"{ AGP-09457 } BOMBA PULSO PERACETICO N 3 PONIENTE PROCESOS POSTERIORES"},
{"descripcion":"{ AGP-09458 } MEDIDOR FLUJO N 1"},
{"descripcion":"{ AGP-09459 } MEDIDOR FLUJO N 2"},
{"descripcion":"{ AGP-09460 } COTROLADOR PERACETICO N 1"},
{"descripcion":"{ AGP-09461 } COTROLADOR PERACETICO N 2"},
{"descripcion":"{ AGP-10213 } BOMBA PULSO PERACETICO N 2 CENTRO N 2 CHILLER AGUA"},
{"descripcion":"{ AGP-10366 } ESTANQUE 30 m3 AGUA PERACETICO (NORTE)"},
{"descripcion":"{ AGP-10367 } ESTANQUE 30 m3 AGUA PERACETICO (SUR)"},
{"descripcion":"{ AGP-09447.1 } BOMBA ALTA PRESION N 1 SISTEMA PERACETICO ESTANQUE SUR"},
{"descripcion":"{ AGP-09448.1 } BOMBA ALTA PRESION N 2 SISTEMA PERACETICO ESTANQUE SUR"},
{"descripcion":"{ AGP-09449.1 } BOMBA ALTA PRESION N 3 SISTEMA PERACETICO ESTANQUE SUR"},
{"descripcion":"{ AGP-09452.1 } BOMBA ALTA PRESION N 5 SISTEMA PERACETICO ESTANQUE NORTE"},
{"descripcion":"{ AGP-09453.1 } BOMBA ALTA PRESION N 6 SISTEMA PERACETICO ESTANQUE NORTE"},
{"descripcion":"{ AGP-09454.1 } BOMBA ALTA PRESION N 7 SISTEMA PERACETICO ESTANQUE NORTE"},
{"descripcion":"{ AGP-09450.1 } BOMBA CENTRIFUGA N 4 SISTEMA PERACETICO ESTANQUE SUR"},
{"descripcion":"{ AGP-09445.HMI1 } HMI TABLERO PRINCIPAL SISTEMA DE ACIDO PERACETICO"},
{"descripcion":"{ AGP-09445.PLC1 } PLC TABLERO PRINCIPAL SISTEMA DE ACIDO PERACETICO"},
{"descripcion":"{ AGP-09022 } RECIRCULADOR DE BAJA -35 N 3"},
{"descripcion":"{ AGP-09023 } BOMBA WITT N 1 RECIRCULADOR DE BAJA -35 N 3"},
{"descripcion":"{ AGP-09024 } BOMBA WITT N 2 RECIRCULADOR DE BAJA -35 N 3"},
{"descripcion":"{ AGP-09025 } LINEA LIQUIDO RECIRCULADOR DE BAJA -35 N 3"},
{"descripcion":"{ AGP-09026 } LINEA SUCCION RECIRCULADOR DE BAJA -35 N 3"},
{"descripcion":"{ AGP-09116 } LÃNEA DE GLICOL N 3 GRAL."},
{"descripcion":"{ AGP-09117 } INTERCAMBIADOR DE GLICOL N 3"},
{"descripcion":"{ AGP-09118 } BOMBAS DE GLICOL N 3 (02)"},
{"descripcion":"{ AGP-09023.1 } MOTOR DE BOMBA WITT NORTE N 1 RECIRCULADOR DE BAJA -35 N 3"},
{"descripcion":"{ AGP-09024.1 } MOTOR DE BOMBA WITT SUR N 2 RECIRCULADOR DE BAJA -35 N 3"},
{"descripcion":"{ AGP-09118.1 } MOTOR DE BOMBA GLICOL N 3 (01) ORIENTE ENFRIADO ENCAJADO FRESCO"},
{"descripcion":"{ AGP-09118.2 } MOTOR DE BOMBA GLICOL N 3 (02) PONIENTE ENFRIADO ENCAJADO FRESCO"},
{"descripcion":"{ AGP-02200 } TRANSFERIDOR MEYN"},
{"descripcion":"{ AGP-02201 } LINEA AEREA EVISCERADO DE POLLOS"},
{"descripcion":"{ AGP-02202 } MOLEDOR DE POLLOS"},
{"descripcion":"{ AGP-02203 } ANERA"},
{"descripcion":"{ AGP-02204 } ABRIDORA DE ABDOMEN"},
{"descripcion":"{ AGP-02205 } MAESTRO EVISCERADOR"},
{"descripcion":"{ AGP-02206 } CINTA PEINETA"},
{"descripcion":"{ AGP-02207 } CINTA CAPACHOS"},
{"descripcion":"{ AGP-02208 } BUCHERA"},
{"descripcion":"{ AGP-02209 } QUEBRANTADORA DE COGOTES"},
{"descripcion":"{ AGP-02210 } CORTADORA DE PIEL"},
{"descripcion":"{ AGP-02211 } PULMONERA"},
{"descripcion":"{ AGP-02212 } DUCHA DE POLLOS"},
{"descripcion":"{ AGP-02213 } DESCOLGADOR DE POLLOS MEYN"},
{"descripcion":"{ AGP-02216 } LINEA EXPURGO INFECCIOSO"},
{"descripcion":"{ AGP-02217 } LINEA EXPURGO SALVADO"},
{"descripcion":"{ AGP-02218 } ESTERILIZADOR EVISCERADO POLLOS N 1"},
{"descripcion":"{ AGP-02219 } LINEA EXPURGO NO INFECCIOSO"},
{"descripcion":"{ AGP-02220 } CORTADOR DE GLANDULA UROPIGIAL"},
{"descripcion":"{ AGP-02300 } PARTIDORA DE CONTRES ORIENTE"},
{"descripcion":"{ AGP-02301 } PARTIDORA DE CONTRES PONIENTE (SEMIL)"},
{"descripcion":"{ AGP-02302 } MESA DE CONTRES NORTE"},
{"descripcion":"{ AGP-02303 } BOMBA DE HIGADOS (PANA)"},
{"descripcion":"{ AGP-02304 } BOMBA DE CORAZONES"},
{"descripcion":"{ AGP-02305 } BOMBA DE CONTRES"},
{"descripcion":"{ AGP-02306 } BOMBA DE COGOTE"},
{"descripcion":"{ AGP-02307 } PELADOR DE COGOTES LINCO"},
{"descripcion":"{ AGP-02308 } ELEVADOR DE CONTRES NORTE"},
{"descripcion":"{ AGP-02309 } ELEVADOR DE CONTRES SUR"},
{"descripcion":"{ AGP-02310 } LAVADOR DE CONTRES"},
{"descripcion":"{ AGP-02311 } MESA DE CONTRES SUR"},
{"descripcion":"{ AGP-02312 } SEPARADOR DE CORAZONES"},
{"descripcion":"{ AGP-02313 } PELADOR DE CONTRES"},
{"descripcion":"{ AGP-02314 } MESA LIMPIADORA DE CORAZONES NORTE"},
{"descripcion":"{ AGP-02315 } MESA LIMPIADORA DE CORAZONES SUR"},
{"descripcion":"{ AGP-02320 } PARTIDORA DE CONTRES NORTE (FRINOX)"},
{"descripcion":"{ AGP-02321 } PARTIDORA DE CONTRES SUR (FRINOX)"},
{"descripcion":"{ AGP-08018 } CINTA COLGADO EVISCERADO"},
{"descripcion":"{ AGP-08019 } CINTA ELEVADOR CONTRES"},
{"descripcion":"{ AGP-09437 } MEZCLADORES AGUA VAPOR EVISCERADO POLLOS N 1"},
{"descripcion":"{ AGP-09438 } MEZCLADORES AGUA VAPOR EVISCERADO POLLOS N 2"},
{"descripcion":"{ AGP-10020 } EXTRACTOR ORIENTE EVISCERADO DE POLLOS [N 13]"},
{"descripcion":"{ AGP-10021 } EXTRACTOR PONIENTE EVISCERADO DE POLLOS [N 14]"},
{"descripcion":"{ AGP-10023 } IMPULSOR SALA EVISCERADO DE POLLOS [N 43]"},
{"descripcion":"{ AGP-10062 } RADIOS EVISCERADO DE POLLOS"},
{"descripcion":"{ AGP-10096 } BALANZAS EVISCERADO DE POLLOS"},
{"descripcion":"{ AGP-10227 } TABLEROS ELECTRICOS DE FUERZA Y CONTROL EVISCERADO DE POLLOS"},
{"descripcion":"{ AGP-10333 } UMA SALA EVISCERADO DE POLLOS (N 64)"},
{"descripcion":"{ AGP-10334 } EXTRACTOR ORIENTE SALA DE EVISCERADO POLLOS [N 60]"},
{"descripcion":"{ AGP-10335 } EXTRACTOR PONIENTE SALA DE EVISCERADO POLLOS [N 61]"},
{"descripcion":"{ AGP-10356 } FLUJOMETRO DUCHA DE POLLOS"},
{"descripcion":"{ AGP-10396 } PELADORA DE COGOTES FRINOX"},
{"descripcion":"{ AGP-10396.1 } MOTORREDUCTOR RODILLO PELADORA DE COGOTES FRINOX"},
{"descripcion":"{ AGP-10396.2 } MOTORREDUCTOR PALETA PELADORA DE COGOTES FRINOX"},
{"descripcion":"{ AGP-10516 } TABLEROS ELECTRICOS FUERZA Y CONTROL SALA EVISCERADO DE POLLOS"},
{"descripcion":"{ AGP-10626 } MOLEDOR DE POLLOS FRINOX"},
{"descripcion":"{ AGP-10672 } CINTA MODULAR SELECCION PANAS"},
{"descripcion":"{ AGP-10688 } ESTERILIZADOR EVISCERADO POLLOS N 2"},
{"descripcion":"{ AGP-10689 } ESTERILIZADOR EVISCERADO POLLOS N 3"},
{"descripcion":"{ AGP-10690 } ESTERILIZADOR EVISCERADO POLLOS N 4"},
{"descripcion":"{ AGP-10691 } ESTERILIZADOR EVISCERADO POLLOS N 5"},
{"descripcion":"{ AGP-10692 } ESTERILIZADOR EVISCERADO POLLOS N 6"},
{"descripcion":"{ AGP-10693 } ESTERILIZADOR EVISCERADO POLLOS N 7"},
{"descripcion":"{ AGP-10694 } ESTERILIZADOR EVISCERADO POLLOS N 8"},
{"descripcion":"{ AGP-02204.S1 } SENSOR TORSION"},
{"descripcion":"{ AGP-02203.1 } MOTOR BOMBA ALTA PRESION ANERA"},
{"descripcion":"{ AGP-02203.S1 } SENSOR TORSION"},
{"descripcion":"{ AGP-02203.S2 } SENSOR PARTIDA DE BOMBA, PRESENCIA DE POLLO"},
{"descripcion":"{ AGP-02208.1 } MOTORREDUCTOR CEPILLO BUCHERA"},
{"descripcion":"{ AGP-02208.2 } MOTOR CUCHILLO CORTE DE COLA"},
{"descripcion":"{ AGP-02208.S1 } SENSOR TORSION"},
{"descripcion":"{ AGP-02207.1 } MOTORREDUCTOR CINTA CAPACHOS"},
{"descripcion":"{ AGP-02207.S1 } SENSOR PULSO Z"},
{"descripcion":"{ AGP-02207.S2 } SENSOR ENCODER"},
{"descripcion":"{ AGP-08018.1 } MOTORREDUCTOR CINTA COLGADO EVISCERADO"},
{"descripcion":"{ AGP-08019.1 } MOTORREDUCTOR CINTA ELEVADOR CONTRES"},
{"descripcion":"{ AGP-02206.1 } MOTORREDUCTOR CINTA PEINETA"},
{"descripcion":"{ AGP-02206.S1 } SENSOR BARRA DE SEGURIDAD"},
{"descripcion":"{ AGP-02210.1 } MOTOR CUCHILLO CORTADOR DE PIEL"},
{"descripcion":"{ AGP-02210.S1 } SENSOR TORSION"},
{"descripcion":"{ AGP-02212.1 } BOMBA DUCHA DE POLLOS"},
{"descripcion":"{ AGP-02212.3 } BOMBA MULTIETAPAS VERTICAL DUCHA DE POLLOS"},
{"descripcion":"{ AGP-02212.S1 } SENSOR TORSION"},
{"descripcion":"{ AGP-02212.S2 } SENSOR PARTIDA DE BOMBA, PRESENCIA DE POLLO"},
{"descripcion":"{ AGP-02308.1 } MOTORREDUCTOR ELEVADOR DE CONTRES NORTE"},
{"descripcion":"{ AGP-02309.1 } MOTORREDUCTOR ELEVADOR DE CONTRES SUR"},
{"descripcion":"{ AGP-10020.1 } MOTOR EXTRACTOR ORIENTE EVISCERADO DE POLLOS [N 60]"},
{"descripcion":"{ AGP-10021.1 } MOTOR EXTRACTOR PONIENTE EVISCERADO DE POLLOS"},
{"descripcion":"{ AGP-10023.1 } MOTOR UMA IMPULSOR SALA EVISCERADO DE POLLOS"},
{"descripcion":"{ AGP-02310.1 } MOTOR LAVADOR DE CONTRES"},
{"descripcion":"{ AGP-02201.1 } MOTORREDUCTOR N 1 LINEA AEREA EVISCERADO DE POLLOS"},
{"descripcion":"{ AGP-02201.2 } MOTORREDUCTOR N 2 LINEA AEREA EVISCERADO DE POLLOS"},
{"descripcion":"{ AGP-02201.3 } MOTORREDUCTOR N 3 LINEA AEREA EVISCERADO DE POLLOS"},
{"descripcion":"{ AGP-02201.4 } MOTORREDUCTOR N 4 LINEA AEREA EVISCERADO DE POLLOS"},
{"descripcion":"{ AGP-02201.5 } MOTORREDUCTOR N 5 LINEA AEREA EVISCERADO DE POLLOS"},
{"descripcion":"{ AGP-02201.HMI1 } HMI TABLERO PRINCIPAL LINEA AEREA EVISCERADO DE POLLOS SUB ESTACION 5"},
{"descripcion":"{ AGP-02201.HMI2 } HMI TABLERO CONTROL LINEA AEREA EVISCERADO DE POLLOS EN SALA"},
{"descripcion":"{ AGP-02201.HMI3 } HMI TABLERO CONTROL CONTADOR DE POLLOS ENFERMOS"},
{"descripcion":"{ AGP-02201.PLC1 } PLC TABLERO PRINCIPAL LINEA AEREA EVISCERADO DE POLLOS"},
{"descripcion":"{ AGP-02201.PLC2 } PLC TABLERO CONTROL CONTADOR DE POLLOS ENFERMOS"},
{"descripcion":"{ AGP-02201.S1 } SENSOR TACOMETRO"},
{"descripcion":"{ AGP-02201.S2 } SENSOR TENSOR DE LINEA"},
{"descripcion":"{ AGP-02216.1 } MOTORREDUCTOR N 1 LINEA AEREA EXPURGO INFECCIOSO"},
{"descripcion":"{ AGP-02219.1 } MOTORREDUCTOR N 1 LINEA AEREA EXPURGO NO INFECCIOSO"},
{"descripcion":"{ AGP-02217.1 } MOTORREDUCTOR N 1 LINEA AEREA EXPURGO SALVADO"},
{"descripcion":"{ AGP-02217.2 } BOMBA DUCHA LINEA EXPURGO SALVADO"},
{"descripcion":"{ AGP-02205.1 } MOTOR BOMBA ALTA PRESION MAESTRO"},
{"descripcion":"{ AGP-02205.S1 } SENSOR TORSION"},
{"descripcion":"{ AGP-02205.S2 } SENSOR PARTIDA DE BOMBA, PRESENCIA DE POLLO"},
{"descripcion":"{ AGP-02205.S3 } SENSOR PULSO Z"},
{"descripcion":"{ AGP-02205.S4 } SENSOR TACOMETRO"},
{"descripcion":"{ AGP-02205.S5 } SENSOR ENCODER"},
{"descripcion":"{ AGP-02302.1 } MOTORREDUCTOR MESA DE CONTRES ORIENTE"},
{"descripcion":"{ AGP-02311.1 } MOTORREDUCTOR MESA DE CONTRES PONIENTE"},
{"descripcion":"{ AGP-02314.1 } MOTORREDUCTOR MESA LIMPIADORA DE CORAZONES NORTE"},
{"descripcion":"{ AGP-02315.1 } MOTORREDUCTOR MESA LIMPIADORA DE CORAZONES SUR"},
{"descripcion":"{ AGP-02202.1 } MOTORREDUCTOR MOLEDOR DE POLLOS"},
{"descripcion":"{ AGP-02320.1 } MOTORREDUCTOR RODILLOS DE CONTRES"},
{"descripcion":"{ AGP-02320.2 } MOTORREDUCTOR PALETA BOTADOR DE CONTRES"},
{"descripcion":"{ AGP-02320.3 } MOTORREDUCTOR CADENA CON PUNTAS"},
{"descripcion":"{ AGP-02320.4 } MOTOR CUCHILLO WIDIA"},
{"descripcion":"{ AGP-02320.5 } BOMBA ALTA PRESION"},
{"descripcion":"{ AGP-02320.6 } MOTORREDUCTOR RODILLOS VISCERAS"},
{"descripcion":"{ AGP-02320.7 } MOTORREDUCTOR FILTRO ROTATORIO FRINOX NORTE"},
{"descripcion":"{ AGP-02300.1 } MOTORREDUCTOR SEPARADOR DE TRIPAS PARTIDORA DE CONTRES ORIENTE"},
{"descripcion":"{ AGP-02300.2 } MOTOR CUCHILLO PARTIDOR DE CONTRES ORIENTE"},
{"descripcion":"{ AGP-02300.3 } MOTORREDUCTOR CADENA DE ARRASTRE PARTIDORA DE CONTRES ORIENTE"},
{"descripcion":"{ AGP-02300.4 } MOTORREDUCTOR RODILLOS LAVADORES PARTIDORA DE CONTRES ORIENTE"},
{"descripcion":"{ AGP-02301.1 } MOTORREDUCTOR SEPARADOR DE TRIPAS PARTIDORA DE CONTRES PONIENTE"},
{"descripcion":"{ AGP-02301.2 } MOTOR CUCHILLO PARTIDOR DE CONTRES PONIENTE"},
{"descripcion":"{ AGP-02301.3 } MOTORREDUCTOR CADENA DE ARRASTRE PARTIDORA DE CONTRES PONIENTE"},
{"descripcion":"{ AGP-02301.4 } MOTORREDUCTOR RODILLOS LAVADORES PARTIDORA DE CONTRES PONIENTE"},
{"descripcion":"{ AGP-02321.1 } MOTORREDUCTOR RODILLOS DE CONTRES"},
{"descripcion":"{ AGP-02321.2 } MOTORREDUCTOR PALETA BOTADOR DE CONTRES"},
{"descripcion":"{ AGP-02321.3 } MOTORREDUCTOR CADENA CON PUNTAS"},
{"descripcion":"{ AGP-02321.4 } MOTOR CUCHILLO WIDIA"},
{"descripcion":"{ AGP-02321.5 } BOMBA ALTA PRESION"},
{"descripcion":"{ AGP-02321.6 } MOTORREDUCTOR RODILLOS VISCERAS"},
{"descripcion":"{ AGP-02321.7 } MOTORREDUCTOR FILTRO ROTATORIO FRINOX SUR"},
{"descripcion":"{ AGP-02307.1 } MOTORREDUCTOR PELADOR DE COGOTES LINCO"},
{"descripcion":"{ AGP-02307.2 } MOTORREDUCTOR PALETA EVACUACION DE COGOTES"},
{"descripcion":"{ AGP-02313.1 } MOTOR PELADOR DE CONTRES"},
{"descripcion":"{ AGP-02211.S2 } SENSOR TORSION"},
{"descripcion":"{ AGP-02209.1 } MOTOR CUCHILLO QUEBRANTADORA DE COGOTES"},
{"descripcion":"{ AGP-02209.S1 } SENSOR TORSION"},
{"descripcion":"{ AGP-02312.1 } MOTOR CENTRAL HIDRAULICA SEPARADOR DE CORAZONES"},
{"descripcion":"{ AGP-02200.1 } MOTOR CUCHILLO CORTADOR DE GARRAS/NUDILLO"},
{"descripcion":"{ AGP-02200.S1 } SENSOR ENCODER"},
{"descripcion":"{ AGP-02200.S2 } SENSOR ENCODER"},
{"descripcion":"{ AGP-10358 } DETECTOR DE METALES PLUMAS"},
{"descripcion":"{ AGP-10520 } INYECTORA GUNTHER LINEA FRESCO"},
{"descripcion":"{ AGP-10521 } HIDROLAVADORA SPITWATER SP04"},
{"descripcion":"{ AGP-9166.1 } DETECTOR DE AMONIACO BAJA N 2"},
{"descripcion":"{ AGP-9166.10 } DETECTOR DE AMONIACO CALIBRADO"},
{"descripcion":"{ AGP-9166.11 } DETECTOR DE AMONIACO BAJA 3"},
{"descripcion":"{ AGP-9166.12 } DETECTOR DE AMONIACO MYCOM"},
{"descripcion":"{ AGP-9166.2 } DETECTOR DE AMONIACO ALTA N 2"},
{"descripcion":"{ AGP-9166.3 } DETECTOR DE AMONIACO ALTA N 1"},
{"descripcion":"{ AGP-9166.4 } DETECTOR DE AMONIACO BAJA N 1"},
{"descripcion":"{ AGP-9166.5 } DETECTOR DE AMONIACO CHILLER DE AIRE (NORTE)"},
{"descripcion":"{ AGP-9166.6 } DETECTOR DE AMONIACO CAMARA 208"},
{"descripcion":"{ AGP-9166.7 } DETECTOR DE AMONIACO CAMARA DE HIELO"},
{"descripcion":"{ AGP-9166.8 } DETECTOR DE AMONIACO CHILLER DE AIRE.(SUR)"},
{"descripcion":"{ AGP-9166.9 } DETECTOR DE AMONIACO CAMARA 202"},
{"descripcion":"{ AGP-09136 } LÃNEA AGUA ANILLO PRESION"},
{"descripcion":"{ AGP-09141 } LÃNEA AGUA 6BAR"},
{"descripcion":"{ AGP-09381 } LINEA AGUA VAPOR ESTANQUE 25M3"},
{"descripcion":"{ AGP-09383 } LINEA AGUA COGENERACION JABAS"},
{"descripcion":"{ AGP-09384 } LINEA AGUA VAPOR BAÑOS GENERALES"},
{"descripcion":"{ AGP-10033 } EXTRACTOR DESHUESADO HQ [N 18]"},
{"descripcion":"{ AGP-10034 } IMPULSOR ORIENTE DESHUESADO HQ [N 50]"},
{"descripcion":"{ AGP-10035 } IMPULSOR PONIENTE DESHUESADO HQ [N 49]"},
{"descripcion":"{ AGP-10033.1 } MOTOR EXTRACTOR DESHUESADO HQ"},
{"descripcion":"{ AGP-10034.1 } MOTOR IMPULSOR NORTE DESHUESADO HQ"},
{"descripcion":"{ AGP-10035.1 } MOTOR IMPULSOR SUR DESHUESADO HQ"},
{"descripcion":"{ AGP-09141.1 } BOMBA N 1 LÃNEA AGUA 6BAR ORIENTE"},
{"descripcion":"{ AGP-09141.2 } BOMBA N 2 LÃNEA AGUA 6BAR PONIENTE"},
{"descripcion":"{ AGP-09136.1 } BOMBA N 1 LINEA AGUA ANILLO PRESION"},
{"descripcion":"{ AGP-09136.2 } BOMBA N 2 LINEA AGUA ANILLO PRESION"},
{"descripcion":"{ AGP-09136.3 } BOMBA N 3 LINEA AGUA ANILLO PRESION"},
{"descripcion":"{ AGP-09136.4 } BOMBA N 4 LINEA AGUA ANILLO PRESION"},
{"descripcion":"{ AGP-09000 } ACUMULADOR NH3 PRINCIPAL"},
{"descripcion":"{ AGP-09001 } ACUMULADOR NH3 SECUNDARIO"},
{"descripcion":"{ AGP-09165 } CONDENSADOR N 2"},
{"descripcion":"{ AGP-09167 } CONDENSADOR N 4"},
{"descripcion":"{ AGP-09168 } CONDENSADOR N 5"},
{"descripcion":"{ AGP-09169 } CONDENSADOR N 6"},
{"descripcion":"{ AGP-09170 } CONDENSADOR N 7"},
{"descripcion":"{ AGP-09173 } CONDENSADOR N 13"},
{"descripcion":"{ AGP-09462 } EXTRACTOR DE AIRE SALA DE MAQUINAS [N 66]"},
{"descripcion":"{ AGP-09463 } EXTRACTOR DE AIRE SALA DE MAQUINAS [N 67]"},
{"descripcion":"{ AGP-09464 } EXTRACTOR DE AIRE SALA DE MAQUINAS [N 68]"},
{"descripcion":"{ AGP-09465 } EXTRACTOR DE AIRE SALA DE MAQUINAS [N 69]"},
{"descripcion":"{ AGP-09466 } EXTRACTOR DE AIRE SALA DE MAQUINAS [N 70]"},
{"descripcion":"{ AGP-09467 } EXTRACTOR PASILLO ESCALERA SADEMA [N 80]"},
{"descripcion":"{ AGP-09468 } EXTRACTOR PASILLO ESCALERA SADEMA [N 79]"},
{"descripcion":"{ AGP-09476 } LINEA LIQUIDO CONDENSADORES - ACUMULADOR"},
{"descripcion":"{ AGP-09477 } LINEA COLECTORA GAS CALIENTE"},
{"descripcion":"{ AGP-10246 } TABLEROS ELECTRICOS NIVEL 3 COMPRESORES"},
{"descripcion":"{ AGP-10325 } TORRE DE ENFRIAMIENTO BENTON NORTE"},
{"descripcion":"{ AGP-09173.1 } MOTOR N 1 VENTILADOR DE CONDENSADOR N 13"},
{"descripcion":"{ AGP-09173.2 } MOTOR N 2 VENTILADOR DE CONDENSADOR N 13"},
{"descripcion":"{ AGP-09173.3 } MOTOR N 3 VENTILADOR DE CONDENSADOR N 13"},
{"descripcion":"{ AGP-09173.4 } MOTOR N 4 VENTILADOR DE CONDENSADOR N 13"},
{"descripcion":"{ AGP-09173.5 } BOMBA N 1 DE CONDENSADOR N 13 ORIENTE"},
{"descripcion":"{ AGP-09173.6 } BOMBA N 2 DE CONDENSADOR N 13 PONIENTE"},
{"descripcion":"{ AGP-09165.1 } MOTOR N 1 VENTILADOR DE CONDENSADOR N 2"},
{"descripcion":"{ AGP-09165.2 } MOTOR N 2 VENTILADOR DE CONDENSADOR N 2"},
{"descripcion":"{ AGP-09165.3 } MOTOR N 3 VENTILADOR DE CONDENSADOR N 2"},
{"descripcion":"{ AGP-09165.4 } MOTOR N 4 VENTILADOR DE CONDENSADOR N 2"},
{"descripcion":"{ AGP-09165.5 } MOTOR N 5 VENTILADOR DE CONDENSADOR N 2"},
{"descripcion":"{ AGP-09165.6 } MOTOR N 6 VENTILADOR DE CONDENSADOR N 2"},
{"descripcion":"{ AGP-09165.7 } BOMBA DE CONDENSADOR N 2"},
{"descripcion":"{ AGP-09167.1 } MOTOR N 1 VENTILADOR DE CONDENSADOR N 4"},
{"descripcion":"{ AGP-09167.2 } MOTOR N 2 VENTILADOR DE CONDENSADOR N 4"},
{"descripcion":"{ AGP-09167.3 } MOTOR N 3 VENTILADOR DE CONDENSADOR N 4"},
{"descripcion":"{ AGP-09167.4 } BOMBA DE CONDENSADOR N 4"},
{"descripcion":"{ AGP-09168.1 } MOTOR N 1 VENTILADOR 1-2 DE CONDENSADOR N 5"},
{"descripcion":"{ AGP-09168.2 } MOTOR N 2 VENTILADOR 3 DE CONDENSADOR N 5"},
{"descripcion":"{ AGP-09168.3 } MOTOR N 3 VENTILADOR DE CONDENSADOR N 5"},
{"descripcion":"{ AGP-09168.4 } BOMBA DE CONDENSADOR N 5"},
{"descripcion":"{ AGP-09169.1 } MOTOR N 1 VENTILADOR DE CONDENSADOR N 6"},
{"descripcion":"{ AGP-09169.2 } MOTOR N 2 VENTILADOR DE CONDENSADOR N 6"},
{"descripcion":"{ AGP-09169.3 } MOTOR N 3 VENTILADOR DE CONDENSADOR N 6"},
{"descripcion":"{ AGP-09169.4 } BOMBA DE CONDENSADOR N 6"},
{"descripcion":"{ AGP-09170.1 } MOTOR N 1 VENTILADOR DE CONDENSADOR N 7"},
{"descripcion":"{ AGP-09170.2 } MOTOR N 2 VENTILADOR DE CONDENSADOR N 7"},
{"descripcion":"{ AGP-09170.3 } MOTOR N 3 VENTILADOR DE CONDENSADOR N 7"},
{"descripcion":"{ AGP-09170.4 } BOMBA DE CONDENSADOR N 7"},
{"descripcion":"{ AGP-09462.1 } MOTOR N 1 EXTRACTOR DE AIRE SALA DE MAQUINAS"},
{"descripcion":"{ AGP-09463.1 } MOTOR N 2 EXTRACTOR DE AIRE SALA DE MAQUINAS"},
{"descripcion":"{ AGP-09464.1 } MOTOR N 3 EXTRACTOR DE AIRE SALA DE MAQUINAS"},
{"descripcion":"{ AGP-09465.1 } MOTOR N 4 EXTRACTOR DE AIRE SALA DE MAQUINAS"},
{"descripcion":"{ AGP-09466.1 } MOTOR N 5 EXTRACTOR DE AIRE SALA DE MAQUINAS"},
{"descripcion":"{ AGP-09468.1 } MOTOR N 7 EXTRACTOR DE AIRE SALA DE MAQUINAS"},
{"descripcion":"{ AGP-09467.1 } MOTOR N 6 EXTRACTOR DE AIRE SALA DE MAQUINAS"},
{"descripcion":"{ AGP-09474 } UNIDAD EVAPORADORA TUNEL N 1"},
{"descripcion":"{ AGP-09474.5 } CONJUNTO VALVULA ENTRADA LIQUIDO TUNEL N 1"},
{"descripcion":"{ AGP-09474.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA TUNEL N 1"},
{"descripcion":"{ AGP-09474.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA TUNEL N 1"},
{"descripcion":"{ AGP-09474.3 } MOTOR VENTILADOR N 3 UNIDAD EVAPORADORA TUNEL N 1"},
{"descripcion":"{ AGP-09474.4 } MOTOR VENTILADOR N 4 UNIDAD EVAPORADORA TUNEL N 1"},
{"descripcion":"{ AGP-09488 } UNIDAD EVAPORADORA TUNEL N 10"},
{"descripcion":"{ AGP-09488.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA TUNEL N 10"},
{"descripcion":"{ AGP-09488.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA TUNEL N 10"},
{"descripcion":"{ AGP-09487 } UNIDAD EVAPORADORA TUNEL N 11"},
{"descripcion":"{ AGP-09487.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA TUNEL N 11"},
{"descripcion":"{ AGP-09487.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA TUNEL N 11"},
{"descripcion":"{ AGP-09486 } UNIDAD EVAPORADORA TUNEL N 12"},
{"descripcion":"{ AGP-09486.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA TUNEL N 12"},
{"descripcion":"{ AGP-09486.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA TUNEL N 12"},
{"descripcion":"{ AGP-09472 } UNIDAD EVAPORADORA TUNEL N 3"},
{"descripcion":"{ AGP-09473 } UNIDAD EVAPORADORA TUNEL N 2"},
{"descripcion":"{ AGP 09473.1 } CONJUNTO DE VALVULA ENTRADA DE LIQUIDO"},
{"descripcion":"{ AGP-09473.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA TUNEL N 2"},
{"descripcion":"{ AGP-09473.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA TUNEL N 2"},
{"descripcion":"{ AGP-09473.3 } MOTOR VENTILADOR N 3 UNIDAD EVAPORADORA TUNEL N 2"},
{"descripcion":"{ AGP-09473.4 } MOTOR VENTILADOR N 4 UNIDAD EVAPORADORA TUNEL N 2"},
{"descripcion":"{ AGP-09472.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA TUNEL N 3"},
{"descripcion":"{ AGP-09472.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA TUNEL N 3"},
{"descripcion":"{ AGP-09472.3 } MOTOR VENTILADOR N 3 UNIDAD EVAPORADORA TUNEL N 3"},
{"descripcion":"{ AGP-09472.4 } MOTOR VENTILADOR N 4 UNIDAD EVAPORADORA TUNEL N 3"},
{"descripcion":"{ AGP-09471 } UNIDAD EVAPORADORA TUNEL N 4"},
{"descripcion":"{ AGP-09471.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA TUNEL N 4"},
{"descripcion":"{ AGP-09471.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA TUNEL N 4"},
{"descripcion":"{ AGP-09471.3 } MOTOR VENTILADOR N 3 UNIDAD EVAPORADORA TUNEL N 4"},
{"descripcion":"{ AGP-09471.4 } MOTOR VENTILADOR N 4 UNIDAD EVAPORADORA TUNEL N 4"},
{"descripcion":"{ AGP-09504 } UNIDAD EVAPORADORA TUNEL N 56"},
{"descripcion":"{ AGP-09504.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA TUNEL N 56"},
{"descripcion":"{ AGP-09504.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA TUNEL N 56"},
{"descripcion":"{ AGP-09504.3 } MOTOR VENTILADOR N 3 UNIDAD EVAPORADORA TUNEL N 56"},
{"descripcion":"{ AGP-09504.4 } MOTOR VENTILADOR N 4 UNIDAD EVAPORADORA TUNEL N 56"},
{"descripcion":"{ AGP-09503 } UNIDAD EVAPORADORA TUNEL N 78"},
{"descripcion":"{ AGP-09503.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA TUNEL N 78"},
{"descripcion":"{ AGP-09503.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA TUNEL N 78"},
{"descripcion":"{ AGP-09503.3 } MOTOR VENTILADOR N 3 UNIDAD EVAPORADORA TUNEL N 78"},
{"descripcion":"{ AGP-09503.4 } MOTOR VENTILADOR N 4 UNIDAD EVAPORADORA TUNEL N 78"},
{"descripcion":"{ AGP-09469 } UNIDAD EVAPORADORA TUNEL N 9"},
{"descripcion":"{ AGP-09469.1 } MOTOR VENTILADOR N 1 UNIDAD EVAPORADORA TUNEL N 9"},
{"descripcion":"{ AGP-09469.2 } MOTOR VENTILADOR N 2 UNIDAD EVAPORADORA TUNEL N 9"},
{"descripcion":"{ 110 } GUILLOTINA CATO"},
{"descripcion":"{ 121-001 } COMPRESOR DE TORNILLO"},
{"descripcion":"{ 121-002 } MOTOR ELECTRICO Y CONTROL"},
{"descripcion":"{ 121-003 } SEPARADOR DE ACEITE"},
{"descripcion":"{ 121-004 } ENFRIADOR DE ACEITE"},
{"descripcion":"{ 121-005 } BOMBA DE LUBRICACION"},
{"descripcion":"{ 121 } COMPRESOR TORNILLO FRICK"},
{"descripcion":"{ 122 } BALANZA DE PISO (HIDRATADO)"},
{"descripcion":"{ 124 } BALANZA DE PISO EMPAQUE"},
{"descripcion":"{ 125 } BALANZA DE PISO (SALIDA PULPA)"},
{"descripcion":"{ 126 } BALANZA DE PISO CHILLER"},
{"descripcion":"{ 130 } CODIFICADORA LINX 7900 #2"},
{"descripcion":"{ 1405-1 } ESTRUCTURA"},
{"descripcion":"{ 1405-2 } SISTEMA HIDRAULICO"},
{"descripcion":"{ 1405-3 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 141-001 } ESTANQUE"},
{"descripcion":"{ 141-002 } FILTROS"},
{"descripcion":"{ 141-003 } BOMBA"},
{"descripcion":"{ 1418-001 } ESTRUCTURA"},
{"descripcion":"{ 1418-002 } TRANSMISION"},
{"descripcion":"{ 1418-003 } CINTA"},
{"descripcion":"{ 1418-004 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 1418 } CINTA SALIDA DETECTOR #1"},
{"descripcion":"{ 1419-001 } MOTOR ELECTRICO"},
{"descripcion":"{ 1419-002 } COMPRESOR"},
{"descripcion":"{ 141 } ABASTECIMIENTO PETROLEO"},
{"descripcion":"{ 1420-001 } MOTOR ELECTRICO"},
{"descripcion":"{ 1420-002 } COMPRESOR"},
{"descripcion":"{ 1421-001 } MOTOR ELECTRICO"},
{"descripcion":"{ 1421-002 } COMPRESOR"},
{"descripcion":"{ 1422 } DETECTOR ANRITSU KD8116AW #2"},
{"descripcion":"{ 1423-1 } SISTEMA NEUMATICO"},
{"descripcion":"{ 1423-2 } CINTA"},
{"descripcion":"{ 1423-3 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 1423-4 } ESTRUCTURA"},
{"descripcion":"{ 1423 } DETECTOR ANRITSU KDS4518ABW #1"},
{"descripcion":"{ 1424 } ELEVADOR CUTTER"},
{"descripcion":"{ 1425-001 } ESTRUCTURA"},
{"descripcion":"{ 1425-002 } MOTOREDUCTOR"},
{"descripcion":"{ 1425-003 } TRANSMISION"},
{"descripcion":"{ 1425-004 } TRANSPORTADOR DE CARGA"},
{"descripcion":"{ 1425-005 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 1425 } ELEVADOR MEZCLADOR INOTEC #1"},
{"descripcion":"{ 1426-001 } ESTRUCTURA"},
{"descripcion":"{ 1426-002 } MOTOREDUCTOR"},
{"descripcion":"{ 1426-003 } TRANSMISION"},
{"descripcion":"{ 1426-004 } TRANSPORTADOR DE CARGA"},
{"descripcion":"{ 1426-005 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 1426 } ELEVADOR MEZCLADOR INOTEC #2"},
{"descripcion":"{ 1455 } ELEVADOR HANDTMANN"},
{"descripcion":"{ 1456-01 } ESTRUCTURA"},
{"descripcion":"{ 1456-02 } UNIDAD DE VACIO"},
{"descripcion":"{ 1456-03 } CAJA DE MODULOS"},
{"descripcion":"{ 1456-04 } CARGADOR DE TRIPAS"},
{"descripcion":"{ 1456-05 } CONTROL ELECTRICO"},
{"descripcion":"{ 1456-06 } ELECTRONICA DE POTENCIA"},
{"descripcion":"{ 1456-07 } UNIDAD COLGANTE"},
{"descripcion":"{ 1456 } TORCEDORA HANDTMANN FPVLH-242"},
{"descripcion":"{ 1457-01 } ESTRUCTURA"},
{"descripcion":"{ 1457-02 } BOMBA DE CARNE"},
{"descripcion":"{ 1457-03 } ACCIONAMIENTO PRINCIPAL"},
{"descripcion":"{ 1457-04 } CARCASA GIRATORIA"},
{"descripcion":"{ 1457-05 } TOLVA DE LLENADO"},
{"descripcion":"{ 1457-06 } CONTRABRAZO, VARILLA DIVISORA"},
{"descripcion":"{ 1457-07 } UNIDADES DE ENLACE"},
{"descripcion":"{ 1457-08 } ACCIONAMIENTO DE LA AMOLADORA"},
{"descripcion":"{ 1457-09 } CONTROL ELECTRICO"},
{"descripcion":"{ 1457-10 } UNIDAD DE VACIO"},
{"descripcion":"{ 1457-11 } SEPARADOR DE AGUA"},
{"descripcion":"{ 1457-12 } VENTILACION"},
{"descripcion":"{ 1457-13 } PALANCA DE RODILLA"},
{"descripcion":"{ 1457-14 } CONTROL COMPACTO (PCK)"},
{"descripcion":"{ 1457-15 } UNIDAD DE ENTRADA"},
{"descripcion":"{ 1457-16 } ACCESORIOS"},
{"descripcion":"{ 1457 } EMBUTIDORA HANDTMANN VF 611"},
{"descripcion":"{ 1459-001 } ESTRUCTURA"},
{"descripcion":"{ 1459-002 } CADENA DE ARRASTRE SUPERIOR"},
{"descripcion":"{ 1459-003 } CADENA DE ARRASTRE INFERIOR"},
{"descripcion":"{ 1459-004 } TRANSMISION CADENAS DE ARRASTRE"},
{"descripcion":"{ 1459-005 } TRANSMISION REDUCTOR"},
{"descripcion":"{ 1459-006 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 1459-007 } BOMBA DUCHAS"},
{"descripcion":"{ 1459-008 } BOMBA PREDUCHA"},
{"descripcion":"{ 1459-009 } BOMBA RECIRCULADORA"},
{"descripcion":"{ 1459 } CHILLER AHUMADOR"},
{"descripcion":"{ 148-001 } ESTRUCTURA"},
{"descripcion":"{ 148-002 } CADENA DE ARRASTRE SUPERIOR"},
{"descripcion":"{ 148-003 } CADENA DE ARRASTRE INFERIOR"},
{"descripcion":"{ 148-004 } TRANSMISION CADENAS DE ARRASTRE"},
{"descripcion":"{ 148-005 } TRANSMISION REDUCTOR"},
{"descripcion":"{ 148-006 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 148-007 } BOMBA DUCHAS"},
{"descripcion":"{ 148-008 } BOMBA PREDUCHA"},
{"descripcion":"{ 148-009 } BOMBA RECIRCULADORA"},
{"descripcion":"{ 148 } CHILLER ALKAR"},
{"descripcion":"{ 1514 } MAQ GENERADOR HIELO ESCAMAS"},
{"descripcion":"{ 1523 } ACUMULADOR P110-20-ERL01"},
{"descripcion":"{ 1525-001 } ESTRUCTURA"},
{"descripcion":"{ 1525-002 } MOTOR ELECTRICO"},
{"descripcion":"{ 1525-003 } TRANSMISION"},
{"descripcion":"{ 1525 } EXTRACTOR HORNOS"},
{"descripcion":"{ 1526-001 } ESTRUCTURA"},
{"descripcion":"{ 1526-002 } MOTOR ELECTRICO"},
{"descripcion":"{ 1526-003 } TRANSMISION"},
{"descripcion":"{ 1526 } EXTRACTOR DE PELADORA 1 Y 2"},
{"descripcion":"{ 1527-001 } ESTRUCTURA"},
{"descripcion":"{ 1527-002 } MOTOR ELECTRICO"},
{"descripcion":"{ 1527-003 } TRANSMISION"},
{"descripcion":"{ 1527 } EXTRACTOR DE PELADORA 3 Y 4"},
{"descripcion":"{ 1528-001 } ESTRUCTURA"},
{"descripcion":"{ 1528-002 } MOTOR ELECTRICO"},
{"descripcion":"{ 1528-003 } TRANSMISION"},
{"descripcion":"{ 1528 } EXTRACTOR DE PELADORA 5 Y 6"},
{"descripcion":"{ 1530 } LINEA DE AMONIACO"},
{"descripcion":"{ 153 } BALANZA DE PISO (RECEPCION MATERIAS PRIMAS)"},
{"descripcion":"{ 159 } ANDEN MATERIAS PRIMAS"},
{"descripcion":"{ 162 } ESTANQUE FIBRA 10.000 LTS"},
{"descripcion":"{ 163-001 } ESTRUCTURA"},
{"descripcion":"{ 163-002 } MOTOR ELECTRICO"},
{"descripcion":"{ 163-003 } TRANSMISION"},
{"descripcion":"{ 163 } EXTRACTOR ANTE HORNO ALKAR"},
{"descripcion":"{ 164-001 } ESTRUCTURA"},
{"descripcion":"{ 164-002 } MOTOR ELECTRICO"},
{"descripcion":"{ 164-003 } TRANSMISION"},
{"descripcion":"{ 164 } EXTRACTOR DE CHILLER ALKAR"},
{"descripcion":"{ 167-001 } ESTRUCTURA"},
{"descripcion":"{ 167-002 } MOTOR ELECTRICO"},
{"descripcion":"{ 167-003 } TRANSMISION"},
{"descripcion":"{ 167 } EXTRACTOR POST HORNO ALKAR"},
{"descripcion":"{ 168-1 } GEA/HGX44E/665-4 S"},
{"descripcion":"{ 168-2 } CONDENSADOR"},
{"descripcion":"{ 168-3 } EVAPORADOR"},
{"descripcion":"{ 168 } U.C CAMARA 9 ORIENTE"},
{"descripcion":"{ 169-1 } COPELAND"},
{"descripcion":"{ 169-2 } CONDENSADOR"},
{"descripcion":"{ 169-3 } EVAPORADOR"},
{"descripcion":"{ 169 } U.C CAMARA 9 PONIENTE"},
{"descripcion":"{ 174 } LINEA AIRE A PRESION"},
{"descripcion":"{ 175 } LINEA DE CONDENSADO"},
{"descripcion":"{ 189 } SISTEMA DE AGUA BAJA PRESION 35 PSI"},
{"descripcion":"{ 190 } SISTEMA DE AGUA CALIENTE"},
{"descripcion":"{ 192 } SISTEMA AGUA RED INCENDIO"},
{"descripcion":"{ 194 } TRANSFORMADOR RHONA 750 KVA #2"},
{"descripcion":"{ 2000-1 } ESTRUCTURA"},
{"descripcion":"{ 2000-2 } TRANSMISION"},
{"descripcion":"{ 2000-3 } CINTA"},
{"descripcion":"{ 2000-4 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 2000 } CINTA LUTETIA #2"},
{"descripcion":"{ 2-001 } GABINETE"},
{"descripcion":"{ 2001 } TOLVA CUADRUPLE EMBUTIDORAS"},
{"descripcion":"{ 2-002 } MOTOR:BOMBA DOSIFICADORA"},
{"descripcion":"{ 2002 } TOLVA EMBUTIDORA VEMAG"},
{"descripcion":"{ 2003-1 } ESTRUCTURA"},
{"descripcion":"{ 2003-2 } SISTEMA HIDRAULICO"},
{"descripcion":"{ 2003-3 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 2-003 } MOTOR: TORCEDOR"},
{"descripcion":"{ 2003 } VOLTEADOR DE TOTEMS JAMONES"},
{"descripcion":"{ 2004-1 } MOTOR ELECTRICO"},
{"descripcion":"{ 2004-2 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 2004-3 } BOMBA"},
{"descripcion":"{ 2-004 } MOTOR: ENLAZADORA"},
{"descripcion":"{ 2005-1 } ESTRUCTURA"},
{"descripcion":"{ 2005 } LAVABOTAS MANUAL CRUDOS"},
{"descripcion":"{ 2-005 } TUBOS DE EMBUTIR"},
{"descripcion":"{ 2006-1 } SISTEMA DE TRACCION"},
{"descripcion":"{ 2006-2 } MOTOREDUCTOR"},
{"descripcion":"{ 2006-3 } RODAMIENTOS"},
{"descripcion":"{ 2006-4 } CINTA"},
{"descripcion":"{ 2006-5 } ESTRUCTURA"},
{"descripcion":"{ 2006-6 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 2-006 } BLOCK TUBO DE EMBUTIR"},
{"descripcion":"{ 2006 } TOLVA PELADORA RAPID PAK"},
{"descripcion":"{ 2007-1 } ESTANQUE"},
{"descripcion":"{ 2007-2 } ESTRUCTURA"},
{"descripcion":"{ 2007-3 } SISTEMAS NEUMATICO"},
{"descripcion":"{ 2007-4 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2007-5 } SISTEMA DE VACIO"},
{"descripcion":"{ 2007 } ESTANQUE DE TRIPAS #1"},
{"descripcion":"{ 2-007 } SEGUIDOR"},
{"descripcion":"{ 2008-1 } ESTANQUE"},
{"descripcion":"{ 2008-2 } ESTRUCTURA"},
{"descripcion":"{ 2008-3 } SISTEMAS NEUMATICO"},
{"descripcion":"{ 2008-4 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2008-5 } SISTEMA DE VACIO"},
{"descripcion":"{ 2-008 } BOMBA DOSIFICADORA"},
{"descripcion":"{ 2008 } ESTANQUE DE TRIPAS #2"},
{"descripcion":"{ 2009-1 } ESTRUCTURA"},
{"descripcion":"{ 2009 } LAVABOTAS MANUAL COCIDOS"},
{"descripcion":"{ 2-009 } TORCEDOR"},
{"descripcion":"{ 2010-1 } ESTRUCTURA"},
{"descripcion":"{ 2010-2 } TRANSMISION"},
{"descripcion":"{ 2010-3 } CINTA"},
{"descripcion":"{ 2010-4 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 2010 } CINTA SALIDA DETECTOR #2"},
{"descripcion":"{ 2-010 } PRENSA"},
{"descripcion":"{ 2011-1 } ESTRUCTURA"},
{"descripcion":"{ 2011-2 } TRANSMISION"},
{"descripcion":"{ 2011-3 } CINTA"},
{"descripcion":"{ 2011-4 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 2011 } CINTA SALIDA DETECTOR #3"},
{"descripcion":"{ 2-011 } TOLVA"},
{"descripcion":"{ 2012-1 } ESTRUCTURA"},
{"descripcion":"{ 2012-2 } TRANSMISION"},
{"descripcion":"{ 2012-3 } CINTA"},
{"descripcion":"{ 2012-4 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 2-012 } CABEZAL ESLABONADOR"},
{"descripcion":"{ 2012 } CINTA SALIDA DETECTOR #4"},
{"descripcion":"{ 2013-1 } ESTRUCTURA"},
{"descripcion":"{ 2013-2 } TRANSMISION"},
{"descripcion":"{ 2013-3 } CINTA"},
{"descripcion":"{ 2013-4 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 2013 } CINTA SALIDA DETECTOR #5"},
{"descripcion":"{ 2-013 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 2014 } CODIFICADORA LINX 7900 #5"},
{"descripcion":"{ 2-014 } SISTEMA NEUMATICO"},
{"descripcion":"{ 2015-1 } SISTEMA NEUMATICO"},
{"descripcion":"{ 2015-2 } CINTA"},
{"descripcion":"{ 2015-3 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 2015-4 } ESTRUCTURA"},
{"descripcion":"{ 2015 } DETECTOR ANRITSU KDU4518ASW #5"},
{"descripcion":"{ 2016-1 } BOMBA"},
{"descripcion":"{ 2016-2 } MOTOR ELECTRICO"},
{"descripcion":"{ 2016-3 } FILTROS"},
{"descripcion":"{ 2016-4 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2016 } BOMBA DE VACIO BUSH RD0360A5H3"},
{"descripcion":"{ 2017-1 } BOMBA"},
{"descripcion":"{ 2017-2 } MOTOR ELECTRICO"},
{"descripcion":"{ 2017-3 } FILTROS"},
{"descripcion":"{ 2017-4 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2017 } BOMBA DE VACIO RD0360A5H3"},
{"descripcion":"{ 2018-1 } BOMBA"},
{"descripcion":"{ 2018-2 } MOTOR ELECTRICO"},
{"descripcion":"{ 2018-3 } FILTROS"},
{"descripcion":"{ 2018-4 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2018 } BOMBA DE VACIO RD0360A5H3"},
{"descripcion":"{ 2019-1 } BOMBA"},
{"descripcion":"{ 2019-2 } MOTOR ELECTRICO"},
{"descripcion":"{ 2019-3 } FILTROS"},
{"descripcion":"{ 2019-4 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2019 } BOMBA DE VACIO RD0200A5Z1"},
{"descripcion":"{ 2020-1 } BOMBA"},
{"descripcion":"{ 2020-2 } MOTOR ELECTRICO"},
{"descripcion":"{ 2020-3 } FILTROS"},
{"descripcion":"{ 2020-4 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2020 } BOMBA DE VACIO RA0302 D 5H3"},
{"descripcion":"{ 2021-1 } BOMBA"},
{"descripcion":"{ 2021-2 } MOTOR ELECTRICO"},
{"descripcion":"{ 2021-3 } FILTROS"},
{"descripcion":"{ 2021-4 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2021 } BOMBA DE VACIO RA0302 D 5H3"},
{"descripcion":"{ 2022-1 } BOMBA"},
{"descripcion":"{ 2022-2 } MOTOR ELECTRICO"},
{"descripcion":"{ 2022-3 } FILTROS"},
{"descripcion":"{ 2022-4 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2022 } BOMBA DE VACIO RA0302 D 5H3"},
{"descripcion":"{ 2023-1 } BOMBA"},
{"descripcion":"{ 2023-2 } MOTOR ELECTRICO"},
{"descripcion":"{ 2023-3 } FILTROS"},
{"descripcion":"{ 2023-4 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2023 } BOMBA DE VACIO RA0160D5Z1"},
{"descripcion":"{ 2024-1 } BOMBA"},
{"descripcion":"{ 2024-2 } MOTOR ELECTRICO"},
{"descripcion":"{ 2024-3 } FILTROS"},
{"descripcion":"{ 2024-4 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2024 } BOMBA DE VACIO RA0302D5Z1 QMXX"},
{"descripcion":"{ 2025-1 } BOMBA"},
{"descripcion":"{ 2025-2 } MOTOR ELECTRICO"},
{"descripcion":"{ 2025-3 } FILTROS"},
{"descripcion":"{ 2025-4 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2025 } BOMBA DE VACIO RA0302D5Z1 QNZZ"},
{"descripcion":"{ 2026-1 } BOMBA"},
{"descripcion":"{ 2026-2 } MOTOR ELECTRICO"},
{"descripcion":"{ 2026-3 } FILTROS"},
{"descripcion":"{ 2026-4 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2026 } BOMBA DE VACIO RA0165D561 QLXX"},
{"descripcion":"{ 2027-1 } BOMBA"},
{"descripcion":"{ 2027-2 } MOTOR ELECTRICO"},
{"descripcion":"{ 2027-3 } FILTROS"},
{"descripcion":"{ 2027-4 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2027 } BOMBA DE VACIO RA0302D5Z1 QNZZ"},
{"descripcion":"{ 2028-1 } BOMBA"},
{"descripcion":"{ 2028-2 } MOTOR ELECTRICO"},
{"descripcion":"{ 2028-3 } FILTROS"},
{"descripcion":"{ 2028-4 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2028 } BOMBA DE VACIO RA0302D5Z1 QMXX"},
{"descripcion":"{ 2029-1 } BOMBA"},
{"descripcion":"{ 2029-2 } MOTOR ELECTRICO"},
{"descripcion":"{ 2029-3 } FILTROS"},
{"descripcion":"{ 2029-4 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2029 } BOMBA DE VACIO RA0040F503"},
{"descripcion":"{ 202 } ELEVADOR KOPPENS (JAMONES)"},
{"descripcion":"{ 2030-1 } MOTOR ELECTRICO"},
{"descripcion":"{ 2030-2 } TURBINAS"},
{"descripcion":"{ 2030-3 } ESCAPE"},
{"descripcion":"{ 2030-4 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2030 } TURBINA ITAHYDRAULIC SAP-450-36-1R8"},
{"descripcion":"{ 2031-1 } MOTOR ELECTRICO"},
{"descripcion":"{ 2031-2 } TURBINAS"},
{"descripcion":"{ 2031-3 } ESCAPE"},
{"descripcion":"{ 2031-4 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2031 } TURBINA ITAHYDRAULIC SAP-450-36-1R8"},
{"descripcion":"{ 2032-1 } MOTOR ELECTRICO"},
{"descripcion":"{ 2032-2 } TURBINAS"},
{"descripcion":"{ 2032-3 } ESCAPE"},
{"descripcion":"{ 2032-4 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2032 } TURBINA ITAHYDRAULIC SAP-450-36-1R8"},
{"descripcion":"{ 2033-1 } MOTOR ELECTRICO"},
{"descripcion":"{ 2033-2 } TURBINAS"},
{"descripcion":"{ 2033-3 } ESCAPE"},
{"descripcion":"{ 2033-4 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2033 } TURBINA ITAHYDRAULIC SAP-450-36-1R8"},
{"descripcion":"{ 2034-1 } MOTOR ELECTRICO"},
{"descripcion":"{ 2034-2 } TURBINAS"},
{"descripcion":"{ 2034-3 } ESCAPE"},
{"descripcion":"{ 2034-4 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2034 } TURBINA ITAHYDRAULIC SAP-450-36-1R8"},
{"descripcion":"{ 2035-1 } MOTOR ELECTRICO"},
{"descripcion":"{ 2035-2 } TURBINAS"},
{"descripcion":"{ 2035-3 } ESCAPE"},
{"descripcion":"{ 2035-4 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2035 } TURBINA BUSH SB0530D0H0 UJ XX"},
{"descripcion":"{ 2037-1 } MOTOR ELECTRICO"},
{"descripcion":"{ 2037-2 } TURBINAS"},
{"descripcion":"{ 2037-3 } ESCAPE"},
{"descripcion":"{ 2037-4 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2037 } TURBINA BUSH SB0530D0H0 UJ XX"},
{"descripcion":"{ 2038-1 } BOMBA DE AGUA"},
{"descripcion":"{ 2038-2 } ASPERSORES"},
{"descripcion":"{ 2038-3 } MOTOVENTILADORES"},
{"descripcion":"{ 2038-4 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 2038 } CONDENSADOR EVAP (GUNTNER)"},
{"descripcion":"{ 2039-1 } BOMBAS"},
{"descripcion":"{ 2039-2 } SISTEMA DE VALVULAS"},
{"descripcion":"{ 2039-3 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 2039 } INTERCAMBIADOR DE CALOR"},
{"descripcion":"{ 2040-1 } VALVULAS"},
{"descripcion":"{ 2040-2 } BOMBAS RECIRCULADORAS (NH3)"},
{"descripcion":"{ 2040 } ESTANQUE RECIRCULADOR CAMARA 3 Y 4"},
{"descripcion":"{ 2041-1 } VALVULAS"},
{"descripcion":"{ 2041-2 } BOMBAS RECIRCULADORAS (NH3)"},
{"descripcion":"{ 2041 } ESTANQUE RECIRCULADOR CAMARA 1"},
{"descripcion":"{ 2042-1 } MOTOR ELECTRICO"},
{"descripcion":"{ 2042-2 } IMPULSOR"},
{"descripcion":"{ 2042-3 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2042 } BOMBA WITT GP51 #1"},
{"descripcion":"{ 2043-1 } MOTOR ELECTRICO"},
{"descripcion":"{ 2043-2 } IMPULSOR"},
{"descripcion":"{ 2043-3 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2043 } BOMBA WITT GP51 #2"},
{"descripcion":"{ 2044-1 } MOTOR ELECTRICO"},
{"descripcion":"{ 2044-2 } IMPULSOR"},
{"descripcion":"{ 2044-3 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2044 } BOMBA WITT GP42 REL 85 #1"},
{"descripcion":"{ 2045-1 } MOTOR ELECTRICO"},
{"descripcion":"{ 2045-2 } IMPULSOR"},
{"descripcion":"{ 2045-3 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2045 } BOMBA WITT GP42 REL 85 #2"},
{"descripcion":"{ 2046-1 } MOTOR ELECTRICO"},
{"descripcion":"{ 2046-2 } IMPULSOR"},
{"descripcion":"{ 2046-3 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2046 } BOMBA REGGIO SN32-160A (GLICOL) #1"},
{"descripcion":"{ 2047-1 } MOTOR ELECTRICO"},
{"descripcion":"{ 2047-2 } IMPULSOR"},
{"descripcion":"{ 2047-3 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2047 } BOMBA REGGIO SN32-160A (GLICOL) #2"},
{"descripcion":"{ 2048-1 } FRASCOLD/Q4-21.1Y1000"},
{"descripcion":"{ 2048-2 } CONDENSADOR"},
{"descripcion":"{ 2048-3 } EVAPORADOR"},
{"descripcion":"{ 2048 } U.C SALA EMPAQUE 2"},
{"descripcion":"{ 2049-1 } BITZER/4HE-25Y-40P"},
{"descripcion":"{ 2049-2 } CONDENSADOR"},
{"descripcion":"{ 2049-3 } EVAPORADOR"},
{"descripcion":"{ 2049 } U.C SALA LUTETIA 2"},
{"descripcion":"{ 2050-1 } MOTOR ELECTRICO"},
{"descripcion":"{ 2050-2 } IMPULSOR"},
{"descripcion":"{ 2050-3 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2050 } BOMBA KBS EMPORIA NBC 32"},
{"descripcion":"{ 2051-1 } MOTOR ELECTRICO"},
{"descripcion":"{ 2051-2 } IMPULSOR"},
{"descripcion":"{ 2051-3 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2051 } BOMBA REGGIO SN32-160A"},
{"descripcion":"{ 2052-1 } MOTOR ELECTRICO"},
{"descripcion":"{ 2052-2 } IMPULSOR"},
{"descripcion":"{ 2052-3 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2052 } BOMBA PEDROLLO F32/200B"},
{"descripcion":"{ 2053-1 } MOTOR ELECTRICO"},
{"descripcion":"{ 2053-2 } IMPULSOR"},
{"descripcion":"{ 2053-3 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2053 } BOMBA PEDROLLO F32/200B"},
{"descripcion":"{ 2054-1 } MOTOR ELECTRICO"},
{"descripcion":"{ 2054-2 } IMPULSOR"},
{"descripcion":"{ 2054-3 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2054 } BOMBA PEDROLLO F32/200B"},
{"descripcion":"{ 2055-1 } MOTOR ELECTRICO"},
{"descripcion":"{ 2055-2 } IMPULSOR"},
{"descripcion":"{ 2055-3 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2055 } BOMBA PEDROLLO NCB65-160/C"},
{"descripcion":"{ 2056-1 } MOTOR ELECTRICO"},
{"descripcion":"{ 2056-2 } IMPULSOR"},
{"descripcion":"{ 2056-3 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2056 } BOMBA PEDROLLO HE70B"},
{"descripcion":"{ 2057-1 } MOTOR ELECTRICO"},
{"descripcion":"{ 2057-2 } IMPULSOR"},
{"descripcion":"{ 2057-3 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2057 } BOMBA PEDROLLO HE70B"},
{"descripcion":"{ 2058-1 } MOTOR ELECTRICO"},
{"descripcion":"{ 2058-2 } IMPULSOR"},
{"descripcion":"{ 2058-3 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2058 } BOMBA PEDROLLO HE70B"},
{"descripcion":"{ 2059-1 } MOTOR ELECTRICO"},
{"descripcion":"{ 2059-2 } IMPULSOR"},
{"descripcion":"{ 2059-3 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2059 } BOMBA PEDROLLO HF5AM"},
{"descripcion":"{ 2060-1 } MOTOR ELECTRICO"},
{"descripcion":"{ 2060-2 } IMPULSOR"},
{"descripcion":"{ 2060-3 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2060 } BOMBA REGGIO SN65-160 E"},
{"descripcion":"{ 2061-1 } MOTOR ELECTRICO"},
{"descripcion":"{ 2061-2 } IMPULSOR"},
{"descripcion":"{ 2061-3 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2061 } BOMBA REGGIO SN65-160E"},
{"descripcion":"{ 2062-1 } MOTOR ELECTRICO"},
{"descripcion":"{ 2062-2 } IMPULSOR"},
{"descripcion":"{ 2062-3 } SISTEMA ELECTRICO"},
{"descripcion":"{ 2062 } BOMBA KSB EMPORIA GC-202/2T2"},
{"descripcion":"{ 2063 } TERMO SPLENDID WM-100L"},
{"descripcion":"{ 2064 } TERMO WINTER T6.0 300 AC/M 300L"},
{"descripcion":"{ 2065-1 } ESTRUCTURA"},
{"descripcion":"{ 2065-2 } MOTOR ELECTRICO"},
{"descripcion":"{ 2065-3 } TRANSMISION"},
{"descripcion":"{ 2065 } EXTRACTOR CHILLER AHUMADOR"},
{"descripcion":"{ 2066-1 } ESTRUCTURA"},
{"descripcion":"{ 2066-2 } MOTOR ELECTRICO"},
{"descripcion":"{ 2066-3 } TRANSMISION"},
{"descripcion":"{ 2066 } EXTRACTOR SALA DE EMBUTIDOS #1"},
{"descripcion":"{ 2067-1 } TURBINA"},
{"descripcion":"{ 2067-2 } MOTOR ELECTRICO"},
{"descripcion":"{ 2067 } EXTRACTOR SALA DE EMBUTIDOS #2"},
{"descripcion":"{ 2068-1 } TURBINA"},
{"descripcion":"{ 2068-2 } MOTOR ELECTRICO"},
{"descripcion":"{ 2068 } EXTRACTOR SALA DE EMBUTIDOS #3"},
{"descripcion":"{ 2069-1 } TURBINA"},
{"descripcion":"{ 2069-2 } MOTOR ELECTRICO"},
{"descripcion":"{ 2069 } EXTRACTOR SALA DE EMBUTIDOS #4"},
{"descripcion":"{ 2070_1 } ESTRUCTURA"},
{"descripcion":"{ 2070_2 } MOTOR ELECTRICO"},
{"descripcion":"{ 2070_3 } TRANSMISION"},
{"descripcion":"{ 2070 } EXTRACTOR S&P"},
{"descripcion":"{ 2071-1 } VALVULAS"},
{"descripcion":"{ 2071 } ESTANQUE PULMON DE AIRE"},
{"descripcion":"{ 2072 } BLACK BEAR YSH-100 1"},
{"descripcion":"{ 2073 } BLACK BEAR YSH-100 2"},
{"descripcion":"{ 2074 } BLACK BEAR(SIN PLACA)"},
{"descripcion":"{ 2075 } BLACK BEAR KSN03"},
{"descripcion":"{ 209-001 } ESTRUCTURA"},
{"descripcion":"{ 209-002 } CHIMENEAS"},
{"descripcion":"{ 209-003 } COMPUERTAS ROTATIVAS"},
{"descripcion":"{ 209-004 } TRANSMISION COMPUERTAS"},
{"descripcion":"{ 209-005 } BLOWER"},
{"descripcion":"{ 209-006 } MOTOR PRINCIPAL"},
{"descripcion":"{ 209-007 } TRANSMISION MOTOR PRINCIPAL"},
{"descripcion":"{ 209-008 } RADIADORES"},
{"descripcion":"{ 209-009 } SISTEMA NEUMATICO"},
{"descripcion":"{ 209-010 } SISTEMA ELECTRICO"},
{"descripcion":"{ 209-011 } SISTEMA DE VAPOR"},
{"descripcion":"{ 209 } HORNO ALKAR #1"},
{"descripcion":"{ 210-001 } ESTRUCTURA"},
{"descripcion":"{ 210-002 } CHIMENEAS"},
{"descripcion":"{ 210-003 } COMPUERTAS ROTATIVAS"},
{"descripcion":"{ 210-004 } TRANSMISION COMPUERTAS"},
{"descripcion":"{ 210-005 } BLOWER"},
{"descripcion":"{ 210-006 } MOTOR PRINCIPAL"},
{"descripcion":"{ 210-007 } TRANSMISION MOTOR PRINCIPAL"},
{"descripcion":"{ 210-008 } RADIADORES"},
{"descripcion":"{ 210-009 } SISTEMA NEUMATICO"},
{"descripcion":"{ 210-010 } SISTEMA ELECTRICO"},
{"descripcion":"{ 210-011 } SISTEMA DE VAPOR"},
{"descripcion":"{ 210 } HORNO ALKAR #2"},
{"descripcion":"{ 211-001 } ESTRUCTURA"},
{"descripcion":"{ 211-002 } CHIMENEAS"},
{"descripcion":"{ 211-003 } COMPUERTAS ROTATIVAS"},
{"descripcion":"{ 211-004 } TRANSMISION COMPUERTAS"},
{"descripcion":"{ 211-005 } BLOWER"},
{"descripcion":"{ 211-006 } MOTOR PRINCIPAL"},
{"descripcion":"{ 211-007 } TRANSMISION MOTOR PRINCIPAL"},
{"descripcion":"{ 211-008 } RADIADORES"},
{"descripcion":"{ 211-009 } SISTEMA NEUMATICO"},
{"descripcion":"{ 211-010 } SISTEMA ELECTRICO"},
{"descripcion":"{ 211-011 } SISTEMA DE VAPOR"},
{"descripcion":"{ 211 } HORNO ALKAR #3"},
{"descripcion":"{ 216-01 } ESTRUCTURA"},
{"descripcion":"{ 216-02 } TRANSPORTADOR Y TRANSMISION"},
{"descripcion":"{ 216-03 } ANILLADOR"},
{"descripcion":"{ 216-04 } TUBERIAS Y BOQUILLAS DE PULVERIZACION"},
{"descripcion":"{ 216-05 } BOMBA"},
{"descripcion":"{ 216-06 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 216 } SMOKE-A-MATIC #1"},
{"descripcion":"{ 217-001 } ESTRUCTURA"},
{"descripcion":"{ 217-002 } TRANSPORTADOR Y TRANSMISION"},
{"descripcion":"{ 217-003 } ANILLADOR"},
{"descripcion":"{ 217-004 } TUBERIAS Y BOQUILLAS DE PULVERIZACION"},
{"descripcion":"{ 217-005 } BOMBA"},
{"descripcion":"{ 217-006 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 217 } SMOKE-A-MATIC #2"},
{"descripcion":"{ 221-001 } MOTOREDUCTOR"},
{"descripcion":"{ 221-002 } CADENA DE ARRASTRE"},
{"descripcion":"{ 221-003 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 221 } LINEA DE BANDEJAS LIMPIAS"},
{"descripcion":"{ 250-001 } ESTRUCTURA"},
{"descripcion":"{ 250-002 } MOTOREDUCTOR"},
{"descripcion":"{ 250-003 } TRANSMISION"},
{"descripcion":"{ 250-004 } TRANSPORTADOR DE CARGA"},
{"descripcion":"{ 250-005 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 250 } ELEVADOR MEZCLADOR NOTHUM 3000"},
{"descripcion":"{ 251-001 } ESTRUCTURA"},
{"descripcion":"{ 251-002 } TOLVA"},
{"descripcion":"{ 251-003 } COMPUERTA DE DESCARGA"},
{"descripcion":"{ 251-004 } TRANSMISION"},
{"descripcion":"{ 251-005 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 251-006 } SISTEMA NEUMATICO"},
{"descripcion":"{ 251 } MEZCLADOR NOTHUM 3000"},
{"descripcion":"{ 269-001 } ESTRUCTURA"},
{"descripcion":"{ 269-002 } SISTEMA DE CARGA"},
{"descripcion":"{ 269-003 } SISTEMA DE CORTE"},
{"descripcion":"{ 269-004 } TRANSMISION DE CORTE"},
{"descripcion":"{ 269-005 } TRANSMISION DE PLATO"},
{"descripcion":"{ 269-006 } SISTEMA DE DESCARGA (RACHA)"},
{"descripcion":"{ 269-007 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 269-008 } SISTEMA HIDRAULICO"},
{"descripcion":"{ 269 } CUTTER KILIA"},
{"descripcion":"{ 274 } CODIFICADORA LINX 7900 #1"},
{"descripcion":"{ 276-001 } ESTRUCTURA"},
{"descripcion":"{ 276-002 } RODAMIENTOS"},
{"descripcion":"{ 276-003 } SISTEMA NEUMATICO"},
{"descripcion":"{ 276-004 } SISTEMA VAPOR"},
{"descripcion":"{ 276-005 } TRANSMISION (TERMO RETRACTIL)"},
{"descripcion":"{ 276-006 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 276 } TERMO RETRACTIL"},
{"descripcion":"{ 2 } ESLABONADORA NL17 #1"},
{"descripcion":"{ 3000-1 } CONDENSADOR GUNTNER"},
{"descripcion":"{ 3000-2 } COMPRESOR : FRICK, MYCOM NL200, MYCOM 4B/8A"},
{"descripcion":"{ 3000 } CHILLER SALMUERA"},
{"descripcion":"{ 3-001 } ESTRUCTURA"},
{"descripcion":"{ 3-002 } TRANSPORTADOR Y TRANSMISION"},
{"descripcion":"{ 3-003 } ANILLADOR"},
{"descripcion":"{ 3-004 } TUBERIAS Y BOQUILLAS DE PULVERIZACION"},
{"descripcion":"{ 3-005 } BOMBA"},
{"descripcion":"{ 3-006 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 301-001 } GABINETE Y ESTRUCTURA"},
{"descripcion":"{ 301-002 } MANDO"},
{"descripcion":"{ 301-003 } CABEZAL DE VACIO"},
{"descripcion":"{ 301-004 } SOPORTE MOVIL INTERMEDIO"},
{"descripcion":"{ 301-005 } TUBOS"},
{"descripcion":"{ 301-006 } SISTEMA ELECTRICO"},
{"descripcion":"{ 301-007 } CONEXIONES DE AIRE Y VAPOR"},
{"descripcion":"{ 301 } PELADORA 2600 #1"},
{"descripcion":"{ 3020-1 } SISTEMA ELECTRICO"},
{"descripcion":"{ 3020-2 } ESCAPE"},
{"descripcion":"{ 3020-3 } TURBINAS"},
{"descripcion":"{ 3020-4 } MOTOR ELECTRICO"},
{"descripcion":"{ 3020 } TURBINA BUSH SB0530D0H0 UJ XX"},
{"descripcion":"{ 306-001 } GABINETE Y ESTRUCTURA"},
{"descripcion":"{ 306-002 } MANDO"},
{"descripcion":"{ 306-003 } CABEZAL DE VACIO"},
{"descripcion":"{ 306-004 } SOPORTE MOVIL INTERMEDIO"},
{"descripcion":"{ 306-005 } TUBOS"},
{"descripcion":"{ 306-006 } SISTEMA ELECTRICO"},
{"descripcion":"{ 306-007 } CONEXIONES DE AIRE Y VAPOR"},
{"descripcion":"{ 306 } PELADORA 2600 #2"},
{"descripcion":"{ 3070-1 } SISTEMA DE VALVULAS"},
{"descripcion":"{ 3070 } MEZCLADOR AGUA/VAPOR BACKUP N 13"},
{"descripcion":"{ 3080-1 } SISTEMA DE VALVULAS"},
{"descripcion":"{ 3080 } MEZCLADOR AGUA/VAPOR PELADORAS N 9"},
{"descripcion":"{ 3081-1 } SISTEMA DE VALVULAS"},
{"descripcion":"{ 3081 } MEZCLADOR AGUA/VAPOR POST HORNOS N 7"},
{"descripcion":"{ 3082-1 } SISTEMA DE VALVULAS"},
{"descripcion":"{ 3082 } MEZCLADOR AGUA/VAPOR CUTTER N 3"},
{"descripcion":"{ 3083-1 } SISTEMA DE VALVULAS"},
{"descripcion":"{ 3083 } MEZCLADOR AGUA/VAPOR UTENSILIOS SUCIOS N 2"},
{"descripcion":"{ 357-001 } ESTRUCTURA"},
{"descripcion":"{ 357-002 } MOTOR ELECTRICO"},
{"descripcion":"{ 357-003 } TRANSMISION"},
{"descripcion":"{ 357 } EXTRACTOR VAPOR PELADORA"},
{"descripcion":"{ 361-01 } TRANSPORTADOR ELEVADOR DE SUMINISTRO"},
{"descripcion":"{ 361-02 } COLLATOR"},
{"descripcion":"{ 361-03 } TRANSPORTADOR INTERMEDIO"},
{"descripcion":"{ 361-04 } CABEZAL DE CARGA"},
{"descripcion":"{ 361-05 } TRANSPORTADOR DE ALIMENTACION CRUZADA"},
{"descripcion":"{ 361-06 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 361 } DRAKE 1300"},
{"descripcion":"{ 3 } SMOKE-A-MATIC #3"},
{"descripcion":"{ 400-001 } ESTRUCTURA"},
{"descripcion":"{ 400-002 } MOTOR PRINCIPAL"},
{"descripcion":"{ 400-003 } REDUCTOR"},
{"descripcion":"{ 400-004 } SISTEMA DE CORTE"},
{"descripcion":"{ 400-005 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 400 } MOLEDOR BUFFALO"},
{"descripcion":"{ 4015-1 } EVAPORADOR"},
{"descripcion":"{ 4015-2 } CONDENSADOR"},
{"descripcion":"{ 4015-3 } COMPRESOR"},
{"descripcion":"{ 4015 } U.C SALA LUTETIA 1"},
{"descripcion":"{ 4016-1 } EVAPORADOR"},
{"descripcion":"{ 4016-2 } CONDENSADOR GUNTNER"},
{"descripcion":"{ 4016-3 } COMPRESOR : FRICK, MYCOM NL200, MYCOM 4B/8A"},
{"descripcion":"{ 4016 } U.C CAMARA 5"},
{"descripcion":"{ 4017-1 } EVAPORADOR"},
{"descripcion":"{ 4017-2 } CONDENSADOR GUNTNER"},
{"descripcion":"{ 4017-3 } COMPRESOR : FRICK, MYCOM NL200, MYCOM 4B/8A"},
{"descripcion":"{ 4017 } U.C CAMARA 4"},
{"descripcion":"{ 4018-1 } EVAPORADOR"},
{"descripcion":"{ 4018-2 } CONDENSADOR GUNTNER"},
{"descripcion":"{ 4018-3 } COMPRESOR : FRICK, MYCOM NL200, MYCOM 4B/8A"},
{"descripcion":"{ 4018 } U.C CAMARA 3"},
{"descripcion":"{ 4019-1 } EVAPORADOR"},
{"descripcion":"{ 4019-2 } CONDENSADOR GUNTNER"},
{"descripcion":"{ 4019-3 } COMPRESOR : FRICK, MYCOM NL200, MYCOM 4B/8A"},
{"descripcion":"{ 4019 } U.C CAMARA 1"},
{"descripcion":"{ 403-001 } ESTRUCTURA"},
{"descripcion":"{ 403-002 } TAMBOR"},
{"descripcion":"{ 403-003 } MOTOREDUCTOR Y TRANSMISION"},
{"descripcion":"{ 403-004 } SISTEMA DE VACIO"},
{"descripcion":"{ 403-005 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 403 } MASAJEADOR DORIT 1400 #1"},
{"descripcion":"{ 404-001 } ESTRUCTURA"},
{"descripcion":"{ 404-002 } TAMBOR"},
{"descripcion":"{ 404-003 } MOTOREDUCTOR Y TRANSMISION"},
{"descripcion":"{ 404-004 } SISTEMA DE VACIO"},
{"descripcion":"{ 404-005 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 404 } MASAJEADOR DORIT 2000"},
{"descripcion":"{ 408-001 } ESTRUCTURA"},
{"descripcion":"{ 408-002 } TRANSMISION"},
{"descripcion":"{ 408-003 } CINTA"},
{"descripcion":"{ 408-004 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 408 } CINTA ALIMENTACION BUFFALO"},
{"descripcion":"{ 409-001 } ESTRUCTURA"},
{"descripcion":"{ 409-002 } TAMBOR"},
{"descripcion":"{ 409-003 } MOTOREDUCTOR Y TRANSMISION"},
{"descripcion":"{ 409-004 } SISTEMA DE VACIO"},
{"descripcion":"{ 409-005 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 409 } TUMBLER OSTRO"},
{"descripcion":"{ 412-1 } BITZER/4HE-25Y-40P"},
{"descripcion":"{ 412-2 } CONDENSADOR"},
{"descripcion":"{ 412-3 } EVAPORADOR"},
{"descripcion":"{ 412 } U.C CAMARA 6"},
{"descripcion":"{ 450-001 } ESTRUCTURA"},
{"descripcion":"{ 450-002 } MOTOR ELECTRICO"},
{"descripcion":"{ 450-003 } REVOLVEDOR"},
{"descripcion":"{ 450-004 } SUMINISTRO DE AGUA"},
{"descripcion":"{ 450-005 } BOMBA"},
{"descripcion":"{ 450-006 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 450 } MEZCLADOR DE SALMUERA"},
{"descripcion":"{ 6002-001 } GABINETE Y ESTRUCTURA"},
{"descripcion":"{ 6002-002 } CABEZAL DE CORTE"},
{"descripcion":"{ 6002-003 } SISTEMA DE EMPUJE"},
{"descripcion":"{ 6002-004 } BANDAS DE TRANSPORTE"},
{"descripcion":"{ 6002-005 } SISTEMA DE GARRAS"},
{"descripcion":"{ 6002-006 } CINTA DE TRANSPORTE"},
{"descripcion":"{ 6002-007 } CINTA DE SALIDA"},
{"descripcion":"{ 6002-008 } CINTA DE DESCARTE"},
{"descripcion":"{ 6002-009 } SOPORTE DE PRODUCTO"},
{"descripcion":"{ 6002-010 } SISTEMA NEUMATICO"},
{"descripcion":"{ 6002-011 } SISTEMA ELEVACION (CINTA DE SALIDA)"},
{"descripcion":"{ 6002-012 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 6002 } LAMINADORA WEBER CCS 404 UB"},
{"descripcion":"{ 6003-001 } ESTACION DE FILM INFERIOR"},
{"descripcion":"{ 6003-002 } ESTACION DE FORMADO"},
{"descripcion":"{ 6003-003 } ESTACION DE CARGA"},
{"descripcion":"{ 6003-004 } ESTACION DE FILM SUPERIOR"},
{"descripcion":"{ 6003-005 } ESTACION DE SELLADO"},
{"descripcion":"{ 6003-006 } ESTACION DE CORTE"},
{"descripcion":"{ 6003-007 } CINTA DE SALIDA"},
{"descripcion":"{ 6003-008 } CADENA DE ARRASTRE"},
{"descripcion":"{ 6003-009 } SISTEMA ELECTRICO"},
{"descripcion":"{ 6003-010 } SISTEMA NEUMATICO"},
{"descripcion":"{ 6003-011 } SISTEMA DE VACIO"},
{"descripcion":"{ 6003-012 } SUMINISTRO DE AGUA"},
{"descripcion":"{ 6003-013 } CHILLER CHILLY 45 400V-S (R-535 A)"},
{"descripcion":"{ 6003 } RAPIDPAK RP 55"},
{"descripcion":"{ 6004-001 } ESTACION DE FILM INFERIOR"},
{"descripcion":"{ 6004-002 } ESTACION DE FORMADO"},
{"descripcion":"{ 6004-003 } ESTACION DE CARGA"},
{"descripcion":"{ 6004-004 } ESTACION DE FILM SUPERIOR"},
{"descripcion":"{ 6004-005 } ESTACION DE SELLADO"},
{"descripcion":"{ 6004-006 } ESTACION DE CORTE"},
{"descripcion":"{ 6004-007 } CINTA DE SALIDA"},
{"descripcion":"{ 6004-008 } CADENA DE ARRASTRE"},
{"descripcion":"{ 6004-009 } SISTEMA ELECTRICO"},
{"descripcion":"{ 6004-010 } SISTEMA NEUMATICO"},
{"descripcion":"{ 6004-011 } SISTEMA DE VACIO"},
{"descripcion":"{ 6004-012 } SUMINISTRO DE AGUA"},
{"descripcion":"{ 6004 } MULTIVAC R-245"},
{"descripcion":"{ 6005-001 } GABINETE"},
{"descripcion":"{ 6005-002 } MOTOREDUCTOR Y TRANSMISION"},
{"descripcion":"{ 6005-003 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 6005-004 } SUMINISTRO DE AGUA"},
{"descripcion":"{ 6005-005 } RODAMIENTOS"},
{"descripcion":"{ 6005-006 } RODILLOS"},
{"descripcion":"{ 6005-007 } BOMBA DOSIFICADORA"},
{"descripcion":"{ 6005 } LAVABOTAS ELECTRICO COCIDOS"},
{"descripcion":"{ 6006-01 } TRANSPORTADOR ELEVADOR DE SUMINISTRO"},
{"descripcion":"{ 6006-02 } COLLATOR"},
{"descripcion":"{ 6006-03 } TRANSPORTADOR INTERMEDIO"},
{"descripcion":"{ 6006-04 } CABEZAL DE CARGA"},
{"descripcion":"{ 6006-05 } TRANSPORTADOR DE ALIMENTACION CRUZADA"},
{"descripcion":"{ 6006-06 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 6006 } DRAKE 1800"},
{"descripcion":"{ 6007-001 } GABINETE Y ESTRUCTURA"},
{"descripcion":"{ 6007-002 } MANDO"},
{"descripcion":"{ 6007-003 } CABEZAL DE VACIO"},
{"descripcion":"{ 6007-004 } SOPORTE MOVIL INTERMEDIO"},
{"descripcion":"{ 6007-005 } TUBOS"},
{"descripcion":"{ 6007-006 } SISTEMA ELECTRICO"},
{"descripcion":"{ 6007-007 } CONEXIONES DE AIRE Y VAPOR"},
{"descripcion":"{ 6007 } PELADORA 2600 #3"},
{"descripcion":"{ 6008-001 } GABINETE Y ESTRUCTURA"},
{"descripcion":"{ 6008-002 } MANDO"},
{"descripcion":"{ 6008-003 } CABEZAL DE VACIO"},
{"descripcion":"{ 6008-004 } SOPORTE MOVIL INTERMEDIO"},
{"descripcion":"{ 6008-005 } TUBOS"},
{"descripcion":"{ 6008-006 } SISTEMA ELECTRICO"},
{"descripcion":"{ 6008-007 } CONEXIONES DE AIRE Y VAPOR"},
{"descripcion":"{ 6008 } PELADORA 2600 #4"},
{"descripcion":"{ 6010-001 } ESTRUCTURA"},
{"descripcion":"{ 6010-002 } TRANSMISION"},
{"descripcion":"{ 6010-003 } CINTA"},
{"descripcion":"{ 6010-004 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 6010 } CINTA SALIDA RAPID PAK"},
{"descripcion":"{ 6011-001 } BOMBA CENTRIFUGA"},
{"descripcion":"{ 6011 } ESTANQUE HUMO LIQUIDO"},
{"descripcion":"{ 6012-001 } ESTRUCTURA"},
{"descripcion":"{ 6012-002 } SISTEMA HIDRAULICO"},
{"descripcion":"{ 6012-003 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 6012 } VOLTEADOR DE TOTEMS MEZCLADORES"},
{"descripcion":"{ 6013-001 } ESTRUCTURA"},
{"descripcion":"{ 6013-002 } TUBO DE EMBUTIR"},
{"descripcion":"{ 6013-003 } FRENO"},
{"descripcion":"{ 6013-004 } SISTEMA CLIPEADO"},
{"descripcion":"{ 6013-005 } TRANSMISION CLIPEADO (PRINCIPAL)"},
{"descripcion":"{ 6013-006 } SISTEMA DE CORTE"},
{"descripcion":"{ 6013-007 } SISTEMA IRIS"},
{"descripcion":"{ 6013-008 } CINTA DESCARGA"},
{"descripcion":"{ 6013-009 } SISTEMA NEUMATICO"},
{"descripcion":"{ 6013-010 } SISTEMA DE LAZO"},
{"descripcion":"{ 6013-011 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 6013 } POLY CLIP ICA 8700"},
{"descripcion":"{ 6015 } CODIFICADORA LINX 7900 #3"},
{"descripcion":"{ 6016 } CODIFICADORA LINX 7900 #4"},
{"descripcion":"{ 6018-1 } SISTEMA NEUMATICO"},
{"descripcion":"{ 6018-2 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 6018-3 } ESTRUCTURA"},
{"descripcion":"{ 6018 } DETECTOR SAFELINE PL63"},
{"descripcion":"{ 6019-1 } SISTEMA NEUMATICO"},
{"descripcion":"{ 6019-2 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 6019-3 } ESTRUCTURA"},
{"descripcion":"{ 6019 } DETECTOR DETECTRONIC 607KB"},
{"descripcion":"{ 6021-1 } SISTEMA NEUMATICO"},
{"descripcion":"{ 6021-2 } CINTA"},
{"descripcion":"{ 6021-3 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 6021-4 } ESTRUCTURA"},
{"descripcion":"{ 6021 } DETECTOR ANRITSU KD8115AW #3"},
{"descripcion":"{ 6022-1 } SISTEMA NEUMATICO"},
{"descripcion":"{ 6022-2 } CINTA"},
{"descripcion":"{ 6022-3 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 6022-4 } ESTRUCTURA"},
{"descripcion":"{ 6023-001 } MOTOR ELECTRICO"},
{"descripcion":"{ 6023-002 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 6023-003 } BOMBA"},
{"descripcion":"{ 6023 } BOMBA SINE EC-40 JAMONES"},
{"descripcion":"{ 6024-001 } MOTOR ELECTRICO"},
{"descripcion":"{ 6024-002 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 6024-003 } BOMBA"},
{"descripcion":"{ 6024 } BOMBA SINE MR-130 #1"},
{"descripcion":"{ 6025-001 } ESTRUCTURA"},
{"descripcion":"{ 6025-002 } SISTEMA NEUMATICO"},
{"descripcion":"{ 6025-003 } SISTEMA TRANSPORTADOR"},
{"descripcion":"{ 6025-004 } TRANSMISION POR CORREA"},
{"descripcion":"{ 6025-005 } ACCIONAMIENTO DE HUSILLOS DE ALIMENTACION"},
{"descripcion":"{ 6025-006 } CAJA DE ENGRANAJES"},
{"descripcion":"{ 6025-007 } TOLVA"},
{"descripcion":"{ 6025-008 } BLOQUEO TOLVA"},
{"descripcion":"{ 6025-009 } AMORTIGUACION DE LA TOLVA"},
{"descripcion":"{ 6025-010 } ACCIONAMIENTO MECANISMO TRANSPORTADOR"},
{"descripcion":"{ 6025-011 } SISTEMA DE VACIO"},
{"descripcion":"{ 6025-012 } CAJA DE HUSILLOS Y TUBO DE EMBUCHADO"},
{"descripcion":"{ 6025-013 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 6025 } EMBUTIDORA VEMAG HP 15 E"},
{"descripcion":"{ 6026-001 } COMPUERTA DE DESCARGA"},
{"descripcion":"{ 6026-002 } SINFIN"},
{"descripcion":"{ 6026-003 } MOTOREDUCTOR"},
{"descripcion":"{ 6026-004 } SISTEMA ELECTRICO"},
{"descripcion":"{ 6026 } TOLVA SALIDA MEZCLADORES INOTEC"},
{"descripcion":"{ 6027-001 } ESTRUCTURA"},
{"descripcion":"{ 6027-002 } COMPUERTA DE DESCARGA"},
{"descripcion":"{ 6027-003 } SINFIN"},
{"descripcion":"{ 6027-004 } MOTOREDUCTOR NT"},
{"descripcion":"{ 6027-005 } SISTEMA ELECTRICO"},
{"descripcion":"{ 6027 } TOLVA SALIDA MEZCLADOR NOTHUM"},
{"descripcion":"{ 6028-001 } ESTRUCTURA"},
{"descripcion":"{ 6028-002 } TOLVA"},
{"descripcion":"{ 6028-003 } SISTEMA DE CORTE"},
{"descripcion":"{ 6028-004 } MOTOR PRINCIPAL"},
{"descripcion":"{ 6028-005 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 6029-01 } GABINETE"},
{"descripcion":"{ 6029-02 } MOTOR:BOMBA DOSIFICADORA"},
{"descripcion":"{ 6029-03 } MOTOR: TORCEDOR"},
{"descripcion":"{ 6029-04 } MOTOR: ENLAZADORA"},
{"descripcion":"{ 6029-05 } TUBOS DE EMBUTIR"},
{"descripcion":"{ 6029-06 } BLOCK TUBO DE EMBUTIR"},
{"descripcion":"{ 6029-07 } SEGUIDOR"},
{"descripcion":"{ 6029-08 } BOMBA DOSIFICADORA"},
{"descripcion":"{ 6029-09 } TORCEDOR"},
{"descripcion":"{ 6029-10 } PRENSA"},
{"descripcion":"{ 6029-11 } TOLVA"},
{"descripcion":"{ 6029-12 } CABEZAL ESLABONADOR"},
{"descripcion":"{ 6029-13 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 6029-14 } SISTEMA NEUMATICO"},
{"descripcion":"{ 6029 } ESLABONADORA NL17 #2"},
{"descripcion":"{ 6030-01 } GABINETE"},
{"descripcion":"{ 6030-02 } MOTOR:BOMBA DOSIFICADORA"},
{"descripcion":"{ 6030-03 } MOTOR: TORCEDOR"},
{"descripcion":"{ 6030-04 } MOTOR: ENLAZADORA"},
{"descripcion":"{ 6030-05 } TUBOS DE EMBUTIR"},
{"descripcion":"{ 6030-06 } BLOCK TUBO DE EMBUTIR"},
{"descripcion":"{ 6030-07 } SEGUIDOR"},
{"descripcion":"{ 6030-08 } BOMBA DOSIFICADORA"},
{"descripcion":"{ 6030-09 } TORCEDOR"},
{"descripcion":"{ 6030-10 } PRENSA"},
{"descripcion":"{ 6030-11 } TOLVA"},
{"descripcion":"{ 6030-12 } CABEZAL ESLABONADOR"},
{"descripcion":"{ 6030-13 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 6030-14 } SISTEMA NEUMATICO"},
{"descripcion":"{ 6030 } ESLABONADORA NL17 #3"},
{"descripcion":"{ 6031-001 } GABINETE"},
{"descripcion":"{ 6031-002 } MOTOREDUCTOR Y TRANSMISION"},
{"descripcion":"{ 6031-003 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 6031-004 } SUMINISTRO DE AGUA"},
{"descripcion":"{ 6031-005 } RODAMIENTOS"},
{"descripcion":"{ 6031-006 } RODILLOS"},
{"descripcion":"{ 6031-007 } BOMBA DOSIFICADORA"},
{"descripcion":"{ 6031 } LAVABOTAS ELECTRICO CRUDOS"},
{"descripcion":"{ 6033-001 } ESTRUCTURA"},
{"descripcion":"{ 6033-002 } TOLVA"},
{"descripcion":"{ 6033-004 } COMPUERTA DE DESCARGA"},
{"descripcion":"{ 6033-005 } TRANSMISION"},
{"descripcion":"{ 6033-006 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 6033-007 } SISTEMA NEUMATICO"},
{"descripcion":"{ 6033 } MEZCLADOR INOTEC IPM4500 #2"},
{"descripcion":"{ 6034 } BALANZA DE PISO (PRODUCCION)"},
{"descripcion":"{ 6036-001 } MOTOR ELECTRICO"},
{"descripcion":"{ 6036-002 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 6036-003 } BOMBA"},
{"descripcion":"{ 6036 } BOMBA SINE MR-135 MOLINO"},
{"descripcion":"{ 6037-001 } MOTOR ELECTRICO"},
{"descripcion":"{ 6037-002 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 6037-003 } BOMBA"},
{"descripcion":"{ 6037 } BOMBA SINE MR-135 EMULSIFICADOR"},
{"descripcion":"{ 6056-1 } SISTEMA NEUMATICO"},
{"descripcion":"{ 6056-2 } CINTA"},
{"descripcion":"{ 6056-3 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 6056-4 } ESTRUCTURA"},
{"descripcion":"{ 6056 } DETECTOR ANRITSU KD8126AW #4"},
{"descripcion":"{ 6061-1 } SISTEMA DE VALVULAS"},
{"descripcion":"{ 6061 } MEZCLADOR AGUA/VAPOR EMBUTIDO JAMONES N 6"},
{"descripcion":"{ 6066-1 } SISTEMA DE VALVULAS"},
{"descripcion":"{ 6066 } MEZCLADOR AGUA/VAPOR LAVADO DE BINS N 1"},
{"descripcion":"{ 6067-1 } ESTRUCTURA"},
{"descripcion":"{ 6067 } CARROS AHUMADORES"},
{"descripcion":"{ 6068-1 } ESTRUCTURA"},
{"descripcion":"{ 6068 } CARROS 200 LITROS"},
{"descripcion":"{ 6069-1 } ESTRUCTURA"},
{"descripcion":"{ 6069 } CARROS PRENSA"},
{"descripcion":"{ 6070-1 } SISTEMA DE VALVULAS"},
{"descripcion":"{ 6070 } MEZCLADOR AGUA/VAPOR EMULSIFICADOR N 4"},
{"descripcion":"{ 6071-1 } SISTEMA DE VALVULAS"},
{"descripcion":"{ 6071 } MEZCLADOR AGUA/VAPOR EMBUTIDO SALCHICHAS N 5"},
{"descripcion":"{ 6072-001 } BOMBAS"},
{"descripcion":"{ 6072-002 } TRANSMISION"},
{"descripcion":"{ 6072-003 } FILTROS"},
{"descripcion":"{ 6072-004 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 6072-005 } SISTEMA DE LAVADO"},
{"descripcion":"{ 6072 } SEPARADOR DE SOLIDOS"},
{"descripcion":"{ 6073-1 } SISTEMA DE VALVULAS"},
{"descripcion":"{ 6073 } MEZCLADOR AGUA/VAPOR CHILLER SALCHICHAS N 8"},
{"descripcion":"{ 6074-001 } ESTRUCTURA"},
{"descripcion":"{ 6074-002 } TAMBOR"},
{"descripcion":"{ 6074-003 } MOTOREDUCTOR Y TRANSMISION"},
{"descripcion":"{ 6074-004 } SISTEMA DE VACIO"},
{"descripcion":"{ 6074-005 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 6074 } MASAJEADOR DORIT 1400 #2"},
{"descripcion":"{ 6075-1 } SISTEMA DE VALVULAS"},
{"descripcion":"{ 6075 } MEZCLADOR AGUA/VAPOR PASILLO CAMARA 1 N 10"},
{"descripcion":"{ 6076-1 } SISTEMA DE VALVULAS"},
{"descripcion":"{ 6076 } MEZCLADOR AGUA/VAPOR PASILLO FILTRO SANITARIO N 11"},
{"descripcion":"{ 6077-1 } SISTEMA DE VALVULAS"},
{"descripcion":"{ 6077 } MEZCLADOR AGUA/VAPOR BACKUP N 12"},
{"descripcion":"{ 6078-001 } GABINETE Y ESTRUCTURA"},
{"descripcion":"{ 6078-002 } MANDO"},
{"descripcion":"{ 6078-003 } CABEZAL DE VACIO"},
{"descripcion":"{ 6078-004 } SOPORTE MOVIL INTERMEDIO"},
{"descripcion":"{ 6078-005 } TUBOS"},
{"descripcion":"{ 6078-006 } SISTEMA ELECTRICO"},
{"descripcion":"{ 6078-007 } CONEXIONES DE AIRE Y VAPOR"},
{"descripcion":"{ 6078 } PELADORA 2600 #5"},
{"descripcion":"{ 6079-1 } SISTEMA DE VALVULAS"},
{"descripcion":"{ 6079 } MEZCLADOR AGUA/VAPOR BACKUP N 14"},
{"descripcion":"{ 6080-001 } MOTOR ELECTRICO"},
{"descripcion":"{ 6080-002 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 6080-003 } BOMBA"},
{"descripcion":"{ 6080 } BOMBA SINE EC-40 MEZCLADORES INOTEC"},
{"descripcion":"{ 6082-001 } MOTOR ELECTRICO"},
{"descripcion":"{ 6082-002 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 6082-003 } BOMBA"},
{"descripcion":"{ 6082 } BOMBA SINE MR-130 #2"},
{"descripcion":"{ 6083-001 } MOTOR ELECTRICO"},
{"descripcion":"{ 6083-002 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 6083-003 } BOMBA"},
{"descripcion":"{ 6083 } BOMBA SINE MR-130 #3"},
{"descripcion":"{ 6086-001 } ESTRUCTURA"},
{"descripcion":"{ 6086-002 } TOLVA"},
{"descripcion":"{ 6086-003 } SISTEMA ELEVACION"},
{"descripcion":"{ 6086-004 } SINFIN"},
{"descripcion":"{ 6086-005 } SISTEMA DE CORTE"},
{"descripcion":"{ 6086-006 } SISTEMA DE GARRAS"},
{"descripcion":"{ 6086-007 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 6090 } TRITURADORA LASKA"},
{"descripcion":"{ 6091-001 } MOTOR ELECTRICO"},
{"descripcion":"{ 6091-002 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 6091-003 } BOMBA"},
{"descripcion":"{ 6091 } BOMBA SINE SPS-500"},
{"descripcion":"{ 6092-001 } ESTRUCTURA"},
{"descripcion":"{ 6092-002 } TRANSPORTADOR Y TRANSMISION"},
{"descripcion":"{ 6092-003 } ANILLADOR"},
{"descripcion":"{ 6092-004 } TUBERIAS Y BOQUILLAS DE PULVERIZACION"},
{"descripcion":"{ 6092-005 } BOMBA"},
{"descripcion":"{ 6092-006 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 6092 } AHUMADOR SAM LK"},
{"descripcion":"{ 6093-01 } GABINETE"},
{"descripcion":"{ 6093-02 } MOTOR Y TRANSMISION : BOMBA DOSIFICADOR"},
{"descripcion":"{ 6093-03 } MOTOR Y TRANSMISION: TORSIONADOR"},
{"descripcion":"{ 6093-04 } MOTOR Y TRANSMISION: EMBUTIDORA"},
{"descripcion":"{ 6093-05 } MOTOR Y TRANSMISION: ELEVADOR"},
{"descripcion":"{ 6093-06 } BOMBA DOSIFICADORA"},
{"descripcion":"{ 6093-07 } MORDAZA DE TRIPAS"},
{"descripcion":"{ 6093-08 } BLOQUE DEL TUBO DE EMBUTICION Y SEGUIDOR"},
{"descripcion":"{ 6093-09 } TUBO DE EMBUTUCION Y CILINDROS"},
{"descripcion":"{ 6093-10 } TOLVA"},
{"descripcion":"{ 6093-11 } TORSIONADOR"},
{"descripcion":"{ 6093-12 } CABEZAL ESLABONADOR"},
{"descripcion":"{ 6093-13 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 6093-14 } SISTEMA NEUMATICO"},
{"descripcion":"{ 6093 } ESLABONADORA LK"},
{"descripcion":"{ 6094-001 } GABINETE Y ESTRUCTURA"},
{"descripcion":"{ 6094-002 } MANDO"},
{"descripcion":"{ 6094-003 } CABEZAL DE VACIO"},
{"descripcion":"{ 6094-004 } SOPORTE MOVIL INTERMEDIO"},
{"descripcion":"{ 6094-005 } TUBOS"},
{"descripcion":"{ 6094-006 } SISTEMA ELECTRICO"},
{"descripcion":"{ 6094-007 } CONEXIONES DE AIRE Y VAPOR"},
{"descripcion":"{ 6094 } PELADORA 2800 #1"},
{"descripcion":"{ 6095-001 } GABINETE Y ESTRUCTURA"},
{"descripcion":"{ 6095-002 } MANDO"},
{"descripcion":"{ 6095-003 } CABEZAL DE VACIO"},
{"descripcion":"{ 6095-004 } SOPORTE MOVIL INTERMEDIO"},
{"descripcion":"{ 6095-005 } TUBOS"},
{"descripcion":"{ 6095-006 } SISTEMA ELECTRICO"},
{"descripcion":"{ 6095-007 } CONEXIONES DE AIRE Y VAPOR"},
{"descripcion":"{ 6095 } PELADORA 2800 #2"},
{"descripcion":"{ 6096-01 } TRANSPORTADOR ELEVADOR DE SUMINISTRO"},
{"descripcion":"{ 6096-02 } COLLATOR"},
{"descripcion":"{ 6096-03 } TRANSPORTADOR INTERMEDIO"},
{"descripcion":"{ 6096-04 } CABEZAL DE CARGA"},
{"descripcion":"{ 6096-05 } TRANSPORTADOR DE ALIMENTACION CRUZADA"},
{"descripcion":"{ 6096-06 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 6096 } DRAKE CS 1800"},
{"descripcion":"{ 6097-001 } ESTACION DE FILM INFERIOR"},
{"descripcion":"{ 6097-002 } ESTACION DE FORMADO"},
{"descripcion":"{ 6097-003 } ESTACION DE CARGA"},
{"descripcion":"{ 6097-004 } ESTACION DE FILM SUPERIOR"},
{"descripcion":"{ 6097-005 } ESTACION DE SELLADO"},
{"descripcion":"{ 6097-006 } ESTACION DE CORTE"},
{"descripcion":"{ 6097-007 } CINTA DE SALIDA"},
{"descripcion":"{ 6097-008 } CADENA DE ARRASTRE"},
{"descripcion":"{ 6097-009 } SISTEMA ELECTRICO"},
{"descripcion":"{ 6097-010 } SISTEMA NEUMATICO"},
{"descripcion":"{ 6097-011 } SISTEMA DE VACIO"},
{"descripcion":"{ 6097-012 } SUMINISTRO DE AGUA"},
{"descripcion":"{ 6097-013 } CHILLER CHILLY 45 400V-S (R-535 B)"},
{"descripcion":"{ 6097 } MULTIVAC R-535-2"},
{"descripcion":"{ 610-001 } ESTRUCTURA"},
{"descripcion":"{ 610-002 } TOLVA"},
{"descripcion":"{ 610-003 } SINFIN"},
{"descripcion":"{ 610-004 } BOMBA DE OVULOS"},
{"descripcion":"{ 610-005 } SISTEMA DE CORTE"},
{"descripcion":"{ 610-006 } SISTEMA DE VACIO"},
{"descripcion":"{ 610-007 } SISTEMA NEUMATICO"},
{"descripcion":"{ 610-008 } TRANSMISION PALETAS"},
{"descripcion":"{ 610-009 } TRANSMISION SINFIN"},
{"descripcion":"{ 610-010 } TRANSMISION OVULOS"},
{"descripcion":"{ 610-011 } MOTOR PRINCIPAL CORTE"},
{"descripcion":"{ 610-012 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 610 } MOLINO INOTEC I175CD-66KW"},
{"descripcion":"{ 614-001 } ESTRUCTURA"},
{"descripcion":"{ 614-002 } TOLVA"},
{"descripcion":"{ 614-004 } COMPUERTA DE DESCAGA"},
{"descripcion":"{ 614-005 } TRANSMISION"},
{"descripcion":"{ 614-006 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 614-007 } SISTEMA NEUMATICO"},
{"descripcion":"{ 614 } MEZCLADOR INOTEC IPM4500 #1"},
{"descripcion":"{ 628 } EMULSIFICADOR INOTEC I225CDVMP 132 D"},
{"descripcion":"{ 67100 } COMPRESOR DE AIRE N 2 FS CURTIS GS50-R"},
{"descripcion":"{ 67101 } COMPRESOR DE AIRE N 3 FS CURTIS GS30-R"},
{"descripcion":"{ 67102 } COMPRESOR DE AIRE N 4 DENAIR DVA-45"},
{"descripcion":"{ 6795 } CHEQUEADOR DE PESO N 1 ANRITSU KWS5678BW77 4670376795"},
{"descripcion":"{ 6796 } CHEQUEADOR DE PESO N 2 ANRITSU KWS5678BW77 4660324563"},
{"descripcion":"{ 6797 } CHEQUEADOR DE PESO N 3 ANRITSU KWS5678BW77 4670372122"},
{"descripcion":"{ 6798 } SECADOR DE AIRE COMPRIMIDO DENAIR DAD-13HTF"},
{"descripcion":"{ 6799 } COMPRESOR DE AIRE N 1 DENAIR DVA-37"},
{"descripcion":"{ 7001 } BOMBA SINE SPS-300 (LK)"},
{"descripcion":"{ 800-001 } ESTRUCTURA"},
{"descripcion":"{ 800-002 } SISTEMA HIDRAULICO"},
{"descripcion":"{ 800-003 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 800 } ANDEN DE DESPACHO"},
{"descripcion":"{ 8032-1 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 8032-2 } ESTRUCTURA"},
{"descripcion":"{ 8032-3 } CINTA"},
{"descripcion":"{ 8032-4 } RODAMIENTOS"},
{"descripcion":"{ 8032-5 } MOTOREDUCTOR"},
{"descripcion":"{ 8032-6 } SISTEMA DE TRACCION"},
{"descripcion":"{ 8032 } TOLVA PELADORA R-535-2"},
{"descripcion":"{ 8033-1 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 8033-2 } ESTRUCTURA"},
{"descripcion":"{ 8033-3 } CINTA"},
{"descripcion":"{ 8033-4 } RODAMIENTOS"},
{"descripcion":"{ 8033-5 } MOTOREDUCTOR"},
{"descripcion":"{ 8033-6 } SISTEMA DE TRACCION"},
{"descripcion":"{ 8033 } TOLVA PELADORA R-535"},
{"descripcion":"{ 8035 } DESNATADOR"},
{"descripcion":"{ 850-1 } ESTRUCTURA"},
{"descripcion":"{ 850 } CARROS PORTA STICK"},
{"descripcion":"{ 853-001 } COMPRESOR DE TORNILLO"},
{"descripcion":"{ 853-002 } MOTOR ELECTRICO Y CONTROL"},
{"descripcion":"{ 853-003 } SEPARADOR DE ACEITE"},
{"descripcion":"{ 853-004 } ENFRIADOR DE ACEITE"},
{"descripcion":"{ 853-005 } BOMBA DE LUBRICACION"},
{"descripcion":"{ 853 } MYCOM N200VLD"},
{"descripcion":"{ 861-1 } DANFOSS/MT160HW4DVE"},
{"descripcion":"{ 861-2 } CONDENSADOR"},
{"descripcion":"{ 861-3 } EVAPORADOR"},
{"descripcion":"{ 861 } U.C ANDEN DESPACHO"},
{"descripcion":"{ 862-1 } GEA/HG4/650 4 S N"},
{"descripcion":"{ 862-2 } CONDENSADOR"},
{"descripcion":"{ 862-3 } EVAPORADOR"},
{"descripcion":"{ 862 } U.C CAMARA 2"},
{"descripcion":"{ 864-1 } COPELAND/9R51-1505-TFD-200"},
{"descripcion":"{ 864-2 } CONDENSADOR"},
{"descripcion":"{ 864-3 } EVAPORADOR"},
{"descripcion":"{ 864 } U.C CAMARA 13"},
{"descripcion":"{ 865-1 } COPELAND/9R51-1505-TFD-200"},
{"descripcion":"{ 865-2 } CONDENSADOR"},
{"descripcion":"{ 865-3 } EVAPORADOR"},
{"descripcion":"{ 865 } U.C SALA LIMPIEZA DE CARNES"},
{"descripcion":"{ 866-1 } COPELAND/511707970"},
{"descripcion":"{ 866-2 } CONDENSADOR"},
{"descripcion":"{ 866-3 } EVAPORADOR"},
{"descripcion":"{ 866 } U.C SALA DESPACHO"},
{"descripcion":"{ 868-1 } DANFOSS/MT160HW4DVE"},
{"descripcion":"{ 868-2 } CONDENSADOR"},
{"descripcion":"{ 868-3 } EVAPORADOR"},
{"descripcion":"{ 868 } U.C ANDEN MATERIAS PRIMAS"},
{"descripcion":"{ 870-001 } ESTRUCTURA"},
{"descripcion":"{ 870-002 } GENERADOR DE VAPOR"},
{"descripcion":"{ 870-003 } LEVANTAMIENTO HIDRAULICO"},
{"descripcion":"{ 870-004 } SISTEMA DE VACIO"},
{"descripcion":"{ 870-005 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 870-006 } TAMBOR"},
{"descripcion":"{ 870-007 } TRAMPILLA DE INSPECCION"},
{"descripcion":"{ 870-008 } TRANSMISION DE TAMBOR"},
{"descripcion":"{ 870 } TUMBLER LUTETIA #1"},
{"descripcion":"{ 872-001 } ESTACION DE FILM INFERIOR"},
{"descripcion":"{ 872-002 } ESTACION DE FORMADO"},
{"descripcion":"{ 872-003 } ESTACION DE CARGA"},
{"descripcion":"{ 872-004 } ESTACION DE FILM SUPERIOR"},
{"descripcion":"{ 872-005 } ESTACION DE SELLADO"},
{"descripcion":"{ 872-006 } ESTACION DE CORTE"},
{"descripcion":"{ 872-007 } CINTA DE SALIDA"},
{"descripcion":"{ 872-008 } CADENA DE ARRASTRE"},
{"descripcion":"{ 872-009 } SISTEMA ELECTRICO"},
{"descripcion":"{ 872-010 } SISTEMA NEUMATICO"},
{"descripcion":"{ 872-011 } SUMINISTRO DE AGUA"},
{"descripcion":"{ 872-012 } CHILLER CHILLY 45 400V-S (RAPID PAK)"},
{"descripcion":"{ 872 } MULTIVAC R-535"},
{"descripcion":"{ 873-001 } ESTRUCTURA"},
{"descripcion":"{ 873-002 } GENERADOR DE VAPOR"},
{"descripcion":"{ 873-003 } LEVANTAMIENTO HIDRAULICO"},
{"descripcion":"{ 873-004 } SISTEMA DE VACIO"},
{"descripcion":"{ 873-005 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 873-006 } TAMBOR"},
{"descripcion":"{ 873-007 } TRAMPILLA DE INSPECCION"},
{"descripcion":"{ 873-008 } TRANSMISION DE TAMBOR"},
{"descripcion":"{ 873 } TUMBLER LUTETIA #2"},
{"descripcion":"{ 874-001 } ESTRUCTURA"},
{"descripcion":"{ 874-002 } TRANSMISION"},
{"descripcion":"{ 874-003 } CINTA"},
{"descripcion":"{ 874-004 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 874 } CINTA LUTETIA #1"},
{"descripcion":"{ 880-001 } MOTOR ELECTRICO"},
{"descripcion":"{ 880-002 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 880-003 } BOMBA"},
{"descripcion":"{ 880 } BOMBA SINE SPS-300"},
{"descripcion":"{ 901-1 } TECUMSEH/TAG4568Z"},
{"descripcion":"{ 901-2 } CONDENSADOR"},
{"descripcion":"{ 901-3 } EVAPORADOR"},
{"descripcion":"{ 901 } U.C CAMARA 7 Y 8"},
{"descripcion":"{ 903-1 } BOCK/HG4/485-4 S"},
{"descripcion":"{ 903-2 } CONDENSADOR"},
{"descripcion":"{ 903-3 } EVAPORADOR"},
{"descripcion":"{ 903 } U.C CAMARA 10"},
{"descripcion":"{ 908-1 } COPELAND/9R51-1505-TFD-200"},
{"descripcion":"{ 908-2 } CONDENSADOR"},
{"descripcion":"{ 908-3 } EVAPORADOR"},
{"descripcion":"{ 908 } U.C CAMARA 14"},
{"descripcion":"{ 911-1 } FRASCOLD/Q4-21.1Y1000"},
{"descripcion":"{ 911-2 } CONDENSADOR"},
{"descripcion":"{ 911-3 } EVAPORADOR"},
{"descripcion":"{ 911 } U.C SALA TUMBLER ORIENTE"},
{"descripcion":"{ 912-1 } FRASCOLD/Q4-21.1Y1000"},
{"descripcion":"{ 912-2 } CONDENSADOR"},
{"descripcion":"{ 912-3 } EVAPORADOR"},
{"descripcion":"{ 912 } U.C SALA TUMBLER PONIENTE"},
{"descripcion":"{ 913-1 } COPELAND/9R51-1505-TFD-200"},
{"descripcion":"{ 913-2 } CONDENSADOR"},
{"descripcion":"{ 913-3 } EVAPORADOR"},
{"descripcion":"{ 913 } U.C SALA EMPAQUE 1"},
{"descripcion":"{ 917-001 } COMPRESOR DE PISTON"},
{"descripcion":"{ 917-002 } MOTOR ELECTRICO"},
{"descripcion":"{ 917-003 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 917 } MYCOM N4WB (4B)"},
{"descripcion":"{ 918-001 } COMPRESOR DE PISTON"},
{"descripcion":"{ 918-002 } MOTOR ELECTRICO"},
{"descripcion":"{ 918-003 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 918 } MYCOM N8WA (8B)"},
{"descripcion":"{ 922 } CONDENSADOR EVAP MEBRAFE"},
{"descripcion":"{ 923-001 } MOTOR ELECTRICO"},
{"descripcion":"{ 923-002 } IMPULSOR"},
{"descripcion":"{ 923-003 } SISTEMA ELECTRICO"},
{"descripcion":"{ 923 } BOMBA POZO PROFUNDO"},
{"descripcion":"{ 924 } SISTEMA AGUA ALTA PRES ( SERVICIO)"},
{"descripcion":"{ 931 } TRANSFORMADOR RHONA 750 KVA #1"},
{"descripcion":"{ 932-001 } SISTEMA DE VALVULAS MANUALES"},
{"descripcion":"{ 932-002 } ESTANQUE"},
{"descripcion":"{ 932 } ABLANDADOR DE AGUA #2 CALDERA"},
{"descripcion":"{ 933-1 } COPELAND/9R51-1505-TFD-200"},
{"descripcion":"{ 933-2 } CONDENSADOR"},
{"descripcion":"{ 933-3 } EVAPORADOR"},
{"descripcion":"{ 933 } U.C CAMARA 11 Y 12"},
{"descripcion":"{ 934-001 } SISTEMA DE VALVULAS MANUALES"},
{"descripcion":"{ 934-002 } ESTANQUE"},
{"descripcion":"{ 934 } ABLANDADOR DE AGUA #1 SADEMA"},
{"descripcion":"{ 935-001 } SISTEMA DE VALVULAS MANUALES"},
{"descripcion":"{ 935-002 } ESTANQUE"},
{"descripcion":"{ 935 } ABLANDADOR DE AGUA #2 SADEMA"},
{"descripcion":"{ 938-001 } MOTOR DIESEL"},
{"descripcion":"{ 938-002 } GRUPO ELECTROGENO"},
{"descripcion":"{ 938-003 } SISTEMA DE COMBUSTIBLE"},
{"descripcion":"{ 938-004 } REGULADOR DE VOLTAJE"},
{"descripcion":"{ 938-005 } SISTEMA DE REFRIGERACION"},
{"descripcion":"{ 938-006 } SISTEMA DE LUBRICACION"},
{"descripcion":"{ 938-007 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 938-008 } ESTRUCTURA PRINCIPAL"},
{"descripcion":"{ 938 } GENERADOR ELECTROPOWER EPD825SCS"},
{"descripcion":"{ 942-001 } SISTEMA ELECTRICO Y CONTROL"},
{"descripcion":"{ 942-002 } QUEMADOR"},
{"descripcion":"{ 942-003 } SISTEMA DE VALVULAS"},
{"descripcion":"{ 942-004 } SISTEMA DE BOMBEO"},
{"descripcion":"{ 942-005 } FILTROS"},
{"descripcion":"{ 942-006 } ESTANQUE DE ALIMENTACION"},
{"descripcion":"{ 942 } CALDERA VISA N SSMA"},
{"descripcion":"{ 945-001 } SISTEMA DE VALVULAS MANUALES"},
{"descripcion":"{ 945-002 } ESTANQUE"},
{"descripcion":"{ 945 } ABLANDADOR DE AGUA #1 CALDERA"},
{"descripcion":"{ 950-001 } ESTACION DE FILM INFERIOR"},
{"descripcion":"{ 950-002 } ESTACION DE FORMADO"},
{"descripcion":"{ 950-003 } ESTACION DE CARGA"},
{"descripcion":"{ 950-004 } ESTACION DE FILM SUPERIOR"},
{"descripcion":"{ 950-005 } ESTACION DE SELLADO"},
{"descripcion":"{ 950-006 } ESTACION DE CORTE"},
{"descripcion":"{ 950-007 } CINTA DE SALIDA"},
{"descripcion":"{ 950-008 } CADENA DE ARRASTRE"},
{"descripcion":"{ 950-009 } SISTEMA ELECTRICO"},
{"descripcion":"{ 950-010 } SISTEMA NEUMATICO"},
{"descripcion":"{ 950-011 } SISTEMA DE VACIO"},
{"descripcion":"{ 950-012 } SUMINISTRO DE AGUA"},
{"descripcion":"{ 950 } MULTIVAC R-225"},
{"descripcion":"{ 955-10 } SISTEMA NEUMATICO"},
{"descripcion":"{ 955-11 } SISTEMA DE VACIO"},
{"descripcion":"{ 955-12 } SUMINISTRO DE AGUA"},
{"descripcion":"{ 955-1 } ESTACION DE FILM INFERIOR"},
{"descripcion":"{ 955-2 } ESTACION DE FORMADO"},
{"descripcion":"{ 955-3 } ESTACION DE CARGA"},
{"descripcion":"{ 955-4 } ESTACION DE FILM SUPERIOR"},
{"descripcion":"{ 955-5 } ESTACION DE SELLADO"},
{"descripcion":"{ 955-6 } ESTACION DE CORTE"},
{"descripcion":"{ 955-7 } CINTA DE SALIDA"},
{"descripcion":"{ 955-8 } CADENA DE ARRASTRE"},
{"descripcion":"{ 955-9 } SISTEMA ELECTRICO"},
{"descripcion":"{ 955 } MULTIVAC C550"},
{"descripcion":"{ 10003 } TALLER MANTENIMIENTO"},
{"descripcion":"{ 1000 } OFICINA SS.GG"},
{"descripcion":"{ 10011 } CASINO"},
{"descripcion":"{ 10020 } PAÑOL DE REPUESTOS"},
{"descripcion":"{ 10055 } CONTROL DE ACCESO"},
{"descripcion":"{ 108 } CAMARA N 7 (0 A 3 C)"},
{"descripcion":"{ 109 } CAMARA N 8 (0 A 3 C)"},
{"descripcion":"{ 1410 } BODEGA DE CARTONES"},
{"descripcion":"{ 1438 } OFICINAS GERENCIA"},
{"descripcion":"{ 1439 } POLICLINICO"},
{"descripcion":"{ 1440 } SALA ACOPIO DE INSUMOS"},
{"descripcion":"{ 1442 } SALA DE BOMBAS"},
{"descripcion":"{ 1444 } SALA DE CAPACITACIONES 2"},
{"descripcion":"{ 1445 } ZONA CONDENSADORES CHILE"},
{"descripcion":"{ 1447 } LAVANDERIA"},
{"descripcion":"{ 144 } CAMARA N 10 (0 A 3 C)"},
{"descripcion":"{ 1450 } SALA DE ACOPIO UTENSILIOS LIMPIOS"},
{"descripcion":"{ 1460 } PASILLO ACCESO COCIDO"},
{"descripcion":"{ 1461 } CAMARA N 2 (-5 A 0 C)"},
{"descripcion":"{ 1465 } PASILLO BANDEJAS LIMPIAS"},
{"descripcion":"{ 1466 } PASILLO COCIDO"},
{"descripcion":"{ 1470 } SALA ALMACENAMIENTO INSUMOS"},
{"descripcion":"{ 1471 } SALA OPERACION HORNOS"},
{"descripcion":"{ 1472 } POST-HORNO"},
{"descripcion":"{ 1476 } ANTE SALA DE PROCESOS"},
{"descripcion":"{ 1477 } SALA LIMPIEZA CARNES (5 A 12 C)"},
{"descripcion":"{ 1489 } SALA DE MEZCLADOR SALCHICHAS"},
{"descripcion":"{ 1532 } OFICINA MANTENIMIENTO"},
{"descripcion":"{ 1535 } ZONA CARGA DE BATERIAS"},
{"descripcion":"{ 1536 } SALA DE REUNIONES GERENCIA"},
{"descripcion":"{ 1538 } SALA DE PELADO"},
{"descripcion":"{ 178 } SALA CALDERA"},
{"descripcion":"{ 179 } SALA COMPRESORES DE AIRE"},
{"descripcion":"{ 180 } SALA DE HIELO"},
{"descripcion":"{ 182 } SALA EMBUTIDO DE JAMONES"},
{"descripcion":"{ 185 } SALA LAMINADO"},
{"descripcion":"{ 195 } CAMARA N 1 (-5 A 0 C)"},
{"descripcion":"{ 315 } SALA EMPAQUE N 2 (5 A 12 C)"},
{"descripcion":"{ 356 } SALA EMPAQUE N 1 (5 A 12 C)"},
{"descripcion":"{ 605 } SALA TUMBLERS (5 A 12 C)"},
{"descripcion":"{ 801 } CAMARA N 13 (0 A 3 C)"},
{"descripcion":"{ 802 } CAMARA N 14 (-5 A -1 C)"},
{"descripcion":"{ 847 } CAMARA N 3 (0 C)"},
{"descripcion":"{ 848 } CAMARA N 4 (0 C)"},
{"descripcion":"{ 856 } FILTRO SANITARIO COCIDO"},
{"descripcion":"{ 857 } FILTRO SANITARIO"},
{"descripcion":"{ 858 } SALA DE CUTTER"},
{"descripcion":"{ 859 } SALA EMBUTIDO VIANESAS"},
{"descripcion":"{ I-TYA-001 } CAMARA N 9 (0 A 3 C)"},
{"descripcion":"{ I-TYA-002 } CAMARA N 11 (0 A 3 C)"},
{"descripcion":"{ I-TYA-003 } CAMARA N 12 (0 A 3 C)"},
{"descripcion":"{ I-TYA-004 } SALA LUTETIA 1"},
{"descripcion":"{ I-TYA-005 } SALA LUTETIA N 2 (2 A 5 C)"},
{"descripcion":"{ I-TYA-006 } SALA ANDEN MATERIAS PRIMAS (5 A 12 C)"},
{"descripcion":"{ I-TYA-007 } SALA MONTADO JAMONES"},
{"descripcion":"{ I-TYA-008 } SALA EMBUTIDORA HANDTMAN"},
{"descripcion":"{ I-TYA-009 } BODEGA DE ABASTECIMIENTO DE INSUMOS CRUDOS"},
{"descripcion":"{ I-TYA-010 } PASILLO DE TUNELES"},
{"descripcion":"{ I-TYA-011 } LABORATORIO CALIDAD"},
{"descripcion":"{ I-TYA-012 } BAÑOS CRUDO"},
{"descripcion":"{ I-TYA-013 } TALLER MANTENIMIENTO CRUDO"},
{"descripcion":"{ I-TYA-014 } OFICINA ROMANA RECEPCION"},
{"descripcion":"{ I-TYA-015 } OFICINA DESARROLLO"},
{"descripcion":"{ I-TYA-016 } OFICINA SUPERVISORES PRODUCCION"},
{"descripcion":"{ I-TYA-017 } CAMARA N 5 (0 C)"},
{"descripcion":"{ I-TYA-018 } CAMARA N 6 (0 A 6 C)"},
{"descripcion":"{ I-TYA-019 } SALA DE JAMONES (5 A 12 C)"},
{"descripcion":"{ I-TYA-020 } PASILLO JAMONES"},
{"descripcion":"{ I-TYA-021 } ZONA LOCKERS COCIDOS"},
{"descripcion":"{ I-TYA-022 } OFICINA ROMANA COCIDOS"},
{"descripcion":"{ I-TYA-023 } TALLER MANTENIMIENTO COCIDOS"},
{"descripcion":"{ I-TYA-024 } OFICINA CALIDAD COCIDOS"},
{"descripcion":"{ I-TYA-025 } OFICINA SUPERVISORES COCIDOS"},
{"descripcion":"{ I-TYA-026 } DUCHAS Y VESTIDORES HOMBRES COCIDOS"},
{"descripcion":"{ I-TYA-027 } BAÑOS HOMBRES COCIDOS"},
{"descripcion":"{ I-TYA-028 } DUCHAS Y VESTIDORES MUJERES COCIDOS"},
{"descripcion":"{ I-TYA-029 } SALA ANDEN DESPACHO"},
{"descripcion":"{ I-TYA-030 } SALA DE ENCAJADO (5 A 12 C)"},
{"descripcion":"{ I-TYA-031 } OFICINA DESPACHO"},
{"descripcion":"{ I-TYA-032 } SALA COMPRESORES FRIO MATERIAS PRIMAS CHILE"},
{"descripcion":"{ I-TYA-033 } SALA DE COMPRESORES DESPACHO"},
{"descripcion":"{ I-TYA-034 } SALA DE TABLERO"},
{"descripcion":"{ I-TYA-035 } SALA DE COMPRESORES"},
{"descripcion":"{ I-TYA-036 } POZO DE AGUA"},
{"descripcion":"{ I-TYA-037 } SALA TRANSFORMADORES"},
{"descripcion":"{ I-TYA-038 } SALA COMPRESORES FRIO DESPACHO"},
{"descripcion":"{ I-TYA-039 } SALA ENFRIADOR DE PLACAS ALKAR"},
{"descripcion":"{ I-TYA-040 } SERVICIOS INDUSTRIALES SEGUNDO PISO"},
{"descripcion":"{ I-TYA-041 } OFICINA RR.HH"},
{"descripcion":"{ I-TYA-042 } OFICINA T.S CHILE"},
{"descripcion":"{ I-TYA-043 } SALA DE CAPACITACIONES 1"},
{"descripcion":"{ I-TYA-044 } BODEGA"},
{"descripcion":"{ I-TYA-045 } BODEGA INDUMENTARIA"},
{"descripcion":"{ I-TYA-046 } SALA DE DOSIFICACION CONDIMENTOS"},
{"descripcion":"{ I-TYA-047 } SALA DE ARCHIVOS"},
{"descripcion":"{ I-TYA-048 } CONTAINERS MAQUINAS"},
{"descripcion":"{ I-TYA-049 } ALMACEN SUSPEL"},
{"descripcion":"{ I-TYA-050 } ALMACEN RESPEL"},
{"descripcion":"{ I-TYA-051 } BODEGA DE DETERGENTES"},
{"descripcion":"{ I-TYA-052 } SALA DE LAVADO DE UTENSILIOS"},
{"descripcion":"{ I-TYA-053 } SALA DE LAVADO DE BANDEJAS"},
{"descripcion":"{ I-TYA-054 } INFRA SS.GG"},
{"descripcion":"{ I-TYA-055 } EX PARRILEROS"},
{"descripcion":"{ I-TYA-056 } PASILLO CENTRAL CRUDOS"},
{"descripcion":"{ I-TYA-057 } UTENSILIOS SUCIOS"},
{"descripcion":"{ I-TYA-058 } PASILLO DE CARROS"},
{"descripcion":"{ I-TYA-059 } SALIDA DE EMERGENCIA COCIDOS"},
{"descripcion":"{ I-TYA-060 } SALA CHILLER ENFRIAMIENTO"},
{"descripcion":"{ I-TYA-061 } PASILLO DE ENTREGA DE PRODUCTOS"},
{"descripcion":"{ I-TYA-062 } INFRAESTRUCTURA PATIO"},
{"descripcion":"{ I-TYA-063 } BODEGA DE RESIDUOS NO PELIGROSOS"},
{"descripcion":"{ I-TYA-064 } JAULA DE REPUESTOS"},
{"descripcion":"{ I-TYA-065 } OFICINA BODEGA"},
{"descripcion":"{ I-TYA-066 } TALLER TRASPALETAS"},
{"descripcion":"{ I-TYA-067 } PORTERIA"},
{"descripcion":"{ I-TYA-068 } CAMARA MANTENIMIENTO PORTERIA"},
{"descripcion":"{ I-TYA-069 } GIMNASIO"},
{"descripcion":"{ I-TYA-070 } QUINCHO"},
{"descripcion":"{ I-TYA-071 } CANCHA"},
{"descripcion":"{ I-TYA-072 } ESTACIONAMIENTO GENERAL"},
{"descripcion":"{ I-TYA-074 } BAÑO PORTERIA"},
{"descripcion":"{ I-TYA-075 } BAÑO SS.GG"},
{"descripcion":"{ I-TYA-076 } BAÑOS GERENCIA"},
{"descripcion":"{ I-TYA-077 } VESTIDORES DE HOMBRES DESPACHO"},
{"descripcion":"{ I-TYA-078 } BAÑO CHICO DESPACHO"},
{"descripcion":"{ I-TYA-079 } BAÑOS CRUDOS"},
{"descripcion":"{ I-TYA-080 } BAÑO DE CONTRATISTAS"},
{"descripcion":"{ I-TYA-081 } BAÑOS Y VESTIDORES MANTENIMIENTO"},
{"descripcion":"{ I-TYA-082 } SALA DE DOSIFICACION DE DETERGENTES"},
{"descripcion":"{ I-TYA-083 } VESTIDORES SEGUNDO PISO DESPACHO"},
{"descripcion":"{ I-TYA-084 } VESTIDORES DE MUJERES DESPACHO"},
{"descripcion":"{ TYA-001 } TECNOLOGIA & ALIMENTOS AV. BERNARDO OÂ´HIGGINS #0128 TALAGANTE REGION METROPOLITANA CHILE"},
{"descripcion":"{ TYAED-000 } EDIFICIOS COMUNES"},
{"descripcion":"{ TYAED-002 } EDIFICIOS PRODUCCION"},
{"descripcion":"{ TYAEDC-001 } BAÑOS Y VESTIDORES"},
{"descripcion":"{ TYAEDC-002 } GENERAL"},
{"descripcion":"{ TYAEDC-003 } BODEGAS Y ALMACENES"},
{"descripcion":"{ TYAEDC-004 } TALLERES"},
{"descripcion":"{ TYAEDC-005 } OFICINAS ADMINISTRACION"},
{"descripcion":"{ TYAEDC-CO-001 } BAÑOS Y VESTIDORES AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYAEDC-CO-002 } GENERAL AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYAEDC-CO-003 } TALLER MANTENIMIENTO AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYAEDC-CO-004 } BODEGAS Y SALAS AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYAEDC-CO-005 } OFICINAS AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYAED-CO-001 } EDIFICOS COMUNES AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYAED-CO-002 } EDIFICIOS PRODUCCION AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYAEDP-001 } INFRA SERVICIOS INDUSTRIALES"},
{"descripcion":"{ TYAEDP-002 } INFRA DESPACHO"},
{"descripcion":"{ TYAEDP-003 } INFRA COCIDOS"},
{"descripcion":"{ TYAEDP-004 } INFRA CRUDOS"},
{"descripcion":"{ TYAEDP-CO-001 } CAMARAS AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-001 } ACCESO PLANTA AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-002 } BAÑOS HOMBRES Y MUJERES AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-003 } BODEGA DE ACOPIO DE BANDEJAS AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-004 } BODEGA DE BANDEJAS SUCIAS AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-005 } BODEGA DE CAJAS AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-006 } BODEGA DE CONDIMENTOS AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-007 } BODEGA DE INSUMOS AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-008 } BODEGA DE MOLDES Y FORMATOS AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-010 } BODEGA DE ROPA Y INSUMOS AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-011 } CAMARA DE CONGELADO N 4 AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-012 } CAMARA DE CONGELADO N 9 AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-013 } CAMARA MATERIAS PRIMAS 12B AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-014 } CAMARA N 16 AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-015 } CASINO AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-016 } DUCHAS Y VESTIDORES HOMBRES AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-017 } FILTRO SANITARIO AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-018 } OFICINA CALIDAD AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-019 } OFICINA DESPACHO AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-020 } OFICINA JEFE PLANTA AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-021 } OFICINA MANTENIMIENTO AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-022 } OFICINA SUPERVISOR DE PRODUCCION AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-023 } PAÑOL AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-024 } PASILLO SALIDA BANDEJAS SUCIAS AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-025 } SALA ANDEN DE RECEPCION AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-026 } SALA COMPRESORES AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-027 } SALA DE ANDEN DE DESPACHO AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-028 } SALA DE BATERIAS AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-029 } SALA DE CAPACITACION AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-030 } SALA DE COMPACTADOR DE BASURA AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-031 } SALA DE EMPAQUE N 1 AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-032 } SALA DE EMPAQUE N 2 AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-033 } SALA DE ESTANQUES AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-034 } SALA DE LUBRICANTES AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-035 } SALA DE MOLIENDA AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-036 } SALA ELECTRICA AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-037 } SALA FILTRO DE ACEITE AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-038 } SALA FREIDORA AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-039 } SALA PRODUCCION AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-040 } SALA RILES MATERIAS PRIMAS AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-041 } SECTOR LAVADO DE CARROS AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-042 } TALLER MANTENIMIENTO AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYA-MA-043 } VESTIDOR DE VISITAS AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYAP-001 } PLANTA CECINAS"},
{"descripcion":"{ TYAP-002 } PLANTA CONGELADOS AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYAPS-10 } ENCAJADO"},
{"descripcion":"{ TYAPS-11 } SANITARIO"},
{"descripcion":"{ TYAPS-12 } BALANZAS"},
{"descripcion":"{ TYAPS-13 } LAMINADO"},
{"descripcion":"{ TYAPS-14 } EMPAQUE"},
{"descripcion":"{ TYAPS-15 } PELADO"},
{"descripcion":"{ TYAPS-16 } HORNEADO"},
{"descripcion":"{ TYAPS-17 } SANITARIO"},
{"descripcion":"{ TYAPS-18 } BALANZAS"},
{"descripcion":"{ TYAPS-19 } CLIPEADO"},
{"descripcion":"{ TYAPS-1 } LEVANTE"},
{"descripcion":"{ TYAPS-20 } TAMBLEADO"},
{"descripcion":"{ TYAPS-21 } MOLIENDA"},
{"descripcion":"{ TYAPS-22 } TRANSPORTE"},
{"descripcion":"{ TYAPS-23 } EMBUTIDO"},
{"descripcion":"{ TYAPS-24 } BOMBEO"},
{"descripcion":"{ TYAPS-25 } EMULSIONADO"},
{"descripcion":"{ TYAPS-26 } MEZCLADO"},
{"descripcion":"{ TYAPS-2 } RILES"},
{"descripcion":"{ TYAPS-3 } AIRE"},
{"descripcion":"{ TYAPS-4 } VACIO"},
{"descripcion":"{ TYAPS-5 } ELECTRICIDAD"},
{"descripcion":"{ TYAPS-6 } REFRIGERACION"},
{"descripcion":"{ TYAPS-7 } AGUA"},
{"descripcion":"{ TYAPS-8 } VAPOR"},
{"descripcion":"{ TYAPS-9 } TRANSPORTE"},
{"descripcion":"{ TYAPS-CO-10 } SANITARIO AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYAPS-CO-1 } MOLIENDA AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYAPS-CO-2 } MEZCLADO AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYAPS-CO-3 } FORMADO AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYAPS-CO-4 } APLICACION DE COBERTURA AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYAPS-CO-5 } FREIODORAS AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYAPS-CO-6 } CONGELACION CRIOGENICA AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYAPS-CO-7 } TRANSPORTE AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYAPS-CO-8 } EMPAQUE AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYAPS-CO-9 } BALANZAS AV.BALMACEDA 0356 MALLOCO CHILE"},
{"descripcion":"{ TYAZ-000 } SERVICIOS INDUSTRIALES"},
{"descripcion":"{ TYAZ-001 } DESPACHO"},
{"descripcion":"{ TYAZ-002 } COCIDOS"},
{"descripcion":"{ TYAZ-003 } CRUDOS"},

  ]

  // Filtrar datos según búsqueda
  const filteredData = data.filter(item => {
    // Dividimos los términos por "%"
    const terms = search.toLowerCase().split("%").filter(Boolean);
    // Validamos que TODOS los términos estén en la descripción
    return terms.every(term =>
      item.descripcion.toLowerCase().includes(term)
    );
  });

  return (<>
    <HeaderMenu Pag_Sel={'prueba'} />
    <div className='container-fluid mt-5 mb-5'>
      <div className='row'>
        <div className='col-12 text-center bg-secondary py-1'> 
          <h5 className=' text-center text-white'>Pruebas</h5>
        </div>
      </div>
      </div>

      <div className='col-12'>
        <input type='text' value={search} onChange={(e) => setSearch(e.target.value) }/>
      </div>

      <ul>
        {filteredData.length > 0 ? (
          filteredData.map((item, index) => (
            <li key={index}>{item.descripcion}</li>
          ))
        ) : (
          <li>No hay coincidencias</li>
        )}
      </ul>

  </>
  )
}
